export const characterStats: Record<string, Record<string, number>> = {
  "Blast": {
    "Captain": 9800,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 9999,
    "Threat Level": 1000,
    "Combat Power": 9900,
    "Speed": 9800,
    "Technique": 9500,
    "Energy": 9500,
    "IQ": 9500,
    "Willpower": 9800,
    "Power": 9900,
    "Hax": 9900,
    "Defence": 9500
  },
  "Zombieman": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 7000,
    "Speed": 6500,
    "Technique": 7000,
    "Energy": 1000,
    "IQ": 7500,
    "Willpower": 9999,
    "Power": 7000,
    "Hax": 7600,
    "Defence": 9000
  },
  "Watchdog Man": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8200,
    "Healer": 1000,
    "Hero Rank": 9000,
    "Threat Level": 1000,
    "Combat Power": 8500,
    "Speed": 9000,
    "Technique": 8500,
    "Energy": 1000,
    "IQ": 7000,
    "Willpower": 9000,
    "Power": 8500,
    "Hax": 8600,
    "Defence": 8305
  },
  "Vaccine Man": {
    "Captain": 6500,
    "Vice Captain": 6700,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8500,
    "Speed": 7000,
    "Technique": 7000,
    "Energy": 9000,
    "IQ": 7000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 8875,
    "Defence": 8175
  },
  "Tatsumaki": {
    "Captain": 9000,
    "Vice Captain": 8800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 9900,
    "Threat Level": 1000,
    "Combat Power": 9500,
    "Speed": 8500,
    "Technique": 8800,
    "Energy": 9999,
    "IQ": 8500,
    "Willpower": 9200,
    "Power": 9500,
    "Hax": 9400,
    "Defence": 8525
  },
  "Tanktop Master": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8200,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 7000,
    "Speed": 6000,
    "Technique": 6000,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 8000,
    "Power": 7000,
    "Hax": 6400,
    "Defence": 8200
  },
  "Superalloy Darkshine": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 8800,
    "Speed": 7000,
    "Technique": 6500,
    "Energy": 1000,
    "IQ": 6000,
    "Willpower": 7500,
    "Power": 8800,
    "Hax": 6700,
    "Defence": 9700
  },
  "Suiryu": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7600,
    "Combat Power": 7600,
    "Speed": 7800,
    "Technique": 8800,
    "Energy": 1000,
    "IQ": 6500,
    "Willpower": 7500,
    "Power": 7600,
    "Hax": 8540,
    "Defence": 7210
  },
  "Stinger": {
    "Captain": 4200,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 5000,
    "Speed": 5500,
    "Technique": 6500,
    "Energy": 1000,
    "IQ": 4800,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 6400,
    "Defence": 5000
  },
  "Spring Mustache": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 4700,
    "Speed": 5000,
    "Technique": 6500,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 5500,
    "Power": 4700,
    "Hax": 6300,
    "Defence": 4570
  },
  "Speed o Sound Sonic": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 5500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 6500,
    "Combat Power": 6500,
    "Speed": 9500,
    "Technique": 9000,
    "Energy": 1000,
    "IQ": 6500,
    "Willpower": 7500,
    "Power": 6500,
    "Hax": 8700,
    "Defence": 5850
  },
  "Sneck": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4200,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 4300,
    "Speed": 5000,
    "Technique": 6000,
    "Energy": 1000,
    "IQ": 4500,
    "Willpower": 5500,
    "Power": 4300,
    "Hax": 5900,
    "Defence": 4235
  },
  "Saitama (Weak)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1200,
    "Support 2": 1200,
    "Tank": 1200,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 1000,
    "Combat Power": 1200,
    "Speed": 1200,
    "Technique": 1000,
    "Energy": 1000,
    "IQ": 2500,
    "Willpower": 9999,
    "Power": 1200,
    "Hax": 1000,
    "Defence": 1200
  },
  "Saitama": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Hero Rank": 7000,
    "Threat Level": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Technique": 7000,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9000,
    "Defence": 9999
  },
  "Puri Puri Prisoner": {
    "Captain": 6000,
    "Vice Captain": 6200,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 7800,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 6800,
    "Speed": 6200,
    "Technique": 6500,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 8500,
    "Power": 6800,
    "Hax": 6900,
    "Defence": 7800
  },
  "Psykos Orochi (Fused)": {
    "Captain": 9000,
    "Vice Captain": 8800,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9300,
    "Healer": 4500,
    "Hero Rank": 1000,
    "Threat Level": 9700,
    "Combat Power": 9700,
    "Speed": 8500,
    "Technique": 9000,
    "Energy": 9999,
    "IQ": 9500,
    "Willpower": 9500,
    "Power": 9700,
    "Hax": 9924,
    "Defence": 9440
  },
  "Pig God": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 7200,
    "Speed": 4500,
    "Technique": 5500,
    "Energy": 1000,
    "IQ": 6500,
    "Willpower": 8500,
    "Power": 7200,
    "Hax": 6100,
    "Defence": 9000
  },
  "Phoenix Man (Resurrected)": {
    "Captain": 7500,
    "Vice Captain": 7400,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8500,
    "Healer": 6000,
    "Hero Rank": 1000,
    "Threat Level": 8800,
    "Combat Power": 8800,
    "Speed": 7800,
    "Technique": 7500,
    "Energy": 8500,
    "IQ": 8000,
    "Willpower": 9500,
    "Power": 8800,
    "Hax": 8575,
    "Defence": 8605
  },
  "Overgrown Rover": {
    "Captain": 6000,
    "Vice Captain": 6200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8800,
    "Combat Power": 8800,
    "Speed": 7500,
    "Technique": 5500,
    "Energy": 9000,
    "IQ": 5000,
    "Willpower": 9000,
    "Power": 8800,
    "Hax": 8950,
    "Defence": 9500
  },
  "Orochi (Monster King)": {
    "Captain": 9200,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9700,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9800,
    "Combat Power": 9800,
    "Speed": 9200,
    "Technique": 9200,
    "Energy": 9500,
    "IQ": 9000,
    "Willpower": 9800,
    "Power": 9800,
    "Hax": 9575,
    "Defence": 9735
  },
  "Okamaitachi": {
    "Captain": 4200,
    "Vice Captain": 4500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 4300,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 4800,
    "Speed": 6000,
    "Technique": 6800,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 5500,
    "Power": 4800,
    "Hax": 6540,
    "Defence": 4475
  },
  "Nyan": {
    "Captain": 5500,
    "Vice Captain": 5600,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7000,
    "Combat Power": 7000,
    "Speed": 8500,
    "Technique": 7500,
    "Energy": 1000,
    "IQ": 6500,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 6675
  },
  "Mumen Rider": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 3500,
    "Healer": 2000,
    "Hero Rank": 3900,
    "Threat Level": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Technique": 3000,
    "Energy": 1000,
    "IQ": 4500,
    "Willpower": 9999,
    "Power": 2500,
    "Hax": 4400,
    "Defence": 3500
  },
  "Metal Bat": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 8200,
    "Speed": 7000,
    "Technique": 7500,
    "Energy": 1000,
    "IQ": 6000,
    "Willpower": 9800,
    "Power": 8200,
    "Hax": 7960,
    "Defence": 8500
  },
  "Melzargard": {
    "Captain": 7000,
    "Vice Captain": 7200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 8200,
    "Speed": 7500,
    "Technique": 7500,
    "Energy": 6500,
    "IQ": 7800,
    "Willpower": 9000,
    "Power": 8200,
    "Hax": 7800,
    "Defence": 9000
  },
  "Lord Boros (Released)": {
    "Captain": 8500,
    "Vice Captain": 8500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9600,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9700,
    "Combat Power": 9700,
    "Speed": 9400,
    "Technique": 8800,
    "Energy": 9500,
    "IQ": 8500,
    "Willpower": 9800,
    "Power": 9700,
    "Hax": 9550,
    "Defence": 9635
  },
  "Lord Boros (Meteoric Burst)": {
    "Captain": 8500,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9800,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9999,
    "Combat Power": 9999,
    "Speed": 9800,
    "Technique": 9200,
    "Energy": 9999,
    "IQ": 8500,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9870
  },
  "Lord Boros (Armoured)": {
    "Captain": 8500,
    "Vice Captain": 8500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9400,
    "Combat Power": 9400,
    "Speed": 9000,
    "Technique": 8500,
    "Energy": 9000,
    "IQ": 8500,
    "Willpower": 9500,
    "Power": 9400,
    "Hax": 9100,
    "Defence": 9500
  },
  "Lightning Max": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 4800,
    "Speed": 6500,
    "Technique": 5500,
    "Energy": 1000,
    "IQ": 4500,
    "Willpower": 6000,
    "Power": 4800,
    "Hax": 5600,
    "Defence": 4605
  },
  "King": {
    "Captain": 2500,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 1000,
    "Healer": 1000,
    "Hero Rank": 9600,
    "Threat Level": 1000,
    "Combat Power": 1000,
    "Speed": 1000,
    "Technique": 1000,
    "Energy": 1000,
    "IQ": 4000,
    "Willpower": 9999,
    "Power": 1000,
    "Hax": 1000,
    "Defence": 1000
  },
  "Iaian": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5200,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 5500,
    "Speed": 6000,
    "Technique": 7000,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 6500,
    "Power": 5500,
    "Hax": 6900,
    "Defence": 5305
  },
  "Homeless Emperor": {
    "Captain": 6500,
    "Vice Captain": 6800,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 8200,
    "Speed": 5500,
    "Technique": 6500,
    "Energy": 9500,
    "IQ": 7000,
    "Willpower": 7500,
    "Power": 8200,
    "Hax": 9175,
    "Defence": 5795
  },
  "Hammerhead": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 5000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 4000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Technique": 2500,
    "Energy": 1000,
    "IQ": 2500,
    "Willpower": 4000,
    "Power": 4000,
    "Hax": 2800,
    "Defence": 5000
  },
  "Gyoro Gyoro": {
    "Captain": 7000,
    "Vice Captain": 7300,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7000,
    "Combat Power": 7000,
    "Speed": 6500,
    "Technique": 8000,
    "Energy": 9200,
    "IQ": 9000,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 8650,
    "Defence": 6350
  },
  "Groribas": {
    "Captain": 5500,
    "Vice Captain": 5600,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7200,
    "Combat Power": 7200,
    "Speed": 6500,
    "Technique": 6000,
    "Energy": 7500,
    "IQ": 6500,
    "Willpower": 7000,
    "Power": 7200,
    "Hax": 7425,
    "Defence": 7070
  },
  "Gouketsu": {
    "Captain": 7500,
    "Vice Captain": 7600,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8800,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9000,
    "Combat Power": 9000,
    "Speed": 8800,
    "Technique": 9000,
    "Energy": 1000,
    "IQ": 7500,
    "Willpower": 9000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 8870
  },
  "Golden Sperm": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9300,
    "Healer": 2500,
    "Hero Rank": 1000,
    "Threat Level": 9500,
    "Combat Power": 9500,
    "Speed": 9300,
    "Technique": 8500,
    "Energy": 5000,
    "IQ": 8000,
    "Willpower": 9500,
    "Power": 9500,
    "Hax": 8700,
    "Defence": 9370
  },
  "Golden Ball": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 4200,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 4500,
    "Speed": 5000,
    "Technique": 6000,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 5900,
    "Defence": 4305
  },
  "Glasses": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Hero Rank": 5000,
    "Threat Level": 1000,
    "Combat Power": 3500,
    "Speed": 4500,
    "Technique": 4000,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 7000,
    "Power": 3500,
    "Hax": 4600,
    "Defence": 3500
  },
  "Geryuganshoop": {
    "Captain": 8000,
    "Vice Captain": 6500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7200,
    "Combat Power": 7200,
    "Speed": 7000,
    "Technique": 7000,
    "Energy": 9000,
    "IQ": 8500,
    "Willpower": 7000,
    "Power": 7200,
    "Hax": 8550,
    "Defence": 6745
  },
  "Genos (G4 Upgraded)": {
    "Captain": 7500,
    "Vice Captain": 7600,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 8400,
    "Speed": 9200,
    "Technique": 8800,
    "Energy": 9000,
    "IQ": 8000,
    "Willpower": 8800,
    "Power": 8400,
    "Hax": 8900,
    "Defence": 8140
  },
  "Genos (Demon Cyborg)": {
    "Captain": 7000,
    "Vice Captain": 7300,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7600,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 7800,
    "Speed": 8200,
    "Technique": 8200,
    "Energy": 8500,
    "IQ": 7600,
    "Willpower": 8500,
    "Power": 7800,
    "Hax": 8350,
    "Defence": 7670
  },
  "Garou (Spiral Form)": {
    "Captain": 8500,
    "Vice Captain": 8600,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8800,
    "Healer": 2500,
    "Hero Rank": 1000,
    "Threat Level": 9400,
    "Combat Power": 9400,
    "Speed": 9500,
    "Technique": 9900,
    "Energy": 5000,
    "IQ": 8800,
    "Willpower": 9900,
    "Power": 9400,
    "Hax": 9900,
    "Defence": 9010
  },
  "Garou (Half Monster)": {
    "Captain": 8000,
    "Vice Captain": 8200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8500,
    "Healer": 2000,
    "Hero Rank": 1000,
    "Threat Level": 9000,
    "Combat Power": 9000,
    "Speed": 9300,
    "Technique": 9800,
    "Energy": 4000,
    "IQ": 8500,
    "Willpower": 9800,
    "Power": 9000,
    "Hax": 9800,
    "Defence": 8675
  },
  "Garou (Base)": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6800,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7200,
    "Combat Power": 7200,
    "Speed": 8000,
    "Technique": 9000,
    "Energy": 1000,
    "IQ": 8000,
    "Willpower": 9000,
    "Power": 7200,
    "Hax": 9000,
    "Defence": 6940
  },
  "Garou (Awakened)": {
    "Captain": 9500,
    "Vice Captain": 9300,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9400,
    "Healer": 3000,
    "Hero Rank": 1000,
    "Threat Level": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Technique": 9999,
    "Energy": 8500,
    "IQ": 9200,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9610
  },
  "Fubuki": {
    "Captain": 6500,
    "Vice Captain": 6800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5000,
    "Healer": 3000,
    "Hero Rank": 5000,
    "Threat Level": 1000,
    "Combat Power": 6000,
    "Speed": 6000,
    "Technique": 7000,
    "Energy": 8500,
    "IQ": 8200,
    "Willpower": 7500,
    "Power": 6000,
    "Hax": 7750,
    "Defence": 5350
  },
  "Flashy Flash": {
    "Captain": 7600,
    "Vice Captain": 7400,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6800,
    "Healer": 1000,
    "Hero Rank": 9600,
    "Threat Level": 1000,
    "Combat Power": 8400,
    "Speed": 9800,
    "Technique": 9500,
    "Energy": 1000,
    "IQ": 7800,
    "Willpower": 8500,
    "Power": 8400,
    "Hax": 9300,
    "Defence": 7360
  },
  "Evil Natural Water": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8500,
    "Speed": 7000,
    "Technique": 5000,
    "Energy": 8500,
    "IQ": 5000,
    "Willpower": 9000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 9000
  },
  "Elder Centipede": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9600,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 9000,
    "Combat Power": 9000,
    "Speed": 6500,
    "Technique": 3500,
    "Energy": 4000,
    "IQ": 4500,
    "Willpower": 8500,
    "Power": 9000,
    "Hax": 5250,
    "Defence": 9600
  },
  "Drive Knight (Gold Form)": {
    "Captain": 7800,
    "Vice Captain": 7600,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8200,
    "Healer": 1000,
    "Hero Rank": 9000,
    "Threat Level": 8500,
    "Combat Power": 8500,
    "Speed": 8000,
    "Technique": 9000,
    "Energy": 6000,
    "IQ": 9000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 8900,
    "Defence": 8305
  },
  "Drive Knight": {
    "Captain": 7200,
    "Vice Captain": 7000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7000,
    "Healer": 1000,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 7500,
    "Speed": 7500,
    "Technique": 8500,
    "Energy": 5000,
    "IQ": 9000,
    "Willpower": 8000,
    "Power": 7500,
    "Hax": 8400,
    "Defence": 7175
  },
  "Dr Genus": {
    "Captain": 5000,
    "Vice Captain": 5200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 2500,
    "Healer": 4500,
    "Hero Rank": 1000,
    "Threat Level": 2500,
    "Combat Power": 2500,
    "Speed": 2500,
    "Technique": 3000,
    "Energy": 2000,
    "IQ": 9500,
    "Willpower": 4000,
    "Power": 2500,
    "Hax": 3200,
    "Defence": 2500
  },
  "Deep Sea King": {
    "Captain": 5500,
    "Vice Captain": 5600,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7800,
    "Combat Power": 7800,
    "Speed": 7200,
    "Technique": 6500,
    "Energy": 3000,
    "IQ": 5500,
    "Willpower": 7800,
    "Power": 7800,
    "Hax": 6760,
    "Defence": 8000
  },
  "Crablante": {
    "Captain": 1500,
    "Vice Captain": 1800,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 3500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 3000,
    "Combat Power": 3000,
    "Speed": 2500,
    "Technique": 2000,
    "Energy": 1000,
    "IQ": 1500,
    "Willpower": 2500,
    "Power": 3000,
    "Hax": 2100,
    "Defence": 3500
  },
  "Child Emperor (Brave Giant)": {
    "Captain": 7000,
    "Vice Captain": 6800,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 2500,
    "Hero Rank": 8800,
    "Threat Level": 8200,
    "Combat Power": 8200,
    "Speed": 7000,
    "Technique": 8500,
    "Energy": 6000,
    "IQ": 9800,
    "Willpower": 7800,
    "Power": 8200,
    "Hax": 8360,
    "Defence": 9000
  },
  "Child Emperor": {
    "Captain": 7000,
    "Vice Captain": 6800,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 4200,
    "Healer": 2500,
    "Hero Rank": 8800,
    "Threat Level": 1000,
    "Combat Power": 4500,
    "Speed": 5000,
    "Technique": 6500,
    "Energy": 4500,
    "IQ": 9800,
    "Willpower": 6500,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 4305
  },
  "Carnage Kabuto (Asura Mode)": {
    "Captain": 6000,
    "Vice Captain": 5800,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8800,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8000,
    "Combat Power": 9000,
    "Speed": 8200,
    "Technique": 6500,
    "Energy": 1000,
    "IQ": 6500,
    "Willpower": 8500,
    "Power": 9000,
    "Hax": 6900,
    "Defence": 8870
  },
  "Carnage Kabuto": {
    "Captain": 5000,
    "Vice Captain": 5200,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8200,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 7800,
    "Combat Power": 7800,
    "Speed": 7200,
    "Technique": 6000,
    "Energy": 1000,
    "IQ": 7000,
    "Willpower": 7500,
    "Power": 7800,
    "Hax": 6300,
    "Defence": 8200
  },
  "Bushidrill": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5000,
    "Healer": 1000,
    "Hero Rank": 6700,
    "Threat Level": 1000,
    "Combat Power": 5200,
    "Speed": 5500,
    "Technique": 6000,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 6000,
    "Power": 5200,
    "Hax": 6000,
    "Defence": 5070
  },
  "Bomb": {
    "Captain": 7800,
    "Vice Captain": 7600,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7600,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8600,
    "Combat Power": 8600,
    "Speed": 8500,
    "Technique": 9700,
    "Energy": 1000,
    "IQ": 8000,
    "Willpower": 8500,
    "Power": 8600,
    "Hax": 9460,
    "Defence": 7950
  },
  "Black Sperm": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8800,
    "Combat Power": 8800,
    "Speed": 8500,
    "Technique": 7000,
    "Energy": 5000,
    "IQ": 7500,
    "Willpower": 9000,
    "Power": 8800,
    "Hax": 7400,
    "Defence": 8605
  },
  "Beefcake": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 9000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8000,
    "Combat Power": 8000,
    "Speed": 4500,
    "Technique": 2500,
    "Energy": 1000,
    "IQ": 2000,
    "Willpower": 5000,
    "Power": 8000,
    "Hax": 3000,
    "Defence": 9000
  },
  "Beast King": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6200,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 5600,
    "Combat Power": 5600,
    "Speed": 5200,
    "Technique": 4000,
    "Energy": 1000,
    "IQ": 2500,
    "Willpower": 4500,
    "Power": 5600,
    "Hax": 4100,
    "Defence": 6200
  },
  "Bang (Silver Fang)": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 1000,
    "Hero Rank": 9600,
    "Threat Level": 1000,
    "Combat Power": 9000,
    "Speed": 9000,
    "Technique": 9900,
    "Energy": 1000,
    "IQ": 8500,
    "Willpower": 9000,
    "Power": 9000,
    "Hax": 9720,
    "Defence": 8220
  },
  "Atomic Samurai": {
    "Captain": 8000,
    "Vice Captain": 7800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7000,
    "Healer": 1000,
    "Hero Rank": 9600,
    "Threat Level": 1000,
    "Combat Power": 8800,
    "Speed": 9000,
    "Technique": 9800,
    "Energy": 1000,
    "IQ": 7600,
    "Willpower": 8500,
    "Power": 8800,
    "Hax": 9540,
    "Defence": 7630
  },
  "Armoured Gorilla": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 5200,
    "Combat Power": 5200,
    "Speed": 4200,
    "Technique": 4500,
    "Energy": 1000,
    "IQ": 4000,
    "Willpower": 5000,
    "Power": 5200,
    "Hax": 4600,
    "Defence": 6500
  },
  "8 Gate Gai": {
    "Captain": 9000,
    "Vice Captain": 9000,
    "Support 1": 9700,
    "Support 2": 9700,
    "Tank": 9700,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 7000,
    "Speed": 9400,
    "Taijutsu": 9999,
    "Power": 9800,
    "Hax": 4000,
    "Defence": 9700
  },
  "Ashura Otsutsuki": {
    "Captain": 9500,
    "Vice Captain": 8000,
    "Support 1": 8999,
    "Support 2": 8999,
    "Tank": 8500,
    "Healer": 6000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 7500,
    "Jutsu": 8500,
    "Clan": 9999,
    "Chakra": 9700,
    "Sensei": 6000,
    "Speed": 8000,
    "Taijutsu": 8000,
    "Power": 9600,
    "Hax": 8500,
    "Defence": 8800
  },
  "Asuma Sarutobi": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 4000,
    "Jutsu": 5500,
    "Clan": 7000,
    "Chakra": 5000,
    "Sensei": 5000,
    "Speed": 5500,
    "Taijutsu": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Ay (Fourth Raikage)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 9200,
    "Taijutsu": 8500,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 8500
  },
  "Boruto (Karma)": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 7500,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 8000,
    "Clan": 8500,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 8200,
    "Defence": 6000
  },
  "Boruto Uzumaki (Base)": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 3000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3500
  },
  "Boruto Uzumaki (Road to Boruto)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 6000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 7500,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 4500
  },
  "Boruto Uzumaki (Scientific Ninja Tool)": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 4500,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 7200,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Chiyo": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4000,
    "Healer": 7000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 5000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 5000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4000
  },
  "Choji Akimichi (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 7300,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 5000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 6000
  },
  "Choji Akimichi (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7300,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 7000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 8000
  },
  "Chojuro": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 4500
  },
  "Choza Akimichi": {
    "Captain": 7000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 7300,
    "Chakra": 5000,
    "Sensei": 4000,
    "Speed": 3500,
    "Taijutsu": 6000,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 7000
  },
  "Code": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7200,
    "Healer": 1000,
    "Eyes": 7800,
    "IQ": 6500,
    "Summon": 7500,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 8500,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 7800,
    "Power": 9000,
    "Hax": 8800,
    "Defence": 7500
  },
  "Daemon": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9200,
    "Healer": 1000,
    "Eyes": 6000,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 9999,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 9200,
    "Taijutsu": 8800,
    "Power": 9500,
    "Hax": 9999,
    "Defence": 9500
  },
  "Danzo Shimura": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 6000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 5000
  },
  "Darui": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "Deidara": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3500,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 4000
  },
  "Delta": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6800,
    "Healer": 1000,
    "Eyes": 7800,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 1000,
    "Speed": 8000,
    "Taijutsu": 6500,
    "Power": 7800,
    "Hax": 7500,
    "Defence": 6800
  },
  "Ebisu": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 2500,
    "Sensei": 4000,
    "Speed": 2500,
    "Taijutsu": 2000,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 2000
  },
  "Eida": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3500,
    "Power": 6500,
    "Hax": 9999,
    "Defence": 4000
  },
  "Fugaku Uchiha": {
    "Captain": 8000,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 9000,
    "Chakra": 5500,
    "Sensei": 5000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 4500
  },
  "Fū (Reanimation)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 4000,
    "Summon": 5000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4000
  },
  "Fū (Alive)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 5000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4000
  },
  "Gaara (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5300,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 6000
  },
  "Gaara (Kazekage)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 4000,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 7500
  },
  "Gaara (Shippuden)": {
    "Captain": 5000,
    "Vice Captain": 6500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3500,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 7000
  },
  "Gengetsu Hōzuki (Reanimation)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 6400,
    "Support 2": 6400,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 8000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Hagoromo Otsutsuki": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9990,
    "Healer": 9999,
    "Eyes": 9999,
    "IQ": 9500,
    "Summon": 9500,
    "Jutsu": 9999,
    "Clan": 9999,
    "Chakra": 9999,
    "Sensei": 9000,
    "Speed": 9000,
    "Taijutsu": 8500,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9500
  },
  "Haku": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3000
  },
  "Hamura Otsutsuki": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 7000,
    "Eyes": 9500,
    "IQ": 9000,
    "Summon": 2000,
    "Jutsu": 9200,
    "Clan": 9999,
    "Chakra": 9500,
    "Sensei": 8500,
    "Speed": 8500,
    "Taijutsu": 8000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 9000
  },
  "Hanabi Hyuga (The Last)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 8000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 3500
  },
  "Han (Reanimation)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 7700,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5000
  },
  "Han (Alive)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 7700,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5000
  },
  "Hanzo of the Salamander (Reanimation)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 8800,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5500
  },
  "Hashirama Senju (Alive)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9800,
    "Healer": 9000,
    "Eyes": 1000,
    "IQ": 8900,
    "Summon": 9000,
    "Jutsu": 9500,
    "Clan": 8400,
    "Chakra": 9500,
    "Sensei": 7000,
    "Speed": 8000,
    "Taijutsu": 8500,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 9000
  },
  "Hashirama Senju (Reanimation)": {
    "Captain": 9400,
    "Vice Captain": 8000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9999,
    "Healer": 7500,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 8500,
    "Jutsu": 9500,
    "Clan": 8400,
    "Chakra": 9500,
    "Sensei": 6500,
    "Speed": 7500,
    "Taijutsu": 8000,
    "Power": 9200,
    "Hax": 9800,
    "Defence": 9000
  },
  "Hidan": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 7500
  },
  "Hinata Hyuga (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 8000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 3500,
    "Hax": 8000,
    "Defence": 3000
  },
  "Hinata Hyuga (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 8000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 5000,
    "Hax": 8500,
    "Defence": 4000
  },
  "Hiruzen Sarutobi (Third Hokage)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9000,
    "Summon": 8000,
    "Jutsu": 9200,
    "Clan": 7000,
    "Chakra": 8000,
    "Sensei": 8000,
    "Speed": 7000,
    "Taijutsu": 7500,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 6000
  },
  "Indra Otsutsuki": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 8500,
    "Summon": 8000,
    "Jutsu": 9000,
    "Clan": 9999,
    "Chakra": 9300,
    "Sensei": 7000,
    "Speed": 8500,
    "Taijutsu": 7500,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8200
  },
  "Ino Yamanaka (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 7400,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 2500
  },
  "Ino Yamanaka (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3500,
    "Healer": 5000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7400,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 3500
  },
  "Inoichi Yamanaka": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7400,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 3000
  },
  "Iruka Umino": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 2500,
    "Sensei": 5000,
    "Speed": 2500,
    "Taijutsu": 2000,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 2500
  },
  "Isshiki Otsutsuki": {
    "Captain": 9800,
    "Vice Captain": 9200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9800,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 9500,
    "Summon": 9999,
    "Jutsu": 9900,
    "Clan": 9999,
    "Chakra": 9999,
    "Sensei": 9000,
    "Speed": 9700,
    "Taijutsu": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9700
  },
  "Itachi Uchiha (Reanimation)": {
    "Captain": 8600,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 9500,
    "Summon": 6500,
    "Jutsu": 9000,
    "Clan": 9000,
    "Chakra": 8500,
    "Sensei": 4500,
    "Speed": 8500,
    "Taijutsu": 6500,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 5500
  },
  "Itachi Uchiha": {
    "Captain": 6000,
    "Vice Captain": 8500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 9500,
    "Summon": 6000,
    "Jutsu": 8000,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 4000,
    "Speed": 8000,
    "Taijutsu": 6000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 5000
  },
  "Jigen": {
    "Captain": 9500,
    "Vice Captain": 8800,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 9700,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9200,
    "Summon": 3000,
    "Jutsu": 9500,
    "Clan": 1000,
    "Chakra": 9500,
    "Sensei": 8500,
    "Speed": 9200,
    "Taijutsu": 8800,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 9200
  },
  "Jiraiya": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 8000,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 9000,
    "Speed": 6500,
    "Taijutsu": 7000,
    "Power": 7800,
    "Hax": 7800,
    "Defence": 6000
  },
  "Jirobo": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3000,
    "Summon": 1000,
    "Jutsu": 2500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 2500,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 2500,
    "Defence": 4000
  },
  "Jugo": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 5500,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4500,
    "Power": 5500,
    "Hax": 4000,
    "Defence": 5000
  },
  "Kabuto Yakushi (Sage Mode)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5500,
    "Healer": 8000,
    "Eyes": 6000,
    "IQ": 8500,
    "Summon": 6000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5000,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 5500
  },
  "Kabuto Yakushi (Snake Sage Transformation)": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 8600,
    "Eyes": 6500,
    "IQ": 9000,
    "Summon": 6500,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 8500,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 5500,
    "Power": 8200,
    "Hax": 7800,
    "Defence": 6000
  },
  "Kabuto Yakushi": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 5000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 4000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Kaguya Otsutsuki": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 6500,
    "Summon": 9999,
    "Jutsu": 9999,
    "Clan": 9999,
    "Chakra": 9999,
    "Sensei": 1000,
    "Speed": 9800,
    "Taijutsu": 8500,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Kakashi Hatake (Double Mangekyō)": {
    "Captain": 9000,
    "Vice Captain": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 9000,
    "Summon": 7000,
    "Jutsu": 9500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 7000,
    "Speed": 9200,
    "Taijutsu": 8500,
    "Power": 9500,
    "Hax": 9999,
    "Defence": 8500
  },
  "Kakashi Hatake (Jonin)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 7000,
    "IQ": 8500,
    "Summon": 6000,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 2000,
    "Speed": 4000,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 5500
  },
  "Kakuzu": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 7000
  },
  "Kankuro (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 4000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3000
  },
  "Kankuro (Shippuden)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 6000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Karin": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 2500,
    "Healer": 8500,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 8500,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2000,
    "Power": 5000,
    "Hax": 3000,
    "Defence": 2500
  },
  "Kawaki (Karma)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 7000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 7500,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 7000
  },
  "Kiba Inuzuka (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 4000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 3500
  },
  "Kiba Inuzuka (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 5000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 4500
  },
  "Kidomaru": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 4000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 3000,
    "Defence": 3500
  },
  "Killer Bee (Samehada)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 5600,
    "Speed": 6500,
    "Taijutsu": 7500,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 7500
  },
  "Killer Bee": {
    "Captain": 6500,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 5500,
    "Speed": 6000,
    "Taijutsu": 7000,
    "Power": 7500,
    "Hax": 6000,
    "Defence": 7000
  },
  "Kimimaro": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 7500,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 5000
  },
  "Kinshiki Otsutsuki": {
    "Captain": 7800,
    "Vice Captain": 8000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 7800,
    "Clan": 9999,
    "Chakra": 8500,
    "Sensei": 1000,
    "Speed": 8200,
    "Taijutsu": 8500,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8800
  },
  "Kisame Hoshigaki": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 6500,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 6000,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 7000
  },
  "Koji Kashin": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 3000,
    "IQ": 8500,
    "Summon": 8000,
    "Jutsu": 8200,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 8000,
    "Speed": 8000,
    "Taijutsu": 7000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6000
  },
  "Konan": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 4000
  },
  "Konohamaru Sarutobi (Young)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 2000,
    "Jutsu": 3000,
    "Clan": 7000,
    "Chakra": 2500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 2000
  },
  "Konohamuru (Adult)": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6800,
    "Summon": 5000,
    "Jutsu": 7000,
    "Clan": 7000,
    "Chakra": 6000,
    "Sensei": 7500,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5000
  },
  "Kurenai": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 5000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 3000
  },
  "Kurotsuchi": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 3000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "Kushina Uzumaki": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 8500,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 7000,
    "Hax": 5000,
    "Defence": 4000
  },
  "Madara Uchiha (Alive)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 5000,
    "Eyes": 9500,
    "IQ": 8500,
    "Summon": 8500,
    "Jutsu": 9500,
    "Clan": 9000,
    "Chakra": 9500,
    "Sensei": 7000,
    "Speed": 8500,
    "Taijutsu": 8000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8000
  },
  "Madara Uchiha (Six Paths)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 9200,
    "Support 2": 9200,
    "Tank": 9500,
    "Healer": 9999,
    "Eyes": 9999,
    "IQ": 9000,
    "Summon": 9500,
    "Jutsu": 9800,
    "Clan": 9000,
    "Chakra": 9999,
    "Sensei": 6000,
    "Speed": 9700,
    "Taijutsu": 9000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9500
  },
  "Mecha-Naruto": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 1000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 5000
  },
  "Mei Terumi (Fifth Mizukage)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 5000
  },
  "Mifune": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3500
  },
  "Might Guy": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 2500,
    "Jutsu": 2000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 6000,
    "Speed": 8000,
    "Taijutsu": 9500,
    "Power": 8000,
    "Hax": 2500,
    "Defence": 6000
  },
  "Minato Namikaze (Fourth Hokage)": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 7000,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 9000,
    "Speed": 9700,
    "Taijutsu": 7000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 6000
  },
  "Minato Namikaze (Reanimation)": {
    "Captain": 9000,
    "Vice Captain": 8600,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8500,
    "Summon": 6500,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 9000,
    "Speed": 9750,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6500
  },
  "Mitsuki (Base - Renewal)": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 3000,
    "IQ": 7000,
    "Summon": 5500,
    "Jutsu": 6000,
    "Clan": 4000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4500
  },
  "Mitsuki (Sage Mode)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 6000,
    "IQ": 7200,
    "Summon": 5000,
    "Jutsu": 7500,
    "Clan": 4000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 8200,
    "Taijutsu": 7000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 5500
  },
  "Momoshiki Otsutsuki": {
    "Captain": 9000,
    "Vice Captain": 9000,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9200,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 8500,
    "Summon": 1000,
    "Jutsu": 9500,
    "Clan": 9999,
    "Chakra": 9700,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 8000,
    "Power": 9800,
    "Hax": 9700,
    "Defence": 8500
  },
  "Mū (Reanimation)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 4000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Nagato": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 9999,
    "Eyes": 9500,
    "IQ": 7500,
    "Summon": 8500,
    "Jutsu": 9550,
    "Clan": 8500,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5000,
    "Power": 9300,
    "Hax": 9500,
    "Defence": 6000
  },
  "Naruto (Baryon Mode)": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9500,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 8000,
    "Summon": 9000,
    "Jutsu": 9700,
    "Clan": 8800,
    "Chakra": 9999,
    "Sensei": 9000,
    "Speed": 9999,
    "Taijutsu": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9700
  },
  "Naruto Uzumaki (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 2000,
    "Summon": 3500,
    "Jutsu": 3000,
    "Clan": 8500,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3500,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 4000
  },
  "Naruto Uzumaki (KCM  -  Kurama Link Mode)": {
    "Captain": 8000,
    "Vice Captain": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 5000,
    "Eyes": 6000,
    "IQ": 5000,
    "Summon": 7500,
    "Jutsu": 8500,
    "Clan": 8500,
    "Chakra": 9500,
    "Sensei": 1000,
    "Speed": 8999,
    "Taijutsu": 7500,
    "Power": 9500,
    "Hax": 8500,
    "Defence": 8000
  },
  "Naruto Uzumaki (KCM2  -  Six Paths Sage Mode)": {
    "Captain": 8500,
    "Vice Captain": 9700,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9000,
    "Healer": 9000,
    "Eyes": 6000,
    "IQ": 7000,
    "Summon": 9000,
    "Jutsu": 8800,
    "Clan": 8500,
    "Chakra": 9999,
    "Sensei": 1000,
    "Speed": 9500,
    "Taijutsu": 8500,
    "Power": 9999,
    "Hax": 9500,
    "Defence": 9000
  },
  "Naruto Uzumaki (Sage Mode)": {
    "Captain": 8000,
    "Vice Captain": 6000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 7500,
    "IQ": 6500,
    "Summon": 8000,
    "Jutsu": 8000,
    "Clan": 8500,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 7200,
    "Taijutsu": 8800,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7000
  },
  "Naruto Uzumaki (Seventh Hokage)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9200,
    "Healer": 6000,
    "Eyes": 8000,
    "IQ": 8000,
    "Summon": 8800,
    "Jutsu": 9200,
    "Clan": 8800,
    "Chakra": 9800,
    "Sensei": 7000,
    "Speed": 9000,
    "Taijutsu": 9500,
    "Power": 9700,
    "Hax": 9200,
    "Defence": 9000
  },
  "Naruto Uzumaki (Shippuden - Teen)": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 5000,
    "Jutsu": 5000,
    "Clan": 8500,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 7000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Naruto Uzumaki (The Last)": {
    "Captain": 9100,
    "Vice Captain": 8200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7500,
    "Healer": 3000,
    "Eyes": 7000,
    "IQ": 7500,
    "Summon": 7000,
    "Jutsu": 8000,
    "Clan": 8500,
    "Chakra": 9850,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 9000,
    "Power": 9000,
    "Hax": 8000,
    "Defence": 7500
  },
  "Neji Hyuga (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 8000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3500
  },
  "Neji Hyuga (Shippuden)": {
    "Captain": 3000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 6500,
    "Power": 5500,
    "Hax": 8500,
    "Defence": 4500
  },
  "Obito Uchiha (Kid)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 4000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 2000,
    "Clan": 9000,
    "Chakra": 2500,
    "Sensei": 1000,
    "Speed": 2500,
    "Taijutsu": 2000,
    "Power": 2500,
    "Hax": 4000,
    "Defence": 2000
  },
  "Obito Uchiha (Ten-Tails Jinchuriki)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 8000,
    "Summon": 9999,
    "Jutsu": 9500,
    "Clan": 9000,
    "Chakra": 9999,
    "Sensei": 1000,
    "Speed": 8500,
    "Taijutsu": 7500,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9000
  },
  "Obito Uchiha (Unmasked War Arc)": {
    "Captain": 8500,
    "Vice Captain": 8500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 7500,
    "Summon": 7000,
    "Jutsu": 8000,
    "Clan": 9000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 9500,
    "Defence": 6500
  },
  "Obito Uchiha": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 6000,
    "Power": 7000,
    "Hax": 9000,
    "Defence": 6000
  },
  "Onoki (Third Tsuchikage)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5000
  },
  "Orochimaru": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 6000,
    "Healer": 6000,
    "Eyes": 1000,
    "IQ": 9500,
    "Summon": 9000,
    "Jutsu": 9000,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 7000,
    "Speed": 6500,
    "Taijutsu": 6000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 6000
  },
  "Pain (Six Paths)": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7000,
    "Healer": 5000,
    "Eyes": 9500,
    "IQ": 8000,
    "Summon": 9100,
    "Jutsu": 9500,
    "Clan": 1000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 6000,
    "Power": 9300,
    "Hax": 9500,
    "Defence": 7000
  },
  "Raza (Kazekage Reanimation)": {
    "Captain": 6500,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4000
  },
  "Rasa (Alive)": {
    "Captain": 6500,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4000
  },
  "Rin Nohara": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 5000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 2500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 2500,
    "Taijutsu": 2000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 2000
  },
  "Rock Lee (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 1000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 6000,
    "Power": 3500,
    "Hax": 1500,
    "Defence": 4000
  },
  "Rock Lee (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 1000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 8000,
    "Power": 4500,
    "Hax": 2500,
    "Defence": 5000
  },
  "Roshi (Reanimation)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7600,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Roshi (Alive)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7600,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Sage Mode Jiraiya": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8500,
    "Summon": 9000,
    "Jutsu": 8800,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 9000,
    "Speed": 7500,
    "Taijutsu": 7800,
    "Power": 8600,
    "Hax": 8600,
    "Defence": 7000
  },
  "Sai": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 5000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3500
  },
  "Sakon - Ukon": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 3000,
    "Defence": 3500
  },
  "Sakumo Hatake": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 6500,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 5500
  },
  "Sakura Haruno (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 7000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Sakura Haruno (War Arc)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6000,
    "Healer": 9000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 7500,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 7000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 6000
  },
  "Sarada Uchiha (Base)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 2000,
    "Eyes": 7000,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8500,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3500
  },
  "Sarada Uchiha (Chidori)": {
    "Captain": 6000,
    "Vice Captain": 5800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 2000,
    "Eyes": 7500,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 8800,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 6000,
    "Power": 6500,
    "Hax": 6800,
    "Defence": 4500
  },
  "Sasori": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 6000
  },
  "Sasuke Uchiha (EMS)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 7000,
    "Summon": 6000,
    "Jutsu": 8000,
    "Clan": 9000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 8500,
    "Taijutsu": 7500,
    "Power": 8000,
    "Hax": 9000,
    "Defence": 6500
  },
  "Sasuke Uchiha (Five Kage Summit)": {
    "Captain": 7200,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6500,
    "Summon": 5000,
    "Jutsu": 8500,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 7000,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 6000
  },
  "Sasuke Uchiha (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 4000,
    "IQ": 4000,
    "Summon": 3000,
    "Jutsu": 3500,
    "Clan": 9000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 4000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 2500
  },
  "Sasuke Uchiha (Shippuden)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 6000,
    "Summon": 5000,
    "Jutsu": 6000,
    "Clan": 9000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 6000,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 5000
  },
  "Sasuke Uchiha (Supporting Kage  -  Boruto Era)": {
    "Captain": 9500,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 9200,
    "Summon": 8200,
    "Jutsu": 9500,
    "Clan": 9200,
    "Chakra": 8500,
    "Sensei": 8500,
    "Speed": 9999,
    "Taijutsu": 9000,
    "Power": 9500,
    "Hax": 9700,
    "Defence": 8500
  },
  "Sasuke Uchiha (Taka - Akatsuki Cloak)": {
    "Captain": 4500,
    "Vice Captain": 7400,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 7500,
    "Summon": 5500,
    "Jutsu": 7000,
    "Clan": 9000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 6500,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 5500
  },
  "Sasuke Uchiha (The Last)": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 9000,
    "Summon": 8000,
    "Jutsu": 9500,
    "Clan": 9000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 8200,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 8000
  },
  "Sasuke Uchiha (War Arc  -  Rinnegan)": {
    "Captain": 9000,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 8500,
    "Summon": 8000,
    "Jutsu": 9500,
    "Clan": 9000,
    "Chakra": 9000,
    "Sensei": 1000,
    "Speed": 9500,
    "Taijutsu": 8000,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 8000
  },
  "Shikaku Nara": {
    "Captain": 9000,
    "Vice Captain": 9300,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9999,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 7500,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Shikamaru Nara (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 7500,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2000,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 2500
  },
  "Shikamaru Nara (Shippuden)": {
    "Captain": 8000,
    "Vice Captain": 8000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9990,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 7500,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3500
  },
  "Shino Aburame (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3000
  },
  "Shino Aburame (Shippuden)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Shisui Uchiha": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 9000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 5000,
    "Power": 6500,
    "Hax": 9000,
    "Defence": 4500
  },
  "Suigetsu Hozuki": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 6000
  },
  "Tayuya": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 6000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 2500
  },
  "Temari (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 6500,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3000
  },
  "Temari (Shippuden)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 6500,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 3500
  },
  "Tenten (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 2500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 2500
  },
  "Tenten (Shippuden)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3500,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3000
  },
  "Third Raikage (Reanimation)": {
    "Captain": 7500,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 3000,
    "Speed": 8500,
    "Taijutsu": 8000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 9000
  },
  "Third Raikage (Alive)": {
    "Captain": 7500,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 3000,
    "Speed": 8500,
    "Taijutsu": 8000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 9000
  },
  "Tobi (Akatsuki)": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 7000,
    "Summon": 6000,
    "Jutsu": 8000,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 6000,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 5000
  },
  "Tobi (Great Ninja War Mask)": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 7000,
    "Summon": 7000,
    "Jutsu": 7000,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 3000,
    "Speed": 8000,
    "Taijutsu": 8000,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 7000
  },
  "Tobi (Masked Man)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 6500,
    "Summon": 9000,
    "Jutsu": 7500,
    "Clan": 9000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6500,
    "Hax": 9000,
    "Defence": 6000
  },
  "Tobirama Senju": {
    "Captain": 8000,
    "Vice Captain": 8500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9000,
    "Summon": 1000,
    "Jutsu": 8500,
    "Clan": 8400,
    "Chakra": 7500,
    "Sensei": 7000,
    "Speed": 9000,
    "Taijutsu": 7000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 6000
  },
  "Toneri Otsutsuki": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 9300,
    "Clan": 9999,
    "Chakra": 9000,
    "Sensei": 1000,
    "Speed": 8600,
    "Taijutsu": 7000,
    "Power": 9400,
    "Hax": 9700,
    "Defence": 7800
  },
  "Tsunade": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7000,
    "Healer": 9500,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 6000,
    "Jutsu": 6500,
    "Clan": 8400,
    "Chakra": 8000,
    "Sensei": 6000,
    "Speed": 7000,
    "Taijutsu": 8000,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 7000
  },
  "Urashiki Otsutsuki": {
    "Captain": 7200,
    "Vice Captain": 6500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Eyes": 9200,
    "IQ": 8000,
    "Summon": 9000,
    "Jutsu": 8200,
    "Clan": 9999,
    "Chakra": 7800,
    "Sensei": 1000,
    "Speed": 8500,
    "Taijutsu": 6800,
    "Power": 8200,
    "Hax": 9200,
    "Defence": 6500
  },
  "Utakata (Reanimation)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 4500
  },
  "Utakata (Alive)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 4500
  },
  "Yagura (Reanimation)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Yagura (Alive)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Yamato": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 6000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Yugito Nii (Reanimation)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000
  },
  "Yugito Nii (Alive)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000
  },
  "Zabuza Momochi": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Aaroniero": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500
  },
  "As Nodt": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7000,
    "Hax": 9000,
    "Defence": 5000
  },
  "Askin": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8000,
    "Hax": 9400,
    "Defence": 6000
  },
  "Bambietta": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 4500
  },
  "Baraggan": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8500,
    "Hax": 9500,
    "Defence": 7000
  },
  "Bazz-B": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 5500
  },
  "BG9": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 6000
  },
  "Byakuya Kuchiki (Bankai)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9000,
    "Bankai": 8500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 8000,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 6000
  },
  "Byakuya Kuchiki (TYBW)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 9700,
    "Reiatsu": 9500,
    "Bankai": 9500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 8500,
    "Sensei": 5000,
    "Ally": 7500,
    "Power": 9700,
    "Hax": 9700,
    "Defence": 6500
  },
  "Byakuya Kuchiki": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 8500,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 7500,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 5500
  },
  "Candice": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 4500
  },
  "Cang Du": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Chojiro Sasakibe": {
    "Captain": 1000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5500,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Cirucci": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3500
  },
  "Coyote Starrk": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 5000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9000,
    "Hax": 7500,
    "Defence": 7000
  },
  "Dangai Ichigo": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 9000,
    "Reiatsu": 9500,
    "Bankai": 7000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 8000
  },
  "Dondochakka": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 2000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 2000,
    "IQ": 2000,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 2000,
    "Hax": 1800,
    "Defence": 3000
  },
  "Ganju Shiba": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 3500
  },
  "Genryusai Yamamoto (Bankai)": {
    "Captain": 9999,
    "Vice Captain": 9000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9999,
    "Bankai": 9999,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 9000,
    "Sensei": 8000,
    "Ally": 7000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9000
  },
  "Genryusai Yamamoto": {
    "Captain": 9999,
    "Vice Captain": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8500,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 9000,
    "Sensei": 8000,
    "Ally": 7000,
    "Power": 9700,
    "Hax": 9600,
    "Defence": 8500
  },
  "Gerard": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 9500
  },
  "Gin Ichimaru": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 9000,
    "Reiatsu": 8000,
    "Bankai": 7500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 8500,
    "Sensei": 4000,
    "Ally": 3000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 5500
  },
  "Giselle": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 9000,
    "Defence": 4000
  },
  "Gremmy": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 5000,
    "Healer": 9999,
    "Zanpakuto": 1000,
    "Reiatsu": 8500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 9000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8500,
    "Hax": 9800,
    "Defence": 5000
  },
  "Grimmjow (Pantera)": {
    "Captain": 6000,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 7000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 6500
  },
  "Grimmjow": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 5500
  },
  "Hachigen Ushoda": {
    "Captain": 1000,
    "Vice Captain": 6000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5000,
    "Healer": 6000,
    "Zanpakuto": 5000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 7000,
    "Sensei": 4000,
    "Ally": 8000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Hiyori Sarugaki (Vizard Mask)": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 5000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 4000
  },
  "Hiyori Sarugaki": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 4000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 3500
  },
  "Hollow Mask Ichigo": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 7500,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8200,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 7000
  },
  "Ichibe Hyosube (Bankai)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9550,
    "Healer": 1000,
    "Zanpakuto": 9800,
    "Reiatsu": 9900,
    "Bankai": 9999,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9800,
    "IQ": 9000,
    "Sensei": 8000,
    "Ally": 8000,
    "Power": 9900,
    "Hax": 9999,
    "Defence": 8000
  },
  "Ichibe Hyosube": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9550,
    "Healer": 1000,
    "Zanpakuto": 9800,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9800,
    "IQ": 9000,
    "Sensei": 8000,
    "Ally": 8000,
    "Power": 9500,
    "Hax": 9999,
    "Defence": 7500
  },
  "Ichigo Kurosaki (Bankai)": {
    "Captain": 2000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 8500,
    "Reiatsu": 9000,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7000
  },
  "Ichigo Kurosaki (Mugetsu)": {
    "Captain": 9950,
    "Vice Captain": 8000,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9500,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9800,
    "Bankai": 9500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9500,
    "IQ": 8000,
    "Sensei": 1000,
    "Ally": 9000,
    "Power": 9800,
    "Hax": 9500,
    "Defence": 9500
  },
  "Ichigo Kurosaki": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6000
  },
  "Ikkaku Madarame (Bankai)": {
    "Captain": 1000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 6000,
    "Bankai": 1500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 6000
  },
  "Ikkaku Madarame": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5500
  },
  "Isane Kotetsu": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 7000,
    "Zanpakuto": 4000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 4000
  },
  "Isshin Kurosaki": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 7500,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 6000,
    "Sensei": 5000,
    "Ally": 8000,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 6500
  },
  "Izuru Kira": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 5500,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Jackie Tristan": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 6000,
    "Speed": 3500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 3500,
    "Hax": 1800,
    "Defence": 4000
  },
  "Jugram Haschwalth": {
    "Captain": 9000,
    "Vice Captain": 8500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 8500,
    "Sensei": 1000,
    "Ally": 8500,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 7500
  },
  "Jushiro Ukitake": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 6000,
    "Zanpakuto": 7500,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 7000,
    "Sensei": 5000,
    "Ally": 8000,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 5000
  },
  "Kaname Tosen (Bankai)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 6000,
    "Bankai": 6000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5000
  },
  "Kaname Tosen (Hollowfication)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 8000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6000
  },
  "Kaname Tosen (Shikai)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 4000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Kenpachi Zaraki": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 9800,
    "Support 2": 9800,
    "Tank": 9500,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 9500,
    "Hax": 3500,
    "Defence": 9500
  },
  "Kensei Muguruma (Bankai)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 2000,
    "Reiatsu": 6000,
    "Bankai": 7000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5500
  },
  "Kensei Muguruma": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Kid Neliel": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4000,
    "Hax": 1800,
    "Defence": 3500
  },
  "Kirio Hikifune": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 6000,
    "Zanpakuto": 7000,
    "Reiatsu": 8600,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 7500,
    "Sensei": 6000,
    "Ally": 8000,
    "Power": 8500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Kisuke Urahara (Bankai)": {
    "Captain": 6000,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 5500,
    "Healer": 6000,
    "Zanpakuto": 8500,
    "Reiatsu": 8000,
    "Bankai": 9500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 9999,
    "Sensei": 9000,
    "Ally": 8000,
    "Power": 8800,
    "Hax": 9000,
    "Defence": 6000
  },
  "Kisuke Urahara": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 5000,
    "Zanpakuto": 7500,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 9999,
    "Sensei": 5000,
    "Ally": 8000,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 5000
  },
  "Kon": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 2000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 1000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 2000,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 1000,
    "Hax": 1200,
    "Defence": 2000
  },
  "Kugo Ginjo": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 8000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 5000
  },
  "Kukaku": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 3500
  },
  "Lille Barro": {
    "Captain": 8600,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9500,
    "Hax": 9700,
    "Defence": 9000
  },
  "Liltotto": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000
  },
  "Lisa Yadomaru": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 5500,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Love Aikawa (Vizard Mask)": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Love Aikawa": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 5000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "Luppi": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Marechiyo Omaeda": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 3500,
    "Reiatsu": 3000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 4000
  },
  "Mashiro Kuna (Vizard Mask)": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 4000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 4500
  },
  "Mashiro Kuna": {
    "Captain": 1000,
    "Vice Captain": 3000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 3000,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 3500,
    "Hax": 3000,
    "Defence": 4000
  },
  "Mask de Masculine": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 7000
  },
  "Mayuri Kurotsuchi (Modified Bankai)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 5000,
    "Healer": 6000,
    "Zanpakuto": 7500,
    "Reiatsu": 7000,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 9800,
    "Sensei": 5000,
    "Ally": 4000,
    "Power": 7500,
    "Hax": 8000,
    "Defence": 5000
  },
  "Mayuri Kurotsuchi": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4500,
    "Healer": 5000,
    "Zanpakuto": 6500,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 9800,
    "Sensei": 4000,
    "Ally": 4000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 4500
  },
  "Meninas": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 6001,
    "Support 2": 6001,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 2200,
    "Defence": 5000
  },
  "Mila Rose": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 4500,
    "Hax": 2500,
    "Defence": 4500
  },
  "Moe Shishigawara": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 2500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 5500,
    "Speed": 3000,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 2500,
    "Hax": 7000,
    "Defence": 3000
  },
  "Momo Hinamori": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 4500,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3500
  },
  "NaNaNa": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 8000,
    "Defence": 3500
  },
  "Nanao Ise": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 7800,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3000
  },
  "Neliel": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 5000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5500
  },
  "Nemu Kurotsuchi": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 4500
  },
  "Nnoitra": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 7000
  },
  "Oetsu Nimaiya": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 8500,
    "Sensei": 7000,
    "Ally": 8000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 7000
  },
  "Orihime Inoue (Base)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 3000,
    "Healer": 8000,
    "Zanpakuto": 1000,
    "Reiatsu": 3000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 9000,
    "Power": 3000,
    "Hax": 9000,
    "Defence": 3000
  },
  "Orihime Inoue (Spirits)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 4000,
    "Healer": 9000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 9000,
    "Power": 4000,
    "Hax": 9500,
    "Defence": 4000
  },
  "Pepe Waccabrada": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 8500,
    "Defence": 3500
  },
  "Pesche": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 3000,
    "Hax": 1800,
    "Defence": 3500
  },
  "Rangiku Matsumoto": {
    "Captain": 1000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 5500,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4000
  },
  "Renji Abarai (Bankai)": {
    "Captain": 2000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 7500,
    "Reiatsu": 7000,
    "Bankai": 7500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 7600
  },
  "Renji Abarai": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 6500,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 6000
  },
  "Retsu Unohana (Bankai)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 9999,
    "Zanpakuto": 9500,
    "Reiatsu": 9500,
    "Bankai": 9000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 7500,
    "Sensei": 6000,
    "Ally": 7000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8000
  },
  "Retsu Unohana": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7500,
    "Healer": 8500,
    "Zanpakuto": 9000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 7500,
    "Sensei": 6000,
    "Ally": 7000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 7500
  },
  "Riruka": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 7000,
    "Speed": 3500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 3500,
    "Hax": 7000,
    "Defence": 3000
  },
  "Robert Accutrone": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 4500
  },
  "Rojuro Otoribashi": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5500,
    "Bankai": 5000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Rukia Kuchiki (Bankai TYBW)": {
    "Captain": 4000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 8500,
    "Reiatsu": 8000,
    "Bankai": 8500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 5500
  },
  "Rukia Kuchiki": {
    "Captain": 1000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 4500
  },
  "Ryuken Ishida": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 8000,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3500
  },
  "Sajin Komomora": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 7000
  },
  "Senjumaru Shutara": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6500,
    "Healer": 7000,
    "Zanpakuto": 9500,
    "Reiatsu": 9000,
    "Bankai": 9600,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 9000,
    "Sensei": 7000,
    "Ally": 8000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 6500
  },
  "Shinji Hirako (Bankai)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 7500,
    "Reiatsu": 7500,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 7000,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 5500
  },
  "Shinji Hirako": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 7000,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5000
  },
  "Shuhei Hisagi": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 5000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "Shukuro Tsukishima": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 8500,
    "Speed": 4000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 3500
  },
  "Shunsui": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9500,
    "Bankai": 9500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 9000,
    "Sensei": 7000,
    "Ally": 8000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 6500
  },
  "Soi-Fon": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 8000,
    "Reiatsu": 7000,
    "Bankai": 7500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 4500
  },
  "Sosuke Aizen (Chrysalis Evolved)": {
    "Captain": 9800,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 9999,
    "Sensei": 8000,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 8000
  },
  "Sosuke Aizen (Chrysalis Form)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7500,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9800,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 9999,
    "Sensei": 7000,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 7500
  },
  "Sosuke Aizen (Hogyoku)": {
    "Captain": 9600,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 9999,
    "Sensei": 6000,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 7000
  },
  "Sosuke Aizen (Monster)": {
    "Captain": 9900,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 8500,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9500,
    "IQ": 9999,
    "Sensei": 9000,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 8500
  },
  "Sosuke Aizen (TYBW)": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9800,
    "IQ": 9999,
    "Sensei": 9999,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9000
  },
  "Sosuke Aizen": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 9999,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 9999,
    "Sensei": 6000,
    "Ally": 1000,
    "Power": 9700,
    "Hax": 9800,
    "Defence": 7000
  },
  "Szayelaporro": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 8500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6500,
    "Hax": 8500,
    "Defence": 5000
  },
  "Tenjiro Kirinji": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 9999,
    "Zanpakuto": 7000,
    "Reiatsu": 8600,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 8000,
    "Sensei": 7000,
    "Ally": 8000,
    "Power": 8500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Tetsuzaemon Iba": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 4500,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 5000
  },
  "Tier Harribel": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6500
  },
  "Toshiro Hitsugaya (Bankai)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 8000,
    "Reiatsu": 7000,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 5000
  },
  "Toshiro Hitsugaya (Mature Bankai)": {
    "Captain": 8000,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9000,
    "Bankai": 9700,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 8000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 6000
  },
  "Toshiro Hitsugaya": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 6500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 7500,
    "Hax": 7800,
    "Defence": 5000
  },
  "True Bankai Ichigo": {
    "Captain": 9500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8500,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9800,
    "Bankai": 9999,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9700,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 9999,
    "Hax": 9700,
    "Defence": 9000
  },
  "Ulquiorra Resurreccion": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 9000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 8000
  },
  "Ulquiorra": {
    "Captain": 6000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7800,
    "Hax": 7000,
    "Defence": 6500
  },
  "Uryu Ishida (Antithesis)": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 8000,
    "Sensei": 1000,
    "Ally": 9000,
    "Power": 7000,
    "Hax": 9500,
    "Defence": 5000
  },
  "Uryu Ishida (Base)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 7000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 3000
  },
  "Vasto Lorde Ichigo": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Zanpakuto": 8500,
    "Reiatsu": 9200,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 9300,
    "Hax": 9000,
    "Defence": 8500
  },
  "Vizard Mask Shinji": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 7000,
    "Sensei": 4000,
    "Ally": 7000,
    "Power": 7500,
    "Hax": 8000,
    "Defence": 5000
  },
  "Wonderweiss": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 1000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Yachiru Kusajishi": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 9000,
    "Reiatsu": 3000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 3000
  },
  "Yammy": {
    "Captain": 4000,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 2000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 8000
  },
  "Yasutora Sado (Base)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 6000,
    "Speed": 3500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 3500,
    "Hax": 2500,
    "Defence": 6000
  },
  "Yasutora Sado (Full Power)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 7200,
    "Speed": 4500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 5000,
    "Hax": 3500,
    "Defence": 7000
  },
  "Yhwach (Almighty)": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9800,
    "Healer": 7000,
    "Zanpakuto": 1000,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9500,
    "IQ": 9800,
    "Sensei": 9000,
    "Ally": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9800
  },
  "Yhwach": {
    "Captain": 9900,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9500,
    "Healer": 5000,
    "Zanpakuto": 1000,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 9500,
    "Sensei": 8000,
    "Ally": 1000,
    "Power": 9800,
    "Hax": 9999,
    "Defence": 9500
  },
  "Yoruichi Shihoin": {
    "Captain": 1000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9400,
    "IQ": 7000,
    "Sensei": 8000,
    "Ally": 8000,
    "Power": 8200,
    "Hax": 6500,
    "Defence": 6000
  },
  "Yukio": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 7200,
    "Speed": 3500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 3500,
    "Hax": 8000,
    "Defence": 3000
  },
  "Yumichika Ayasegawa (True Shikai)": {
    "Captain": 1000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4000
  },
  "Yumichika Ayasegawa": {
    "Captain": 1000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 7500,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 3500
  },
  "Zangetsu": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 8000,
    "Reiatsu": 8000,
    "Bankai": 7000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 6000,
    "Ally": 6000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6000
  },
  "Zommari": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 8500,
    "Defence": 4000
  },
  "Adult Gohan (Base)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 5500,
    "Energy Manipulation": 6000,
    "Martial Arts": 6000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Android 16": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 6700,
    "Energy Manipulation": 1000,
    "Martial Arts": 6000,
    "Power": 7000,
    "Hax": 5500,
    "Defence": 8000
  },
  "Android 17 (TOP)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 6500,
    "Form": 1000,
    "Speed": 7500,
    "IQ": 9000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 6500,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 7500
  },
  "Android 17": {
    "Captain": 5500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 6500
  },
  "Android 18": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Android 20": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 9500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 3000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Android 21 (Evil)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 6000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6500
  },
  "Android 21": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 9000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Anilaza": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 7000,
    "Martial Arts": 4000,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 9000
  },
  "Babidi": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 5000,
    "Martial Arts": 1000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3000
  },
  "Baby Vegeta": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 6000,
    "Form": 8000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 6500,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 6500
  },
  "Bardock (SSJ1)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 4000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Bardock": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 4500
  },
  "Beast Gohan": {
    "Captain": 9500,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9000,
    "Form": 9400,
    "Speed": 9900,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9500,
    "Martial Arts": 9999,
    "Power": 9500,
    "Hax": 9400,
    "Defence": 9000
  },
  "Beerus": {
    "Captain": 9800,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9800,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9900,
    "Form": 9900,
    "Speed": 9600,
    "IQ": 9000,
    "Sensei": 7000,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 9800,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9900
  },
  "Black Frieza": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9200,
    "Healer": 1000,
    "Ki Control": 9700,
    "Technique": 9000,
    "Form": 9600,
    "Speed": 9500,
    "IQ": 9000,
    "Sensei": 1000,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 8500,
    "Power": 9999,
    "Hax": 9600,
    "Defence": 9500
  },
  "Broly (Base)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 2000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 4000,
    "Martial Arts": 5000,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 6000
  },
  "Broly (Beserk DBS)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 6000,
    "Form": 9300,
    "Speed": 9000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 1000,
    "Martial Arts": 5000,
    "Power": 9500,
    "Hax": 9300,
    "Defence": 9500
  },
  "Broly (Beserk)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 5000,
    "Form": 8000,
    "Speed": 8500,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 8500,
    "Martial Arts": 4500,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 9000
  },
  "Bulma": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 1000,
    "Healer": 1000,
    "Ki Control": 1000,
    "Technique": 1000,
    "Form": 1000,
    "Speed": 1000,
    "IQ": 9999,
    "Sensei": 1000,
    "Power Level": 1000,
    "Energy Manipulation": 1000,
    "Martial Arts": 1000,
    "Power": 1000,
    "Hax": 1000,
    "Defence": 1000
  },
  "Burter": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3500,
    "Energy Manipulation": 3000,
    "Martial Arts": 3000,
    "Power": 3500,
    "Hax": 2500,
    "Defence": 3000
  },
  "Buuhan": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8500,
    "Healer": 7000,
    "Ki Control": 9000,
    "Technique": 8000,
    "Form": 8500,
    "Speed": 8000,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 9000,
    "Martial Arts": 7000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Caulifla (SSJ1)": {
    "Captain": 4000,
    "Vice Captain": 6500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 4000,
    "Speed": 6000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5000
  },
  "Caulifla": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "Cell (1st Form)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4500,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 5000
  },
  "Cell (2nd Form)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Cell Max": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 8000,
    "Martial Arts": 5000,
    "Power": 9000,
    "Hax": 7000,
    "Defence": 9500
  },
  "Champa": {
    "Captain": 9800,
    "Vice Captain": 9000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9800,
    "Healer": 1000,
    "Ki Control": 9800,
    "Technique": 9500,
    "Form": 9800,
    "Speed": 9700,
    "IQ": 8500,
    "Sensei": 6000,
    "Power Level": 9800,
    "Energy Manipulation": 9800,
    "Martial Arts": 9500,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 9500
  },
  "Chiaotzu": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 2500,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 2000,
    "Energy Manipulation": 2500,
    "Martial Arts": 2000,
    "Power": 2500,
    "Hax": 3000,
    "Defence": 1500
  },
  "Chichi": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 2000,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 2000,
    "Energy Manipulation": 2000,
    "Martial Arts": 4000,
    "Power": 2000,
    "Hax": 3000,
    "Defence": 2000
  },
  "Cooler": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 7000
  },
  "Corrupted Zamasu": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 8000,
    "Form": 9200,
    "Speed": 8500,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9500,
    "Martial Arts": 7000,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 9000
  },
  "Dabura": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Dyspo": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 9000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 6500
  },
  "Evil Buu": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 4000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 6000
  },
  "Fattenks": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 3000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 7000
  },
  "Freiza (1st Form)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 2000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 4500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500
  },
  "Frieza (2nd Form)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 5000,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 6000
  },
  "Frieza (Final Form)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 7500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Frieza (Full Power)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 6500,
    "Form": 8500,
    "Speed": 7500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 6000,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 6000
  },
  "Fused Zamasu": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 8500,
    "Form": 9000,
    "Speed": 8500,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9500,
    "Martial Arts": 7500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 8000
  },
  "Future Trunks (Base)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Future Trunks (SSJ1)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 4000,
    "Speed": 6500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Future Trunks (Sword of Hope)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 8000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 6500,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 7500
  },
  "Gamma 1": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 7500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 7500,
    "Martial Arts": 6000,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 7000
  },
  "Gamma 2": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 7000
  },
  "Gas": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7500,
    "Form": 8500,
    "Speed": 9000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 7000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7500
  },
  "Ginyu": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Gogeta (Base)": {
    "Captain": 7500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7800,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 8500,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 8000
  },
  "Gogeta (SSJ1)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7500,
    "Form": 4000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 9000,
    "Martial Arts": 9000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Gogeta (SSJ4)": {
    "Captain": 9001,
    "Vice Captain": 7000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 8500,
    "Form": 8000,
    "Speed": 9000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 9000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8000
  },
  "Gogeta (SSJB)": {
    "Captain": 9900,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9800,
    "Technique": 9500,
    "Form": 9000,
    "Speed": 9800,
    "IQ": 9000,
    "Sensei": 1000,
    "Power Level": 9800,
    "Energy Manipulation": 9800,
    "Martial Arts": 9500,
    "Power": 9800,
    "Hax": 9500,
    "Defence": 9000
  },
  "Gohan (Base)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 3500,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 4000,
    "Energy Manipulation": 4000,
    "Martial Arts": 4000,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3500
  },
  "Gohan (SSJ1)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 4000,
    "Speed": 6000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 6000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Gohan (SSJ2)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 6000,
    "Speed": 7500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 7000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6000
  },
  "Goku (Base)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5500,
    "Martial Arts": 7000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Goku (Kaioken)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 2000,
    "Speed": 7000,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6500,
    "Martial Arts": 7500,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Goku (Mastered Ultra Instinct)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9800,
    "Healer": 1000,
    "Ki Control": 9999,
    "Technique": 9999,
    "Form": 9500,
    "Speed": 9800,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9700,
    "Energy Manipulation": 9500,
    "Martial Arts": 9900,
    "Power": 9999,
    "Hax": 9500,
    "Defence": 9800
  },
  "Goku (SSG)": {
    "Captain": 8200,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 8500,
    "Form": 7000,
    "Speed": 9500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 9000,
    "Martial Arts": 9000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Goku (SSJ1)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 7000,
    "Form": 4000,
    "Speed": 8000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7500,
    "Martial Arts": 8000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 7000
  },
  "Goku (SSJ2)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7500,
    "Form": 5000,
    "Speed": 8200,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 7500,
    "Energy Manipulation": 8000,
    "Martial Arts": 8500,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 7500
  },
  "Goku (SSJ3)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 8000,
    "Form": 6000,
    "Speed": 9000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8500,
    "Martial Arts": 8500,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 8000
  },
  "Goku (SSJ4)": {
    "Captain": 8000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 8000,
    "Form": 7000,
    "Speed": 8500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 9000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 8000
  },
  "Goku (SSJB Kaioken)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9000,
    "Form": 8500,
    "Speed": 9700,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9500,
    "Martial Arts": 9500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 9000
  },
  "Goku (SSJB)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9000,
    "Form": 8000,
    "Speed": 9600,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9500,
    "Martial Arts": 9500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 9000
  },
  "Goku (Ultra-Instinct-Sign-)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 9800,
    "Technique": 9500,
    "Form": 9000,
    "Speed": 9600,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9800,
    "Martial Arts": 9700,
    "Power": 9800,
    "Hax": 9500,
    "Defence": 9500
  },
  "Goku Black (Rosé)": {
    "Captain": 9000,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 8000,
    "Form": 8500,
    "Speed": 8000,
    "IQ": 9000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 7500,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7000
  },
  "Goku Black": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 7500,
    "Form": 1000,
    "Speed": 7500,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 7000,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 6500
  },
  "Golden Frieza": {
    "Captain": 8900,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7500,
    "Form": 9000,
    "Speed": 9000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 7000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7000
  },
  "Gotenks (Base)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4500
  },
  "Gotenks (SSJ3)": {
    "Captain": 7000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 6000,
    "Speed": 7500,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 7000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6500
  },
  "Granolah": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 8000,
    "Form": 9000,
    "Speed": 9200,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9500,
    "Martial Arts": 7500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 7000
  },
  "Guldo": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 2000,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 1500,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 2000,
    "Energy Manipulation": 2000,
    "Martial Arts": 1500,
    "Power": 2000,
    "Hax": 6000,
    "Defence": 1500
  },
  "Hercule": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1000,
    "Healer": 1000,
    "Ki Control": 1000,
    "Technique": 2000,
    "Form": 1000,
    "Speed": 1000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 1000,
    "Energy Manipulation": 1000,
    "Martial Arts": 3000,
    "Power": 1000,
    "Hax": 2000,
    "Defence": 1000
  },
  "Hit": {
    "Captain": 8000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 9000,
    "Form": 1000,
    "Speed": 8500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 8500,
    "Power": 8000,
    "Hax": 9700,
    "Defence": 7000
  },
  "Janemba": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 8000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 6000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8000
  },
  "Jeice": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2500,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3000,
    "Martial Arts": 2500,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 2500
  },
  "Jiren (Full-Power)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9800,
    "Healer": 1000,
    "Ki Control": 9800,
    "Technique": 9700,
    "Form": 9500,
    "Speed": 9700,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 9800,
    "Energy Manipulation": 9800,
    "Martial Arts": 9700,
    "Power": 9800,
    "Hax": 9700,
    "Defence": 9800
  },
  "Jiren": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9700,
    "Technique": 9500,
    "Form": 9400,
    "Speed": 9500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9700,
    "Martial Arts": 9600,
    "Power": 9700,
    "Hax": 9500,
    "Defence": 9500
  },
  "Kale (Beserk)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 5000,
    "Form": 8000,
    "Speed": 7500,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 6000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 8000
  },
  "Kale": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 3500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4500
  },
  "Kefla": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7500,
    "Form": 8500,
    "Speed": 8500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 8000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7500
  },
  "Kid Buu": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 8500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 8200,
    "Energy Manipulation": 9000,
    "Martial Arts": 6500,
    "Power": 9000,
    "Hax": 8000,
    "Defence": 8500
  },
  "Kid Gohan": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3000,
    "Martial Arts": 3000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 2000
  },
  "Kid Goten (SSJ1)": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 2500,
    "Healer": 1000,
    "Ki Control": 3500,
    "Technique": 3000,
    "Form": 4000,
    "Speed": 3000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3500,
    "Energy Manipulation": 3500,
    "Martial Arts": 3500,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 2500
  },
  "Kid Goten": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 2000,
    "Technique": 1500,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 2500,
    "Sensei": 1000,
    "Power Level": 2000,
    "Energy Manipulation": 2000,
    "Martial Arts": 2500,
    "Power": 2000,
    "Hax": 1500,
    "Defence": 1500
  },
  "Kid Trunks (SSJ1)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 4500,
    "Technique": 4000,
    "Form": 5000,
    "Speed": 5500,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 4500,
    "Energy Manipulation": 4500,
    "Martial Arts": 4000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 3000
  },
  "Kid Trunks": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3000,
    "Martial Arts": 3000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 2000
  },
  "King-Cold": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 5000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500
  },
  "Krillin": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 3500,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 4000,
    "Energy Manipulation": 4000,
    "Martial Arts": 4500,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 2500
  },
  "Majin Buu (Super)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 9200,
    "Ki Control": 7000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 4000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 8000
  },
  "Majin Buu": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7500,
    "Healer": 9000,
    "Ki Control": 6500,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 3500,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 8000
  },
  "Majin Vegeta": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 6000,
    "Speed": 7500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 7500,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7000
  },
  "Master Roshi (Unleashed)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 8000,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 7000,
    "Sensei": 9999,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 9000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4000
  },
  "Master Roshi": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 8000,
    "Form": 1000,
    "Speed": 3000,
    "IQ": 6000,
    "Sensei": 7000,
    "Power Level": 4000,
    "Energy Manipulation": 4000,
    "Martial Arts": 9000,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 2000
  },
  "Meta-Cooler": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 6500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 5000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 7000
  },
  "Moro": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8500,
    "Healer": 6000,
    "Ki Control": 9500,
    "Technique": 8000,
    "Form": 9200,
    "Speed": 9000,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9500,
    "Energy Manipulation": 9500,
    "Martial Arts": 7000,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 8500
  },
  "Nappa": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 3500,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 4000,
    "Energy Manipulation": 4000,
    "Martial Arts": 3500,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 4000
  },
  "Omega Shenron": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7500,
    "Form": 1000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 7000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Orange Piccolo": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 7500,
    "Form": 8000,
    "Speed": 7800,
    "IQ": 8000,
    "Sensei": 7000,
    "Power Level": 9200,
    "Energy Manipulation": 9000,
    "Martial Arts": 7500,
    "Power": 9200,
    "Hax": 8500,
    "Defence": 9500
  },
  "Pan": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 2000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 2000,
    "Energy Manipulation": 2000,
    "Martial Arts": 2500,
    "Power": 2000,
    "Hax": 2500,
    "Defence": 1500
  },
  "Perfect Cell": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 6500,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 7000,
    "Speed": 7000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 7000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7000
  },
  "Piccolo": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 6500,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 7000,
    "Sensei": 6000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 6000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 6000
  },
  "Pui-Pui": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 1500,
    "Technique": 1000,
    "Form": 1000,
    "Speed": 1500,
    "IQ": 2000,
    "Sensei": 1000,
    "Power Level": 1500,
    "Energy Manipulation": 1500,
    "Martial Arts": 1500,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 1500
  },
  "Raditz": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 2500,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 2000,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3000,
    "Martial Arts": 2500,
    "Power": 3000,
    "Hax": 2000,
    "Defence": 2500
  },
  "Rage Shenron": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 6500,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 6500
  },
  "Recoome": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 2500,
    "Technique": 2000,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 2500,
    "Sensei": 1000,
    "Power Level": 2500,
    "Energy Manipulation": 2500,
    "Martial Arts": 3000,
    "Power": 2500,
    "Hax": 2000,
    "Defence": 3000
  },
  "Ribrianne": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Saibaman": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 1500,
    "Technique": 1000,
    "Form": 1000,
    "Speed": 1500,
    "IQ": 1000,
    "Sensei": 1000,
    "Power Level": 1500,
    "Energy Manipulation": 1500,
    "Martial Arts": 1500,
    "Power": 1500,
    "Hax": 2000,
    "Defence": 1500
  },
  "Super 17": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 7500,
    "Energy Manipulation": 7500,
    "Martial Arts": 5500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 7000
  },
  "Super Baby 2": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 6500,
    "Form": 8000,
    "Speed": 7000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 6500,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 7000
  },
  "Supreme Kai Shin": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 7000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 4500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5000
  },
  "Tien": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 4500,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 4500,
    "Energy Manipulation": 4500,
    "Martial Arts": 5000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 3000
  },
  "Toppo (Base)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 6000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6500
  },
  "Toppo (Destruction)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 7500,
    "Form": 8500,
    "Speed": 8500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 7000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Turles": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500
  },
  "UUB": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4500,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Vados": {
    "Captain": 9900,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Ki Control": 9999,
    "Technique": 9999,
    "Form": 9999,
    "Speed": 9999,
    "IQ": 9999,
    "Sensei": 9999,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Vegeta (Base)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5500,
    "Energy Manipulation": 6000,
    "Martial Arts": 6500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500
  },
  "Vegeta (EVO-SSJB)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9600,
    "Technique": 8800,
    "Form": 8800,
    "Speed": 9500,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9600,
    "Energy Manipulation": 9600,
    "Martial Arts": 9200,
    "Power": 9600,
    "Hax": 8800,
    "Defence": 9000
  },
  "Vegeta (Namek)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 3500,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 5000
  },
  "Vegeta (SSJ1)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 4000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 7000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6500
  },
  "Vegeta (SSJ2)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 5000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 8000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7000
  },
  "Vegeta (SSJ4)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 7500,
    "Form": 7000,
    "Speed": 8000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 8000,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 8000
  },
  "Vegeta (SSJB)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 8500,
    "Form": 8000,
    "Speed": 9500,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9500,
    "Martial Arts": 9000,
    "Power": 9500,
    "Hax": 8500,
    "Defence": 9000
  },
  "Vegeta (Ultra-Ego)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 9700,
    "Technique": 9000,
    "Form": 9200,
    "Speed": 9600,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9700,
    "Energy Manipulation": 9700,
    "Martial Arts": 9200,
    "Power": 9800,
    "Hax": 9200,
    "Defence": 9500
  },
  "Vegito (Base)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7500,
    "Form": 6000,
    "Speed": 8000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 9000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8500
  },
  "Vegito (SSJ1)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 8500,
    "Form": 4000,
    "Speed": 8500,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 9000,
    "Energy Manipulation": 9000,
    "Martial Arts": 8500,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8000
  },
  "Vegito (SSJB)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9000,
    "Healer": 1000,
    "Ki Control": 9800,
    "Technique": 9500,
    "Form": 9000,
    "Speed": 9700,
    "IQ": 9500,
    "Sensei": 1000,
    "Power Level": 9800,
    "Energy Manipulation": 9800,
    "Martial Arts": 9500,
    "Power": 9800,
    "Hax": 9500,
    "Defence": 9000
  },
  "Videl": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 1000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 4000,
    "Sensei": 1000,
    "Power Level": 1000,
    "Energy Manipulation": 1000,
    "Martial Arts": 3000,
    "Power": 1000,
    "Hax": 2500,
    "Defence": 1500
  },
  "Whis": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Ki Control": 9999,
    "Technique": 9999,
    "Form": 9999,
    "Speed": 9999,
    "IQ": 9999,
    "Sensei": 9999,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Yamcha": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2000,
    "Healer": 1000,
    "Ki Control": 2500,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 2500,
    "Energy Manipulation": 2500,
    "Martial Arts": 3500,
    "Power": 2500,
    "Hax": 3000,
    "Defence": 2000
  },
  "Zamasu": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 7500,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 8000,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 6500,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 6500
  },
  "Adult Charmy": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8200,
    "Healer": 9200,
    "Magic Power": 8800,
    "Grimoire Skill": 8500,
    "Combat Skill": 7800,
    "Mana Control": 8600,
    "Speed": 7200,
    "Squad Synergy": 8200,
    "Transformation": 9000,
    "Experience": 8500,
    "Willpower": 8400,
    "Power": 8800,
    "Hax": 9000,
    "Defence": 8200,
    "IQ": 7600
  },
  "Asta (1st Transformation)": {
    "Captain": 4200,
    "Vice Captain": 3800,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 7500,
    "Healer": 1000,
    "Magic Power": 1000,
    "Grimoire Skill": 6800,
    "Combat Skill": 7200,
    "Mana Control": 1000,
    "Speed": 7800,
    "Squad Synergy": 6500,
    "Transformation": 7200,
    "Experience": 4800,
    "Willpower": 9999,
    "Power": 6500,
    "Hax": 7200,
    "Defence": 7500,
    "IQ": 5200
  },
  "Asta (Base)": {
    "Captain": 3200,
    "Vice Captain": 3800,
    "Support 1": 2800,
    "Support 2": 2800,
    "Tank": 7500,
    "Healer": 1000,
    "Magic Power": 1000,
    "Grimoire Skill": 5800,
    "Combat Skill": 6500,
    "Mana Control": 1000,
    "Speed": 6800,
    "Squad Synergy": 6000,
    "Transformation": 4200,
    "Experience": 4800,
    "Willpower": 8200,
    "Power": 5800,
    "Hax": 5000,
    "Defence": 6500,
    "IQ": 5200
  },
  "Asta (Devil Union)": {
    "Captain": 9000,
    "Vice Captain": 7200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9200,
    "Healer": 5200,
    "Magic Power": 1000,
    "Grimoire Skill": 8800,
    "Combat Skill": 9400,
    "Mana Control": 8200,
    "Speed": 9500,
    "Squad Synergy": 7800,
    "Transformation": 9800,
    "Experience": 7800,
    "Willpower": 9900,
    "Power": 9300,
    "Hax": 9800,
    "Defence": 9200,
    "IQ": 7200
  },
  "Asta (Timeskip)": {
    "Captain": 5200,
    "Vice Captain": 5800,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8500,
    "Healer": 1000,
    "Magic Power": 1000,
    "Grimoire Skill": 7800,
    "Combat Skill": 8200,
    "Mana Control": 1000,
    "Speed": 8800,
    "Squad Synergy": 7200,
    "Transformation": 8500,
    "Experience": 8000,
    "Willpower": 9200,
    "Power": 7200,
    "Hax": 8500,
    "Defence": 8500,
    "IQ": 6500
  },
  "Charlotte Roselei": {
    "Captain": 8200,
    "Vice Captain": 7800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6800,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7500,
    "Combat Skill": 7200,
    "Mana Control": 7600,
    "Speed": 7000,
    "Squad Synergy": 7800,
    "Transformation": 8000,
    "Experience": 7800,
    "Willpower": 8200,
    "Power": 7800,
    "Hax": 8000,
    "Defence": 6800,
    "IQ": 7500
  },
  "Damnatio Kira": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 8200,
    "Grimoire Skill": 8000,
    "Combat Skill": 6800,
    "Mana Control": 8500,
    "Speed": 6500,
    "Squad Synergy": 7200,
    "Transformation": 7200,
    "Experience": 8500,
    "Willpower": 7800,
    "Power": 8200,
    "Hax": 8500,
    "Defence": 7200,
    "IQ": 8800
  },
  "Dante Zogratis (Devil Form)": {
    "Captain": 8999,
    "Vice Captain": 7800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9800,
    "Healer": 1000,
    "Magic Power": 9800,
    "Grimoire Skill": 9200,
    "Combat Skill": 8800,
    "Mana Control": 9500,
    "Speed": 8200,
    "Squad Synergy": 6800,
    "Transformation": 9800,
    "Experience": 8500,
    "Willpower": 9200,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 9500,
    "IQ": 7800
  },
  "Dante Zogratis": {
    "Captain": 8900,
    "Vice Captain": 7800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8800,
    "Healer": 1000,
    "Magic Power": 9200,
    "Grimoire Skill": 8500,
    "Combat Skill": 8200,
    "Mana Control": 8800,
    "Speed": 7500,
    "Squad Synergy": 6200,
    "Transformation": 8500,
    "Experience": 8500,
    "Willpower": 8500,
    "Power": 9200,
    "Hax": 8500,
    "Defence": 8800,
    "IQ": 7800
  },
  "Dark Elf Patry": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 6800,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 8200,
    "Mana Control": 9000,
    "Speed": 9500,
    "Squad Synergy": 7200,
    "Transformation": 9500,
    "Experience": 8200,
    "Willpower": 8800,
    "Power": 9200,
    "Hax": 9500,
    "Defence": 7800,
    "IQ": 7800
  },
  "Devil Form (Liebe)": {
    "Captain": 6800,
    "Vice Captain": 7200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9200,
    "Healer": 1000,
    "Magic Power": 1000,
    "Grimoire Skill": 8800,
    "Combat Skill": 8500,
    "Mana Control": 1000,
    "Speed": 8800,
    "Squad Synergy": 6500,
    "Transformation": 9800,
    "Experience": 8500,
    "Willpower": 9500,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 9200,
    "IQ": 7200
  },
  "Dorothy Unsworth": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 7800,
    "Healer": 7200,
    "Magic Power": 9000,
    "Grimoire Skill": 9200,
    "Combat Skill": 6800,
    "Mana Control": 8800,
    "Speed": 6500,
    "Squad Synergy": 8200,
    "Transformation": 8500,
    "Experience": 8200,
    "Willpower": 8000,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 7800,
    "IQ": 8500
  },
  "Fana": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7500,
    "Healer": 7800,
    "Magic Power": 8800,
    "Grimoire Skill": 8200,
    "Combat Skill": 7800,
    "Mana Control": 8500,
    "Speed": 7200,
    "Squad Synergy": 6500,
    "Transformation": 8800,
    "Experience": 7500,
    "Willpower": 8200,
    "Power": 8800,
    "Hax": 8800,
    "Defence": 7500,
    "IQ": 6800
  },
  "Finral": {
    "Captain": 4200,
    "Vice Captain": 5800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5800,
    "Healer": 1000,
    "Magic Power": 6800,
    "Grimoire Skill": 7800,
    "Combat Skill": 5200,
    "Mana Control": 7500,
    "Speed": 8200,
    "Squad Synergy": 8800,
    "Transformation": 4800,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 6800,
    "Hax": 8200,
    "Defence": 5800,
    "IQ": 7200
  },
  "Fuegoleon Vermillion (Salamander)": {
    "Captain": 9200,
    "Vice Captain": 8800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8200,
    "Healer": 1000,
    "Magic Power": 9500,
    "Grimoire Skill": 9000,
    "Combat Skill": 8500,
    "Mana Control": 9200,
    "Speed": 8200,
    "Squad Synergy": 9000,
    "Transformation": 9200,
    "Experience": 8500,
    "Willpower": 9200,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 8200,
    "IQ": 8800
  },
  "Fuegoleon Vermillion": {
    "Captain": 8800,
    "Vice Captain": 8400,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 8000,
    "Mana Control": 8500,
    "Speed": 7200,
    "Squad Synergy": 8500,
    "Transformation": 7800,
    "Experience": 8200,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 8200,
    "Defence": 7800,
    "IQ": 8200
  },
  "Fused Lilith and Naamah": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9500,
    "Healer": 7200,
    "Magic Power": 9800,
    "Grimoire Skill": 9500,
    "Combat Skill": 9000,
    "Mana Control": 9800,
    "Speed": 8800,
    "Squad Synergy": 6800,
    "Transformation": 9900,
    "Experience": 9200,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9900,
    "Defence": 9500,
    "IQ": 8200
  },
  "Gadjah": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 7800,
    "Healer": 1000,
    "Magic Power": 9000,
    "Grimoire Skill": 8500,
    "Combat Skill": 8000,
    "Mana Control": 8800,
    "Speed": 8200,
    "Squad Synergy": 7200,
    "Transformation": 8500,
    "Experience": 8800,
    "Willpower": 8500,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 7800,
    "IQ": 7800
  },
  "Gauche Adlai": {
    "Captain": 3800,
    "Vice Captain": 4200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 7500,
    "Combat Skill": 6800,
    "Mana Control": 7000,
    "Speed": 6500,
    "Squad Synergy": 6200,
    "Transformation": 5800,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 6500,
    "IQ": 6800
  },
  "Gordon Agrippa": {
    "Captain": 3200,
    "Vice Captain": 3800,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 6200,
    "Healer": 7200,
    "Magic Power": 7000,
    "Grimoire Skill": 6800,
    "Combat Skill": 5800,
    "Mana Control": 6500,
    "Speed": 5500,
    "Squad Synergy": 5800,
    "Transformation": 5200,
    "Experience": 6000,
    "Willpower": 7200,
    "Power": 7000,
    "Hax": 5200,
    "Defence": 6200,
    "IQ": 6200
  },
  "Grey": {
    "Captain": 2800,
    "Vice Captain": 3200,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 5800,
    "Healer": 7800,
    "Magic Power": 6800,
    "Grimoire Skill": 7200,
    "Combat Skill": 5200,
    "Mana Control": 7500,
    "Speed": 5800,
    "Squad Synergy": 7200,
    "Transformation": 6200,
    "Experience": 5800,
    "Willpower": 7500,
    "Power": 6800,
    "Hax": 6200,
    "Defence": 5800,
    "IQ": 6500
  },
  "Gueldre Poizot": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 6800,
    "Grimoire Skill": 6500,
    "Combat Skill": 6200,
    "Mana Control": 6000,
    "Speed": 5800,
    "Squad Synergy": 5200,
    "Transformation": 5800,
    "Experience": 6500,
    "Willpower": 4800,
    "Power": 6800,
    "Hax": 5800,
    "Defence": 7200,
    "IQ": 5500
  },
  "Heath Grice": {
    "Captain": 3800,
    "Vice Captain": 4200,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 6200,
    "Healer": 1000,
    "Magic Power": 6500,
    "Grimoire Skill": 6000,
    "Combat Skill": 5800,
    "Mana Control": 5500,
    "Speed": 5200,
    "Squad Synergy": 4500,
    "Transformation": 5200,
    "Experience": 5500,
    "Willpower": 5200,
    "Power": 6500,
    "Hax": 5200,
    "Defence": 6200,
    "IQ": 4800
  },
  "Hell Lotus": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 8500,
    "Healer": 4800,
    "Magic Power": 8800,
    "Grimoire Skill": 8200,
    "Combat Skill": 7800,
    "Mana Control": 8500,
    "Speed": 7500,
    "Squad Synergy": 5800,
    "Transformation": 7000,
    "Experience": 7800,
    "Willpower": 8500,
    "Power": 8800,
    "Hax": 7000,
    "Defence": 8500,
    "IQ": 7200
  },
  "Henry Legolant": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8200,
    "Healer": 1000,
    "Magic Power": 7500,
    "Grimoire Skill": 7200,
    "Combat Skill": 5800,
    "Mana Control": 6800,
    "Speed": 4800,
    "Squad Synergy": 7200,
    "Transformation": 6200,
    "Experience": 6200,
    "Willpower": 7800,
    "Power": 7500,
    "Hax": 6200,
    "Defence": 8200,
    "IQ": 6500
  },
  "Jack the Ripper": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 8200,
    "Grimoire Skill": 7800,
    "Combat Skill": 8500,
    "Mana Control": 7500,
    "Speed": 7800,
    "Squad Synergy": 7500,
    "Transformation": 7800,
    "Experience": 8200,
    "Willpower": 8500,
    "Power": 8200,
    "Hax": 8600,
    "Defence": 7200,
    "IQ": 7200
  },
  "Julius Novachrono": {
    "Captain": 9900,
    "Vice Captain": 9500,
    "Support 1": 9200,
    "Support 2": 9200,
    "Tank": 8500,
    "Healer": 8200,
    "Magic Power": 9900,
    "Grimoire Skill": 9800,
    "Combat Skill": 9500,
    "Mana Control": 9900,
    "Speed": 9500,
    "Squad Synergy": 9500,
    "Transformation": 9200,
    "Experience": 9800,
    "Willpower": 9500,
    "Power": 9900,
    "Hax": 9999,
    "Defence": 8500,
    "IQ": 9800
  },
  "Kahono": {
    "Captain": 3200,
    "Vice Captain": 3800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 5800,
    "Healer": 7500,
    "Magic Power": 6500,
    "Grimoire Skill": 6800,
    "Combat Skill": 6200,
    "Mana Control": 7000,
    "Speed": 6500,
    "Squad Synergy": 6800,
    "Transformation": 5200,
    "Experience": 5200,
    "Willpower": 6800,
    "Power": 6500,
    "Hax": 5200,
    "Defence": 5800,
    "IQ": 6000
  },
  "Kaiser Granvorka": {
    "Captain": 8200,
    "Vice Captain": 7800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8500,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7500,
    "Combat Skill": 7200,
    "Mana Control": 7800,
    "Speed": 6800,
    "Squad Synergy": 7800,
    "Transformation": 7200,
    "Experience": 8500,
    "Willpower": 7800,
    "Power": 7800,
    "Hax": 7200,
    "Defence": 8500,
    "IQ": 7500
  },
  "Kiato": {
    "Captain": 3800,
    "Vice Captain": 4200,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 5800,
    "Healer": 1000,
    "Magic Power": 6500,
    "Grimoire Skill": 6800,
    "Combat Skill": 7200,
    "Mana Control": 6200,
    "Speed": 7500,
    "Squad Synergy": 6500,
    "Transformation": 5800,
    "Experience": 5500,
    "Willpower": 6800,
    "Power": 6500,
    "Hax": 5800,
    "Defence": 5800,
    "IQ": 5800
  },
  "Kid Charmy": {
    "Captain": 2800,
    "Vice Captain": 3200,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 6200,
    "Healer": 6500,
    "Magic Power": 6800,
    "Grimoire Skill": 6200,
    "Combat Skill": 5800,
    "Mana Control": 6000,
    "Speed": 5500,
    "Squad Synergy": 5800,
    "Transformation": 4800,
    "Experience": 4800,
    "Willpower": 6500,
    "Power": 6800,
    "Hax": 4800,
    "Defence": 6200,
    "IQ": 5200
  },
  "Kirsch Vermillion": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7500,
    "Combat Skill": 6800,
    "Mana Control": 7200,
    "Speed": 7000,
    "Squad Synergy": 7200,
    "Transformation": 6800,
    "Experience": 6500,
    "Willpower": 6800,
    "Power": 7800,
    "Hax": 6800,
    "Defence": 6500,
    "IQ": 7500
  },
  "Klaus Lunettes": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 7000,
    "Combat Skill": 6500,
    "Mana Control": 6800,
    "Speed": 6200,
    "Squad Synergy": 7200,
    "Transformation": 5800,
    "Experience": 6200,
    "Willpower": 6800,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 6500,
    "IQ": 7500
  },
  "Ladros": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 6800,
    "Combat Skill": 7000,
    "Mana Control": 6500,
    "Speed": 6800,
    "Squad Synergy": 5200,
    "Transformation": 7200,
    "Experience": 6200,
    "Willpower": 6500,
    "Power": 7800,
    "Hax": 7200,
    "Defence": 7200,
    "IQ": 5800
  },
  "Langris Vaude": {
    "Captain": 6800,
    "Vice Captain": 8500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6800,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 7200,
    "Mana Control": 8000,
    "Speed": 7800,
    "Squad Synergy": 6800,
    "Transformation": 7200,
    "Experience": 7200,
    "Willpower": 7800,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 6800,
    "IQ": 7500
  },
  "Leopold Vermillion (Base)": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 6800,
    "Combat Skill": 7000,
    "Mana Control": 6500,
    "Speed": 7200,
    "Squad Synergy": 6800,
    "Transformation": 5800,
    "Experience": 5800,
    "Willpower": 7500,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 6500,
    "IQ": 6200
  },
  "Leopold Vermillion (Timeskip)": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7500,
    "Combat Skill": 7800,
    "Mana Control": 7200,
    "Speed": 7800,
    "Squad Synergy": 7200,
    "Transformation": 8200,
    "Experience": 6500,
    "Willpower": 8200,
    "Power": 7800,
    "Hax": 8200,
    "Defence": 7200,
    "IQ": 6800
  },
  "Licht": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8200,
    "Healer": 7800,
    "Magic Power": 9500,
    "Grimoire Skill": 9200,
    "Combat Skill": 8800,
    "Mana Control": 9500,
    "Speed": 9400,
    "Squad Synergy": 8200,
    "Transformation": 9200,
    "Experience": 9200,
    "Willpower": 9000,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 8200,
    "IQ": 8800
  },
  "Lolopechka (Clumsy)": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7200,
    "Healer": 8500,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 6500,
    "Mana Control": 8500,
    "Speed": 6800,
    "Squad Synergy": 7200,
    "Transformation": 7800,
    "Experience": 7500,
    "Willpower": 7800,
    "Power": 8500,
    "Hax": 7800,
    "Defence": 7200,
    "IQ": 7800
  },
  "Lolopechka (Undine)": {
    "Captain": 9200,
    "Vice Captain": 8800,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 8200,
    "Healer": 9800,
    "Magic Power": 9800,
    "Grimoire Skill": 9500,
    "Combat Skill": 7200,
    "Mana Control": 9800,
    "Speed": 7800,
    "Squad Synergy": 8800,
    "Transformation": 9500,
    "Experience": 8500,
    "Willpower": 9200,
    "Power": 9800,
    "Hax": 9500,
    "Defence": 8200,
    "IQ": 9200
  },
  "Luck Voltia (Lightning Battle God Magic)": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 8500,
    "Mana Control": 7800,
    "Speed": 9200,
    "Squad Synergy": 7500,
    "Transformation": 8800,
    "Experience": 7200,
    "Willpower": 8200,
    "Power": 8500,
    "Hax": 8800,
    "Defence": 7600,
    "IQ": 7200
  },
  "Luck Voltia": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6000,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7500,
    "Combat Skill": 7800,
    "Mana Control": 7200,
    "Speed": 8500,
    "Squad Synergy": 7000,
    "Transformation": 6800,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 7800,
    "Hax": 7200,
    "Defence": 6800,
    "IQ": 6500
  },
  "Magna Swing (Base)": {
    "Captain": 3800,
    "Vice Captain": 4200,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 6200,
    "Grimoire Skill": 6500,
    "Combat Skill": 7200,
    "Mana Control": 5800,
    "Speed": 6800,
    "Squad Synergy": 6500,
    "Transformation": 5200,
    "Experience": 5500,
    "Willpower": 7800,
    "Power": 6200,
    "Hax": 5200,
    "Defence": 6500,
    "IQ": 5800
  },
  "Magna Swing (Timeskip)": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 6800,
    "Grimoire Skill": 7200,
    "Combat Skill": 7800,
    "Mana Control": 6500,
    "Speed": 7500,
    "Squad Synergy": 7200,
    "Transformation": 6800,
    "Experience": 6200,
    "Willpower": 8500,
    "Power": 6800,
    "Hax": 6800,
    "Defence": 7200,
    "IQ": 6500
  },
  "Mars": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7800,
    "Healer": 5200,
    "Magic Power": 7200,
    "Grimoire Skill": 6800,
    "Combat Skill": 7500,
    "Mana Control": 6500,
    "Speed": 7000,
    "Squad Synergy": 5800,
    "Transformation": 7200,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 7200,
    "Hax": 7200,
    "Defence": 7800,
    "IQ": 6200
  },
  "Marx Francois": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 5800,
    "Healer": 6500,
    "Magic Power": 7200,
    "Grimoire Skill": 7500,
    "Combat Skill": 5200,
    "Mana Control": 7800,
    "Speed": 6500,
    "Squad Synergy": 7800,
    "Transformation": 6800,
    "Experience": 7200,
    "Willpower": 6800,
    "Power": 7200,
    "Hax": 6800,
    "Defence": 5800,
    "IQ": 8200
  },
  "Megicula": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 9200,
    "Support 2": 9200,
    "Tank": 8800,
    "Healer": 9500,
    "Magic Power": 9800,
    "Grimoire Skill": 9500,
    "Combat Skill": 8500,
    "Mana Control": 9800,
    "Speed": 8200,
    "Squad Synergy": 7800,
    "Transformation": 9800,
    "Experience": 9500,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 8800,
    "IQ": 9200
  },
  "Mereoleona Vermillion": {
    "Captain": 9500,
    "Vice Captain": 9200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8800,
    "Healer": 1000,
    "Magic Power": 9500,
    "Grimoire Skill": 9200,
    "Combat Skill": 9500,
    "Mana Control": 9999,
    "Speed": 9200,
    "Squad Synergy": 8500,
    "Transformation": 9500,
    "Experience": 9200,
    "Willpower": 9800,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8800,
    "IQ": 8200
  },
  "Mimosa Vermillion": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5800,
    "Healer": 8800,
    "Magic Power": 8200,
    "Grimoire Skill": 7800,
    "Combat Skill": 6200,
    "Mana Control": 8000,
    "Speed": 6800,
    "Squad Synergy": 8200,
    "Transformation": 7200,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 8200,
    "Hax": 8200,
    "Defence": 5800,
    "IQ": 7500
  },
  "Nacht Faust (Devil)": {
    "Captain": 7200,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7800,
    "Healer": 1000,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 8500,
    "Mana Control": 9000,
    "Speed": 9200,
    "Squad Synergy": 8500,
    "Transformation": 9500,
    "Experience": 7800,
    "Willpower": 8800,
    "Power": 9200,
    "Hax": 9500,
    "Defence": 7800,
    "IQ": 8200
  },
  "Nacht Faust": {
    "Captain": 7200,
    "Vice Captain": 8500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7200,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 8000,
    "Mana Control": 8500,
    "Speed": 8500,
    "Squad Synergy": 7800,
    "Transformation": 8200,
    "Experience": 7800,
    "Willpower": 8200,
    "Power": 8500,
    "Hax": 8200,
    "Defence": 7200,
    "IQ": 8200
  },
  "Nebra Silva": {
    "Captain": 5200,
    "Vice Captain": 5800,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 6200,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 6800,
    "Combat Skill": 6500,
    "Mana Control": 7000,
    "Speed": 6500,
    "Squad Synergy": 6200,
    "Transformation": 6200,
    "Experience": 6200,
    "Willpower": 5800,
    "Power": 7200,
    "Hax": 6200,
    "Defence": 6200,
    "IQ": 6800
  },
  "Nero": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5800,
    "Healer": 6500,
    "Magic Power": 7500,
    "Grimoire Skill": 8200,
    "Combat Skill": 5200,
    "Mana Control": 7800,
    "Speed": 7200,
    "Squad Synergy": 7200,
    "Transformation": 8200,
    "Experience": 8800,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 9000,
    "Defence": 5800,
    "IQ": 8500
  },
  "Noelle Silva (Base)": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5500,
    "Healer": 1000,
    "Magic Power": 7800,
    "Grimoire Skill": 7200,
    "Combat Skill": 6800,
    "Mana Control": 6500,
    "Speed": 7000,
    "Squad Synergy": 6800,
    "Transformation": 5800,
    "Experience": 5500,
    "Willpower": 7800,
    "Power": 7800,
    "Hax": 5800,
    "Defence": 7200,
    "IQ": 6500
  },
  "Noelle Silva (Valkyrie Dress)": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8500,
    "Healer": 1000,
    "Magic Power": 8800,
    "Grimoire Skill": 8500,
    "Combat Skill": 8200,
    "Mana Control": 8000,
    "Speed": 8600,
    "Squad Synergy": 7800,
    "Transformation": 8800,
    "Experience": 5500,
    "Willpower": 8800,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 8500,
    "IQ": 7200
  },
  "Nozel Silva (Mercury Magic)": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8200,
    "Healer": 1000,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 7800,
    "Mana Control": 9200,
    "Speed": 8400,
    "Squad Synergy": 8200,
    "Transformation": 8800,
    "Experience": 7800,
    "Willpower": 8500,
    "Power": 9200,
    "Hax": 9000,
    "Defence": 8200,
    "IQ": 8000
  },
  "Nozel Silva": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 8200,
    "Combat Skill": 7500,
    "Mana Control": 8500,
    "Speed": 7800,
    "Squad Synergy": 7800,
    "Transformation": 7800,
    "Experience": 7800,
    "Willpower": 8200,
    "Power": 8500,
    "Hax": 7800,
    "Defence": 7800,
    "IQ": 8000
  },
  "Patolli": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7500,
    "Healer": 6800,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 8200,
    "Mana Control": 9000,
    "Speed": 9300,
    "Squad Synergy": 7200,
    "Transformation": 9200,
    "Experience": 8800,
    "Willpower": 9000,
    "Power": 9200,
    "Hax": 9200,
    "Defence": 7500,
    "IQ": 8500
  },
  "Rades Spirito": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 6800,
    "Healer": 5800,
    "Magic Power": 7500,
    "Grimoire Skill": 7200,
    "Combat Skill": 6500,
    "Mana Control": 7000,
    "Speed": 6200,
    "Squad Synergy": 5800,
    "Transformation": 6500,
    "Experience": 6500,
    "Willpower": 7200,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 6800,
    "IQ": 6800
  },
  "Rhya": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7200,
    "Healer": 6500,
    "Magic Power": 9200,
    "Grimoire Skill": 9500,
    "Combat Skill": 7800,
    "Mana Control": 8800,
    "Speed": 7800,
    "Squad Synergy": 6800,
    "Transformation": 8800,
    "Experience": 8500,
    "Willpower": 8500,
    "Power": 9200,
    "Hax": 9300,
    "Defence": 7200,
    "IQ": 8200
  },
  "Rill Boismortier": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 7200,
    "Healer": 6800,
    "Magic Power": 9200,
    "Grimoire Skill": 9500,
    "Combat Skill": 6800,
    "Mana Control": 8800,
    "Speed": 7200,
    "Squad Synergy": 8200,
    "Transformation": 8500,
    "Experience": 7200,
    "Willpower": 8200,
    "Power": 9200,
    "Hax": 9000,
    "Defence": 7200,
    "IQ": 7800
  },
  "Sally": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 5800,
    "Healer": 5200,
    "Magic Power": 6500,
    "Grimoire Skill": 7200,
    "Combat Skill": 5200,
    "Mana Control": 6200,
    "Speed": 5500,
    "Squad Synergy": 5800,
    "Transformation": 5800,
    "Experience": 5800,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 5800,
    "Defence": 5800,
    "IQ": 7800
  },
  "Sekke Bronzazza": {
    "Captain": 2800,
    "Vice Captain": 3200,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 5200,
    "Healer": 1000,
    "Magic Power": 4500,
    "Grimoire Skill": 4200,
    "Combat Skill": 3800,
    "Mana Control": 4000,
    "Speed": 3500,
    "Squad Synergy": 3800,
    "Transformation": 3200,
    "Experience": 4200,
    "Willpower": 2800,
    "Power": 4500,
    "Hax": 3200,
    "Defence": 5200,
    "IQ": 3200
  },
  "Sister Lily": {
    "Captain": 3800,
    "Vice Captain": 4200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 4800,
    "Healer": 7800,
    "Magic Power": 5800,
    "Grimoire Skill": 6200,
    "Combat Skill": 3800,
    "Mana Control": 6500,
    "Speed": 4200,
    "Squad Synergy": 7200,
    "Transformation": 4800,
    "Experience": 5200,
    "Willpower": 7500,
    "Power": 5800,
    "Hax": 4800,
    "Defence": 4800,
    "IQ": 6800
  },
  "Sol Marron": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 6800,
    "Grimoire Skill": 6500,
    "Combat Skill": 6200,
    "Mana Control": 6000,
    "Speed": 5800,
    "Squad Synergy": 5800,
    "Transformation": 5200,
    "Experience": 5800,
    "Willpower": 6200,
    "Power": 6800,
    "Hax": 5200,
    "Defence": 6500,
    "IQ": 5500
  },
  "Solid Silva": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6500,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 6800,
    "Combat Skill": 6500,
    "Mana Control": 6800,
    "Speed": 6200,
    "Squad Synergy": 6000,
    "Transformation": 5800,
    "Experience": 5800,
    "Willpower": 5500,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 6500,
    "IQ": 5800
  },
  "Valtos": {
    "Captain": 4200,
    "Vice Captain": 4800,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 5800,
    "Healer": 1000,
    "Magic Power": 6800,
    "Grimoire Skill": 6500,
    "Combat Skill": 6200,
    "Mana Control": 6200,
    "Speed": 7800,
    "Squad Synergy": 5200,
    "Transformation": 5800,
    "Experience": 6200,
    "Willpower": 5200,
    "Power": 6800,
    "Hax": 5800,
    "Defence": 5800,
    "IQ": 5800
  },
  "Vanessa Enoteca": {
    "Captain": 4800,
    "Vice Captain": 5200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5800,
    "Healer": 6500,
    "Magic Power": 7200,
    "Grimoire Skill": 7800,
    "Combat Skill": 6200,
    "Mana Control": 7500,
    "Speed": 6800,
    "Squad Synergy": 7800,
    "Transformation": 6800,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 7200,
    "Hax": 9200,
    "Defence": 5800,
    "IQ": 7200
  },
  "Vanica Zogratis (Devil Form)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 8200,
    "Healer": 4000,
    "Magic Power": 9500,
    "Grimoire Skill": 9000,
    "Combat Skill": 8500,
    "Mana Control": 9200,
    "Speed": 8500,
    "Squad Synergy": 6800,
    "Transformation": 9500,
    "Experience": 8200,
    "Willpower": 9000,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 8200,
    "IQ": 7500
  },
  "Vanica Zogratis": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7500,
    "Healer": 8500,
    "Magic Power": 8800,
    "Grimoire Skill": 8200,
    "Combat Skill": 7800,
    "Mana Control": 8500,
    "Speed": 7800,
    "Squad Synergy": 6200,
    "Transformation": 8200,
    "Experience": 8200,
    "Willpower": 8500,
    "Power": 8800,
    "Hax": 8200,
    "Defence": 7500,
    "IQ": 7500
  },
  "Vetto": {
    "Captain": 6800,
    "Vice Captain": 7200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8800,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 7800,
    "Combat Skill": 8500,
    "Mana Control": 7800,
    "Speed": 7800,
    "Squad Synergy": 6500,
    "Transformation": 8500,
    "Experience": 7800,
    "Willpower": 8200,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8800,
    "IQ": 6800
  },
  "William Vangeance": {
    "Captain": 9200,
    "Vice Captain": 8800,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 7800,
    "Healer": 8500,
    "Magic Power": 9500,
    "Grimoire Skill": 9200,
    "Combat Skill": 7800,
    "Mana Control": 9200,
    "Speed": 7800,
    "Squad Synergy": 9000,
    "Transformation": 8800,
    "Experience": 8500,
    "Willpower": 8800,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 7800,
    "IQ": 8500
  },
  "Witch Queen": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 8500,
    "Healer": 9999,
    "Magic Power": 9800,
    "Grimoire Skill": 9500,
    "Combat Skill": 7200,
    "Mana Control": 9900,
    "Speed": 7800,
    "Squad Synergy": 7800,
    "Transformation": 9200,
    "Experience": 9800,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9600,
    "Defence": 8500,
    "IQ": 9500
  },
  "Yami": {
    "Captain": 9500,
    "Vice Captain": 9200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8800,
    "Healer": 1000,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 9500,
    "Mana Control": 8500,
    "Speed": 8800,
    "Squad Synergy": 8800,
    "Transformation": 8800,
    "Experience": 9200,
    "Willpower": 9800,
    "Power": 9400,
    "Hax": 9500,
    "Defence": 8800,
    "IQ": 8200
  },
  "Yuno (Base)": {
    "Captain": 5800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6800,
    "Healer": 1000,
    "Magic Power": 8500,
    "Grimoire Skill": 7800,
    "Combat Skill": 7200,
    "Mana Control": 8200,
    "Speed": 7800,
    "Squad Synergy": 7200,
    "Transformation": 6800,
    "Experience": 6200,
    "Willpower": 8200,
    "Power": 8500,
    "Hax": 7200,
    "Defence": 6800,
    "IQ": 7500
  },
  "Yuno (Spirit of Boreas)": {
    "Captain": 6800,
    "Vice Captain": 7200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 5800,
    "Magic Power": 9200,
    "Grimoire Skill": 8800,
    "Combat Skill": 8200,
    "Mana Control": 9000,
    "Speed": 9300,
    "Squad Synergy": 7800,
    "Transformation": 8800,
    "Experience": 6800,
    "Willpower": 8500,
    "Power": 9600,
    "Hax": 9500,
    "Defence": 8600,
    "IQ": 8200
  },
  "Yuno (Spirit of Zephyr)": {
    "Captain": 7800,
    "Vice Captain": 8200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8500,
    "Healer": 1000,
    "Magic Power": 9500,
    "Grimoire Skill": 9200,
    "Combat Skill": 8800,
    "Mana Control": 9500,
    "Speed": 9200,
    "Squad Synergy": 8200,
    "Transformation": 9500,
    "Experience": 7200,
    "Willpower": 8800,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8500,
    "IQ": 8200
  },
  "Zagred": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 8500,
    "Healer": 7800,
    "Magic Power": 9800,
    "Grimoire Skill": 9500,
    "Combat Skill": 8200,
    "Mana Control": 9800,
    "Speed": 8500,
    "Squad Synergy": 7200,
    "Transformation": 9800,
    "Experience": 9500,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 8500,
    "IQ": 9200
  },
  "Zenon Zogratis (Devil Form)": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Healer": 1000,
    "Magic Power": 9800,
    "Grimoire Skill": 9200,
    "Combat Skill": 8500,
    "Mana Control": 9800,
    "Speed": 8800,
    "Squad Synergy": 6800,
    "Transformation": 9800,
    "Experience": 8200,
    "Willpower": 9200,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 8800,
    "IQ": 7800
  },
  "Zenon Zogratis": {
    "Captain": 7800,
    "Vice Captain": 9000,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8200,
    "Healer": 1000,
    "Magic Power": 9600,
    "Grimoire Skill": 8500,
    "Combat Skill": 7800,
    "Mana Control": 8800,
    "Speed": 8200,
    "Squad Synergy": 6200,
    "Transformation": 8500,
    "Experience": 8200,
    "Willpower": 8500,
    "Power": 9200,
    "Hax": 8500,
    "Defence": 8200,
    "IQ": 7800
  },
  "Zora Ideale": {
    "Captain": 5200,
    "Vice Captain": 5800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 6800,
    "Healer": 1000,
    "Magic Power": 7200,
    "Grimoire Skill": 8500,
    "Combat Skill": 7200,
    "Mana Control": 7800,
    "Speed": 6800,
    "Squad Synergy": 7200,
    "Transformation": 6500,
    "Experience": 6500,
    "Willpower": 7800,
    "Power": 7200,
    "Hax": 8200,
    "Defence": 6800,
    "IQ": 8200
  },
  "All For One": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Quirk Power": 9999,
    "Quirk Control": 9500,
    "Quirk Versatility": 9800,
    "Combat Skill": 9200,
    "Speed": 9500,
    "Resolve": 9800,
    "Teamwork": 6000,
    "Mentor": 8500,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9000,
    "IQ": 9500
  },
  "All Might (True Hero Form)": {
    "Captain": 9800,
    "Vice Captain": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9700,
    "Healer": 1000,
    "Quirk Power": 9900,
    "Quirk Control": 9500,
    "Quirk Versatility": 8500,
    "Combat Skill": 9600,
    "Speed": 9700,
    "Resolve": 9999,
    "Teamwork": 9000,
    "Mentor": 9500,
    "Power": 9999,
    "Hax": 9500,
    "Defence": 9700,
    "IQ": 8500
  },
  "All Might (Weakened State)": {
    "Captain": 6500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 8000,
    "Quirk Versatility": 7000,
    "Combat Skill": 8500,
    "Speed": 5000,
    "Resolve": 9999,
    "Teamwork": 8500,
    "Mentor": 9800,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 5500,
    "IQ": 9000
  },
  "Backdraft": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 2000,
    "Quirk Power": 3500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 3000,
    "Speed": 3000,
    "Resolve": 5000,
    "Teamwork": 6000,
    "Mentor": 3000,
    "Power": 3500,
    "Hax": 5000,
    "Defence": 4000,
    "IQ": 4000
  },
  "Best Jeanist": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 2000,
    "Quirk Power": 6000,
    "Quirk Control": 8500,
    "Quirk Versatility": 8000,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 7000,
    "Teamwork": 7500,
    "Mentor": 6000,
    "Power": 6000,
    "Hax": 9000,
    "Defence": 6000,
    "IQ": 7500
  },
  "Bruce": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 2500,
    "Quirk Control": 3000,
    "Quirk Versatility": 2000,
    "Combat Skill": 3000,
    "Speed": 2500,
    "Resolve": 4000,
    "Teamwork": 3500,
    "Mentor": 1500,
    "Power": 2500,
    "Hax": 3000,
    "Defence": 3500,
    "IQ": 2000
  },
  "Burnin": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3500,
    "Combat Skill": 4000,
    "Speed": 5000,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 3000,
    "IQ": 3500
  },
  "Camie Utsushimi": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 5000,
    "Combat Skill": 3000,
    "Speed": 3500,
    "Resolve": 4000,
    "Teamwork": 4000,
    "Mentor": 2000,
    "Power": 4000,
    "Hax": 6500,
    "Defence": 2000,
    "IQ": 3500
  },
  "Cathleen Bate (Star and Stripe)": {
    "Captain": 9200,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8800,
    "Healer": 1000,
    "Quirk Power": 9800,
    "Quirk Control": 9500,
    "Quirk Versatility": 9800,
    "Combat Skill": 9000,
    "Speed": 8500,
    "Resolve": 9800,
    "Teamwork": 7000,
    "Mentor": 6000,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 8800,
    "IQ": 8500
  },
  "Cementoss": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 6500,
    "Combat Skill": 3500,
    "Speed": 3000,
    "Resolve": 5000,
    "Teamwork": 5500,
    "Mentor": 5000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 6000,
    "IQ": 6000
  },
  "Chiyo Shuzenji": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 2000,
    "Healer": 9500,
    "Quirk Power": 6000,
    "Quirk Control": 8500,
    "Quirk Versatility": 4000,
    "Combat Skill": 1500,
    "Speed": 2000,
    "Resolve": 7000,
    "Teamwork": 6000,
    "Mentor": 8500,
    "Power": 6000,
    "Hax": 8500,
    "Defence": 2000,
    "IQ": 8000
  },
  "Curious": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 4500,
    "Quirk Versatility": 4000,
    "Combat Skill": 3500,
    "Speed": 3000,
    "Resolve": 6000,
    "Teamwork": 4000,
    "Mentor": 3000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 3000,
    "IQ": 5500
  },
  "Dabi": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Quirk Power": 8500,
    "Quirk Control": 2500,
    "Quirk Versatility": 5000,
    "Combat Skill": 7000,
    "Speed": 7000,
    "Resolve": 9000,
    "Teamwork": 6000,
    "Mentor": 2000,
    "Power": 8500,
    "Hax": 6500,
    "Defence": 3000,
    "IQ": 6000
  },
  "Daigoro Banjo Blackwhip": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 6000,
    "Speed": 5500,
    "Resolve": 7500,
    "Teamwork": 5500,
    "Mentor": 5000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5500,
    "IQ": 5000
  },
  "Death Arms": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3000,
    "Combat Skill": 4500,
    "Speed": 3500,
    "Resolve": 5000,
    "Teamwork": 4500,
    "Mentor": 3000,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 5000,
    "IQ": 3500
  },
  "Denki Kaminari": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2000,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 2000,
    "Quirk Versatility": 3500,
    "Combat Skill": 3500,
    "Speed": 4500,
    "Resolve": 5000,
    "Teamwork": 4500,
    "Mentor": 2000,
    "Power": 6000,
    "Hax": 3500,
    "Defence": 2000,
    "IQ": 2500
  },
  "Ectoplasm": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4500,
    "Speed": 4000,
    "Resolve": 5000,
    "Teamwork": 5000,
    "Mentor": 5500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4000,
    "IQ": 5500
  },
  "Edgeshot": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 3000,
    "Quirk Power": 6000,
    "Quirk Control": 8000,
    "Quirk Versatility": 7000,
    "Combat Skill": 7500,
    "Speed": 8500,
    "Resolve": 7000,
    "Teamwork": 6000,
    "Mentor": 5000,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 4000,
    "IQ": 6500
  },
  "Eijiro Kirishima": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4000,
    "Combat Skill": 5000,
    "Speed": 4000,
    "Resolve": 7500,
    "Teamwork": 6000,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 8000,
    "IQ": 3500
  },
  "En Tayutai (Smoke-Eater)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4000,
    "Combat Skill": 4000,
    "Speed": 3500,
    "Resolve": 5000,
    "Teamwork": 5500,
    "Mentor": 4000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 3500,
    "IQ": 4500
  },
  "Enji Todoroki": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 8500,
    "Quirk Versatility": 8000,
    "Combat Skill": 8000,
    "Speed": 7500,
    "Resolve": 8500,
    "Teamwork": 6000,
    "Mentor": 6000,
    "Power": 9000,
    "Hax": 8800,
    "Defence": 7000,
    "IQ": 7500
  },
  "Eri": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 1000,
    "Healer": 9500,
    "Quirk Power": 9500,
    "Quirk Control": 1500,
    "Quirk Versatility": 2000,
    "Combat Skill": 1000,
    "Speed": 1500,
    "Resolve": 4500,
    "Teamwork": 2500,
    "Mentor": 1500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 1000,
    "IQ": 3000
  },
  "Fat Gum": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 5500,
    "Quirk Versatility": 5000,
    "Combat Skill": 5000,
    "Speed": 3000,
    "Resolve": 7000,
    "Teamwork": 6500,
    "Mentor": 5500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 8500,
    "IQ": 5500
  },
  "Fumikage Tokoyami": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 6000,
    "Quirk Versatility": 6500,
    "Combat Skill": 6000,
    "Speed": 6500,
    "Resolve": 7000,
    "Teamwork": 6000,
    "Mentor": 3500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 5500,
    "IQ": 6000
  },
  "Gentle Criminal": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 5500,
    "Quirk Versatility": 6000,
    "Combat Skill": 3500,
    "Speed": 4000,
    "Resolve": 4500,
    "Teamwork": 3500,
    "Mentor": 2000,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 2500,
    "IQ": 5000
  },
  "Geten": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 6500,
    "Teamwork": 4000,
    "Mentor": 3000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 5000
  },
  "Gigantomachia": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 9800,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 7000,
    "Quirk Versatility": 5000,
    "Combat Skill": 8000,
    "Speed": 7000,
    "Resolve": 9999,
    "Teamwork": 2000,
    "Mentor": 1000,
    "Power": 9000,
    "Hax": 7500,
    "Defence": 9800,
    "IQ": 4000
  },
  "Gran Torino": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 8000,
    "Quirk Versatility": 7000,
    "Combat Skill": 7500,
    "Speed": 8500,
    "Resolve": 8000,
    "Teamwork": 6000,
    "Mentor": 9999,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 4000,
    "IQ": 7000
  },
  "Hanta Sero": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 3500,
    "Quirk Control": 5000,
    "Quirk Versatility": 5500,
    "Combat Skill": 3500,
    "Speed": 4500,
    "Resolve": 4500,
    "Teamwork": 5000,
    "Mentor": 2000,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 4000
  },
  "Hari Kurono": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 4500,
    "Speed": 5000,
    "Resolve": 5000,
    "Teamwork": 4500,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 6000
  },
  "Hawks": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 6800,
    "Quirk Control": 8500,
    "Quirk Versatility": 9000,
    "Combat Skill": 7000,
    "Speed": 9700,
    "Resolve": 8500,
    "Teamwork": 8000,
    "Mentor": 6000,
    "Power": 6800,
    "Hax": 9000,
    "Defence": 5000,
    "IQ": 8000
  },
  "Hikage Shinomori (Danger Sense)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 7000,
    "Quirk Versatility": 5500,
    "Combat Skill": 5000,
    "Speed": 5500,
    "Resolve": 6500,
    "Teamwork": 5000,
    "Mentor": 4500,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 6000
  },
  "Himiko Toga": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 3000,
    "Healer": 5000,
    "Quirk Power": 5500,
    "Quirk Control": 7000,
    "Quirk Versatility": 8000,
    "Combat Skill": 6000,
    "Speed": 7000,
    "Resolve": 8500,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 5500,
    "Hax": 8000,
    "Defence": 3000,
    "IQ": 6500
  },
  "Hitoshi Shinso": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 5500,
    "Quirk Versatility": 5000,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 6000,
    "Teamwork": 5000,
    "Mentor": 3000,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 2500,
    "IQ": 7000
  },
  "Hizashi Yamada (Present Mic)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 6500,
    "Quirk Versatility": 5000,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 6000,
    "Teamwork": 5500,
    "Mentor": 6000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 3500,
    "IQ": 5500
  },
  "Hound Dog": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 5500,
    "Speed": 5500,
    "Resolve": 6500,
    "Teamwork": 5000,
    "Mentor": 5000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 6000,
    "IQ": 5000
  },
  "Ibara Shiozaki": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 6000,
    "Teamwork": 5500,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 5000,
    "IQ": 5000
  },
  "Inasa Yoarashi": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5500,
    "Speed": 6500,
    "Resolve": 7000,
    "Teamwork": 5500,
    "Mentor": 3500,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 5000
  },
  "Itsuka Kendo": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 6000,
    "Teamwork": 6500,
    "Mentor": 4500,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 5500,
    "IQ": 7500
  },
  "Izuku Midoriya (Final War)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Quirk Power": 9200,
    "Quirk Control": 8500,
    "Quirk Versatility": 9000,
    "Combat Skill": 8000,
    "Speed": 9000,
    "Resolve": 9800,
    "Teamwork": 7500,
    "Mentor": 6000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 7500,
    "IQ": 8000
  },
  "Jack Mantis": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 5000,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 4500,
    "IQ": 3500
  },
  "Kamui Woods": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5500,
    "Speed": 5500,
    "Resolve": 6000,
    "Teamwork": 6000,
    "Mentor": 4500,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Katsuki Bakugo (Final War)": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Quirk Power": 8800,
    "Quirk Control": 8800,
    "Quirk Versatility": 7500,
    "Combat Skill": 8500,
    "Speed": 9500,
    "Resolve": 9500,
    "Teamwork": 6000,
    "Mentor": 4500,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 7000,
    "IQ": 7000
  },
  "Kinoko Komori": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 5500,
    "Quirk Versatility": 6000,
    "Combat Skill": 3500,
    "Speed": 3500,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 2500,
    "IQ": 5000
  },
  "Masaki Mizushima": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5500,
    "Quirk Versatility": 5000,
    "Combat Skill": 3000,
    "Speed": 3000,
    "Resolve": 4500,
    "Teamwork": 5500,
    "Mentor": 2000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 4500
  },
  "Koji Koda": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5500,
    "Quirk Versatility": 5000,
    "Combat Skill": 3000,
    "Speed": 3000,
    "Resolve": 4500,
    "Teamwork": 5500,
    "Mentor": 2000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 4500
  },
  "Koku Hanabata": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 4500,
    "Speed": 4000,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 3500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 3500,
    "IQ": 6000
  },
  "Kudo": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 5000,
    "Speed": 5000,
    "Resolve": 6000,
    "Teamwork": 5500,
    "Mentor": 4500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 4500,
    "IQ": 5500
  },
  "Kugo Sakamata": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 6000,
    "Speed": 5500,
    "Resolve": 7000,
    "Teamwork": 6500,
    "Mentor": 5500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6500,
    "IQ": 5500
  },
  "Kurogiri": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 7500,
    "Quirk Versatility": 8000,
    "Combat Skill": 4500,
    "Speed": 6500,
    "Resolve": 6000,
    "Teamwork": 6000,
    "Mentor": 4000,
    "Power": 7000,
    "Hax": 8000,
    "Defence": 4500,
    "IQ": 6500
  },
  "Kyoka Jiro": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 6000,
    "Mentor": 3500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 5500
  },
  "La Brava": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 1500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 2000,
    "Speed": 2500,
    "Resolve": 4500,
    "Teamwork": 5500,
    "Mentor": 1500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 1500,
    "IQ": 6500
  },
  "Lady Nagant": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 9000,
    "Quirk Versatility": 7000,
    "Combat Skill": 8000,
    "Speed": 7000,
    "Resolve": 7500,
    "Teamwork": 4500,
    "Mentor": 4500,
    "Power": 7500,
    "Hax": 9000,
    "Defence": 4500,
    "IQ": 7500
  },
  "Lizardy": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3500,
    "Combat Skill": 4000,
    "Speed": 4500,
    "Resolve": 4500,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 4500,
    "IQ": 3500
  },
  "Mandalay": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 6000,
    "Teamwork": 7000,
    "Mentor": 5000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3500,
    "IQ": 5500
  },
  "Mashirao Ojiro": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 2200,
    "Quirk Control": 4500,
    "Quirk Versatility": 1800,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 5000,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 3500,
    "Hax": 1200,
    "Defence": 4000,
    "IQ": 4000
  },
  "Mei Hatsume": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 2000,
    "Healer": 1000,
    "Quirk Power": 3500,
    "Quirk Control": 4500,
    "Quirk Versatility": 4000,
    "Combat Skill": 2500,
    "Speed": 3500,
    "Resolve": 5500,
    "Teamwork": 4500,
    "Mentor": 3500,
    "Power": 3500,
    "Hax": 4500,
    "Defence": 2000,
    "IQ": 8500
  },
  "Mezo Shoji": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5000,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 6000,
    "Mentor": 3500,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 5500,
    "IQ": 4500
  },
  "Midnight": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5000,
    "Speed": 5000,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 6000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 6000
  },
  "Mina Ashido": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 5500,
    "Combat Skill": 5000,
    "Speed": 5500,
    "Resolve": 5500,
    "Teamwork": 5500,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 3500,
    "IQ": 4500
  },
  "Minoru Mineta": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2000,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 5500,
    "Quirk Versatility": 6500,
    "Combat Skill": 3000,
    "Speed": 3500,
    "Resolve": 3500,
    "Teamwork": 4500,
    "Mentor": 2000,
    "Power": 4000,
    "Hax": 6500,
    "Defence": 2000,
    "IQ": 5000
  },
  "Mirio Togata (Lemillion)": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 9500,
    "Quirk Versatility": 9000,
    "Combat Skill": 8000,
    "Speed": 8000,
    "Resolve": 9800,
    "Teamwork": 7500,
    "Mentor": 5500,
    "Power": 7500,
    "Hax": 9500,
    "Defence": 6500,
    "IQ": 7000
  },
  "Mirko": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 8000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 8500,
    "Speed": 9500,
    "Resolve": 9800,
    "Teamwork": 5500,
    "Mentor": 4500,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 7000,
    "IQ": 6000
  },
  "Momo Yaoyorozu": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 8500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 6000,
    "Teamwork": 6500,
    "Mentor": 5000,
    "Power": 6500,
    "Hax": 9000,
    "Defence": 3500,
    "IQ": 9000
  },
  "Moonfish": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 4500,
    "Quirk Versatility": 4000,
    "Combat Skill": 5000,
    "Speed": 5000,
    "Resolve": 5500,
    "Teamwork": 1500,
    "Mentor": 1500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 4500,
    "IQ": 2500
  },
  "Mr. Compress": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 4500,
    "Speed": 5000,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 3500,
    "Power": 5000,
    "Hax": 6500,
    "Defence": 3500,
    "IQ": 6000
  },
  "Mudman": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3500,
    "Combat Skill": 3500,
    "Speed": 3500,
    "Resolve": 4500,
    "Teamwork": 4500,
    "Mentor": 2000,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 4500,
    "IQ": 3500
  },
  "Muscular": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 7500,
    "Healer": 1000,
    "Quirk Power": 8000,
    "Quirk Control": 5500,
    "Quirk Versatility": 3500,
    "Combat Skill": 6000,
    "Speed": 5500,
    "Resolve": 6500,
    "Teamwork": 1500,
    "Mentor": 1500,
    "Power": 8000,
    "Hax": 5500,
    "Defence": 9000,
    "IQ": 3500
  },
  "Mustard": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 4500,
    "Quirk Versatility": 4000,
    "Combat Skill": 3000,
    "Speed": 3000,
    "Resolve": 3500,
    "Teamwork": 2500,
    "Mentor": 1500,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 2000,
    "IQ": 4000
  },
  "Nana Shimura (Flight)": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 7000,
    "Quirk Versatility": 6500,
    "Combat Skill": 6500,
    "Speed": 7500,
    "Resolve": 8500,
    "Teamwork": 6000,
    "Mentor": 6500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 5500,
    "IQ": 6000
  },
  "Neito Monoma": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 8000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 8500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 4000,
    "Power": 6500,
    "Hax": 8500,
    "Defence": 3500,
    "IQ": 7000
  },
  "Nejire Hado": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5500,
    "Speed": 7000,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 4000,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Nirengeki Shoda": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 5000,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4000,
    "IQ": 4500
  },
  "Ochaco Uraraka": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 6500,
    "Combat Skill": 5000,
    "Speed": 5000,
    "Resolve": 7000,
    "Teamwork": 6500,
    "Mentor": 3500,
    "Power": 5500,
    "Hax": 7500,
    "Defence": 3500,
    "IQ": 5500
  },
  "Overhaul": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 8000,
    "Quirk Power": 9500,
    "Quirk Control": 9000,
    "Quirk Versatility": 8500,
    "Combat Skill": 6500,
    "Speed": 6500,
    "Resolve": 8500,
    "Teamwork": 4500,
    "Mentor": 5500,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 7000,
    "IQ": 8000
  },
  "Pixie-Bob": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 8000,
    "Quirk Versatility": 6000,
    "Combat Skill": 5000,
    "Speed": 4500,
    "Resolve": 6000,
    "Teamwork": 6000,
    "Mentor": 5000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Pony Tsunotori": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 5500,
    "Quirk Versatility": 5500,
    "Combat Skill": 4000,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 3500,
    "IQ": 4500
  },
  "Principal Nezu": {
    "Captain": 8000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 3500,
    "Quirk Control": 4500,
    "Quirk Versatility": 4000,
    "Combat Skill": 2000,
    "Speed": 3500,
    "Resolve": 7500,
    "Teamwork": 6500,
    "Mentor": 9000,
    "Power": 3500,
    "Hax": 4500,
    "Defence": 2500,
    "IQ": 9999
  },
  "Ragdoll": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 5500,
    "Quirk Versatility": 4500,
    "Combat Skill": 4000,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 6500,
    "Mentor": 4500,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 6000
  },
  "Re-Destro": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8000,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 7000,
    "Speed": 6500,
    "Resolve": 8500,
    "Teamwork": 5500,
    "Mentor": 6000,
    "Power": 9000,
    "Hax": 8000,
    "Defence": 8000,
    "IQ": 7500
  },
  "Reiko Yanagi": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 3500,
    "Speed": 3500,
    "Resolve": 4500,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 2500,
    "IQ": 4500
  },
  "Rikido Sato": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 4500,
    "Quirk Versatility": 3500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 5000,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 5500,
    "IQ": 3500
  },
  "Rock Lock": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 6500,
    "Teamwork": 5500,
    "Mentor": 4500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 5500,
    "IQ": 5500
  },
  "Ryuko Tatsuma (Dragon)": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7500,
    "Healer": 1000,
    "Quirk Power": 8500,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 7000,
    "Speed": 7000,
    "Resolve": 8000,
    "Teamwork": 6000,
    "Mentor": 5000,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 7500,
    "IQ": 6000
  },
  "Ryuko Tatsuma": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 6500,
    "Quirk Versatility": 5500,
    "Combat Skill": 6000,
    "Speed": 6000,
    "Resolve": 7000,
    "Teamwork": 5500,
    "Mentor": 5000,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 6500,
    "IQ": 6000
  },
  "Seiji Shishikura": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 5500,
    "Quirk Versatility": 4500,
    "Combat Skill": 4500,
    "Speed": 4000,
    "Resolve": 5500,
    "Teamwork": 4500,
    "Mentor": 3000,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 3500,
    "IQ": 5000
  },
  "Shihai Kuroiro": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Quirk Power": 4500,
    "Quirk Control": 5500,
    "Quirk Versatility": 6000,
    "Combat Skill": 4500,
    "Speed": 5000,
    "Resolve": 5000,
    "Teamwork": 5000,
    "Mentor": 3000,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 4000,
    "IQ": 5000
  },
  "Shin Nemoto": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 4500,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 5500
  },
  "Shota Aizawa": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 8500,
    "Quirk Versatility": 7500,
    "Combat Skill": 8000,
    "Speed": 7000,
    "Resolve": 9000,
    "Teamwork": 7500,
    "Mentor": 9500,
    "Power": 6500,
    "Hax": 9200,
    "Defence": 5500,
    "IQ": 8500
  },
  "Shoto Todoroki": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 8000,
    "Quirk Versatility": 7500,
    "Combat Skill": 7000,
    "Speed": 7000,
    "Resolve": 8000,
    "Teamwork": 6000,
    "Mentor": 5000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 6500,
    "IQ": 7500
  },
  "Sir Nighteye": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 6000,
    "Speed": 5500,
    "Resolve": 8000,
    "Teamwork": 6500,
    "Mentor": 7500,
    "Power": 9000,
    "Hax": 7500,
    "Defence": 5000,
    "IQ": 8500
  },
  "Snipe": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6500,
    "Quirk Versatility": 5000,
    "Combat Skill": 6500,
    "Speed": 5500,
    "Resolve": 6000,
    "Teamwork": 5500,
    "Mentor": 5000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 6000
  },
  "Spinner": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 3500,
    "Quirk Control": 4000,
    "Quirk Versatility": 3500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 6500,
    "Teamwork": 4500,
    "Mentor": 2500,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 4500,
    "IQ": 4500
  },
  "Stain": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 8500,
    "Speed": 8000,
    "Resolve": 9500,
    "Teamwork": 3500,
    "Mentor": 4500,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 5000,
    "IQ": 7000
  },
  "Tamaki Amajiki (Suneater)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 8000,
    "Quirk Control": 7500,
    "Quirk Versatility": 8500,
    "Combat Skill": 6500,
    "Speed": 6500,
    "Resolve": 5500,
    "Teamwork": 5500,
    "Mentor": 4000,
    "Power": 8000,
    "Hax": 9000,
    "Defence": 6000,
    "IQ": 6000
  },
  "Tenya Iida": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 7000,
    "Quirk Versatility": 5500,
    "Combat Skill": 6000,
    "Speed": 9000,
    "Resolve": 7500,
    "Teamwork": 6500,
    "Mentor": 4500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 5500,
    "IQ": 6500
  },
  "Tetsutetsu Tetsutetsu": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4000,
    "Combat Skill": 5000,
    "Speed": 4500,
    "Resolve": 7000,
    "Teamwork": 5500,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 8000,
    "IQ": 4000
  },
  "Thirteen": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 7000,
    "Quirk Versatility": 6500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 5500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 6500
  },
  "Tiger": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5000,
    "Combat Skill": 5500,
    "Speed": 6000,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 4500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 6000,
    "IQ": 5000
  },
  "Tomura Shigaraki (Awakened Decay)": {
    "Captain": 8800,
    "Vice Captain": 8000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8500,
    "Healer": 1000,
    "Quirk Power": 9500,
    "Quirk Control": 8500,
    "Quirk Versatility": 8000,
    "Combat Skill": 8000,
    "Speed": 8500,
    "Resolve": 9500,
    "Teamwork": 4500,
    "Mentor": 3500,
    "Power": 9500,
    "Hax": 9999,
    "Defence": 8500,
    "IQ": 8000
  },
  "Tomura Shigaraki (Early Villain)": {
    "Captain": 9000,
    "Vice Captain": 6000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 7500,
    "Quirk Control": 5500,
    "Quirk Versatility": 4500,
    "Combat Skill": 5000,
    "Speed": 5500,
    "Resolve": 7500,
    "Teamwork": 3500,
    "Mentor": 2500,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 4500,
    "IQ": 6500
  },
  "Toru Hagakure (Invisible Girl)": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 4500,
    "Quirk Versatility": 5500,
    "Combat Skill": 3500,
    "Speed": 5000,
    "Resolve": 5000,
    "Teamwork": 5500,
    "Mentor": 2500,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 2500,
    "IQ": 4500
  },
  "Tsuyu Asui": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 5000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5500,
    "Speed": 6500,
    "Resolve": 6000,
    "Teamwork": 6500,
    "Mentor": 4000,
    "Power": 5000,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 6000
  },
  "Twice": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 8500,
    "Combat Skill": 5000,
    "Speed": 5500,
    "Resolve": 7000,
    "Teamwork": 6500,
    "Mentor": 4000,
    "Power": 6500,
    "Hax": 9800,
    "Defence": 3500,
    "IQ": 6000
  },
  "Vlad King": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 6500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6500,
    "IQ": 6000
  },
  "Wash": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 6000,
    "Quirk Power": 6000,
    "Quirk Control": 6500,
    "Quirk Versatility": 6000,
    "Combat Skill": 5000,
    "Speed": 5000,
    "Resolve": 6000,
    "Teamwork": 6000,
    "Mentor": 5000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Yo Shindo": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 5000,
    "Quirk Versatility": 4500,
    "Combat Skill": 4500,
    "Speed": 4500,
    "Resolve": 5500,
    "Teamwork": 5500,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 4500,
    "IQ": 4500
  },
  "Yoichi Shigaraki (1st User OFA)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 8500,
    "Teamwork": 5500,
    "Mentor": 6500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 3500,
    "IQ": 6500
  },
  "Yosetsu Awase": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Quirk Power": 4000,
    "Quirk Control": 5000,
    "Quirk Versatility": 5500,
    "Combat Skill": 4000,
    "Speed": 4000,
    "Resolve": 5000,
    "Teamwork": 5000,
    "Mentor": 2500,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 3500,
    "IQ": 4500
  },
  "Yu Takeyama": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 6000,
    "Quirk Versatility": 5500,
    "Combat Skill": 5500,
    "Speed": 5000,
    "Resolve": 6000,
    "Teamwork": 5500,
    "Mentor": 4500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6500,
    "IQ": 5000
  },
  "Yuga Aoyama": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2500,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 4500,
    "Quirk Versatility": 4500,
    "Combat Skill": 3500,
    "Speed": 4500,
    "Resolve": 4500,
    "Teamwork": 4500,
    "Mentor": 2000,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 2500,
    "IQ": 4000
  },
  "Antares Dragon Form": {
    "Captain": 9800,
    "Vice Captain": 9500,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9900,
    "Healer": 1000,
    "Aura": 9999,
    "Combat Power": 9999,
    "Speed": 9700,
    "Mana Output": 9800,
    "Summon": 9300,
    "Rank": 9999,
    "Power": 9999,
    "Defence": 9900,
    "Hax": 9999,
    "IQ": 8800
  },
  "Antares": {
    "Captain": 9800,
    "Vice Captain": 9400,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9600,
    "Healer": 1000,
    "Aura": 9999,
    "Combat Power": 9800,
    "Speed": 9800,
    "Mana Output": 9800,
    "Summon": 9200,
    "Rank": 9999,
    "Power": 9999,
    "Defence": 9600,
    "Hax": 9999,
    "IQ": 9000
  },
  "Ashborn (True form)": {
    "Captain": 9900,
    "Vice Captain": 9700,
    "Support 1": 9600,
    "Support 2": 9600,
    "Tank": 9900,
    "Healer": 1000,
    "Aura": 9900,
    "Combat Power": 9900,
    "Speed": 9900,
    "Mana Output": 9900,
    "Summon": 9999,
    "Rank": 9999,
    "Power": 9900,
    "Defence": 9900,
    "Hax": 9999,
    "IQ": 9500
  },
  "Atsushi Kumamoto": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6200,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 6800,
    "Speed": 7500,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 6800,
    "Power": 6800,
    "Defence": 6200,
    "Hax": 6800,
    "IQ": 6000
  },
  "Baek Yoonho (Base)": {
    "Captain": 7200,
    "Vice Captain": 6500,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6800,
    "Combat Power": 6800,
    "Speed": 6800,
    "Mana Output": 6800,
    "Summon": 1000,
    "Rank": 6800,
    "Power": 6800,
    "Defence": 6500,
    "Hax": 6800,
    "IQ": 6500
  },
  "Baek Yoonho (Beast Form)": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7800,
    "Healer": 1000,
    "Aura": 7800,
    "Combat Power": 7800,
    "Speed": 7800,
    "Mana Output": 7800,
    "Summon": 1000,
    "Rank": 7800,
    "Power": 7800,
    "Defence": 7800,
    "Hax": 7800,
    "IQ": 6800
  },
  "Baran": {
    "Captain": 8200,
    "Vice Captain": 7800,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8500,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 8500,
    "Speed": 8200,
    "Mana Output": 8500,
    "Summon": 7200,
    "Rank": 8500,
    "Power": 8500,
    "Defence": 8500,
    "Hax": 8500,
    "IQ": 7800
  },
  "Baruka": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 7200,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 7200,
    "Hax": 7200,
    "IQ": 6500
  },
  "Beast Monarch": {
    "Captain": 9600,
    "Vice Captain": 9200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9700,
    "Healer": 1000,
    "Aura": 9700,
    "Combat Power": 9700,
    "Speed": 9200,
    "Mana Output": 9600,
    "Summon": 1000,
    "Rank": 9700,
    "Power": 9700,
    "Defence": 9700,
    "Hax": 9700,
    "IQ": 8800
  },
  "Bellion": {
    "Captain": 8800,
    "Vice Captain": 9200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Healer": 1000,
    "Aura": 9500,
    "Combat Power": 9200,
    "Speed": 9200,
    "Mana Output": 9000,
    "Summon": 9500,
    "Rank": 8800,
    "Power": 9500,
    "Defence": 8800,
    "Hax": 9500,
    "IQ": 8200
  },
  "Beru (Shadow)": {
    "Captain": 8500,
    "Vice Captain": 7800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Healer": 9000,
    "Aura": 9400,
    "Combat Power": 8800,
    "Speed": 8800,
    "Mana Output": 8800,
    "Summon": 9000,
    "Rank": 8800,
    "Power": 9400,
    "Defence": 8800,
    "Hax": 9400,
    "IQ": 7800
  },
  "Beru": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8500,
    "Healer": 8500,
    "Aura": 9300,
    "Combat Power": 8500,
    "Speed": 9000,
    "Mana Output": 8500,
    "Summon": 8500,
    "Rank": 8500,
    "Power": 9300,
    "Defence": 8500,
    "Hax": 9600,
    "IQ": 7800
  },
  "Cha Hae-In": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7800,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 8700,
    "Speed": 8500,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 8500,
    "Power": 8700,
    "Defence": 7800,
    "Hax": 8700,
    "IQ": 7800
  },
  "Choi Jong-In": {
    "Captain": 8500,
    "Vice Captain": 7800,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 6800,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 8500,
    "Speed": 7800,
    "Mana Output": 8800,
    "Summon": 1000,
    "Rank": 8500,
    "Power": 8800,
    "Defence": 6800,
    "Hax": 8800,
    "IQ": 8200
  },
  "Christopher Reed": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Healer": 1000,
    "Aura": 8400,
    "Combat Power": 9000,
    "Speed": 8300,
    "Mana Output": 8300,
    "Summon": 1000,
    "Rank": 9500,
    "Power": 9000,
    "Defence": 8800,
    "Hax": 9200,
    "IQ": 8300
  },
  "Esil Radiru": {
    "Captain": 5800,
    "Vice Captain": 5200,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Aura": 6000,
    "Combat Power": 6000,
    "Speed": 6000,
    "Mana Output": 6000,
    "Summon": 1000,
    "Rank": 6800,
    "Power": 6000,
    "Defence": 6000,
    "Hax": 6000,
    "IQ": 5500
  },
  "Frost Monarch": {
    "Captain": 9600,
    "Vice Captain": 9200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9700,
    "Healer": 1000,
    "Aura": 9700,
    "Combat Power": 9700,
    "Speed": 9200,
    "Mana Output": 9600,
    "Summon": 1000,
    "Rank": 9700,
    "Power": 9700,
    "Defence": 9700,
    "Hax": 9700,
    "IQ": 8800
  },
  "Gina": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Go Gun-Hee": {
    "Captain": 8800,
    "Vice Captain": 8200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6000,
    "Healer": 1000,
    "Aura": 7800,
    "Combat Power": 7880,
    "Speed": 6000,
    "Mana Output": 6800,
    "Summon": 1000,
    "Rank": 8200,
    "Power": 7800,
    "Defence": 6000,
    "Hax": 6800,
    "IQ": 8800
  },
  "Goto Ryuji": {
    "Captain": 8800,
    "Vice Captain": 7000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 8500,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 8500,
    "Speed": 8500,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 8500,
    "Power": 8500,
    "Defence": 8500,
    "Hax": 8500,
    "IQ": 8200
  },
  "Greed": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7800,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 4000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Han Semi": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 7000,
    "Aura": 5500,
    "Combat Power": 6200,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 6200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 5200
  },
  "Han Song-Yi": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2500,
    "Healer": 1000,
    "Aura": 2500,
    "Combat Power": 4200,
    "Speed": 4200,
    "Mana Output": 4200,
    "Summon": 1000,
    "Rank": 4200,
    "Power": 4200,
    "Defence": 2500,
    "Hax": 4200,
    "IQ": 4200
  },
  "Hwang Dong-Soo": {
    "Captain": 6800,
    "Vice Captain": 6500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 7200,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 7200,
    "Hax": 7200,
    "IQ": 6800
  },
  "Hwang Dongsuk": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Aura": 2000,
    "Combat Power": 2200,
    "Speed": 2000,
    "Mana Output": 2000,
    "Summon": 1000,
    "Rank": 3000,
    "Power": 2200,
    "Defence": 3000,
    "Hax": 2200,
    "IQ": 2500
  },
  "Igris (Shadow)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 8200,
    "Healer": 1000,
    "Aura": 9200,
    "Combat Power": 8200,
    "Speed": 8500,
    "Mana Output": 8200,
    "Summon": 9000,
    "Rank": 8200,
    "Power": 9400,
    "Defence": 8200,
    "Hax": 9200,
    "IQ": 7200
  },
  "Igris": {
    "Captain": 6200,
    "Vice Captain": 5800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 8200,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 8200,
    "Rank": 7200,
    "Power": 8200,
    "Defence": 7200,
    "Hax": 8200,
    "IQ": 6200
  },
  "Iron": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Aura": 2500,
    "Combat Power": 3200,
    "Speed": 3200,
    "Mana Output": 3200,
    "Summon": 7000,
    "Rank": 3200,
    "Power": 3200,
    "Defence": 3500,
    "Hax": 3200,
    "IQ": 2200
  },
  "Jima": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Kaisel": {
    "Captain": 2200,
    "Vice Captain": 2800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 7200,
    "Combat Power": 7200,
    "Speed": 8200,
    "Mana Output": 7200,
    "Summon": 7000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 7200,
    "Hax": 7200,
    "IQ": 4500
  },
  "Kamish": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 9500,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 9300,
    "Speed": 9000,
    "Mana Output": 8500,
    "Summon": 9000,
    "Rank": 8500,
    "Power": 9300,
    "Defence": 9500,
    "Hax": 8500,
    "IQ": 7800
  },
  "Kang Tae-Shik": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7000,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Kanae Tawata": {
    "Captain": 6000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4000,
    "Healer": 1000,
    "Aura": 4000,
    "Combat Power": 6000,
    "Speed": 7000,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 7800,
    "Power": 6200,
    "Defence": 4000,
    "Hax": 6200,
    "IQ": 6000
  },
  "Kim Chul": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Aura": 5500,
    "Combat Power": 6200,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 6200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 5200
  },
  "Kim Sangshik": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 3200,
    "Healer": 1000,
    "Aura": 3200,
    "Combat Power": 4200,
    "Speed": 4200,
    "Mana Output": 4200,
    "Summon": 1000,
    "Rank": 4200,
    "Power": 4200,
    "Defence": 3200,
    "Hax": 4200,
    "IQ": 3200
  },
  "Lee Bora": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3200,
    "Healer": 6000,
    "Aura": 3200,
    "Combat Power": 3200,
    "Speed": 3200,
    "Mana Output": 4500,
    "Summon": 6500,
    "Rank": 6200,
    "Power": 4500,
    "Defence": 3200,
    "Hax": 4500,
    "IQ": 6200
  },
  "Lee Joohee": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2200,
    "Healer": 6200,
    "Aura": 2200,
    "Combat Power": 2200,
    "Speed": 2200,
    "Mana Output": 3200,
    "Summon": 1000,
    "Rank": 4200,
    "Power": 3200,
    "Defence": 2200,
    "Hax": 3200,
    "IQ": 4200
  },
  "Lee Minsung": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Aura": 5500,
    "Combat Power": 6200,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 6200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 5200
  },
  "Lennart Niermann": {
    "Captain": 8500,
    "Vice Captain": 7800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8500,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 8500,
    "Speed": 8500,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 9200,
    "Power": 8500,
    "Defence": 8500,
    "Hax": 8500,
    "IQ": 8200
  },
  "Lim Tae-Gyu": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Liu Zhigang": {
    "Captain": 9200,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Healer": 1000,
    "Aura": 9200,
    "Combat Power": 9200,
    "Speed": 9200,
    "Mana Output": 9200,
    "Summon": 1000,
    "Rank": 9600,
    "Power": 9200,
    "Defence": 8800,
    "Hax": 9600,
    "IQ": 8500
  },
  "Ma Dongwook": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 1000,
    "Rank": 8800,
    "Power": 7200,
    "Defence": 7500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Min Byung-Gyu": {
    "Captain": 6200,
    "Vice Captain": 5800,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 5500,
    "Healer": 9999,
    "Aura": 5500,
    "Combat Power": 5200,
    "Speed": 5200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 6800
  },
  "Monarch of Iron Body": {
    "Captain": 9500,
    "Vice Captain": 9200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9700,
    "Healer": 1000,
    "Aura": 9800,
    "Combat Power": 9800,
    "Speed": 8800,
    "Mana Output": 9500,
    "Summon": 8500,
    "Rank": 9800,
    "Power": 9800,
    "Defence": 9999,
    "Hax": 9800,
    "IQ": 8800
  },
  "Monarch of Beginnings (Legia)": {
    "Captain": 9500,
    "Vice Captain": 9200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9600,
    "Healer": 1000,
    "Aura": 9800,
    "Combat Power": 9800,
    "Speed": 9200,
    "Mana Output": 9500,
    "Summon": 9000,
    "Rank": 9800,
    "Power": 9800,
    "Defence": 9600,
    "Hax": 9800,
    "IQ": 9200
  },
  "Park Heejin": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Aura": 5500,
    "Combat Power": 6200,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 6200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 5200
  },
  "Plague Monarch": {
    "Captain": 9500,
    "Vice Captain": 9200,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 9500,
    "Healer": 1000,
    "Aura": 9800,
    "Combat Power": 9800,
    "Speed": 9200,
    "Mana Output": 9500,
    "Summon": 8500,
    "Rank": 9800,
    "Power": 9800,
    "Defence": 9500,
    "Hax": 9800,
    "IQ": 9200
  },
  "Seo Jiwoo": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 2200,
    "Healer": 1000,
    "Aura": 2200,
    "Combat Power": 4200,
    "Speed": 4200,
    "Mana Output": 4200,
    "Summon": 1000,
    "Rank": 4200,
    "Power": 4200,
    "Defence": 2200,
    "Hax": 4200,
    "IQ": 4200
  },
  "Shimizu": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 6800,
    "Healer": 8500,
    "Aura": 6800,
    "Combat Power": 7800,
    "Speed": 7800,
    "Mana Output": 7800,
    "Summon": 1000,
    "Rank": 7800,
    "Power": 7800,
    "Defence": 6800,
    "Hax": 7800,
    "IQ": 6800
  },
  "Son Kihoon": {
    "Captain": 5200,
    "Vice Captain": 4800,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Aura": 5500,
    "Combat Power": 6200,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 6200,
    "Power": 6200,
    "Defence": 5500,
    "Hax": 6200,
    "IQ": 5200
  },
  "Song Chi-Yul": {
    "Captain": 6800,
    "Vice Captain": 6200,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Aura": 6500,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 4000,
    "Summon": 1000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 6500,
    "Hax": 7200,
    "IQ": 6500
  },
  "Statue of God": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 9500,
    "Healer": 1000,
    "Aura": 9500,
    "Combat Power": 8500,
    "Speed": 3000,
    "Mana Output": 1000,
    "Summon": 1000,
    "Rank": 7000,
    "Power": 9500,
    "Defence": 9500,
    "Hax": 9500,
    "IQ": 1000
  },
  "Sung Il-Hwan": {
    "Captain": 8800,
    "Vice Captain": 8200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9500,
    "Healer": 1000,
    "Aura": 9500,
    "Combat Power": 9500,
    "Speed": 9500,
    "Mana Output": 9500,
    "Summon": 1000,
    "Rank": 9500,
    "Power": 9500,
    "Defence": 9500,
    "Hax": 9500,
    "IQ": 8800
  },
  "Sung Jinah": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 1000,
    "Healer": 1000,
    "Aura": 1000,
    "Combat Power": 1000,
    "Speed": 1000,
    "Mana Output": 1000,
    "Summon": 1000,
    "Rank": 1000,
    "Power": 1000,
    "Defence": 1000,
    "Hax": 1100,
    "IQ": 1000
  },
  "Sung Jinwoo (A Rank)": {
    "Captain": 6800,
    "Vice Captain": 5800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7800,
    "Healer": 1000,
    "Aura": 6800,
    "Combat Power": 6800,
    "Speed": 7800,
    "Mana Output": 7800,
    "Summon": 8500,
    "Rank": 6800,
    "Power": 8200,
    "Defence": 8000,
    "Hax": 8500,
    "IQ": 7800
  },
  "Sung Jinwoo (B Rank)": {
    "Captain": 5800,
    "Vice Captain": 4800,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 5800,
    "Combat Power": 5800,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 7800,
    "Rank": 5800,
    "Power": 7200,
    "Defence": 7200,
    "Hax": 7200,
    "IQ": 7200
  },
  "Sung Jinwoo (C Rank)": {
    "Captain": 4800,
    "Vice Captain": 3800,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 6200,
    "Healer": 1000,
    "Aura": 4800,
    "Combat Power": 4800,
    "Speed": 6200,
    "Mana Output": 6200,
    "Summon": 1000,
    "Rank": 4800,
    "Power": 6200,
    "Defence": 6200,
    "Hax": 6200,
    "IQ": 6200
  },
  "Sung Jinwoo (D Rank)": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 2200,
    "Healer": 1000,
    "Aura": 2200,
    "Combat Power": 3200,
    "Speed": 3200,
    "Mana Output": 3200,
    "Summon": 1000,
    "Rank": 3200,
    "Power": 3200,
    "Defence": 2200,
    "Hax": 3200,
    "IQ": 6000
  },
  "Sung Jinwoo (E Rank)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 1000,
    "Healer": 1000,
    "Aura": 1000,
    "Combat Power": 1000,
    "Speed": 1000,
    "Mana Output": 1000,
    "Summon": 1000,
    "Rank": 1000,
    "Power": 1000,
    "Defence": 1000,
    "Hax": 1200,
    "IQ": 6000
  },
  "Sung Jinwoo (Final Shadow Monarch)": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Aura": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Mana Output": 9999,
    "Summon": 9999,
    "Rank": 9999,
    "Power": 9999,
    "Defence": 9999,
    "Hax": 9999,
    "IQ": 9800
  },
  "Sung Jinwoo (S Rank)": {
    "Captain": 8800,
    "Vice Captain": 7800,
    "Support 1": 9200,
    "Support 2": 9200,
    "Tank": 8800,
    "Healer": 1000,
    "Aura": 8800,
    "Combat Power": 8800,
    "Speed": 9300,
    "Mana Output": 8800,
    "Summon": 9800,
    "Rank": 8800,
    "Power": 9300,
    "Defence": 9000,
    "Hax": 9500,
    "IQ": 8800
  },
  "Sung Jinwoo (True Shadow Monarch)": {
    "Captain": 9800,
    "Vice Captain": 9500,
    "Support 1": 9800,
    "Support 2": 9800,
    "Tank": 9999,
    "Healer": 1000,
    "Aura": 9990,
    "Combat Power": 9990,
    "Speed": 9990,
    "Mana Output": 9999,
    "Summon": 9999,
    "Rank": 9999,
    "Power": 9999,
    "Defence": 9999,
    "Hax": 9999,
    "IQ": 9500
  },
  "Tank": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 6000,
    "Healer": 1000,
    "Aura": 2500,
    "Combat Power": 3200,
    "Speed": 3200,
    "Mana Output": 3200,
    "Summon": 6500,
    "Rank": 3200,
    "Power": 3200,
    "Defence": 3500,
    "Hax": 3200,
    "IQ": 2200
  },
  "The Architect": {
    "Captain": 9000,
    "Vice Captain": 1000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7000,
    "Healer": 1000,
    "Aura": 7000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Mana Output": 6000,
    "Summon": 1000,
    "Rank": 6000,
    "Power": 7000,
    "Defence": 7000,
    "Hax": 9500,
    "IQ": 9999
  },
  "Thomas Andre": {
    "Captain": 8800,
    "Vice Captain": 7800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9400,
    "Healer": 1000,
    "Aura": 8800,
    "Combat Power": 9200,
    "Speed": 8800,
    "Mana Output": 8800,
    "Summon": 1000,
    "Rank": 9700,
    "Power": 9400,
    "Defence": 9400,
    "Hax": 9200,
    "IQ": 7800
  },
  "Tusk (Shadow)": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8200,
    "Healer": 1000,
    "Aura": 8200,
    "Combat Power": 8200,
    "Speed": 8200,
    "Mana Output": 8200,
    "Summon": 8000,
    "Rank": 8200,
    "Power": 8200,
    "Defence": 8200,
    "Hax": 9000,
    "IQ": 7200
  },
  "Tusk": {
    "Captain": 6200,
    "Vice Captain": 5800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7200,
    "Healer": 1000,
    "Aura": 7200,
    "Combat Power": 7200,
    "Speed": 7200,
    "Mana Output": 7200,
    "Summon": 7000,
    "Rank": 7200,
    "Power": 7200,
    "Defence": 7200,
    "Hax": 7200,
    "IQ": 6200
  },
  "Woo Jinchul": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 6800,
    "Healer": 1000,
    "Aura": 6800,
    "Combat Power": 6800,
    "Speed": 6800,
    "Mana Output": 6800,
    "Summon": 1000,
    "Rank": 6800,
    "Power": 6800,
    "Defence": 6800,
    "Hax": 6800,
    "IQ": 8200
  },
  "Yoo Jinho": {
    "Captain": 2200,
    "Vice Captain": 2200,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 2200,
    "Healer": 1000,
    "Aura": 2200,
    "Combat Power": 2200,
    "Speed": 2200,
    "Mana Output": 2200,
    "Summon": 1000,
    "Rank": 3200,
    "Power": 2200,
    "Defence": 2200,
    "Hax": 2200,
    "IQ": 6200
  },
  "Yoo Soo-Hyun": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 1000,
    "Healer": 1000,
    "Aura": 1000,
    "Combat Power": 1000,
    "Speed": 1000,
    "Mana Output": 1000,
    "Summon": 1000,
    "Rank": 4000,
    "Power": 1000,
    "Defence": 1000,
    "Hax": 1100,
    "IQ": 1000
  },
  "Yuri Orloff": {
    "Captain": 7500,
    "Vice Captain": 7800,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8500,
    "Healer": 1000,
    "Aura": 8500,
    "Combat Power": 7000,
    "Speed": 7000,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 8500,
    "Power": 8500,
    "Defence": 8500,
    "Hax": 8500,
    "IQ": 8200
  },
  "Ace": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Weapon Skill": 3000,
    "Willpower": 8500,
    "Power": 7800,
    "Hax": 8000,
    "Defence": 6000,
    "IQ": 6000
  },
  "Arlong": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3200,
    "Speed": 3500,
    "Weapon Skill": 3000,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 1200,
    "Defence": 3800,
    "IQ": 4000
  },
  "Avalo Pizarro": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 5000,
    "Combat Power": 6000,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 7500,
    "IQ": 5000
  },
  "Bartolomeo": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 3000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Weapon Skill": 2000,
    "Willpower": 7000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 9800,
    "IQ": 5000
  },
  "Bellamy": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 4000,
    "Haki": 1500,
    "Combat Power": 3000,
    "Speed": 4500,
    "Weapon Skill": 2500,
    "Willpower": 3500,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 2800,
    "IQ": 3000
  },
  "Belo Betty": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 4000,
    "Combat Power": 3000,
    "Speed": 4000,
    "Weapon Skill": 3000,
    "Willpower": 9500,
    "Power": 3000,
    "Hax": 9000,
    "Defence": 2500,
    "IQ": 7000
  },
  "Benn Beckman": {
    "Captain": 8000,
    "Vice Captain": 9500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9200,
    "Combat Power": 8500,
    "Speed": 8000,
    "Weapon Skill": 9500,
    "Willpower": 9000,
    "Power": 9200,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 9500
  },
  "Bepo": {
    "Captain": 2500,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 8000,
    "Devil Fruit": 1000,
    "Haki": 2000,
    "Combat Power": 3000,
    "Speed": 3500,
    "Weapon Skill": 2000,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 1800,
    "Defence": 4000,
    "IQ": 4500
  },
  "Bon Clay": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2800,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 4000,
    "Weapon Skill": 3500,
    "Willpower": 8000,
    "Power": 3500,
    "Hax": 6500,
    "Defence": 2800,
    "IQ": 4500
  },
  "Catarina Devon": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 5000,
    "Combat Power": 6000,
    "Speed": 6000,
    "Weapon Skill": 5500,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 7500,
    "Defence": 5500,
    "IQ": 6000
  },
  "Cavendish": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 6500,
    "Speed": 8000,
    "Weapon Skill": 7500,
    "Willpower": 6000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 5000,
    "IQ": 5500
  },
  "Crocus": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 1500,
    "Healer": 8500,
    "Devil Fruit": 1000,
    "Haki": 3000,
    "Combat Power": 1500,
    "Speed": 2000,
    "Weapon Skill": 1500,
    "Willpower": 5000,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 1500,
    "IQ": 8500
  },
  "Dalmatian": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 4500,
    "Combat Power": 4800,
    "Speed": 6000,
    "Weapon Skill": 4000,
    "Willpower": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500,
    "IQ": 5000
  },
  "Diamante": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 5500,
    "Willpower": 5000,
    "Power": 6000,
    "Hax": 6500,
    "Defence": 5000,
    "IQ": 6000
  },
  "Doc Q & Stronger": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 4000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 3000,
    "Speed": 2500,
    "Weapon Skill": 2000,
    "Willpower": 4500,
    "Power": 3500,
    "Hax": 6500,
    "Defence": 2500,
    "IQ": 7000
  },
  "Don Krieg": {
    "Captain": 2500,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2800,
    "Speed": 2000,
    "Weapon Skill": 3500,
    "Willpower": 3000,
    "Power": 3500,
    "Hax": 1200,
    "Defence": 4000,
    "IQ": 3500
  },
  "Gol D. Roger": {
    "Captain": 9999,
    "Vice Captain": 9700,
    "Support 1": 9900,
    "Support 2": 9900,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9800,
    "Weapon Skill": 9999,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9500,
    "IQ": 9800
  },
  "Hachi": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2800,
    "Speed": 2500,
    "Weapon Skill": 4500,
    "Willpower": 3500,
    "Power": 3000,
    "Hax": 1500,
    "Defence": 2500,
    "IQ": 3500
  },
  "Hack": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 4000,
    "Speed": 3500,
    "Weapon Skill": 4000,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 3000,
    "Defence": 4500,
    "IQ": 4000
  },
  "Helmeppo": {
    "Captain": 1500,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2500,
    "Combat Power": 2000,
    "Speed": 2500,
    "Weapon Skill": 3000,
    "Willpower": 4000,
    "Power": 2500,
    "Hax": 1800,
    "Defence": 2000,
    "IQ": 4500
  },
  "Hina": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 3500,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 3500,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 4500,
    "IQ": 6000
  },
  "Hiriluk": {
    "Captain": 500,
    "Vice Captain": 500,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 500,
    "Healer": 7000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 500,
    "Speed": 1000,
    "Weapon Skill": 500,
    "Willpower": 8500,
    "Power": 500,
    "Hax": 1200,
    "Defence": 500,
    "IQ": 7500
  },
  "Izo": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 6500,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5000,
    "IQ": 6000
  },
  "Jesus Burgess": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 5500,
    "Combat Power": 7000,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 7000,
    "Power": 8000,
    "Hax": 6000,
    "Defence": 7500,
    "IQ": 5000
  },
  "Jozu": {
    "Captain": 6500,
    "Vice Captain": 7500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 6000,
    "Combat Power": 7500,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 7500,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 9500,
    "IQ": 5500
  },
  "Karasu": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 8500,
    "Weapon Skill": 5500,
    "Willpower": 7000,
    "Power": 6500,
    "Hax": 8000,
    "Defence": 5000,
    "IQ": 7000
  },
  "Koala": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 3000,
    "Speed": 4000,
    "Weapon Skill": 3500,
    "Willpower": 6000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 2500,
    "IQ": 6500
  },
  "Lafitte": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 6000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 7500
  },
  "Lindbergh": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 8000
  },
  "Lucky Roux": {
    "Captain": 5000,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 6000,
    "Speed": 9999,
    "Weapon Skill": 5000,
    "Willpower": 6500,
    "Power": 7000,
    "Hax": 4000,
    "Defence": 6000,
    "IQ": 5500
  },
  "Momonga": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6500,
    "Combat Power": 6500,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 7000,
    "Power": 6500,
    "Hax": 2500,
    "Defence": 6000,
    "IQ": 6500
  },
  "Morley": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 5500,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 5500,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 8000,
    "IQ": 6000
  },
  "Oars Jr": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2000,
    "Combat Power": 6500,
    "Speed": 2000,
    "Weapon Skill": 4000,
    "Willpower": 7500,
    "Power": 8000,
    "Hax": 1200,
    "Defence": 8500,
    "IQ": 3000
  },
  "Onigumo": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 6000,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 6000,
    "IQ": 6000
  },
  "Princess Vivi": {
    "Captain": 1500,
    "Vice Captain": 2000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 1200,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2500,
    "Weapon Skill": 2500,
    "Willpower": 6000,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 1200,
    "IQ": 7000
  },
  "Sanjuan Wolf": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 4000,
    "Combat Power": 6500,
    "Speed": 1500,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 9500,
    "IQ": 3500
  },
  "Scopper Gaban": {
    "Captain": 8000,
    "Vice Captain": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9000,
    "Combat Power": 8500,
    "Speed": 8500,
    "Weapon Skill": 9500,
    "Willpower": 9000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 8000
  },
  "Sentomaru": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 2500,
    "Defence": 7500,
    "IQ": 6000
  },
  "Shiki": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9000,
    "Combat Power": 9200,
    "Speed": 8000,
    "Weapon Skill": 9000,
    "Willpower": 9500,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8500,
    "IQ": 9000
  },
  "Shiryu": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7000,
    "Combat Power": 8500,
    "Speed": 6000,
    "Weapon Skill": 9500,
    "Willpower": 7000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 7000,
    "IQ": 7500
  },
  "Stussy": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 6500,
    "Combat Power": 6000,
    "Speed": 7000,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 7500,
    "Defence": 4500,
    "IQ": 8000
  },
  "T-Bone": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 4000,
    "IQ": 5000
  },
  "Tsuru": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7000,
    "Combat Power": 6000,
    "Speed": 5500,
    "Weapon Skill": 6000,
    "Willpower": 8000,
    "Power": 6000,
    "Hax": 8500,
    "Defence": 5000,
    "IQ": 9500
  },
  "Van Augur": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 6000,
    "Combat Power": 6000,
    "Speed": 9000,
    "Weapon Skill": 9000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 7000
  },
  "Vasco Shot": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 5000,
    "Combat Power": 6500,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 7500,
    "IQ": 4000
  },
  "Vegapunk": {
    "Captain": 6000,
    "Vice Captain": 2500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 2000,
    "Healer": 9999,
    "Devil Fruit": 9000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2000,
    "Weapon Skill": 2000,
    "Willpower": 7000,
    "Power": 2500,
    "Hax": 9500,
    "Defence": 2000,
    "IQ": 9999
  },
  "Vista": {
    "Captain": 6500,
    "Vice Captain": 7500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Weapon Skill": 9000,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 2200,
    "Defence": 6000,
    "IQ": 6500
  },
  "Wapol": {
    "Captain": 1500,
    "Vice Captain": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 4500,
    "Haki": 1000,
    "Combat Power": 1800,
    "Speed": 2000,
    "Weapon Skill": 2000,
    "Willpower": 3000,
    "Power": 2500,
    "Hax": 4500,
    "Defence": 3500,
    "IQ": 5000
  },
  "Yasopp": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8000,
    "Combat Power": 7000,
    "Speed": 7500,
    "Weapon Skill": 9800,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 4500,
    "Defence": 5500,
    "IQ": 7500
  },
  "Whitebeard": {
    "Captain": 9990,
    "Vice Captain": 9000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9900,
    "Healer": 1000,
    "Devil Fruit": 9999,
    "Haki": 9500,
    "Combat Power": 9999,
    "Speed": 8000,
    "Weapon Skill": 9500,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9900,
    "IQ": 8800
  },
  "Marco (Base)": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8500,
    "Healer": 8000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 7500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 8500,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 8500,
    "IQ": 7500
  },
  "Marco (Full Phoenix Regeneration)": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9500,
    "Healer": 9000,
    "Devil Fruit": 9000,
    "Haki": 7500,
    "Combat Power": 8000,
    "Speed": 9500,
    "Weapon Skill": 6000,
    "Willpower": 9000,
    "Power": 8000,
    "Hax": 9000,
    "Defence": 9500,
    "IQ": 7500
  },
  "Akainu": {
    "Captain": 9200,
    "Vice Captain": 8000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9000,
    "Combat Power": 9300,
    "Speed": 7000,
    "Weapon Skill": 6000,
    "Willpower": 9200,
    "Power": 9300,
    "Hax": 9700,
    "Defence": 9000,
    "IQ": 8000
  },
  "Aokiji": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8800,
    "Healer": 1000,
    "Devil Fruit": 9300,
    "Haki": 8500,
    "Combat Power": 8700,
    "Speed": 6500,
    "Weapon Skill": 6000,
    "Willpower": 8500,
    "Power": 8700,
    "Hax": 9600,
    "Defence": 8800,
    "IQ": 8000
  },
  "Kizaru": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 9400,
    "Haki": 8500,
    "Combat Power": 8800,
    "Speed": 9999,
    "Weapon Skill": 7000,
    "Willpower": 8000,
    "Power": 8800,
    "Hax": 9700,
    "Defence": 8500,
    "IQ": 7500
  },
  "Fujitora": {
    "Captain": 8900,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8600,
    "Healer": 1000,
    "Devil Fruit": 9200,
    "Haki": 8800,
    "Combat Power": 8600,
    "Speed": 6000,
    "Weapon Skill": 7500,
    "Willpower": 9000,
    "Power": 8800,
    "Hax": 9200,
    "Defence": 8600,
    "IQ": 8500
  },
  "Ryokugyu (Greenbull)": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 8000,
    "Combat Power": 8000,
    "Speed": 5500,
    "Weapon Skill": 1000,
    "Willpower": 5000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 7000,
    "IQ": 6000
  },
  "Garp (Base)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9800,
    "Combat Power": 9500,
    "Speed": 8000,
    "Weapon Skill": 1000,
    "Willpower": 9800,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 9000,
    "IQ": 8000
  },
  "Hero Garp (Full Haki)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9999,
    "Combat Power": 9800,
    "Speed": 9000,
    "Weapon Skill": 1000,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9800,
    "Defence": 9800,
    "IQ": 8000
  },
  "Sengoku (Base)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 9000,
    "Combat Power": 8500,
    "Speed": 6500,
    "Weapon Skill": 7000,
    "Willpower": 9500,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 8000,
    "IQ": 9000
  },
  "Sengoku (Buddha)": {
    "Captain": 9200,
    "Vice Captain": 8000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9200,
    "Combat Power": 9200,
    "Speed": 7000,
    "Weapon Skill": 7500,
    "Willpower": 9700,
    "Power": 9200,
    "Hax": 9800,
    "Defence": 9500,
    "IQ": 9000
  },
  "Koby": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 3500,
    "Speed": 4500,
    "Weapon Skill": 3000,
    "Willpower": 9800,
    "Power": 4500,
    "Hax": 1800,
    "Defence": 3500,
    "IQ": 6000
  },
  "Smoker": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 5000,
    "Combat Power": 4500,
    "Speed": 5500,
    "Weapon Skill": 4500,
    "Willpower": 6500,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 7500,
    "IQ": 6000
  },
  "Luffy (Base)": {
    "Captain": 8500,
    "Vice Captain": 5000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 7500,
    "Combat Power": 6000,
    "Speed": 6500,
    "Weapon Skill": 1000,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 6000,
    "IQ": 4000
  },
  "Luffy (Gear 2)": {
    "Captain": 7200,
    "Vice Captain": 5200,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6200,
    "Healer": 1000,
    "Devil Fruit": 6800,
    "Haki": 7500,
    "Combat Power": 6500,
    "Speed": 8500,
    "Weapon Skill": 1000,
    "Willpower": 8600,
    "Power": 7500,
    "Hax": 6800,
    "Defence": 6200,
    "IQ": 4200
  },
  "Luffy (Gear 3)": {
    "Captain": 7300,
    "Vice Captain": 5300,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 7600,
    "Combat Power": 8000,
    "Speed": 8000,
    "Weapon Skill": 6800,
    "Willpower": 8700,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7500,
    "IQ": 4300
  },
  "Luffy (Gear 4 Boundman)": {
    "Captain": 8500,
    "Vice Captain": 6500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8800,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 8500,
    "Combat Power": 9000,
    "Speed": 8000,
    "Weapon Skill": 1000,
    "Willpower": 9200,
    "Power": 9300,
    "Hax": 8500,
    "Defence": 8800,
    "IQ": 5500
  },
  "Luffy (Gear 4 Snakeman)": {
    "Captain": 8500,
    "Vice Captain": 6500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 8500,
    "Combat Power": 8500,
    "Speed": 9500,
    "Weapon Skill": 8200,
    "Willpower": 9200,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 6000
  },
  "Luffy (Gear 5)": {
    "Captain": 9800,
    "Vice Captain": 8000,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Devil Fruit": 9999,
    "Haki": 9500,
    "Combat Power": 9999,
    "Speed": 9800,
    "Weapon Skill": 1000,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9500,
    "IQ": 7500
  },
  "Zoro (Base)": {
    "Captain": 5000,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7500,
    "Combat Power": 7500,
    "Speed": 6000,
    "Weapon Skill": 9000,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 3000,
    "Defence": 7000,
    "IQ": 5000
  },
  "Zoro (Asura)": {
    "Captain": 5000,
    "Vice Captain": 9000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8500,
    "Combat Power": 9000,
    "Speed": 7500,
    "Weapon Skill": 9500,
    "Willpower": 9999,
    "Power": 9000,
    "Hax": 4500,
    "Defence": 8000,
    "IQ": 5000
  },
  "Law": {
    "Captain": 9000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 8000,
    "Devil Fruit": 9000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Weapon Skill": 7500,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 6000,
    "IQ": 9000
  },
  "Eustass Kid": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 6500,
    "Combat Power": 8000,
    "Speed": 5500,
    "Weapon Skill": 6000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 7000,
    "IQ": 6000
  },
  "Killer": {
    "Captain": 5000,
    "Vice Captain": 7000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 7500,
    "Weapon Skill": 8000,
    "Willpower": 7000,
    "Power": 6500,
    "Hax": 3500,
    "Defence": 5500,
    "IQ": 6500
  },
  "Apoo": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 3000,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 5500,
    "Willpower": 4500,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000,
    "IQ": 5500
  },
  "Basil Hawkins": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 3500,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 6000,
    "IQ": 7000
  },
  "Urouge": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 6000,
    "Speed": 4500,
    "Weapon Skill": 4500,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 7000,
    "IQ": 5000
  },
  "Bonney": {
    "Captain": 7000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3000,
    "Healer": 5000,
    "Devil Fruit": 6500,
    "Haki": 2500,
    "Combat Power": 3000,
    "Speed": 4000,
    "Weapon Skill": 2000,
    "Willpower": 6000,
    "Power": 3000,
    "Hax": 6500,
    "Defence": 3000,
    "IQ": 6000
  },
  "Capone Bege": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 3000,
    "Combat Power": 4500,
    "Speed": 3500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 6500,
    "IQ": 6500
  },
  "X Drake (Base)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4500,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 3500,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 6000,
    "IQ": 6000
  },
  "X Drake (Allosaurus)": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 5000,
    "Combat Power": 6500,
    "Speed": 5500,
    "Weapon Skill": 5500,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 7500,
    "IQ": 5500
  },
  "Kaido (Base)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9700,
    "Combat Power": 9700,
    "Speed": 8000,
    "Weapon Skill": 9000,
    "Willpower": 9500,
    "Power": 9700,
    "Hax": 9500,
    "Defence": 9800,
    "IQ": 7800
  },
  "Kaido (Dragon)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 9100,
    "Support 2": 9100,
    "Tank": 9900,
    "Healer": 1000,
    "Devil Fruit": 9700,
    "Haki": 9500,
    "Combat Power": 9800,
    "Speed": 7000,
    "Weapon Skill": 8500,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9700,
    "Defence": 9900,
    "IQ": 7800
  },
  "Kaido (Flame Dragon)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 9200,
    "Support 2": 9200,
    "Tank": 9900,
    "Healer": 1000,
    "Devil Fruit": 9800,
    "Haki": 9500,
    "Combat Power": 9900,
    "Speed": 9200,
    "Weapon Skill": 8500,
    "Willpower": 9500,
    "Power": 9900,
    "Hax": 9800,
    "Defence": 9900,
    "IQ": 7800
  },
  "Kaido (Hybrid)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9600,
    "Healer": 1000,
    "Devil Fruit": 9900,
    "Haki": 9700,
    "Combat Power": 9999,
    "Speed": 9000,
    "Weapon Skill": 9500,
    "Willpower": 9700,
    "Power": 9999,
    "Hax": 9900,
    "Defence": 9999,
    "IQ": 8200
  },
  "Big Mom": {
    "Captain": 9600,
    "Vice Captain": 8500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9700,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9000,
    "Combat Power": 9600,
    "Speed": 6500,
    "Weapon Skill": 8000,
    "Willpower": 9400,
    "Power": 9600,
    "Hax": 9500,
    "Defence": 9700,
    "IQ": 7500
  },
  "Big Mom (Hera Fusion)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9700,
    "Healer": 1000,
    "Devil Fruit": 9700,
    "Haki": 9000,
    "Combat Power": 9700,
    "Speed": 7000,
    "Weapon Skill": 8000,
    "Willpower": 9400,
    "Power": 9700,
    "Hax": 9700,
    "Defence": 9700,
    "IQ": 7500
  },
  "Big Mom (Prometheus Rage Mode)": {
    "Captain": 9800,
    "Vice Captain": 9200,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 9800,
    "Haki": 9000,
    "Combat Power": 9600,
    "Speed": 7500,
    "Weapon Skill": 8000,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9800,
    "Defence": 9800,
    "IQ": 7500
  },
  "Big Mom (Zeus Fusion)": {
    "Captain": 9700,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9700,
    "Healer": 1000,
    "Devil Fruit": 9700,
    "Haki": 9000,
    "Combat Power": 9700,
    "Speed": 8000,
    "Weapon Skill": 8000,
    "Willpower": 9400,
    "Power": 9700,
    "Hax": 9700,
    "Defence": 9700,
    "IQ": 7500
  },
  "Blackbeard": {
    "Captain": 9500,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9200,
    "Healer": 1000,
    "Devil Fruit": 9999,
    "Haki": 8500,
    "Combat Power": 9400,
    "Speed": 6000,
    "Weapon Skill": 7000,
    "Willpower": 9000,
    "Power": 9700,
    "Hax": 9999,
    "Defence": 9200,
    "IQ": 9000
  },
  "Shanks": {
    "Captain": 9900,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9600,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9999,
    "Combat Power": 9700,
    "Speed": 9800,
    "Weapon Skill": 9999,
    "Willpower": 9800,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 8500,
    "IQ": 9300
  },
  "Silvers Rayleigh": {
    "Captain": 9300,
    "Vice Captain": 9500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9800,
    "Combat Power": 9300,
    "Speed": 9600,
    "Weapon Skill": 9700,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9700,
    "Defence": 8500,
    "IQ": 9500
  },
  "Katakuri (Base)": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 9000,
    "Combat Power": 8000,
    "Speed": 8000,
    "Weapon Skill": 7000,
    "Willpower": 8500,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 8500
  },
  "Katakuri (Awakening Mochi)": {
    "Captain": 8000,
    "Vice Captain": 9000,
    "Support 1": 6550,
    "Support 2": 6550,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 8000,
    "Combat Power": 8500,
    "Speed": 8500,
    "Weapon Skill": 7000,
    "Willpower": 8800,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 8500,
    "IQ": 8500
  },
  "King (Base)": {
    "Captain": 5947,
    "Vice Captain": 5647,
    "Tank": 6047,
    "Healer": 1000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6297,
    "Speed": 8000,
    "Magic Specialist": 5547,
    "Willpower": 5797,
    "Power": 6297,
    "Hax": 3500,
    "Defence": 6047,
    "IQ": 5597
  },
  "King (Lunarian Flame Mode)": {
    "Captain": 7000,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7500,
    "Combat Power": 8500,
    "Speed": 6000,
    "Weapon Skill": 8000,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 9800,
    "IQ": 6200
  },
  "Queen (Base)": {
    "Captain": 6500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 7500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 8500,
    "IQ": 8500
  },
  "Queen (Brachiosaurus)": {
    "Captain": 6800,
    "Vice Captain": 7800,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 7800,
    "Haki": 6000,
    "Combat Power": 8000,
    "Speed": 4000,
    "Weapon Skill": 5500,
    "Willpower": 6500,
    "Power": 8000,
    "Hax": 7800,
    "Defence": 9000,
    "IQ": 8000
  },
  "Queen (Plague)": {
    "Captain": 6999,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 6000,
    "Combat Power": 7500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 8500,
    "IQ": 8000
  },
  "Jack (Base)": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 5500,
    "Combat Power": 7500,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 9000,
    "IQ": 4500
  },
  "Jack (Mammoth)": {
    "Captain": 6500,
    "Vice Captain": 7500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 5500,
    "Combat Power": 8000,
    "Speed": 3000,
    "Weapon Skill": 4500,
    "Willpower": 7000,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 9500,
    "IQ": 4000
  },
  "Charlotte Smoothie": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 5500,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 7500,
    "IQ": 6000
  },
  "Who's-Who (Base)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4500,
    "Combat Power": 5500,
    "Speed": 6000,
    "Weapon Skill": 6500,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 6000,
    "IQ": 5000
  },
  "Who's-Who (Saber-Tooth Tiger)": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 5000,
    "Combat Power": 6500,
    "Speed": 6500,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 7500,
    "IQ": 4500
  },
  "Sasaki (Base)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 6500,
    "IQ": 4500
  },
  "Sasaki (Triceratops)": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 4500,
    "Combat Power": 6500,
    "Speed": 4000,
    "Weapon Skill": 4500,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 8000,
    "IQ": 4000
  },
  "Black Maria (Base)": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 3500,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 4500,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 5500,
    "IQ": 5500
  },
  "Black Maria (Rosamygale Grauvogeli Spider)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 4500,
    "Weapon Skill": 4000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 7000,
    "IQ": 5000
  },
  "Page One (Base)": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 3000,
    "Combat Power": 4500,
    "Speed": 4500,
    "Weapon Skill": 4000,
    "Willpower": 4500,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 6000,
    "IQ": 4000
  },
  "Page One (Spinosaurus)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 3500,
    "Combat Power": 5500,
    "Speed": 4000,
    "Weapon Skill": 3500,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 7500,
    "IQ": 3500
  },
  "Ulti (Base)": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 4000,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 4500,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 6500,
    "IQ": 4000
  },
  "Ulti (Hybrid)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4500,
    "Combat Power": 6000,
    "Speed": 5500,
    "Weapon Skill": 4000,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 7500,
    "IQ": 3500
  },
  "Mihawk": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9550,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9500,
    "Combat Power": 9000,
    "Speed": 9700,
    "Weapon Skill": 9999,
    "Willpower": 9000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 9000,
    "IQ": 8500
  },
  "Boa Hancock": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7500,
    "Combat Power": 6500,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 7500,
    "Power": 7500,
    "Hax": 8000,
    "Defence": 6000,
    "IQ": 7000
  },
  "Doflamingo": {
    "Captain": 8000,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 8500,
    "Weapon Skill": 6000,
    "Willpower": 8000,
    "Power": 7000,
    "Hax": 9200,
    "Defence": 9000,
    "IQ": 8500
  },
  "Crocodile": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 8300,
    "Speed": 5000,
    "Weapon Skill": 5000,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 5500,
    "IQ": 8000
  },
  "Corazon": {
    "Captain": 4000,
    "Vice Captain": 4800,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 3500,
    "Combat Power": 3800,
    "Speed": 5000,
    "Weapon Skill": 3000,
    "Willpower": 8000,
    "Power": 4000,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 6500
  },
  "Gecko Moria": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 3000,
    "Combat Power": 5000,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 4000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 5500,
    "IQ": 6000
  },
  "Gecko Moria (Shadow Asgard)": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 4000,
    "Combat Power": 7500,
    "Speed": 4500,
    "Weapon Skill": 4500,
    "Willpower": 5000,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 5500
  },
  "Bartholomew Kuma (Base)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7500,
    "Healer": 5000,
    "Devil Fruit": 8000,
    "Haki": 5500,
    "Combat Power": 6500,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 7000,
    "Power": 6500,
    "Hax": 8000,
    "Defence": 7500,
    "IQ": 6500
  },
  "Buggy": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 3000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 2000,
    "Weapon Skill": 2000,
    "Willpower": 6000,
    "Power": 2000,
    "Hax": 3000,
    "Defence": 2500,
    "IQ": 5000
  },
  "Enel (Base)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 5500,
    "Speed": 8000,
    "Weapon Skill": 4000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 8500,
    "Defence": 5000,
    "IQ": 6000
  },
  "Enel (Raijin Amaru Lightning Giant)": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 8000,
    "Weapon Skill": 3500,
    "Willpower": 5500,
    "Power": 7000,
    "Hax": 9500,
    "Defence": 7000,
    "IQ": 5500
  },
  "Magellan (Base)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 3000,
    "Combat Power": 6000,
    "Speed": 3500,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 6500,
    "IQ": 6500
  },
  "Magellan (Venom Demon)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 3500,
    "Combat Power": 7500,
    "Speed": 3000,
    "Weapon Skill": 2500,
    "Willpower": 6500,
    "Power": 7500,
    "Hax": 9000,
    "Defence": 8500,
    "IQ": 6000
  },
  "Kozuki Oden": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9000,
    "Combat Power": 9000,
    "Speed": 8000,
    "Weapon Skill": 9500,
    "Willpower": 9999,
    "Power": 9000,
    "Hax": 4000,
    "Defence": 8000,
    "IQ": 7500
  },
  "Yamato (Base)": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8000,
    "Combat Power": 8000,
    "Speed": 7000,
    "Weapon Skill": 7500,
    "Willpower": 9000,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 8000,
    "IQ": 5500
  },
  "Yamato (Hybrid)": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8000,
    "Speed": 8000,
    "Weapon Skill": 7500,
    "Willpower": 9000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 5500
  },
  "Sabo (Base)": {
    "Captain": 7000,
    "Vice Captain": 9000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 7500,
    "Weapon Skill": 7000,
    "Willpower": 8500,
    "Power": 7000,
    "Hax": 3500,
    "Defence": 6500,
    "IQ": 8000
  },
  "Sabo (Mera Mera Awakening)": {
    "Captain": 8000,
    "Vice Captain": 8700,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8000,
    "Combat Power": 8000,
    "Speed": 8500,
    "Weapon Skill": 6500,
    "Willpower": 9000,
    "Power": 8800,
    "Hax": 9000,
    "Defence": 7000,
    "IQ": 8000
  },
  "Monkey D. Dragon": {
    "Captain": 9800,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9500,
    "Combat Power": 9000,
    "Speed": 9000,
    "Weapon Skill": 8000,
    "Willpower": 9800,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 8000,
    "IQ": 9999
  },
  "Rocks D. Xebec": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9800,
    "Combat Power": 9999,
    "Speed": 8500,
    "Weapon Skill": 9500,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9700,
    "Defence": 9800,
    "IQ": 9000
  },
  "Imu": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Devil Fruit": 9999,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Weapon Skill": 9999,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999
  },
  "Jaygarcia Saturn": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8000,
    "Speed": 6000,
    "Weapon Skill": 6000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 9000
  },
  "Jaygarcia Saturn (Gyuki Monster Form)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9500,
    "Healer": 1000,
    "Devil Fruit": 9800,
    "Haki": 9000,
    "Combat Power": 9500,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 9000,
    "Power": 9500,
    "Hax": 9800,
    "Defence": 9500,
    "IQ": 8500
  },
  "Saint Topman Warcury": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8500,
    "Speed": 8900,
    "Weapon Skill": 6000,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 9000,
    "IQ": 8000
  },
  "Topman Warcury (Butsu Monster Form)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 9700,
    "Haki": 9000,
    "Combat Power": 9500,
    "Speed": 6000,
    "Weapon Skill": 5500,
    "Willpower": 8500,
    "Power": 9500,
    "Hax": 9700,
    "Defence": 9800,
    "IQ": 7500
  },
  "Saint Marcus Mars": {
    "Captain": 8500,
    "Vice Captain": 8300,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8300,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8500,
    "IQ": 8500
  },
  "Saint Shepherd Ju Peter": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8000,
    "Speed": 6500,
    "Weapon Skill": 5500,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 9000
  },
  "Saint Ethan Baron": {
    "Captain": 9250,
    "Vice Captain": 7500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8800,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8500,
    "Speed": 6000,
    "Weapon Skill": 8500,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8800,
    "IQ": 8000
  },
  "Lucci (Base)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 5000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 5500,
    "IQ": 6500
  },
  "Lucci (Hybrid Leopard)": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 8000,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 7000,
    "IQ": 6000
  },
  "Lucci (Awakened Leopard)": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 8000,
    "Speed": 9000,
    "Weapon Skill": 5500,
    "Willpower": 7000,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 8500,
    "IQ": 5500
  },
  "Kaku (Base)": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4000,
    "Combat Power": 4500,
    "Speed": 6000,
    "Weapon Skill": 6000,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 5000,
    "IQ": 6000
  },
  "S-Hawk": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 6000,
    "Combat Power": 7000,
    "Speed": 6500,
    "Weapon Skill": 8000,
    "Willpower": 5000,
    "Power": 7000,
    "Hax": 3000,
    "Defence": 8000,
    "IQ": 4000
  },
  "S-Bear": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 7500,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 6500,
    "Hax": 7500,
    "Defence": 8000,
    "IQ": 4000
  },
  "S-Snake": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 6000,
    "Weapon Skill": 5500,
    "Willpower": 5000,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 7000,
    "IQ": 4000
  },
  "S-Shark": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 6000,
    "Combat Power": 7000,
    "Speed": 5500,
    "Weapon Skill": 6500,
    "Willpower": 5000,
    "Power": 7000,
    "Hax": 5000,
    "Defence": 8000,
    "IQ": 4000
  },
  "Caesar Clown": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 2000,
    "Healer": 2500,
    "Devil Fruit": 8000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Weapon Skill": 2000,
    "Willpower": 2000,
    "Power": 2500,
    "Hax": 6500,
    "Defence": 2000,
    "IQ": 8000
  },
  "Emporio Ivankov": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4000,
    "Healer": 6000,
    "Devil Fruit": 6000,
    "Haki": 3500,
    "Combat Power": 4000,
    "Speed": 5000,
    "Weapon Skill": 3000,
    "Willpower": 7000,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 4000,
    "IQ": 7000
  },
  "Kurozumi Orochi": {
    "Captain": 1500,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 1800,
    "Speed": 2000,
    "Weapon Skill": 1500,
    "Willpower": 2500,
    "Power": 1800,
    "Hax": 4000,
    "Defence": 2000,
    "IQ": 4000
  },
  "Kuma (Pacifista Modifications)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 5000,
    "Devil Fruit": 7000,
    "Haki": 4000,
    "Combat Power": 6000,
    "Speed": 5000,
    "Weapon Skill": 4500,
    "Willpower": 4000,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 8000,
    "IQ": 6000
  },
  "Brogy": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2000,
    "Combat Power": 5000,
    "Speed": 2000,
    "Weapon Skill": 4000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 1200,
    "Defence": 7000,
    "IQ": 3000
  },
  "Dorry": {
    "Captain": 8000,
    "Vice Captain": 3500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2000,
    "Combat Power": 5000,
    "Speed": 2000,
    "Weapon Skill": 4000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 1200,
    "Defence": 7000,
    "IQ": 3000
  },
  "Hajrudin": {
    "Captain": 6500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1500,
    "Combat Power": 4000,
    "Speed": 2500,
    "Weapon Skill": 3500,
    "Willpower": 5500,
    "Power": 4000,
    "Hax": 1200,
    "Defence": 6000,
    "IQ": 3500
  },
  "Sanji (Base)": {
    "Captain": 4500,
    "Vice Captain": 6000,
    "Support 1": 6600,
    "Support 2": 6600,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 6000,
    "Speed": 7500,
    "Weapon Skill": 3000,
    "Willpower": 7000,
    "Power": 6000,
    "Hax": 2500,
    "Defence": 5500,
    "IQ": 6000
  },
  "Sanji (Diable Jambe)": {
    "Captain": 5000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 7500,
    "Speed": 8500,
    "Weapon Skill": 5000,
    "Willpower": 7500,
    "Power": 7500,
    "Hax": 3500,
    "Defence": 6000,
    "IQ": 6200
  },
  "Sanji (Ifrit Jambe)": {
    "Captain": 6500,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 9000,
    "Speed": 9500,
    "Weapon Skill": 1000,
    "Willpower": 8500,
    "Power": 9000,
    "Hax": 4500,
    "Defence": 8000,
    "IQ": 6500
  },
  "Nami (Base)": {
    "Captain": 2000,
    "Vice Captain": 6000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Weapon Skill": 4000,
    "Willpower": 4000,
    "Power": 2500,
    "Hax": 3000,
    "Defence": 1500,
    "IQ": 8500
  },
  "Nami (Zeus)": {
    "Captain": 2000,
    "Vice Captain": 6000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 3500,
    "Weapon Skill": 6000,
    "Willpower": 4500,
    "Power": 5500,
    "Hax": 8000,
    "Defence": 2000,
    "IQ": 8500
  },
  "Usopp (Base)": {
    "Captain": 1500,
    "Vice Captain": 2000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 1200,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 1500,
    "Speed": 2500,
    "Weapon Skill": 7000,
    "Willpower": 3000,
    "Power": 3500,
    "Hax": 3500,
    "Defence": 1200,
    "IQ": 7000
  },
  "Usopp (Sogeking)": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 1500,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 2000,
    "Speed": 3000,
    "Weapon Skill": 7500,
    "Willpower": 6000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 1500,
    "IQ": 7200
  },
  "Chopper": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 2000,
    "Healer": 9000,
    "Devil Fruit": 4000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 2500,
    "Weapon Skill": 2500,
    "Willpower": 5000,
    "Power": 2000,
    "Hax": 4000,
    "Defence": 2000,
    "IQ": 8000
  },
  "Chopper (Monster Point)": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 3000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 7500,
    "Speed": 4000,
    "Weapon Skill": 1500,
    "Willpower": 6000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 8000,
    "IQ": 3000
  },
  "Nico Robin (Base)": {
    "Captain": 2000,
    "Vice Captain": 3000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 1800,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 3500,
    "Weapon Skill": 1000,
    "Willpower": 8000,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 1800,
    "IQ": 8000
  },
  "Nico Robin (Demonio Fleur)": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 3000,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 5000,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7500,
    "Defence": 4000,
    "IQ": 8000
  },
  "Franky (Base)": {
    "Captain": 2500,
    "Vice Captain": 3500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7000,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 3000,
    "Weapon Skill": 6000,
    "Willpower": 5500,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 7000,
    "IQ": 7500
  },
  "General Franky": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8500,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 7000,
    "Speed": 4000,
    "Weapon Skill": 7000,
    "Willpower": 6000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 8500,
    "IQ": 7000
  },
  "Brook (Base)": {
    "Captain": 2000,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 4500,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 6000,
    "Weapon Skill": 6000,
    "Willpower": 4000,
    "Power": 3000,
    "Hax": 4500,
    "Defence": 1500,
    "IQ": 5000
  },
  "Brook (Soul King)": {
    "Captain": 2500,
    "Vice Captain": 3500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1500,
    "Combat Power": 4000,
    "Speed": 9500,
    "Weapon Skill": 6500,
    "Willpower": 5000,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 2000,
    "IQ": 5500
  },
  "Jinbe": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 8500,
    "Speed": 5500,
    "Weapon Skill": 4000,
    "Willpower": 8000,
    "Power": 7000,
    "Hax": 3000,
    "Defence": 8000,
    "IQ": 6500
  },
  "Albion": {
    "Captain": 6200,
    "Vice Captain": 5900,
    "Tank": 7500,
    "Healer": 1000,
    "Support 1": 5800,
    "Support 2": 5800,
    "Demon Form": 6500,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6700,
    "Speed": 5800,
    "Magic Specialist": 5900,
    "Willpower": 6500,
    "Power": 6700,
    "Hax": 6500,
    "Defence": 7500,
    "IQ": 6000
  },
  "Anne": {
    "Captain": 1800,
    "Vice Captain": 1600,
    "Tank": 1900,
    "Healer": 1000,
    "Support 1": 1500,
    "Support 2": 1500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 2100,
    "Speed": 1700,
    "Magic Specialist": 1500,
    "Willpower": 1800,
    "Power": 2100,
    "Hax": 1200,
    "Defence": 1900,
    "IQ": 1600
  },
  "Arthur (Chaos Vessel)": {
    "Captain": 7200,
    "Vice Captain": 6900,
    "Tank": 7300,
    "Healer": 1000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 7800,
    "Combat Power": 7600,
    "Speed": 7000,
    "Magic Specialist": 6800,
    "Willpower": 7100,
    "Power": 7600,
    "Hax": 7800,
    "Defence": 7300,
    "IQ": 6900
  },
  "Arthur Pendragon": {
    "Captain": 4500,
    "Vice Captain": 3400,
    "Tank": 3800,
    "Healer": 1000,
    "Support 1": 3200,
    "Support 2": 3200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Magic Specialist": 3300,
    "Willpower": 3600,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3800,
    "IQ": 5500
  },
  "Arthur Pendragon (Chaos King)": {
    "Captain": 9000,
    "Vice Captain": 7800,
    "Tank": 8200,
    "Healer": 1000,
    "Support 1": 7600,
    "Support 2": 7600,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 8700,
    "Combat Power": 8500,
    "Speed": 7900,
    "Magic Specialist": 7700,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 8700,
    "Defence": 8200,
    "IQ": 9999
  },
  "Ban (Base)": {
    "Captain": 3300,
    "Vice Captain": 3000,
    "Tank": 3400,
    "Healer": 1000,
    "Support 1": 2800,
    "Support 2": 2800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3100,
    "Magic Specialist": 2900,
    "Willpower": 5000,
    "Power": 3600,
    "Hax": 2500,
    "Defence": 3400,
    "IQ": 3000
  },
  "Ban (Purgatory)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 7900,
    "Healer": 6000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8100,
    "Speed": 9600,
    "Magic Specialist": 7400,
    "Willpower": 9999,
    "Power": 8100,
    "Hax": 5000,
    "Defence": 7900,
    "IQ": 7500
  },
  "Ban (Sacred Treasure Courechouse)": {
    "Captain": 7100,
    "Vice Captain": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Support 1": 6600,
    "Support 2": 6600,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7500,
    "Speed": 6900,
    "Magic Specialist": 6700,
    "Willpower": 8900,
    "Power": 7500,
    "Hax": 4000,
    "Defence": 7200,
    "IQ": 6800
  },
  "Cath Palug (Base)": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 3000,
    "Defence": 3900,
    "IQ": 3500
  },
  "Cath Palug (Beast)": {
    "Captain": 8200,
    "Vice Captain": 7900,
    "Tank": 8300,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 8500,
    "Combat Power": 8600,
    "Speed": 8000,
    "Magic Specialist": 7800,
    "Willpower": 8100,
    "Power": 8600,
    "Hax": 8500,
    "Defence": 8300,
    "IQ": 7900
  },
  "Chandler (Base)": {
    "Captain": 3100,
    "Vice Captain": 2800,
    "Tank": 3200,
    "Healer": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Demon Form": 3300,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8000,
    "Speed": 2900,
    "Magic Specialist": 4600,
    "Willpower": 3000,
    "Power": 3500,
    "Hax": 3300,
    "Defence": 3200,
    "IQ": 2800
  },
  "Chandler (Demon)": {
    "Captain": 7100,
    "Vice Captain": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Support 1": 6600,
    "Support 2": 6600,
    "Demon Form": 7300,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7500,
    "Speed": 6900,
    "Magic Specialist": 8600,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 7300,
    "Defence": 7200,
    "IQ": 6800
  },
  "Cusack (Base)": {
    "Captain": 3100,
    "Vice Captain": 2800,
    "Tank": 3200,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Demon Form": 3300,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3500,
    "Speed": 2900,
    "Magic Specialist": 4600,
    "Willpower": 3000,
    "Power": 3500,
    "Hax": 3300,
    "Defence": 3200,
    "IQ": 2800
  },
  "Cusack (Demon)": {
    "Captain": 7300,
    "Vice Captain": 7000,
    "Tank": 7400,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Demon Form": 7500,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7700,
    "Speed": 7100,
    "Magic Specialist": 8800,
    "Willpower": 7200,
    "Power": 7700,
    "Hax": 7500,
    "Defence": 7400,
    "IQ": 7000
  },
  "Demon King": {
    "Captain": 9999,
    "Vice Captain": 8600,
    "Tank": 9999,
    "Healer": 1000,
    "Support 1": 8400,
    "Support 2": 8400,
    "Demon Form": 9999,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9999,
    "Speed": 8500,
    "Magic Specialist": 9999,
    "Willpower": 9200,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 8800
  },
  "Demon King Zeldris": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Tank": 9200,
    "Healer": 1000,
    "Support 1": 8300,
    "Support 2": 8300,
    "Demon Form": 9000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9200,
    "Speed": 8400,
    "Magic Specialist": 8500,
    "Willpower": 9100,
    "Power": 9200,
    "Hax": 9999,
    "Defence": 9200,
    "IQ": 8600
  },
  "Denzel Liones": {
    "Captain": 3700,
    "Vice Captain": 3400,
    "Tank": 3800,
    "Healer": 1000,
    "Support 1": 3200,
    "Support 2": 3200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Magic Specialist": 3300,
    "Willpower": 3600,
    "Power": 4000,
    "Hax": 1800,
    "Defence": 3800,
    "IQ": 3400
  },
  "Derieri": {
    "Captain": 6600,
    "Vice Captain": 6300,
    "Tank": 6700,
    "Healer": 1000,
    "Support 1": 6100,
    "Support 2": 6100,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6400,
    "Magic Specialist": 6200,
    "Willpower": 6500,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 6700,
    "IQ": 6300
  },
  "Derieri (Indura)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 7900,
    "Healer": 1000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Demon Form": 8300,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8200,
    "Speed": 7600,
    "Magic Specialist": 7400,
    "Willpower": 7700,
    "Power": 8200,
    "Hax": 8300,
    "Defence": 7900,
    "IQ": 7500
  },
  "Diane (Base)": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 6600,
    "Healer": 1000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5600,
    "Speed": 4800,
    "Magic Specialist": 4900,
    "Willpower": 5500,
    "Power": 5600,
    "Hax": 3500,
    "Defence": 6600,
    "IQ": 5000
  },
  "Diane (Sacred Treasure)": {
    "Captain": 7200,
    "Vice Captain": 6900,
    "Tank": 8500,
    "Healer": 1000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7600,
    "Speed": 6700,
    "Magic Specialist": 6800,
    "Willpower": 7400,
    "Power": 7600,
    "Hax": 8000,
    "Defence": 8500,
    "IQ": 6900
  },
  "Donny": {
    "Captain": 1500,
    "Vice Captain": 1200,
    "Tank": 1600,
    "Healer": 1000,
    "Support 1": 1100,
    "Support 2": 1100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1800,
    "Speed": 1300,
    "Magic Specialist": 1100,
    "Willpower": 1400,
    "Power": 1800,
    "Hax": 1200,
    "Defence": 1600,
    "IQ": 1200
  },
  "Dreyfus": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 3000,
    "Defence": 3900,
    "IQ": 3500
  },
  "Dreyfus (Possessed)": {
    "Captain": 5400,
    "Vice Captain": 5100,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 4900,
    "Support 2": 4900,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 5200,
    "Magic Specialist": 5000,
    "Willpower": 5300,
    "Power": 5800,
    "Hax": 4000,
    "Defence": 5500,
    "IQ": 5100
  },
  "Drole": {
    "Captain": 7200,
    "Vice Captain": 6900,
    "Tank": 8500,
    "Healer": 1000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7600,
    "Speed": 6700,
    "Magic Specialist": 6800,
    "Willpower": 7400,
    "Power": 7600,
    "Hax": 7000,
    "Defence": 8500,
    "IQ": 6900
  },
  "Elaine": {
    "Captain": 3600,
    "Vice Captain": 3300,
    "Tank": 3700,
    "Healer": 4000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3900,
    "Speed": 3400,
    "Magic Specialist": 3200,
    "Willpower": 3500,
    "Power": 3900,
    "Hax": 4200,
    "Defence": 3700,
    "IQ": 4000
  },
  "Elaine (Resurrected)": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 5400,
    "Healer": 5000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 4900,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 6000,
    "Defence": 5400,
    "IQ": 5700
  },
  "Elizabeth": {
    "Captain": 3300,
    "Vice Captain": 3000,
    "Tank": 3400,
    "Healer": 5200,
    "Support 1": 3500,
    "Support 2": 3500,
    "Demon Form": 1000,
    "Goddess Blessing": 3500,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3100,
    "Magic Specialist": 3500,
    "Willpower": 5000,
    "Power": 3600,
    "Hax": 3500,
    "Defence": 3400,
    "IQ": 3000
  },
  "Elizabeth (Goddess)": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 6600,
    "Healer": 8500,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 7000,
    "Chaos User": 1000,
    "Combat Power": 6900,
    "Speed": 6300,
    "Magic Specialist": 6700,
    "Willpower": 6400,
    "Power": 6900,
    "Hax": 7000,
    "Defence": 6600,
    "IQ": 6200
  },
  "Escanor (Day)": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 8400,
    "Healer": 1000,
    "Support 1": 8800,
    "Support 2": 8800,
    "Demon Form": 1000,
    "Goddess Blessing": 9000,
    "Chaos User": 1000,
    "Combat Power": 8000,
    "Speed": 8100,
    "Magic Specialist": 4900,
    "Willpower": 7100,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 8400,
    "IQ": 7000
  },
  "Escanor (Night)": {
    "Captain": 1100,
    "Vice Captain": 1000,
    "Tank": 1200,
    "Healer": 1000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1300,
    "Speed": 1000,
    "Magic Specialist": 1000,
    "Willpower": 9000,
    "Power": 1300,
    "Hax": 1200,
    "Defence": 1200,
    "IQ": 1100
  },
  "Escanor (Sunshine Peak)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 9999,
    "Healer": 1000,
    "Support 1": 8300,
    "Support 2": 8300,
    "Demon Form": 1000,
    "Goddess Blessing": 9000,
    "Chaos User": 1000,
    "Combat Power": 8200,
    "Speed": 8600,
    "Magic Specialist": 7400,
    "Willpower": 9000,
    "Power": 8200,
    "Hax": 9999,
    "Defence": 8900,
    "IQ": 8500
  },
  "Escanor (The One)": {
    "Captain": 8300,
    "Vice Captain": 8000,
    "Tank": 9500,
    "Healer": 1000,
    "Support 1": 8800,
    "Support 2": 8800,
    "Demon Form": 1000,
    "Goddess Blessing": 9000,
    "Chaos User": 1000,
    "Combat Power": 9700,
    "Speed": 9100,
    "Magic Specialist": 8900,
    "Willpower": 9999,
    "Power": 9700,
    "Hax": 9700,
    "Defence": 9400,
    "IQ": 8000
  },
  "Estarossa": {
    "Captain": 7100,
    "Vice Captain": 6800,
    "Tank": 7200,
    "Healer": 1000,
    "Support 1": 6600,
    "Support 2": 6600,
    "Demon Form": 7300,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7500,
    "Speed": 8600,
    "Magic Specialist": 6700,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 9000,
    "Defence": 7200,
    "IQ": 6800
  },
  "Estarossa (Unleashed)": {
    "Captain": 8000,
    "Vice Captain": 7700,
    "Tank": 8100,
    "Healer": 1000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Demon Form": 8200,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8400,
    "Speed": 9500,
    "Magic Specialist": 7600,
    "Willpower": 7900,
    "Power": 8400,
    "Hax": 8200,
    "Defence": 8100,
    "IQ": 7700
  },
  "Fraudrin": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 6600,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 6700,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6900,
    "Speed": 6300,
    "Magic Specialist": 6100,
    "Willpower": 6400,
    "Power": 6900,
    "Hax": 6700,
    "Defence": 6600,
    "IQ": 6200
  },
  "Galand": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 6600,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 6700,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6900,
    "Speed": 8000,
    "Magic Specialist": 6100,
    "Willpower": 6400,
    "Power": 6900,
    "Hax": 6700,
    "Defence": 6600,
    "IQ": 6200
  },
  "Gawain (Base)": {
    "Captain": 5400,
    "Vice Captain": 5100,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 4900,
    "Support 2": 4900,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 5200,
    "Magic Specialist": 5000,
    "Willpower": 5300,
    "Power": 5800,
    "Hax": 3500,
    "Defence": 5500,
    "IQ": 5100
  },
  "Gawain (Sunshine)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 7900,
    "Healer": 1000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8200,
    "Speed": 7600,
    "Magic Specialist": 7400,
    "Willpower": 7700,
    "Power": 8200,
    "Hax": 6500,
    "Defence": 7900,
    "IQ": 7500
  },
  "Gelda": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 7000,
    "Defence": 3900,
    "IQ": 3500
  },
  "Gerheade": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 5700,
    "Support 1": 4000,
    "Support 2": 4000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 5900,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 4000,
    "Defence": 3900,
    "IQ": 3500
  },
  "Gilthunder": {
    "Captain": 5500,
    "Vice Captain": 5900,
    "Tank": 5400,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 4900,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 6500,
    "Defence": 5400,
    "IQ": 5000
  },
  "Gloxinia": {
    "Captain": 7100,
    "Vice Captain": 6800,
    "Tank": 7200,
    "Healer": 8000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7500,
    "Speed": 7000,
    "Magic Specialist": 8600,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 7200,
    "IQ": 6800
  },
  "Gowther": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 5400,
    "Healer": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 4900,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 9500,
    "Defence": 5400,
    "IQ": 9999
  },
  "Gowther (Base)": {
    "Captain": 5500,
    "Vice Captain": 5200,
    "Tank": 5600,
    "Healer": 3500,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5900,
    "Speed": 5300,
    "Magic Specialist": 5100,
    "Willpower": 5400,
    "Power": 5900,
    "Hax": 9500,
    "Defence": 5600,
    "IQ": 7800
  },
  "Gowther (Demon)": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 6600,
    "Healer": 4500,
    "Support 1": 7700,
    "Support 2": 7700,
    "Demon Form": 6700,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6900,
    "Speed": 6300,
    "Magic Specialist": 6100,
    "Willpower": 6400,
    "Power": 6900,
    "Hax": 9500,
    "Defence": 6600,
    "IQ": 8800
  },
  "Gray Demon": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 7800,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6000,
    "Magic Specialist": 6200,
    "Willpower": 6800,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 7800,
    "IQ": 6300
  },
  "Grayroad": {
    "Captain": 6600,
    "Vice Captain": 6300,
    "Tank": 6700,
    "Healer": 1000,
    "Support 1": 6100,
    "Support 2": 6100,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6400,
    "Magic Specialist": 6200,
    "Willpower": 6500,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 6700,
    "IQ": 6300
  },
  "Guila": {
    "Captain": 3700,
    "Vice Captain": 3400,
    "Tank": 3800,
    "Healer": 1000,
    "Support 1": 3200,
    "Support 2": 3200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Magic Specialist": 5200,
    "Willpower": 3600,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3800,
    "IQ": 3400
  },
  "Hawk": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1300,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 1500,
    "Defence": 3900,
    "IQ": 3500
  },
  "Hawk (Transpork)": {
    "Captain": 4100,
    "Vice Captain": 3800,
    "Tank": 4200,
    "Healer": 1000,
    "Support 1": 3600,
    "Support 2": 3600,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1600,
    "Combat Power": 4400,
    "Speed": 3900,
    "Magic Specialist": 3700,
    "Willpower": 4000,
    "Power": 4400,
    "Hax": 1800,
    "Defence": 4200,
    "IQ": 3800
  },
  "Helbram": {
    "Captain": 5500,
    "Vice Captain": 5200,
    "Tank": 5600,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5900,
    "Speed": 5300,
    "Magic Specialist": 5100,
    "Willpower": 5400,
    "Power": 5900,
    "Hax": 4000,
    "Defence": 5600,
    "IQ": 5200
  },
  "Hendrickson": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 5400,
    "Healer": 4000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 4900,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 5000,
    "Defence": 5400,
    "IQ": 8000
  },
  "Hendrickson (Gray Demon)": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 7800,
    "Healer": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6000,
    "Magic Specialist": 6200,
    "Willpower": 6800,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 7800,
    "IQ": 6300
  },
  "Howzer": {
    "Captain": 5500,
    "Vice Captain": 5200,
    "Tank": 5600,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5900,
    "Speed": 5300,
    "Magic Specialist": 5100,
    "Willpower": 5400,
    "Power": 5900,
    "Hax": 2200,
    "Defence": 5600,
    "IQ": 5200
  },
  "Ironside": {
    "Captain": 6000,
    "Vice Captain": 5200,
    "Tank": 5600,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5900,
    "Speed": 5300,
    "Magic Specialist": 5100,
    "Willpower": 5400,
    "Power": 5900,
    "Hax": 6500,
    "Defence": 5600,
    "IQ": 5200
  },
  "Isolde": {
    "Captain": 1600,
    "Vice Captain": 1300,
    "Tank": 1700,
    "Healer": 1000,
    "Support 1": 1200,
    "Support 2": 1200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1900,
    "Speed": 1400,
    "Magic Specialist": 1200,
    "Willpower": 1500,
    "Power": 1900,
    "Hax": 1800,
    "Defence": 1700,
    "IQ": 1300
  },
  "Jade": {
    "Captain": 1700,
    "Vice Captain": 1400,
    "Tank": 1800,
    "Healer": 1000,
    "Support 1": 1300,
    "Support 2": 1300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 2000,
    "Speed": 1500,
    "Magic Specialist": 1300,
    "Willpower": 1600,
    "Power": 2000,
    "Hax": 1900,
    "Defence": 1800,
    "IQ": 1400
  },
  "Jericho": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 5400,
    "Healer": 1000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 4900,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 4200,
    "Defence": 5400,
    "IQ": 5000
  },
  "Jericho (4KOA)": {
    "Captain": 5800,
    "Vice Captain": 5500,
    "Tank": 5900,
    "Healer": 1000,
    "Support 1": 5300,
    "Support 2": 5300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6200,
    "Speed": 5600,
    "Magic Specialist": 5400,
    "Willpower": 5700,
    "Power": 6200,
    "Hax": 4700,
    "Defence": 5900,
    "IQ": 5500
  },
  "King (Fat)": {
    "Captain": 3300,
    "Vice Captain": 3000,
    "Tank": 3400,
    "Healer": 3000,
    "Support 1": 2800,
    "Support 2": 2800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3100,
    "Magic Specialist": 2900,
    "Willpower": 3200,
    "Power": 3600,
    "Hax": 3000,
    "Defence": 3400,
    "IQ": 3000
  },
  "King (Partial Wings)": {
    "Captain": 7200,
    "Vice Captain": 6900,
    "Tank": 7300,
    "Healer": 4500,
    "Support 1": 6700,
    "Support 2": 6700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7600,
    "Speed": 7000,
    "Magic Specialist": 6800,
    "Willpower": 7100,
    "Power": 7600,
    "Hax": 8200,
    "Defence": 7300,
    "IQ": 6900
  },
  "King (True Fairy King)": {
    "Captain": 8200,
    "Vice Captain": 7900,
    "Tank": 8500,
    "Healer": 6000,
    "Support 1": 8800,
    "Support 2": 8800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9000,
    "Speed": 8500,
    "Magic Specialist": 9500,
    "Willpower": 7100,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 8500,
    "IQ": 6900
  },
  "King Bartra Liones": {
    "Captain": 6200,
    "Vice Captain": 5100,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 4900,
    "Support 2": 4900,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 5200,
    "Magic Specialist": 5000,
    "Willpower": 5300,
    "Power": 5800,
    "Hax": 5200,
    "Defence": 5500,
    "IQ": 5300
  },
  "Lancelot": {
    "Captain": 9999,
    "Vice Captain": 8400,
    "Tank": 7900,
    "Healer": 1000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8200,
    "Speed": 9900,
    "Magic Specialist": 7500,
    "Willpower": 7800,
    "Power": 8200,
    "Hax": 8500,
    "Defence": 7900,
    "IQ": 9400
  },
  "Lancelot (Fox)": {
    "Captain": 5600,
    "Vice Captain": 9000,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 7000,
    "Magic Specialist": 5000,
    "Willpower": 5400,
    "Power": 5800,
    "Hax": 9000,
    "Defence": 5500,
    "IQ": 7100
  },
  "Ludociel (Archangel)": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Tank": 8100,
    "Healer": 5500,
    "Support 1": 9100,
    "Support 2": 9100,
    "Demon Form": 1000,
    "Goddess Blessing": 8400,
    "Chaos User": 1000,
    "Combat Power": 8400,
    "Speed": 9999,
    "Magic Specialist": 9500,
    "Willpower": 7900,
    "Power": 8400,
    "Hax": 9000,
    "Defence": 8100,
    "IQ": 9400
  },
  "Mael (Archangel)": {
    "Captain": 8700,
    "Vice Captain": 7600,
    "Tank": 8000,
    "Healer": 5500,
    "Support 1": 7400,
    "Support 2": 7400,
    "Demon Form": 1000,
    "Goddess Blessing": 9000,
    "Chaos User": 1000,
    "Combat Power": 8300,
    "Speed": 9400,
    "Magic Specialist": 9400,
    "Willpower": 7800,
    "Power": 8300,
    "Hax": 9200,
    "Defence": 8000,
    "IQ": 7800
  },
  "Mael (Corrupted)": {
    "Captain": 9200,
    "Vice Captain": 8100,
    "Tank": 8500,
    "Healer": 1000,
    "Support 1": 7900,
    "Support 2": 7900,
    "Demon Form": 1000,
    "Goddess Blessing": 8600,
    "Chaos User": 1000,
    "Combat Power": 8800,
    "Speed": 9500,
    "Magic Specialist": 9500,
    "Willpower": 8300,
    "Power": 8800,
    "Hax": 9400,
    "Defence": 8500,
    "IQ": 8300
  },
  "Margaret Liones": {
    "Captain": 1500,
    "Vice Captain": 1200,
    "Tank": 1600,
    "Healer": 1000,
    "Support 1": 1100,
    "Support 2": 1100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1800,
    "Speed": 1300,
    "Magic Specialist": 1100,
    "Willpower": 1400,
    "Power": 1800,
    "Hax": 1500,
    "Defence": 1600,
    "IQ": 1200
  },
  "Matrona": {
    "Captain": 3600,
    "Vice Captain": 3300,
    "Tank": 4800,
    "Healer": 1000,
    "Support 1": 3100,
    "Support 2": 3100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3900,
    "Speed": 3100,
    "Magic Specialist": 3200,
    "Willpower": 3800,
    "Power": 3900,
    "Hax": 3200,
    "Defence": 4800,
    "IQ": 3300
  },
  "Melascula": {
    "Captain": 6600,
    "Vice Captain": 6300,
    "Tank": 6700,
    "Healer": 1000,
    "Support 1": 6100,
    "Support 2": 6100,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6400,
    "Magic Specialist": 8100,
    "Willpower": 6500,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 6700,
    "IQ": 6300
  },
  "Meliodas (Assault Mode)": {
    "Captain": 9200,
    "Vice Captain": 8100,
    "Tank": 8500,
    "Healer": 1000,
    "Support 1": 7900,
    "Support 2": 7900,
    "Demon Form": 9000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8800,
    "Speed": 9500,
    "Magic Specialist": 8000,
    "Willpower": 9500,
    "Power": 8800,
    "Hax": 9800,
    "Defence": 8500,
    "IQ": 8300
  },
  "Meliodas (Base)": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Tank": 3300,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 3400,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 4700,
    "Magic Specialist": 2800,
    "Willpower": 5000,
    "Power": 3600,
    "Hax": 3400,
    "Defence": 3300,
    "IQ": 8000
  },
  "Meliodas (Demon King Possessed)": {
    "Captain": 9500,
    "Vice Captain": 8400,
    "Tank": 8800,
    "Healer": 1000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Demon Form": 8900,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9100,
    "Speed": 9500,
    "Magic Specialist": 8300,
    "Willpower": 9500,
    "Power": 9100,
    "Hax": 8900,
    "Defence": 8800,
    "IQ": 8600
  },
  "Meliodas (Demon King Successor)": {
    "Captain": 9400,
    "Vice Captain": 8300,
    "Tank": 8700,
    "Healer": 1000,
    "Support 1": 8100,
    "Support 2": 8100,
    "Demon Form": 8800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9000,
    "Speed": 9500,
    "Magic Specialist": 8200,
    "Willpower": 9500,
    "Power": 9000,
    "Hax": 8800,
    "Defence": 8700,
    "IQ": 8500
  },
  "Meliodas (Demon Mark Stage 2)": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Tank": 3500,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 3900,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3800,
    "Speed": 4900,
    "Magic Specialist": 3000,
    "Willpower": 5200,
    "Power": 6000,
    "Hax": 3900,
    "Defence": 3500,
    "IQ": 8000
  },
  "Meliodas (Demon Mark)": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Tank": 3400,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 3800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3700,
    "Speed": 4800,
    "Magic Specialist": 2900,
    "Willpower": 5100,
    "Power": 6000,
    "Hax": 3800,
    "Defence": 3400,
    "IQ": 8000
  },
  "Meliodas (True Magic Form)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Tank": 8900,
    "Healer": 1000,
    "Support 1": 8300,
    "Support 2": 8300,
    "Demon Form": 9000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 9200,
    "Speed": 9500,
    "Magic Specialist": 8400,
    "Willpower": 9500,
    "Power": 9200,
    "Hax": 9000,
    "Defence": 8900,
    "IQ": 8700
  },
  "Merlin (Base)": {
    "Captain": 5300,
    "Vice Captain": 5000,
    "Tank": 5400,
    "Healer": 4000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5700,
    "Speed": 5100,
    "Magic Specialist": 6800,
    "Willpower": 5200,
    "Power": 5700,
    "Hax": 9500,
    "Defence": 5400,
    "IQ": 9000
  },
  "Merlin (True Form)": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Tank": 6600,
    "Healer": 5500,
    "Support 1": 7700,
    "Support 2": 7700,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6900,
    "Speed": 6300,
    "Magic Specialist": 9500,
    "Willpower": 6400,
    "Power": 6900,
    "Hax": 9500,
    "Defence": 6600,
    "IQ": 8800
  },
  "Monspeet": {
    "Captain": 6600,
    "Vice Captain": 6300,
    "Tank": 6700,
    "Healer": 1000,
    "Support 1": 6100,
    "Support 2": 6100,
    "Demon Form": 6800,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7000,
    "Speed": 6400,
    "Magic Specialist": 6200,
    "Willpower": 6500,
    "Power": 7000,
    "Hax": 6800,
    "Defence": 6700,
    "IQ": 6300
  },
  "Monspeet (Indura)": {
    "Captain": 8000,
    "Vice Captain": 7700,
    "Tank": 8100,
    "Healer": 1000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Demon Form": 8500,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8400,
    "Speed": 7800,
    "Magic Specialist": 7600,
    "Willpower": 7900,
    "Power": 8400,
    "Hax": 8500,
    "Defence": 8100,
    "IQ": 7700
  },
  "Nanashi": {
    "Captain": 3500,
    "Vice Captain": 3800,
    "Tank": 3400,
    "Healer": 1000,
    "Support 1": 2800,
    "Support 2": 2800,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3700,
    "Speed": 3100,
    "Magic Specialist": 2900,
    "Willpower": 3200,
    "Power": 3700,
    "Hax": 3500,
    "Defence": 3400,
    "IQ": 3000
  },
  "Nerobasta": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 4000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 5300,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 4000,
    "Defence": 3900,
    "IQ": 4100
  },
  "Original Demon": {
    "Captain": 8600,
    "Vice Captain": 7900,
    "Tank": 8300,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Demon Form": 9900,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8600,
    "Speed": 8000,
    "Magic Specialist": 9500,
    "Willpower": 8100,
    "Power": 8600,
    "Hax": 9000,
    "Defence": 8300,
    "IQ": 7900
  },
  "Oslo": {
    "Captain": 3600,
    "Vice Captain": 3300,
    "Tank": 3700,
    "Healer": 1000,
    "Support 1": 3100,
    "Support 2": 3100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3900,
    "Speed": 3400,
    "Magic Specialist": 3200,
    "Willpower": 3500,
    "Power": 3900,
    "Hax": 2200,
    "Defence": 3700,
    "IQ": 3300
  },
  "Pellegarde": {
    "Captain": 5500,
    "Vice Captain": 5200,
    "Tank": 5600,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5900,
    "Speed": 5300,
    "Magic Specialist": 5100,
    "Willpower": 5400,
    "Power": 5900,
    "Hax": 6500,
    "Defence": 5600,
    "IQ": 5200
  },
  "Percival (Base)": {
    "Captain": 1600,
    "Vice Captain": 1300,
    "Tank": 1700,
    "Healer": 2500,
    "Support 1": 1200,
    "Support 2": 1200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1900,
    "Speed": 1400,
    "Magic Specialist": 1200,
    "Willpower": 3400,
    "Power": 1900,
    "Hax": 2500,
    "Defence": 1700,
    "IQ": 1300
  },
  "Percival (Hope)": {
    "Captain": 3200,
    "Vice Captain": 2900,
    "Tank": 3300,
    "Healer": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3000,
    "Magic Specialist": 2800,
    "Willpower": 9999,
    "Power": 3600,
    "Hax": 5200,
    "Defence": 3300,
    "IQ": 2900
  },
  "Red Cardinal Helbram": {
    "Captain": 3600,
    "Vice Captain": 3300,
    "Tank": 3700,
    "Healer": 1000,
    "Support 1": 3100,
    "Support 2": 3100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3900,
    "Speed": 3400,
    "Magic Specialist": 3200,
    "Willpower": 3500,
    "Power": 3900,
    "Hax": 3500,
    "Defence": 3700,
    "IQ": 3300
  },
  "Red Demon": {
    "Captain": 3200,
    "Vice Captain": 2900,
    "Tank": 3300,
    "Healer": 1000,
    "Support 1": 2700,
    "Support 2": 2700,
    "Demon Form": 3400,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3000,
    "Magic Specialist": 2800,
    "Willpower": 3100,
    "Power": 3600,
    "Hax": 3400,
    "Defence": 3300,
    "IQ": 2900
  },
  "Rou": {
    "Captain": 3600,
    "Vice Captain": 3300,
    "Tank": 3700,
    "Healer": 1000,
    "Support 1": 3100,
    "Support 2": 3100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3900,
    "Speed": 3400,
    "Magic Specialist": 3200,
    "Willpower": 3500,
    "Power": 3900,
    "Hax": 1500,
    "Defence": 3700,
    "IQ": 3300
  },
  "Sariel (Archangel)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 7900,
    "Healer": 5500,
    "Support 1": 8900,
    "Support 2": 8900,
    "Demon Form": 1000,
    "Goddess Blessing": 8200,
    "Chaos User": 1000,
    "Combat Power": 8200,
    "Speed": 9300,
    "Magic Specialist": 9300,
    "Willpower": 7700,
    "Power": 8200,
    "Hax": 8800,
    "Defence": 7900,
    "IQ": 8200
  },
  "Slader": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 3200,
    "Defence": 3900,
    "IQ": 3500
  },
  "Supreme Deity": {
    "Captain": 9999,
    "Vice Captain": 8700,
    "Tank": 9100,
    "Healer": 7000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Demon Form": 1000,
    "Goddess Blessing": 9999,
    "Chaos User": 1000,
    "Combat Power": 9400,
    "Speed": 8800,
    "Magic Specialist": 9999,
    "Willpower": 8900,
    "Power": 9400,
    "Hax": 9999,
    "Defence": 9100,
    "IQ": 9000
  },
  "Talisker": {
    "Captain": 5400,
    "Vice Captain": 5100,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 4900,
    "Support 2": 4900,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 5200,
    "Magic Specialist": 5000,
    "Willpower": 5300,
    "Power": 5800,
    "Hax": 4500,
    "Defence": 5500,
    "IQ": 5100
  },
  "Tarmiel (Archangel)": {
    "Captain": 7800,
    "Vice Captain": 7500,
    "Tank": 9100,
    "Healer": 5500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Demon Form": 1000,
    "Goddess Blessing": 8300,
    "Chaos User": 1000,
    "Combat Power": 8300,
    "Speed": 7400,
    "Magic Specialist": 9400,
    "Willpower": 8100,
    "Power": 8300,
    "Hax": 8900,
    "Defence": 9100,
    "IQ": 8300
  },
  "The Elder": {
    "Captain": 3700,
    "Vice Captain": 3400,
    "Tank": 3800,
    "Healer": 1000,
    "Support 1": 3200,
    "Support 2": 3200,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Magic Specialist": 3300,
    "Willpower": 3600,
    "Power": 4000,
    "Hax": 3300,
    "Defence": 3800,
    "IQ": 3400
  },
  "Tristan (Base)": {
    "Captain": 5600,
    "Vice Captain": 6000,
    "Tank": 5500,
    "Healer": 4000,
    "Support 1": 4900,
    "Support 2": 4900,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5800,
    "Speed": 7000,
    "Magic Specialist": 5000,
    "Willpower": 5400,
    "Power": 5800,
    "Hax": 6200,
    "Defence": 5500,
    "IQ": 5100
  },
  "Tristan (Demon)": {
    "Captain": 8200,
    "Vice Captain": 8600,
    "Tank": 8100,
    "Healer": 5000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Demon Form": 8200,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8400,
    "Speed": 9500,
    "Magic Specialist": 7600,
    "Willpower": 7900,
    "Power": 8400,
    "Hax": 8200,
    "Defence": 8100,
    "IQ": 7700
  },
  "Tristan (Goddess)": {
    "Captain": 8100,
    "Vice Captain": 8500,
    "Tank": 8000,
    "Healer": 5000,
    "Support 1": 7400,
    "Support 2": 7400,
    "Demon Form": 1000,
    "Goddess Blessing": 8400,
    "Chaos User": 1000,
    "Combat Power": 8300,
    "Speed": 9400,
    "Magic Specialist": 7500,
    "Willpower": 7800,
    "Power": 8300,
    "Hax": 8400,
    "Defence": 8000,
    "IQ": 7600
  },
  "Varghese": {
    "Captain": 1500,
    "Vice Captain": 1200,
    "Tank": 1600,
    "Healer": 1000,
    "Support 1": 1100,
    "Support 2": 1100,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 1800,
    "Speed": 1300,
    "Magic Specialist": 1100,
    "Willpower": 1400,
    "Power": 1800,
    "Hax": 1200,
    "Defence": 1600,
    "IQ": 1200
  },
  "Veronica Liones": {
    "Captain": 1700,
    "Vice Captain": 1400,
    "Tank": 1800,
    "Healer": 1000,
    "Support 1": 1300,
    "Support 2": 1300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 2000,
    "Speed": 1500,
    "Magic Specialist": 1300,
    "Willpower": 1600,
    "Power": 2000,
    "Hax": 1500,
    "Defence": 1800,
    "IQ": 1400
  },
  "Vivian": {
    "Captain": 3300,
    "Vice Captain": 3000,
    "Tank": 3400,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 3600,
    "Speed": 3100,
    "Magic Specialist": 4800,
    "Willpower": 3200,
    "Power": 3600,
    "Hax": 6500,
    "Defence": 3400,
    "IQ": 5500
  },
  "Vivian (Perfect Chaos)": {
    "Captain": 3400,
    "Vice Captain": 3100,
    "Tank": 3500,
    "Healer": 1000,
    "Support 1": 4600,
    "Support 2": 4600,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 4000,
    "Combat Power": 3700,
    "Speed": 3200,
    "Magic Specialist": 4900,
    "Willpower": 3300,
    "Power": 3700,
    "Hax": 4000,
    "Defence": 3500,
    "IQ": 5600
  },
  "Wild": {
    "Captain": 7100,
    "Vice Captain": 6800,
    "Tank": 8400,
    "Healer": 1000,
    "Support 1": 6600,
    "Support 2": 6600,
    "Demon Form": 1200,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7500,
    "Speed": 6600,
    "Magic Specialist": 6700,
    "Willpower": 9999,
    "Power": 7500,
    "Hax": 5000,
    "Defence": 8400,
    "IQ": 6800
  },
  "Zaratras": {
    "Captain": 3800,
    "Vice Captain": 3500,
    "Tank": 3900,
    "Healer": 1000,
    "Support 1": 3300,
    "Support 2": 3300,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4100,
    "Speed": 3600,
    "Magic Specialist": 3400,
    "Willpower": 3700,
    "Power": 4100,
    "Hax": 3400,
    "Defence": 3900,
    "IQ": 3500
  },
  "Zeldris (Base)": {
    "Captain": 8400,
    "Vice Captain": 8700,
    "Tank": 7500,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Demon Form": 7600,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 7800,
    "Speed": 9200,
    "Magic Specialist": 7000,
    "Willpower": 7300,
    "Power": 7800,
    "Hax": 9000,
    "Defence": 7500,
    "IQ": 9200
  },
  "Zeldris (Demon Mark)": {
    "Captain": 8900,
    "Vice Captain": 8400,
    "Tank": 8000,
    "Healer": 1000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Demon Form": 8500,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 8300,
    "Speed": 9400,
    "Magic Specialist": 7500,
    "Willpower": 7800,
    "Power": 8300,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 9600
  },
  "Angel": {
    "Grade": 9000,
    "Captain": 7500,
    "Vice Captain": 7200,
    "Healer": 9000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8800,
    "Combat Specialist": 7300,
    "Technique Specialist": 9550,
    "Power": 8800,
    "Hax": 9200,
    "Defence": 5500,
    "IQ": 8800,
    "Speed": 7500
  },
  "Aoi Todo": {
    "Grade": 7800,
    "Captain": 7700,
    "Vice Captain": 7400,
    "Healer": 1000,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7200,
    "Combat Specialist": 7600,
    "Technique Specialist": 8000,
    "Power": 7200,
    "Hax": 8000,
    "Defence": 7500,
    "IQ": 9999,
    "Speed": 7800
  },
  "Aoi Todo (Boogie Woogie Peak)": {
    "Grade": 8200,
    "Captain": 7700,
    "Vice Captain": 7400,
    "Healer": 1000,
    "Support 1": 7600,
    "Support 2": 7600,
    "Tank": 8000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7600,
    "Combat Specialist": 9600,
    "Technique Specialist": 8400,
    "Power": 7600,
    "Hax": 8400,
    "Defence": 7900,
    "IQ": 9500,
    "Speed": 8200
  },
  "Atsuya Kusakabe": {
    "Grade": 7500,
    "Captain": 7400,
    "Vice Captain": 8100,
    "Healer": 1000,
    "Support 1": 6900,
    "Support 2": 6900,
    "Tank": 6700,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7000,
    "Combat Specialist": 7800,
    "Technique Specialist": 8200,
    "Power": 7000,
    "Hax": 8200,
    "Defence": 6700,
    "IQ": 9000,
    "Speed": 7000
  },
  "Choso": {
    "Grade": 8000,
    "Captain": 7800,
    "Vice Captain": 7500,
    "Healer": 1000,
    "Support 1": 7300,
    "Support 2": 7300,
    "Tank": 7100,
    "Domain Expansion": 1000,
    "Cursed Spirit": 7000,
    "Cursed Energy": 7700,
    "Combat Specialist": 7400,
    "Technique Specialist": 7900,
    "Power": 7700,
    "Hax": 7900,
    "Defence": 7100,
    "IQ": 7500,
    "Speed": 7800
  },
  "Dagon": {
    "Grade": 8500,
    "Captain": 7200,
    "Vice Captain": 6900,
    "Healer": 1000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Tank": 7500,
    "Domain Expansion": 8000,
    "Cursed Spirit": 8500,
    "Cursed Energy": 7600,
    "Combat Specialist": 6800,
    "Technique Specialist": 7300,
    "Power": 7600,
    "Hax": 8600,
    "Defence": 7500,
    "IQ": 6500,
    "Speed": 7500
  },
  "Eso and Kechizu": {
    "Grade": 5500,
    "Captain": 4800,
    "Vice Captain": 4500,
    "Healer": 1000,
    "Support 1": 4300,
    "Support 2": 4300,
    "Tank": 4600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 5300,
    "Cursed Energy": 5000,
    "Combat Specialist": 4700,
    "Technique Specialist": 5000,
    "Power": 5000,
    "Hax": 5300,
    "Defence": 4600,
    "IQ": 5500,
    "Speed": 5800
  },
  "Finger Bearer": {
    "Grade": 7000,
    "Captain": 6200,
    "Vice Captain": 5900,
    "Healer": 1000,
    "Support 1": 5700,
    "Support 2": 5700,
    "Tank": 6400,
    "Domain Expansion": 1000,
    "Cursed Spirit": 7200,
    "Cursed Energy": 6600,
    "Combat Specialist": 6000,
    "Technique Specialist": 6300,
    "Power": 6600,
    "Hax": 7600,
    "Defence": 6400,
    "IQ": 5000,
    "Speed": 6500
  },
  "Fumihiko Takaba": {
    "Grade": 9000,
    "Captain": 6500,
    "Vice Captain": 6200,
    "Healer": 1000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9999,
    "Domain Expansion": 8000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8500,
    "Combat Specialist": 5000,
    "Technique Specialist": 9500,
    "Power": 8500,
    "Hax": 9999,
    "Defence": 4000,
    "IQ": 8500,
    "Speed": 6000
  },
  "Grasshopper Curse": {
    "Grade": 3500,
    "Captain": 3000,
    "Vice Captain": 2800,
    "Healer": 1000,
    "Support 1": 2600,
    "Support 2": 2600,
    "Tank": 3200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 4000,
    "Cursed Energy": 3300,
    "Combat Specialist": 2900,
    "Technique Specialist": 3100,
    "Power": 3300,
    "Hax": 4000,
    "Defence": 3200,
    "IQ": 3000,
    "Speed": 4500
  },
  "Hajime Kashimo": {
    "Grade": 8800,
    "Captain": 8500,
    "Vice Captain": 8200,
    "Healer": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8600,
    "Combat Specialist": 8300,
    "Technique Specialist": 8400,
    "Power": 8600,
    "Hax": 8400,
    "Defence": 7800,
    "IQ": 7500,
    "Speed": 8800
  },
  "Hajime Kashimo (Lightning Beast)": {
    "Grade": 9200,
    "Captain": 8900,
    "Vice Captain": 9000,
    "Healer": 1000,
    "Support 1": 8400,
    "Support 2": 8400,
    "Tank": 8200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9000,
    "Combat Specialist": 8700,
    "Technique Specialist": 8800,
    "Power": 9000,
    "Hax": 8800,
    "Defence": 8200,
    "IQ": 7800,
    "Speed": 9500
  },
  "Hanami (Sealed)": {
    "Grade": 8500,
    "Captain": 7300,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7700,
    "Domain Expansion": 8400,
    "Cursed Spirit": 8500,
    "Cursed Energy": 7500,
    "Combat Specialist": 7100,
    "Technique Specialist": 7400,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 7700,
    "IQ": 7000,
    "Speed": 7200
  },
  "Hanami (Unsealed)": {
    "Grade": 8500,
    "Captain": 7300,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7700,
    "Domain Expansion": 8400,
    "Cursed Spirit": 8500,
    "Cursed Energy": 7500,
    "Combat Specialist": 7800,
    "Technique Specialist": 8000,
    "Power": 8200,
    "Hax": 9000,
    "Defence": 8200,
    "IQ": 7000,
    "Speed": 7200
  },
  "Haruta Shigemo": {
    "Grade": 4500,
    "Captain": 4000,
    "Vice Captain": 3800,
    "Healer": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4300,
    "Combat Specialist": 3900,
    "Technique Specialist": 4100,
    "Power": 4300,
    "Hax": 4100,
    "Defence": 4200,
    "IQ": 5000,
    "Speed": 5500
  },
  "Hiromi Higuruma": {
    "Grade": 8500,
    "Captain": 8000,
    "Vice Captain": 7700,
    "Healer": 1000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7200,
    "Domain Expansion": 8800,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8200,
    "Combat Specialist": 7600,
    "Technique Specialist": 8600,
    "Power": 8200,
    "Hax": 9500,
    "Defence": 7200,
    "IQ": 9200,
    "Speed": 7000
  },
  "Jinichi Zenin": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 1000,
    "Support 1": 6300,
    "Support 2": 6300,
    "Tank": 6600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6700,
    "Combat Specialist": 6900,
    "Technique Specialist": 6200,
    "Power": 7000,
    "Hax": 6200,
    "Defence": 6600,
    "IQ": 6000,
    "Speed": 6800
  },
  "Joe Jujutsu": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9999,
    "Healer": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 9999,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "Jogo": {
    "Grade": 8800,
    "Captain": 8000,
    "Vice Captain": 7700,
    "Healer": 1000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7600,
    "Domain Expansion": 8700,
    "Cursed Spirit": 8800,
    "Cursed Energy": 8200,
    "Combat Specialist": 7800,
    "Technique Specialist": 8500,
    "Power": 8200,
    "Hax": 8800,
    "Defence": 7600,
    "IQ": 7500,
    "Speed": 8500
  },
  "John Kaizen": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9999,
    "Healer": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 9999,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "John Rabbit": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9999,
    "Healer": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 9999,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "John Zenin": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9999,
    "Healer": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 9999,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "Kenjaku": {
    "Grade": 9500,
    "Captain": 9200,
    "Vice Captain": 8900,
    "Healer": 1000,
    "Support 1": 8700,
    "Support 2": 8700,
    "Tank": 8500,
    "Domain Expansion": 9990,
    "Cursed Spirit": 9300,
    "Cursed Energy": 9100,
    "Combat Specialist": 8800,
    "Technique Specialist": 9500,
    "Power": 9100,
    "Hax": 9800,
    "Defence": 8500,
    "IQ": 9999,
    "Speed": 8000
  },
  "Kento Nanami": {
    "Grade": 7600,
    "Captain": 7500,
    "Vice Captain": 7200,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7300,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7100,
    "Combat Specialist": 7400,
    "Technique Specialist": 7500,
    "Power": 7100,
    "Hax": 7500,
    "Defence": 7300,
    "IQ": 8800,
    "Speed": 7000
  },
  "Kinji Hakari": {
    "Grade": 8500,
    "Captain": 8200,
    "Vice Captain": 7900,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 7500,
    "Domain Expansion": 8600,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8300,
    "Combat Specialist": 8000,
    "Technique Specialist": 8400,
    "Power": 8300,
    "Hax": 9500,
    "Defence": 8000,
    "IQ": 7500,
    "Speed": 8200
  },
  "Kinji Hakari (Jackpot Mode)": {
    "Grade": 9000,
    "Captain": 8700,
    "Vice Captain": 8400,
    "Healer": 8995,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 9900,
    "Domain Expansion": 9000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 8500,
    "Technique Specialist": 8900,
    "Power": 8800,
    "Hax": 9600,
    "Defence": 8800,
    "IQ": 9000,
    "Speed": 8800
  },
  "Kirara Hoshi": {
    "Grade": 5000,
    "Captain": 4800,
    "Vice Captain": 4600,
    "Healer": 1000,
    "Support 1": 4400,
    "Support 2": 4400,
    "Tank": 4500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4900,
    "Combat Specialist": 4700,
    "Technique Specialist": 5200,
    "Power": 4900,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 6200,
    "Speed": 5800
  },
  "Mahito": {
    "Grade": 9000,
    "Captain": 7500,
    "Vice Captain": 7200,
    "Healer": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7300,
    "Domain Expansion": 8500,
    "Cursed Spirit": 8400,
    "Cursed Energy": 7800,
    "Combat Specialist": 7400,
    "Technique Specialist": 8200,
    "Power": 7800,
    "Hax": 9500,
    "Defence": 7300,
    "IQ": 7800,
    "Speed": 8000
  },
  "Mahito (Instant Spirit Body)": {
    "Grade": 9000,
    "Captain": 8200,
    "Vice Captain": 7900,
    "Healer": 5500,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 8000,
    "Domain Expansion": 9200,
    "Cursed Spirit": 9400,
    "Cursed Energy": 8500,
    "Combat Specialist": 8100,
    "Technique Specialist": 8800,
    "Power": 8500,
    "Hax": 9200,
    "Defence": 8000,
    "IQ": 8200,
    "Speed": 8500
  },
  "Mahoraga": {
    "Grade": 9999,
    "Captain": 2000,
    "Vice Captain": 2000,
    "Healer": 1000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9999,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 4000,
    "Speed": 8500
  },
  "Mai Zenin": {
    "Grade": 3500,
    "Captain": 3300,
    "Vice Captain": 3100,
    "Healer": 1000,
    "Support 1": 2900,
    "Support 2": 2900,
    "Tank": 3400,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 3200,
    "Combat Specialist": 3000,
    "Technique Specialist": 3600,
    "Power": 3200,
    "Hax": 3600,
    "Defence": 3400,
    "IQ": 5500,
    "Speed": 5000
  },
  "Maki Zenin (Awakened)": {
    "Grade": 9200,
    "Captain": 9000,
    "Vice Captain": 8700,
    "Healer": 1000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 1000,
    "Combat Specialist": 9500,
    "Technique Specialist": 1000,
    "Power": 9200,
    "Hax": 4500,
    "Defence": 8800,
    "IQ": 8000,
    "Speed": 9800
  },
  "Maki Zenin (Pre-Awakening)": {
    "Grade": 4000,
    "Captain": 3800,
    "Vice Captain": 3600,
    "Healer": 1000,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 3900,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 2000,
    "Combat Specialist": 4200,
    "Technique Specialist": 1000,
    "Power": 3500,
    "Hax": 1800,
    "Defence": 3900,
    "IQ": 7000,
    "Speed": 7500
  },
  "Masamichi Yaga": {
    "Grade": 7500,
    "Captain": 7200,
    "Vice Captain": 6900,
    "Healer": 1000,
    "Support 1": 6700,
    "Support 2": 6700,
    "Tank": 7000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7300,
    "Combat Specialist": 6800,
    "Technique Specialist": 7600,
    "Power": 7300,
    "Hax": 8000,
    "Defence": 7000,
    "IQ": 8800,
    "Speed": 6000
  },
  "Megumi Fushiguro": {
    "Grade": 6000,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 5300,
    "Support 2": 5300,
    "Tank": 5600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5900,
    "Combat Specialist": 5700,
    "Technique Specialist": 6200,
    "Power": 5900,
    "Hax": 6200,
    "Defence": 5600,
    "IQ": 8200,
    "Speed": 7200
  },
  "Megumi Fushiguro (Chimera Shadow Garden)": {
    "Grade": 7000,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 6300,
    "Support 2": 6300,
    "Tank": 6600,
    "Domain Expansion": 7500,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6900,
    "Combat Specialist": 6700,
    "Technique Specialist": 7200,
    "Power": 6900,
    "Hax": 7500,
    "Defence": 6600,
    "IQ": 8200,
    "Speed": 7500
  },
  "Megumi Fushiguro (Mahoraga Summon)": {
    "Grade": 8500,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6400,
    "Combat Specialist": 6200,
    "Technique Specialist": 9000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 5600,
    "IQ": 8200,
    "Speed": 7000
  },
  "Mei Mei": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6900,
    "Combat Specialist": 6700,
    "Technique Specialist": 7100,
    "Power": 7200,
    "Hax": 7100,
    "Defence": 6200,
    "IQ": 8500,
    "Speed": 7000
  },
  "Miguel": {
    "Grade": 8500,
    "Captain": 8200,
    "Vice Captain": 7900,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 8000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8300,
    "Combat Specialist": 8100,
    "Technique Specialist": 8400,
    "Power": 8300,
    "Hax": 8400,
    "Defence": 8500,
    "IQ": 7000,
    "Speed": 8500
  },
  "Naobito Zenin": {
    "Grade": 7800,
    "Captain": 7600,
    "Vice Captain": 7300,
    "Healer": 1000,
    "Support 1": 7100,
    "Support 2": 7100,
    "Tank": 7400,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7500,
    "Combat Specialist": 7700,
    "Technique Specialist": 7600,
    "Power": 7500,
    "Hax": 7600,
    "Defence": 7400,
    "IQ": 7500,
    "Speed": 9300
  },
  "Naoya Zenin": {
    "Grade": 7500,
    "Captain": 7300,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7100,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 7200,
    "Combat Specialist": 7400,
    "Technique Specialist": 7300,
    "Power": 7200,
    "Hax": 7300,
    "Defence": 7100,
    "IQ": 7000,
    "Speed": 9000
  },
  "Nobara Kugisaki": {
    "Grade": 5000,
    "Captain": 4800,
    "Vice Captain": 4500,
    "Healer": 1000,
    "Support 1": 4300,
    "Support 2": 4300,
    "Tank": 4600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5000,
    "Combat Specialist": 4700,
    "Technique Specialist": 6200,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4600,
    "IQ": 7000,
    "Speed": 6200
  },
  "Noritoshi Kamo": {
    "Grade": 5500,
    "Captain": 5300,
    "Vice Captain": 5000,
    "Healer": 1000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 5100,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5400,
    "Combat Specialist": 5200,
    "Technique Specialist": 5600,
    "Power": 5400,
    "Hax": 6200,
    "Defence": 5100,
    "IQ": 7500,
    "Speed": 6500
  },
  "Ogi Zenin": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 1000,
    "Support 1": 6300,
    "Support 2": 6300,
    "Tank": 6600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6700,
    "Combat Specialist": 6900,
    "Technique Specialist": 6200,
    "Power": 6700,
    "Hax": 6200,
    "Defence": 6600,
    "IQ": 6000,
    "Speed": 6500
  },
  "Panda": {
    "Grade": 5500,
    "Captain": 5300,
    "Vice Captain": 5000,
    "Healer": 1000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 5400,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5200,
    "Combat Specialist": 5100,
    "Technique Specialist": 5000,
    "Power": 5200,
    "Hax": 5500,
    "Defence": 5400,
    "IQ": 7200,
    "Speed": 6000
  },
  "Panda (Gorilla Mode)": {
    "Grade": 6000,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 5300,
    "Support 2": 5300,
    "Tank": 5900,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5600,
    "Combat Specialist": 5700,
    "Technique Specialist": 5400,
    "Power": 6200,
    "Hax": 5800,
    "Defence": 5900,
    "IQ": 7000,
    "Speed": 6500
  },
  "Ranta Zenin": {
    "Grade": 4000,
    "Captain": 3800,
    "Vice Captain": 3600,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3900,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 3700,
    "Combat Specialist": 3500,
    "Technique Specialist": 3800,
    "Power": 3700,
    "Hax": 3800,
    "Defence": 3900,
    "IQ": 4500,
    "Speed": 4800
  },
  "Rika Orimoto": {
    "Grade": 9200,
    "Captain": 6500,
    "Vice Captain": 8700,
    "Healer": 1000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9300,
    "Cursed Energy": 9100,
    "Combat Specialist": 8900,
    "Technique Specialist": 9000,
    "Power": 9100,
    "Hax": 9300,
    "Defence": 8800,
    "IQ": 7000,
    "Speed": 8800
  },
  "Riko Amanai": {
    "Grade": 2000,
    "Captain": 1800,
    "Vice Captain": 1600,
    "Healer": 1000,
    "Support 1": 1400,
    "Support 2": 1400,
    "Tank": 1700,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 1900,
    "Combat Specialist": 1500,
    "Technique Specialist": 1000,
    "Power": 1900,
    "Hax": 1200,
    "Defence": 1700,
    "IQ": 4000,
    "Speed": 3000
  },
  "Ryomen Sukuna (15 Fingers)": {
    "Grade": 9900,
    "Captain": 9000,
    "Vice Captain": 9500,
    "Healer": 5000,
    "Support 1": 9300,
    "Support 2": 9300,
    "Tank": 9700,
    "Domain Expansion": 9000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9900,
    "Combat Specialist": 9800,
    "Technique Specialist": 9900,
    "Power": 9900,
    "Hax": 9900,
    "Defence": 9700,
    "IQ": 9800,
    "Speed": 9900
  },
  "Ryomen Sukuna (3 Fingers)": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6600,
    "Domain Expansion": 7000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6900,
    "Combat Specialist": 8000,
    "Technique Specialist": 7000,
    "Power": 6900,
    "Hax": 7100,
    "Defence": 6600,
    "IQ": 8000,
    "Speed": 8000
  },
  "Ryomen Sukuna (Domain Expansion)": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9600,
    "Healer": 6000,
    "Support 1": 9400,
    "Support 2": 9400,
    "Tank": 9800,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9900,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9800,
    "IQ": 9900,
    "Speed": 9999
  },
  "Ryomen Sukuna (Heian Era)": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9600,
    "Healer": 8000,
    "Support 1": 9400,
    "Support 2": 9400,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9900,
    "IQ": 9999,
    "Speed": 9999
  },
  "Ryomen Sukuna (Megumi Possession)": {
    "Grade": 9900,
    "Captain": 9800,
    "Vice Captain": 9700,
    "Healer": 6000,
    "Support 1": 9300,
    "Support 2": 9300,
    "Tank": 9700,
    "Domain Expansion": 9900,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9900,
    "Combat Specialist": 9800,
    "Technique Specialist": 9999,
    "Power": 9900,
    "Hax": 9900,
    "Defence": 9700,
    "IQ": 9800,
    "Speed": 9900
  },
  "Ryu Ishigori": {
    "Grade": 8600,
    "Captain": 8300,
    "Vice Captain": 8000,
    "Healer": 1000,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8100,
    "Domain Expansion": 8500,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9200,
    "Combat Specialist": 8200,
    "Technique Specialist": 8400,
    "Power": 9000,
    "Hax": 8600,
    "Defence": 8100,
    "IQ": 7000,
    "Speed": 7500
  },
  "Satoru Gojo": {
    "Grade": 9999,
    "Captain": 9900,
    "Vice Captain": 9500,
    "Healer": 1000,
    "Support 1": 9300,
    "Support 2": 9300,
    "Tank": 9800,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9800,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9800,
    "IQ": 9800,
    "Speed": 9999
  },
  "Satoru Gojo (Domain Expansion)": {
    "Grade": 9999,
    "Captain": 9900,
    "Vice Captain": 9800,
    "Healer": 1000,
    "Support 1": 9700,
    "Support 2": 9700,
    "Tank": 9999,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "Satoru Gojo (Hollow Purple)": {
    "Grade": 9999,
    "Captain": 9900,
    "Vice Captain": 9500,
    "Healer": 1000,
    "Support 1": 9400,
    "Support 2": 9400,
    "Tank": 9900,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9900,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9800,
    "IQ": 9800,
    "Speed": 9999
  },
  "Shoko Ieiri (Teen)": {
    "Grade": 4000,
    "Captain": 3500,
    "Vice Captain": 3300,
    "Healer": 6500,
    "Support 1": 3600,
    "Support 2": 3600,
    "Tank": 3000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4200,
    "Combat Specialist": 3200,
    "Technique Specialist": 4500,
    "Power": 4200,
    "Hax": 4500,
    "Defence": 3000,
    "IQ": 7000,
    "Speed": 4500
  },
  "Shoko Ieiri": {
    "Grade": 7000,
    "Captain": 5500,
    "Vice Captain": 5200,
    "Healer": 9000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6800,
    "Combat Specialist": 5000,
    "Technique Specialist": 7200,
    "Power": 6800,
    "Hax": 7200,
    "Defence": 4500,
    "IQ": 7500,
    "Speed": 5000
  },
  "Suguru Geto": {
    "Grade": 9500,
    "Captain": 9200,
    "Vice Captain": 8900,
    "Healer": 1000,
    "Support 1": 8700,
    "Support 2": 8700,
    "Tank": 8800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9600,
    "Cursed Energy": 9100,
    "Combat Specialist": 9000,
    "Technique Specialist": 9300,
    "Power": 9100,
    "Hax": 9700,
    "Defence": 8800,
    "IQ": 9500,
    "Speed": 8500
  },
  "Takako Uro": {
    "Grade": 8500,
    "Captain": 8200,
    "Vice Captain": 7900,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 8000,
    "Domain Expansion": 8000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8300,
    "Combat Specialist": 8100,
    "Technique Specialist": 8400,
    "Power": 8300,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 7500,
    "Speed": 7800
  },
  "Tengen": {
    "Grade": 8000,
    "Captain": 7000,
    "Vice Captain": 6700,
    "Healer": 1000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9999,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9000,
    "Combat Specialist": 6000,
    "Technique Specialist": 9999,
    "Power": 9000,
    "Hax": 9999,
    "Defence": 7500,
    "IQ": 9800,
    "Speed": 5000
  },
  "Toge Inumaki": {
    "Grade": 6000,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 5300,
    "Support 2": 5300,
    "Tank": 5400,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5900,
    "Combat Specialist": 5600,
    "Technique Specialist": 6500,
    "Power": 5900,
    "Hax": 7200,
    "Defence": 5400,
    "IQ": 7500,
    "Speed": 6000
  },
  "Toji Fushiguro": {
    "Grade": 9500,
    "Captain": 9400,
    "Vice Captain": 9100,
    "Healer": 1000,
    "Support 1": 8900,
    "Support 2": 8900,
    "Tank": 9300,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 1000,
    "Combat Specialist": 9800,
    "Technique Specialist": 1000,
    "Power": 9400,
    "Hax": 4500,
    "Defence": 9300,
    "IQ": 8500,
    "Speed": 9400
  },
  "Ultimate Mechamaru": {
    "Grade": 7500,
    "Captain": 7300,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9000,
    "Combat Specialist": 6900,
    "Technique Specialist": 7600,
    "Power": 7600,
    "Hax": 7600,
    "Defence": 7200,
    "IQ": 8000,
    "Speed": 6000
  },
  "Uraume": {
    "Grade": 8500,
    "Captain": 8200,
    "Vice Captain": 7900,
    "Healer": 1000,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 8000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8300,
    "Combat Specialist": 8100,
    "Technique Specialist": 8400,
    "Power": 8300,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 8000,
    "Speed": 7800
  },
  "Utahime Iori": {
    "Grade": 6500,
    "Captain": 6300,
    "Vice Captain": 6000,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6100,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6400,
    "Combat Specialist": 6200,
    "Technique Specialist": 6600,
    "Power": 6400,
    "Hax": 7200,
    "Defence": 6100,
    "IQ": 7000,
    "Speed": 5500
  },
  "Yorozu": {
    "Grade": 8600,
    "Captain": 8300,
    "Vice Captain": 8000,
    "Healer": 1000,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8100,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8500,
    "Combat Specialist": 8200,
    "Technique Specialist": 8400,
    "Power": 8500,
    "Hax": 9200,
    "Defence": 8100,
    "IQ": 7500,
    "Speed": 7800
  },
  "Yuji Itadori": {
    "Grade": 5500,
    "Captain": 5300,
    "Vice Captain": 5000,
    "Healer": 1000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 5200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5100,
    "Combat Specialist": 5400,
    "Technique Specialist": 5000,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 5200,
    "IQ": 7000,
    "Speed": 7500
  },
  "Yuji Itadori (Black Flash)": {
    "Grade": 6500,
    "Captain": 6300,
    "Vice Captain": 6000,
    "Healer": 1000,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 6200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6100,
    "Combat Specialist": 8500,
    "Technique Specialist": 6000,
    "Power": 7600,
    "Hax": 6500,
    "Defence": 6200,
    "IQ": 7000,
    "Speed": 8000
  },
  "Yuji Itadori (Sukuna Vessel)": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 8000,
    "Support 1": 6300,
    "Support 2": 6300,
    "Tank": 6600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6900,
    "Combat Specialist": 6700,
    "Technique Specialist": 6500,
    "Power": 7800,
    "Hax": 7600,
    "Defence": 6600,
    "IQ": 7500,
    "Speed": 8000
  },
  "Yuki Tsukumo": {
    "Grade": 9500,
    "Captain": 9200,
    "Vice Captain": 8900,
    "Healer": 1000,
    "Support 1": 8700,
    "Support 2": 8700,
    "Tank": 9100,
    "Domain Expansion": 9400,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9300,
    "Combat Specialist": 9000,
    "Technique Specialist": 9200,
    "Power": 9500,
    "Hax": 9400,
    "Defence": 9100,
    "IQ": 9000,
    "Speed": 8600
  },
  "Yuta Okkotsu (Jujutsu Kaisen 0)": {
    "Grade": 9000,
    "Captain": 8500,
    "Vice Captain": 8000,
    "Healer": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9200,
    "Cursed Energy": 9200,
    "Combat Specialist": 8000,
    "Technique Specialist": 8200,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 7800,
    "IQ": 7500,
    "Speed": 7800
  },
  "Yuta Okkotsu (Fully Manifested Rika)": {
    "Grade": 9800,
    "Captain": 9300,
    "Vice Captain": 9000,
    "Healer": 8700,
    "Support 1": 9100,
    "Support 2": 9100,
    "Tank": 9400,
    "Domain Expansion": 9800,
    "Cursed Spirit": 9700,
    "Cursed Energy": 9700,
    "Combat Specialist": 9500,
    "Technique Specialist": 9700,
    "Power": 9700,
    "Hax": 9900,
    "Defence": 9400,
    "IQ": 9000,
    "Speed": 9000
  },
  "Dr Hogback": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 1500,
    "Healer": 7500,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1200,
    "Speed": 1000,
    "Weapon Skill": 1200,
    "Willpower": 2000,
    "Power": 1200,
    "Hax": 6000,
    "Defence": 1500,
    "IQ": 7000
  },
  "Perona": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 3000,
    "Weapon Skill": 2000,
    "Willpower": 4000,
    "Power": 1500,
    "Hax": 7000,
    "Defence": 1500,
    "IQ": 5000
  },
  "Charlotte Perospero": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 5500,
    "Weapon Skill": 5000,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7500,
    "Defence": 6000,
    "IQ": 7000
  },
  "Zunesha": {
    "Captain": 8000,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9999,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 9500,
    "Speed": 3000,
    "Weapon Skill": 1000,
    "Willpower": 9000,
    "Power": 9500,
    "Hax": 4000,
    "Defence": 9999,
    "IQ": 8000
  },
  "Rebecca": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 5000,
    "Weapon Skill": 4000,
    "Willpower": 6000,
    "Power": 3000,
    "Hax": 2000,
    "Defence": 1500,
    "IQ": 4000
  },
  "Boa Sandersonia": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 3000,
    "Combat Power": 4000,
    "Speed": 5000,
    "Weapon Skill": 3500,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4500,
    "IQ": 4000
  },
  "Boa Marigold": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 3000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Weapon Skill": 3500,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 5000,
    "IQ": 4000
  },
  "Vinsmoke Judge": {
    "Captain": 6000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 3500,
    "Defence": 5000,
    "IQ": 8500
  },
  "Vinsmoke Reiju": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 3000,
    "Devil Fruit": 1000,
    "Haki": 3000,
    "Combat Power": 5000,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 6500
  },
  "Vinsmoke Ichiji": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 6000,
    "Speed": 7500,
    "Weapon Skill": 5500,
    "Willpower": 5500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 5500,
    "IQ": 5000
  },
  "Vinsmoke Niji": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 6000,
    "Speed": 8000,
    "Weapon Skill": 5500,
    "Willpower": 5500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 5000,
    "IQ": 5000
  },
  "Vinsmoke Yonji": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 3500,
    "Defence": 6000,
    "IQ": 5000
  },
  "Zeff": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2000,
    "Combat Power": 3500,
    "Speed": 1000,
    "Weapon Skill": 5000,
    "Willpower": 8000,
    "Power": 3500,
    "Hax": 2000,
    "Defence": 3000,
    "IQ": 6000
  },
  "Kozuki Momonosuke": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 9200,
    "Haki": 2000,
    "Combat Power": 2500,
    "Speed": 3500,
    "Weapon Skill": 3000,
    "Willpower": 9500,
    "Power": 2500,
    "Hax": 3000,
    "Defence": 3500,
    "IQ": 5000
  },
  "Kozuki Hiyori": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1000,
    "Healer": 2000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1200,
    "Speed": 2000,
    "Weapon Skill": 2000,
    "Willpower": 5000,
    "Power": 1200,
    "Hax": 1500,
    "Defence": 1000,
    "IQ": 6000
  },
  "Kinemon": {
    "Captain": 6800,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 4000,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 7000,
    "Willpower": 9999,
    "Power": 5000,
    "Hax": 3500,
    "Defence": 5000,
    "IQ": 6000
  },
  "Kanjuro": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 3000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 6500
  },
  "Raizo": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 3500,
    "Combat Power": 4500,
    "Speed": 5000,
    "Weapon Skill": 4500,
    "Willpower": 6000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4000,
    "IQ": 5500
  },
  "Kikunojo": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 6000,
    "Weapon Skill": 6500,
    "Willpower": 6500,
    "Power": 5500,
    "Hax": 2500,
    "Defence": 4500,
    "IQ": 5500
  },
  "Denjiro": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 6000,
    "Speed": 6000,
    "Weapon Skill": 7000,
    "Willpower": 7000,
    "Power": 6000,
    "Hax": 2500,
    "Defence": 5500,
    "IQ": 6500
  },
  "Ashura Doji": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 6500,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 7000,
    "Power": 6500,
    "Hax": 2000,
    "Defence": 6500,
    "IQ": 5500
  },
  "Kawamatsu": {
    "Captain": 3000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 5500,
    "Speed": 6000,
    "Weapon Skill": 6000,
    "Willpower": 6500,
    "Power": 5500,
    "Hax": 2500,
    "Defence": 6000,
    "IQ": 6000
  },
  "Inuarashi": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 7000,
    "Weapon Skill": 6500,
    "Willpower": 7000,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 5500,
    "IQ": 6000
  },
  "Nekomamushi": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 7000,
    "Weapon Skill": 7500,
    "Willpower": 7000,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 5500,
    "IQ": 6000
  },
  "Hibari": {
    "Captain": 1500,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2500,
    "Weapon Skill": 6000,
    "Willpower": 4000,
    "Power": 1500,
    "Hax": 4000,
    "Defence": 1500,
    "IQ": 5500
  },
  "Emeth": {
    "Captain": 7000,
    "Vice Captain": 1000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 7500,
    "Speed": 4000,
    "Weapon Skill": 6000,
    "Willpower": 8000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 9000,
    "IQ": 3000
  },
  "Nika": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Devil Fruit": 9999,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Weapon Skill": 9999,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999
  },
  "Shaka": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 3000,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3500,
    "IQ": 9500
  },
  "Lilith": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3500,
    "IQ": 9500
  },
  "Edison": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Weapon Skill": 3500,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3500,
    "IQ": 9500
  },
  "Pythagoras": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 3000,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 8000,
    "Defence": 3500,
    "IQ": 9500
  },
  "Atlas": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 4000,
    "IQ": 9000
  },
  "York": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 3000,
    "Weapon Skill": 3000,
    "Willpower": 5000,
    "Power": 3000,
    "Hax": 8000,
    "Defence": 3000,
    "IQ": 9000
  },
  "Shukaku (One Tail)": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 7600,
    "Support 2": 7600,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 9100,
    "Jutsu": 8200,
    "Clan": 1000,
    "Chakra": 8100,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 7000,
    "Power": 8600,
    "Hax": 8200,
    "Defence": 8800
  },
  "Matatabi (Two Tails)": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 7700,
    "Support 2": 7700,
    "Tank": 7200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 9200,
    "Jutsu": 7800,
    "Clan": 1000,
    "Chakra": 8200,
    "Sensei": 1000,
    "Speed": 8500,
    "Taijutsu": 7300,
    "Power": 8200,
    "Hax": 7600,
    "Defence": 7300
  },
  "Isobu (Three Tails)": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 9300,
    "Jutsu": 7600,
    "Clan": 1000,
    "Chakra": 8300,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 6500,
    "Power": 8200,
    "Hax": 7300,
    "Defence": 9200
  },
  "Son Goku (Four Tails)": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8600,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 9400,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 8800,
    "Sensei": 1000,
    "Speed": 7200,
    "Taijutsu": 8000,
    "Power": 9000,
    "Hax": 8500,
    "Defence": 8700
  },
  "Kokuo (Five Tails)": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 8100,
    "Support 2": 8100,
    "Tank": 8300,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 9500,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 8600,
    "Sensei": 1000,
    "Speed": 8800,
    "Taijutsu": 8200,
    "Power": 8700,
    "Hax": 7800,
    "Defence": 8400
  },
  "Saiken (Six Tails)": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 8700,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 9600,
    "Jutsu": 8200,
    "Clan": 1000,
    "Chakra": 8400,
    "Sensei": 1000,
    "Speed": 6200,
    "Taijutsu": 6200,
    "Power": 8300,
    "Hax": 8500,
    "Defence": 8800
  },
  "Chomei (Seven Tails)": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 8300,
    "Support 2": 8300,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 9700,
    "Jutsu": 7800,
    "Clan": 1000,
    "Chakra": 8900,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 7000,
    "Power": 8100,
    "Hax": 7900,
    "Defence": 7400
  },
  "Gyuki (Eight Tails)": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9300,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 9800,
    "Jutsu": 8800,
    "Clan": 1000,
    "Chakra": 9300,
    "Sensei": 1000,
    "Speed": 8000,
    "Taijutsu": 8500,
    "Power": 9400,
    "Hax": 8700,
    "Defence": 9300
  },
  "Kurama (Nine Tails)": {
    "Captain": 9000,
    "Vice Captain": 8800,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9600,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8500,
    "Summon": 9900,
    "Jutsu": 9300,
    "Clan": 1000,
    "Chakra": 9800,
    "Sensei": 1000,
    "Speed": 9000,
    "Taijutsu": 8800,
    "Power": 9800,
    "Hax": 9300,
    "Defence": 9600
  },
  "Ten Tails": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 9999,
    "IQ": 6000,
    "Summon": 9999,
    "Jutsu": 9999,
    "Clan": 1000,
    "Chakra": 9999,
    "Sensei": 1000,
    "Speed": 9200,
    "Taijutsu": 9000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Soul King": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Zanpakuto": 1000,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 9999,
    "Sensei": 9000,
    "Ally": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Ichigo Kurosaki (Horn of Salvation)": {
    "Captain": 9400,
    "Vice Captain": 8200,
    "Support 1": 9300,
    "Support 2": 9300,
    "Tank": 9600,
    "Healer": 1000,
    "Zanpakuto": 9800,
    "Reiatsu": 9999,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9800,
    "IQ": 8000,
    "Sensei": 1000,
    "Ally": 9000,
    "Power": 9999,
    "Hax": 9800,
    "Defence": 9600
  },
  "Daishinkan (Grand Priest)": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Ki Control": 9999,
    "Technique": 9999,
    "Form": 9999,
    "Speed": 9999,
    "IQ": 9999,
    "Sensei": 9999,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Zeno": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 1000,
    "Ki Control": 9999,
    "Technique": 9999,
    "Form": 1000,
    "Speed": 9999,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 9999,
    "Energy Manipulation": 9999,
    "Martial Arts": 1000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Attendants of Zenos": {
    "Captain": 9990,
    "Vice Captain": 9000,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9500,
    "Form": 9500,
    "Speed": 9700,
    "IQ": 8500,
    "Sensei": 7000,
    "Power Level": 9700,
    "Energy Manipulation": 9500,
    "Martial Arts": 9500,
    "Power": 9700,
    "Hax": 9200,
    "Defence": 9500
  },
  "Belmod": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9500,
    "Healer": 1000,
    "Ki Control": 9500,
    "Technique": 9700,
    "Form": 9800,
    "Speed": 9400,
    "IQ": 9200,
    "Sensei": 8000,
    "Power Level": 9800,
    "Energy Manipulation": 9999,
    "Martial Arts": 9500,
    "Power": 9800,
    "Hax": 9999,
    "Defence": 9600
  },
  "King Kai": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 7800,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 8500,
    "Sensei": 9500,
    "Power Level": 5000,
    "Energy Manipulation": 6500,
    "Martial Arts": 6000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 4500
  },
  "Loki": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9200,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9500,
    "Combat Power": 9700,
    "Speed": 8200,
    "Weapon Skill": 8500,
    "IQ": 7500,
    "Willpower": 9000,
    "Power": 9200,
    "Hax": 7800,
    "Defence": 9200
  },
  "Loki (Transformation)": {
    "Captain": 9000,
    "Vice Captain": 9900,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9999,
    "Healer": 1000,
    "Devil Fruit": 9900,
    "Haki": 9000,
    "Combat Power": 9800,
    "Speed": 9000,
    "Weapon Skill": 8800,
    "Willpower": 9500,
    "Power": 9800,
    "Hax": 9999,
    "Defence": 9700,
    "IQ": 7500
  },
  "Figarland Garling": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9800,
    "Combat Power": 9700,
    "Speed": 9400,
    "Weapon Skill": 9900,
    "Willpower": 9500,
    "Power": 9600,
    "Hax": 9000,
    "Defence": 9000,
    "IQ": 9200
  },
  "Garp (Prime)": {
    "Captain": 9999,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9900,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9500,
    "Weapon Skill": 1000,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9800,
    "Defence": 9900,
    "IQ": 8200
  },
  "Joyboy": {
    "Captain": 9999,
    "Vice Captain": 9800,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9700,
    "Healer": 1000,
    "Devil Fruit": 9999,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Weapon Skill": 5000,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9900,
    "Defence": 9600,
    "IQ": 8500
  },
  "Kong": {
    "Captain": 9300,
    "Vice Captain": 8800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9300,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9300,
    "Combat Power": 9400,
    "Speed": 8200,
    "Weapon Skill": 1000,
    "Willpower": 9500,
    "Power": 9400,
    "Hax": 8800,
    "Defence": 9300,
    "IQ": 9300
  },
  "Yuji Itadori (Modulo)": {
    "Grade": 9999,
    "Captain": 9999,
    "Vice Captain": 9999,
    "Healer": 5000,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9500,
    "Domain Expansion": 9999,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9999,
    "Combat Specialist": 9999,
    "Technique Specialist": 9000,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999,
    "Speed": 9999
  },
  "Maru": {
    "Grade": 9999,
    "Captain": 9300,
    "Vice Captain": 9000,
    "Healer": 1000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9700,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9800,
    "Cursed Energy": 8000,
    "Combat Specialist": 9500,
    "Technique Specialist": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9700,
    "IQ": 9600,
    "Speed": 9700
  },
  "Cross": {
    "Grade": 9900,
    "Captain": 9200,
    "Vice Captain": 9000,
    "Healer": 1000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9600,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9300,
    "Cursed Energy": 9900,
    "Combat Specialist": 9700,
    "Technique Specialist": 9800,
    "Power": 9800,
    "Hax": 9900,
    "Defence": 9600,
    "IQ": 9400,
    "Speed": 9800
  },
  "Dabura Karaba": {
    "Grade": 9800,
    "Captain": 9500,
    "Vice Captain": 8800,
    "Healer": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9900,
    "Domain Expansion": 9500,
    "Cursed Spirit": 9800,
    "Cursed Energy": 9700,
    "Combat Specialist": 9900,
    "Technique Specialist": 9300,
    "Power": 9999,
    "Hax": 9400,
    "Defence": 9900,
    "IQ": 8800,
    "Speed": 9999
  },
  "Tsurugi Okkotsu": {
    "Grade": 9300,
    "Captain": 8800,
    "Vice Captain": 8500,
    "Healer": 1000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9200,
    "Combat Specialist": 9600,
    "Technique Specialist": 9000,
    "Power": 9300,
    "Hax": 8800,
    "Defence": 8800,
    "IQ": 8500,
    "Speed": 9500
  },
  "Charles Bernard": {
    "Grade": 9200,
    "Captain": 8500,
    "Vice Captain": 8200,
    "Healer": 1000,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 8500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 9000,
    "Combat Specialist": 8800,
    "Technique Specialist": 9400,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 8500,
    "IQ": 9200,
    "Speed": 8800
  },
  "Kuroushi": {
    "Grade": 9000,
    "Captain": 7500,
    "Vice Captain": 7200,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 9500,
    "Cursed Energy": 9000,
    "Combat Specialist": 9200,
    "Technique Specialist": 8500,
    "Power": 9300,
    "Hax": 9000,
    "Defence": 9000,
    "IQ": 7500,
    "Speed": 9000
  },
  "Osuki": {
    "Grade": 8800,
    "Captain": 7200,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 8800,
    "Domain Expansion": 8800,
    "Cursed Spirit": 9300,
    "Cursed Energy": 8800,
    "Combat Specialist": 8500,
    "Technique Specialist": 9000,
    "Power": 8800,
    "Hax": 9400,
    "Defence": 8500,
    "IQ": 7800,
    "Speed": 8500
  },
  "Yuka Okkotsu": {
    "Grade": 8800,
    "Captain": 7800,
    "Vice Captain": 7500,
    "Healer": 6000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7500,
    "Domain Expansion": 7500,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8800,
    "Combat Specialist": 8400,
    "Technique Specialist": 9000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 7800,
    "IQ": 8500,
    "Speed": 8600
  },
  "Aizetsu": {
    "Captain": 5400,
    "Vice Captain": 5900,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 6600,
    "Healer": 1000,
    "Speed": 5600,
    "Power": 6000,
    "IQ": 4400,
    "Breathing": 1000,
    "Demon": 6600,
    "Hashira": 1000,
    "Weapon Skill": 4500,
    "Technique": 5400,
    "Hax": 4600,
    "Defence": 6600
  },
  "Akaza": {
    "Captain": 7900,
    "Vice Captain": 8400,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8200,
    "Healer": 1000,
    "Speed": 9000,
    "Power": 9000,
    "IQ": 6800,
    "Breathing": 1000,
    "Demon": 9400,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 9200,
    "Hax": 3800,
    "Defence": 8400
  },
  "Amane Ubuyashiki": {
    "Captain": 5000,
    "Vice Captain": 7600,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 1800,
    "Healer": 4200,
    "Speed": 1600,
    "Power": 1400,
    "IQ": 8200,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 1200,
    "Hax": 6000,
    "Defence": 1800
  },
  "Aoi Kanzaki": {
    "Captain": 2600,
    "Vice Captain": 2400,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2000,
    "Healer": 6200,
    "Speed": 3000,
    "Power": 2200,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 2600,
    "Technique": 2200,
    "Hax": 1400,
    "Defence": 2200
  },
  "Daki & Gyutaro": {
    "Captain": 7200,
    "Vice Captain": 7700,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9000,
    "Healer": 1000,
    "Speed": 7400,
    "Power": 7800,
    "IQ": 5600,
    "Breathing": 1000,
    "Demon": 8700,
    "Hashira": 1000,
    "Weapon Skill": 7000,
    "Technique": 7000,
    "Hax": 6000,
    "Defence": 7400
  },
  "Daki": {
    "Captain": 6600,
    "Vice Captain": 7100,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 6800,
    "Healer": 1000,
    "Speed": 7400,
    "Power": 7000,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 7300,
    "Hashira": 1000,
    "Weapon Skill": 6600,
    "Technique": 6600,
    "Hax": 5600,
    "Defence": 6800
  },
  "Demon King Tanjiro": {
    "Captain": 9000,
    "Vice Captain": 7000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 9999,
    "Healer": 1000,
    "Speed": 9500,
    "Power": 9600,
    "IQ": 6800,
    "Breathing": 9999,
    "Demon": 9999,
    "Hashira": 1000,
    "Weapon Skill": 9200,
    "Technique": 9000,
    "Hax": 7000,
    "Defence": 9400
  },
  "Doma": {
    "Captain": 8000,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8400,
    "Healer": 1000,
    "Speed": 8600,
    "Power": 9100,
    "IQ": 8000,
    "Breathing": 1000,
    "Demon": 9600,
    "Hashira": 1000,
    "Weapon Skill": 6000,
    "Technique": 8600,
    "Hax": 8600,
    "Defence": 8600
  },
  "Enmu": {
    "Captain": 5800,
    "Vice Captain": 6300,
    "Support 1": 3600,
    "Support 2": 3600,
    "Tank": 5400,
    "Healer": 1000,
    "Speed": 6000,
    "Power": 6600,
    "IQ": 6600,
    "Breathing": 1000,
    "Demon": 6800,
    "Hashira": 1000,
    "Weapon Skill": 2400,
    "Technique": 6600,
    "Hax": 7600,
    "Defence": 5400
  },
  "Genya Shinazugawa (Demon)": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 7200,
    "Healer": 1000,
    "Speed": 7200,
    "Power": 5200,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 7600,
    "Hashira": 1000,
    "Weapon Skill": 6800,
    "Technique": 6400,
    "Hax": 3400,
    "Defence": 7200
  },
  "Genya Shinazugawa": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5600,
    "Healer": 1000,
    "Speed": 5400,
    "Power": 5200,
    "IQ": 4600,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 5600,
    "Technique": 4800,
    "Hax": 2000,
    "Defence": 5200
  },
  "Giyu Tomioka (Base)": {
    "Captain": 7000,
    "Vice Captain": 7600,
    "Support 1": 4600,
    "Support 2": 4600,
    "Tank": 6800,
    "Healer": 1000,
    "Speed": 7000,
    "Power": 7700,
    "IQ": 6200,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 9000,
    "Weapon Skill": 8000,
    "Technique": 7600,
    "Hax": 2000,
    "Defence": 6800
  },
  "Giyu Tomioka (Mark)": {
    "Captain": 8000,
    "Vice Captain": 7600,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7400,
    "Healer": 1000,
    "Speed": 7800,
    "Power": 8400,
    "IQ": 6200,
    "Breathing": 8800,
    "Demon": 1000,
    "Hashira": 9500,
    "Weapon Skill": 8800,
    "Technique": 8400,
    "Hax": 2200,
    "Defence": 7400
  },
  "Gyokko": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6600,
    "Healer": 1000,
    "Speed": 6600,
    "Power": 7100,
    "IQ": 6200,
    "Breathing": 1000,
    "Demon": 8800,
    "Hashira": 1000,
    "Weapon Skill": 3800,
    "Technique": 6800,
    "Hax": 7200,
    "Defence": 6600
  },
  "Gyomei Himejima (Mark)": {
    "Captain": 8100,
    "Vice Captain": 8600,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 9200,
    "Healer": 1000,
    "Speed": 7200,
    "Power": 8600,
    "IQ": 5800,
    "Breathing": 8700,
    "Demon": 1000,
    "Hashira": 9999,
    "Weapon Skill": 8600,
    "Technique": 8000,
    "Hax": 1800,
    "Defence": 9300
  },
  "Gyomei Himejima": {
    "Captain": 7400,
    "Vice Captain": 7900,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9000,
    "Healer": 1000,
    "Speed": 6600,
    "Power": 8000,
    "IQ": 5600,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 9800,
    "Weapon Skill": 7900,
    "Technique": 7600,
    "Hax": 1600,
    "Defence": 8800
  },
  "Gyutaro": {
    "Captain": 8300,
    "Vice Captain": 8800,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 8400,
    "Healer": 1000,
    "Speed": 8200,
    "Power": 8900,
    "IQ": 6600,
    "Breathing": 1000,
    "Demon": 9200,
    "Hashira": 1000,
    "Weapon Skill": 8400,
    "Technique": 8300,
    "Hax": 7200,
    "Defence": 8400
  },
  "Hand Demon": {
    "Captain": 4200,
    "Vice Captain": 4700,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4600,
    "Healer": 1000,
    "Speed": 4400,
    "Power": 4000,
    "IQ": 3400,
    "Breathing": 1000,
    "Demon": 4800,
    "Hashira": 1000,
    "Weapon Skill": 3400,
    "Technique": 4000,
    "Hax": 4000,
    "Defence": 4600
  },
  "Hantengu": {
    "Captain": 7600,
    "Vice Captain": 8100,
    "Support 1": 4400,
    "Support 2": 4400,
    "Tank": 1000,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 8200,
    "IQ": 6000,
    "Breathing": 1000,
    "Demon": 9000,
    "Hashira": 1000,
    "Weapon Skill": 3400,
    "Technique": 7600,
    "Hax": 8200,
    "Defence": 8200
  },
  "Hinatsuru": {
    "Captain": 2800,
    "Vice Captain": 2600,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 2600,
    "Healer": 2000,
    "Speed": 3800,
    "Power": 3000,
    "IQ": 3600,
    "Breathing": 2000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 3400,
    "Technique": 2800,
    "Hax": 1400,
    "Defence": 2600
  },
  "Inosuke Hashibira": {
    "Captain": 4600,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5800,
    "Healer": 1000,
    "Speed": 6600,
    "Power": 5800,
    "IQ": 3600,
    "Breathing": 5600,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6600,
    "Technique": 4600,
    "Hax": 2600,
    "Defence": 6000
  },
  "Kagaya Ubuyashiki": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 2600,
    "Healer": 2000,
    "Speed": 2000,
    "Power": 2400,
    "IQ": 9600,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 6500,
    "Hax": 8500,
    "Defence": 2600
  },
  "Kaigaku": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 6800,
    "Healer": 1000,
    "Speed": 7800,
    "Power": 7300,
    "IQ": 4800,
    "Breathing": 8500,
    "Demon": 7400,
    "Hashira": 1000,
    "Weapon Skill": 7600,
    "Technique": 6800,
    "Hax": 3600,
    "Defence": 6800
  },
  "Kanae Kocho": {
    "Captain": 6400,
    "Vice Captain": 6900,
    "Support 1": 4600,
    "Support 2": 4600,
    "Tank": 6000,
    "Healer": 5700,
    "Speed": 7000,
    "Power": 7000,
    "IQ": 6200,
    "Breathing": 7400,
    "Demon": 1000,
    "Hashira": 7400,
    "Weapon Skill": 7200,
    "Technique": 7000,
    "Hax": 1600,
    "Defence": 5800
  },
  "Kanao Tsuyuri": {
    "Captain": 6200,
    "Vice Captain": 6700,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5800,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 6600,
    "IQ": 4400,
    "Breathing": 7400,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6500,
    "Technique": 6800,
    "Hax": 3800,
    "Defence": 5800
  },
  "Karaku": {
    "Captain": 5600,
    "Vice Captain": 6100,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 5400,
    "Healer": 1000,
    "Speed": 7200,
    "Power": 6200,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 6600,
    "Hashira": 1000,
    "Weapon Skill": 2800,
    "Technique": 5800,
    "Hax": 5200,
    "Defence": 5400
  },
  "Kiyo Terauchi": {
    "Captain": 2200,
    "Vice Captain": 2000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 1600,
    "Healer": 5600,
    "Speed": 2400,
    "Power": 1600,
    "IQ": 4400,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 1600,
    "Hax": 1200,
    "Defence": 1600
  },
  "Kokushibo": {
    "Captain": 8800,
    "Vice Captain": 9300,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9000,
    "Healer": 1000,
    "Speed": 9200,
    "Power": 9400,
    "IQ": 7600,
    "Breathing": 9500,
    "Demon": 9800,
    "Hashira": 1000,
    "Weapon Skill": 9500,
    "Technique": 9400,
    "Hax": 5200,
    "Defence": 9000
  },
  "Kotetsu": {
    "Captain": 2200,
    "Vice Captain": 2000,
    "Support 1": 2400,
    "Support 2": 2400,
    "Tank": 2200,
    "Healer": 1400,
    "Speed": 2600,
    "Power": 1800,
    "IQ": 3200,
    "Breathing": 2000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1800,
    "Technique": 1800,
    "Hax": 1200,
    "Defence": 2000
  },
  "Kyogai": {
    "Captain": 4600,
    "Vice Captain": 5100,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 4800,
    "Healer": 1000,
    "Speed": 5000,
    "Power": 4400,
    "IQ": 3800,
    "Breathing": 1000,
    "Demon": 5200,
    "Hashira": 1000,
    "Weapon Skill": 3800,
    "Technique": 4600,
    "Hax": 5400,
    "Defence": 4800
  },
  "Kyojuro Rengoku": {
    "Captain": 8200,
    "Vice Captain": 8600,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7400,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 7600,
    "IQ": 6600,
    "Breathing": 8400,
    "Demon": 1000,
    "Hashira": 8800,
    "Weapon Skill": 8400,
    "Technique": 8000,
    "Hax": 1800,
    "Defence": 7200
  },
  "Makio": {
    "Captain": 2800,
    "Vice Captain": 2600,
    "Support 1": 4400,
    "Support 2": 4400,
    "Tank": 2600,
    "Healer": 2000,
    "Speed": 3800,
    "Power": 3000,
    "IQ": 3600,
    "Breathing": 2000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 3400,
    "Technique": 2800,
    "Hax": 1400,
    "Defence": 2600
  },
  "Makomo": {
    "Captain": 3600,
    "Vice Captain": 4000,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 3400,
    "Healer": 1000,
    "Speed": 4600,
    "Power": 3800,
    "IQ": 4200,
    "Breathing": 4200,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 4200,
    "Technique": 3800,
    "Hax": 1400,
    "Defence": 3400
  },
  "Mitsuri Kanroji (Mark)": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7800,
    "Healer": 1000,
    "Speed": 8200,
    "Power": 8100,
    "IQ": 5400,
    "Breathing": 8600,
    "Demon": 1000,
    "Hashira": 8900,
    "Weapon Skill": 8400,
    "Technique": 7600,
    "Hax": 2000,
    "Defence": 7800
  },
  "Mitsuri Kanroji": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 7200,
    "Healer": 1000,
    "Speed": 7400,
    "Power": 7300,
    "IQ": 5400,
    "Breathing": 7800,
    "Demon": 1000,
    "Hashira": 8200,
    "Weapon Skill": 7600,
    "Technique": 7000,
    "Hax": 1800,
    "Defence": 7200
  },
  "Muichiro Tokito (Mark)": {
    "Captain": 6900,
    "Vice Captain": 7400,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Speed": 8700,
    "Power": 8300,
    "IQ": 6600,
    "Breathing": 9000,
    "Demon": 1000,
    "Hashira": 9300,
    "Weapon Skill": 9000,
    "Technique": 9000,
    "Hax": 2800,
    "Defence": 6800
  },
  "Muichiro Tokito": {
    "Captain": 6900,
    "Vice Captain": 7400,
    "Support 1": 4600,
    "Support 2": 4600,
    "Tank": 6400,
    "Healer": 1000,
    "Speed": 7900,
    "Power": 7500,
    "IQ": 6600,
    "Breathing": 8200,
    "Demon": 1000,
    "Hashira": 8600,
    "Weapon Skill": 8200,
    "Technique": 8200,
    "Hax": 2600,
    "Defence": 6200
  },
  "Muzan Kibutsuji": {
    "Captain": 9000,
    "Vice Captain": 9500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9600,
    "Healer": 9999,
    "Speed": 9000,
    "Power": 9800,
    "IQ": 9200,
    "Breathing": 1000,
    "Demon": 9900,
    "Hashira": 1000,
    "Weapon Skill": 3000,
    "Technique": 9200,
    "Hax": 9200,
    "Defence": 9800
  },
  "Naho Takada": {
    "Captain": 2200,
    "Vice Captain": 2000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 1600,
    "Healer": 5600,
    "Speed": 2400,
    "Power": 1600,
    "IQ": 4400,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 1600,
    "Hax": 1200,
    "Defence": 1600
  },
  "Nakime": {
    "Captain": 5600,
    "Vice Captain": 6100,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5000,
    "Healer": 1000,
    "Speed": 4600,
    "Power": 5800,
    "IQ": 7000,
    "Breathing": 1000,
    "Demon": 8800,
    "Hashira": 1000,
    "Weapon Skill": 1400,
    "Technique": 6200,
    "Hax": 8200,
    "Defence": 5000
  },
  "Nezuko Kamado (Base)": {
    "Captain": 3200,
    "Vice Captain": 3600,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 6200,
    "Healer": 1000,
    "Speed": 5200,
    "Power": 4600,
    "IQ": 3800,
    "Breathing": 1000,
    "Demon": 5200,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 2000,
    "Hax": 4200,
    "Defence": 6800
  },
  "Nezuko Kamado (Demon)": {
    "Captain": 6600,
    "Vice Captain": 7000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 8200,
    "Healer": 6000,
    "Speed": 7800,
    "Power": 7600,
    "IQ": 5200,
    "Breathing": 1000,
    "Demon": 8600,
    "Hashira": 1000,
    "Weapon Skill": 2200,
    "Technique": 5000,
    "Hax": 6800,
    "Defence": 8600
  },
  "Obanai Iguro (Mark)": {
    "Captain": 7700,
    "Vice Captain": 8200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7200,
    "Healer": 1000,
    "Speed": 8300,
    "Power": 8200,
    "IQ": 6600,
    "Breathing": 8800,
    "Demon": 1000,
    "Hashira": 9100,
    "Weapon Skill": 8800,
    "Technique": 8200,
    "Hax": 2400,
    "Defence": 7200
  },
  "Obanai Iguro": {
    "Captain": 6900,
    "Vice Captain": 7400,
    "Support 1": 4600,
    "Support 2": 4600,
    "Tank": 6600,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 7400,
    "IQ": 6400,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 8400,
    "Weapon Skill": 8000,
    "Technique": 7600,
    "Hax": 2200,
    "Defence": 6600
  },
  "Rui": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 6000,
    "Healer": 1000,
    "Speed": 6800,
    "Power": 6600,
    "IQ": 5600,
    "Breathing": 1000,
    "Demon": 6800,
    "Hashira": 1000,
    "Weapon Skill": 2600,
    "Technique": 6400,
    "Hax": 7000,
    "Defence": 6000
  },
  "Ruka Rengoku": {
    "Captain": 1800,
    "Vice Captain": 1600,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 1400,
    "Healer": 3800,
    "Speed": 1400,
    "Power": 1200,
    "IQ": 4600,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 1000,
    "Hax": 1400,
    "Defence": 1400
  },
  "Sabito": {
    "Captain": 5600,
    "Vice Captain": 6100,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 5400,
    "Healer": 1000,
    "Speed": 6600,
    "Power": 6200,
    "IQ": 5200,
    "Breathing": 6800,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6600,
    "Technique": 6000,
    "Hax": 1800,
    "Defence": 5400
  },
  "Sakonji Urokodaki": {
    "Captain": 6600,
    "Vice Captain": 7100,
    "Support 1": 6400,
    "Support 2": 6400,
    "Tank": 6600,
    "Healer": 2000,
    "Speed": 6600,
    "Power": 7300,
    "IQ": 6800,
    "Breathing": 7600,
    "Demon": 1000,
    "Hashira": 7900,
    "Weapon Skill": 7600,
    "Technique": 7800,
    "Hax": 1600,
    "Defence": 6600
  },
  "Sanemi Shinazugawa (Mark)": {
    "Captain": 7800,
    "Vice Captain": 8300,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 8000,
    "Healer": 1000,
    "Speed": 8300,
    "Power": 8500,
    "IQ": 6000,
    "Breathing": 8800,
    "Demon": 1000,
    "Hashira": 9700,
    "Weapon Skill": 8800,
    "Technique": 8100,
    "Hax": 1800,
    "Defence": 8000
  },
  "Sanemi Shinazugawa": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 4400,
    "Support 2": 4400,
    "Tank": 7400,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 7800,
    "IQ": 5800,
    "Breathing": 8100,
    "Demon": 1000,
    "Hashira": 9200,
    "Weapon Skill": 8100,
    "Technique": 7600,
    "Hax": 1600,
    "Defence": 7400
  },
  "Sekido": {
    "Captain": 6400,
    "Vice Captain": 6900,
    "Support 1": 3600,
    "Support 2": 3600,
    "Tank": 7000,
    "Healer": 1000,
    "Speed": 6800,
    "Power": 6800,
    "IQ": 4600,
    "Breathing": 1000,
    "Demon": 6800,
    "Hashira": 1000,
    "Weapon Skill": 3200,
    "Technique": 6200,
    "Hax": 4800,
    "Defence": 6800
  },
  "Senjuro Rengoku": {
    "Captain": 2200,
    "Vice Captain": 2000,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 2200,
    "Healer": 1000,
    "Speed": 2200,
    "Power": 1800,
    "IQ": 4200,
    "Breathing": 1400,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1400,
    "Technique": 1600,
    "Hax": 1200,
    "Defence": 2000
  },
  "Shinjuro Rengoku": {
    "Captain": 6800,
    "Vice Captain": 7300,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 7000,
    "Healer": 1000,
    "Speed": 6600,
    "Power": 7500,
    "IQ": 6000,
    "Breathing": 7700,
    "Demon": 1000,
    "Hashira": 7800,
    "Weapon Skill": 7700,
    "Technique": 6000,
    "Hax": 1400,
    "Defence": 6800
  },
  "Shinobu Kocho": {
    "Captain": 6400,
    "Vice Captain": 6900,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 3600,
    "Healer": 9500,
    "Speed": 8400,
    "Power": 6600,
    "IQ": 8600,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 8000,
    "Weapon Skill": 7000,
    "Technique": 8200,
    "Hax": 6600,
    "Defence": 3800
  },
  "Spider Brother": {
    "Captain": 4400,
    "Vice Captain": 4900,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4600,
    "Healer": 1000,
    "Speed": 5200,
    "Power": 4800,
    "IQ": 3400,
    "Breathing": 1000,
    "Demon": 5200,
    "Hashira": 1000,
    "Weapon Skill": 3600,
    "Technique": 4400,
    "Hax": 3800,
    "Defence": 4600
  },
  "Spider Demon": {
    "Captain": 5200,
    "Vice Captain": 5700,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 5600,
    "Healer": 1000,
    "Speed": 5400,
    "Power": 5800,
    "IQ": 4200,
    "Breathing": 1000,
    "Demon": 6000,
    "Hashira": 1000,
    "Weapon Skill": 3600,
    "Technique": 5200,
    "Hax": 4600,
    "Defence": 5600
  },
  "Spider Mother": {
    "Captain": 4600,
    "Vice Captain": 5100,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 4600,
    "Healer": 1000,
    "Speed": 5600,
    "Power": 5000,
    "IQ": 3800,
    "Breathing": 1000,
    "Demon": 5400,
    "Hashira": 1000,
    "Weapon Skill": 3200,
    "Technique": 4600,
    "Hax": 4000,
    "Defence": 4600
  },
  "Spider Sister": {
    "Captain": 4400,
    "Vice Captain": 4900,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4200,
    "Healer": 1000,
    "Speed": 5600,
    "Power": 4800,
    "IQ": 3400,
    "Breathing": 1000,
    "Demon": 5200,
    "Hashira": 1000,
    "Weapon Skill": 3000,
    "Technique": 4400,
    "Hax": 4000,
    "Defence": 4200
  },
  "Suma": {
    "Captain": 2800,
    "Vice Captain": 2600,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2600,
    "Healer": 2200,
    "Speed": 3800,
    "Power": 3000,
    "IQ": 3600,
    "Breathing": 2000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 3400,
    "Technique": 2800,
    "Hax": 1400,
    "Defence": 2600
  },
  "Sumi Nakahara": {
    "Captain": 2200,
    "Vice Captain": 2000,
    "Support 1": 4800,
    "Support 2": 4800,
    "Tank": 1600,
    "Healer": 5600,
    "Speed": 2400,
    "Power": 1600,
    "IQ": 4400,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 1600,
    "Hax": 1200,
    "Defence": 1600
  },
  "Susamaru": {
    "Captain": 4400,
    "Vice Captain": 4900,
    "Support 1": 3200,
    "Support 2": 3200,
    "Tank": 4200,
    "Healer": 1000,
    "Speed": 6200,
    "Power": 4600,
    "IQ": 3400,
    "Breathing": 1000,
    "Demon": 5000,
    "Hashira": 1000,
    "Weapon Skill": 4400,
    "Technique": 4400,
    "Hax": 4200,
    "Defence": 4200
  },
  "Swamp Demon": {
    "Captain": 2400,
    "Vice Captain": 2800,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 2600,
    "Healer": 1000,
    "Speed": 3000,
    "Power": 2400,
    "IQ": 1800,
    "Breathing": 1000,
    "Demon": 3200,
    "Hashira": 1000,
    "Weapon Skill": 1600,
    "Technique": 2000,
    "Hax": 1800,
    "Defence": 2600
  },
  "Tamayo": {
    "Captain": 4800,
    "Vice Captain": 4400,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 3600,
    "Healer": 9000,
    "Speed": 4200,
    "Power": 4600,
    "IQ": 8200,
    "Breathing": 1000,
    "Demon": 6600,
    "Hashira": 1000,
    "Weapon Skill": 1800,
    "Technique": 6000,
    "Hax": 6800,
    "Defence": 4200
  },
  "Tanjiro Kamado (Hinokami Kagura)": {
    "Captain": 7600,
    "Vice Captain": 8000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7400,
    "Healer": 1000,
    "Speed": 8600,
    "Power": 8800,
    "IQ": 7200,
    "Breathing": 9999,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 8600,
    "Technique": 8400,
    "Hax": 4000,
    "Defence": 7600
  },
  "Tanjiro Kamado (Water Breathing)": {
    "Captain": 5200,
    "Vice Captain": 5700,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 5000,
    "Healer": 1000,
    "Speed": 6000,
    "Power": 6400,
    "IQ": 6200,
    "Breathing": 6400,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6200,
    "Technique": 6000,
    "Hax": 3500,
    "Defence": 5200
  },
  "Tanjuro Kamado": {
    "Captain": 4400,
    "Vice Captain": 4000,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 4600,
    "Healer": 1000,
    "Speed": 4400,
    "Power": 4400,
    "IQ": 4600,
    "Breathing": 9000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 7000,
    "Technique": 8000,
    "Hax": 1600,
    "Defence": 4200
  },
  "Tengen & Wives": {
    "Captain": 7700,
    "Vice Captain": 8200,
    "Support 1": 5600,
    "Support 2": 5600,
    "Tank": 7400,
    "Healer": 2200,
    "Speed": 8500,
    "Power": 8000,
    "IQ": 6600,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 8600,
    "Weapon Skill": 8000,
    "Technique": 7800,
    "Hax": 4200,
    "Defence": 7400
  },
  "Tengen Uzui (Retired)": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Speed": 7200,
    "Power": 6700,
    "IQ": 6800,
    "Breathing": 6800,
    "Demon": 1000,
    "Hashira": 7400,
    "Weapon Skill": 6800,
    "Technique": 7600,
    "Hax": 3600,
    "Defence": 6100
  },
  "Tengen Uzui": {
    "Captain": 7500,
    "Vice Captain": 8000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 7700,
    "Healer": 1000,
    "Speed": 9900,
    "Power": 9000,
    "IQ": 6800,
    "Breathing": 8000,
    "Demon": 1000,
    "Hashira": 9500,
    "Weapon Skill": 9000,
    "Technique": 7800,
    "Hax": 4200,
    "Defence": 7400
  },
  "Urogi": {
    "Captain": 5200,
    "Vice Captain": 5700,
    "Support 1": 3600,
    "Support 2": 3600,
    "Tank": 5200,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 5800,
    "IQ": 4200,
    "Breathing": 1000,
    "Demon": 6600,
    "Hashira": 1000,
    "Weapon Skill": 2400,
    "Technique": 5200,
    "Hax": 4400,
    "Defence": 5200
  },
  "Yahaba": {
    "Captain": 4200,
    "Vice Captain": 4700,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Speed": 5000,
    "Power": 4400,
    "IQ": 3400,
    "Breathing": 1000,
    "Demon": 4800,
    "Hashira": 1000,
    "Weapon Skill": 4600,
    "Technique": 4200,
    "Hax": 4000,
    "Defence": 4000
  },
  "Yoriichi Tsugikuni": {
    "Captain": 9999,
    "Vice Captain": 9600,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9200,
    "Healer": 1000,
    "Speed": 9900,
    "Power": 9999,
    "IQ": 7200,
    "Breathing": 9999,
    "Demon": 1000,
    "Hashira": 9999,
    "Weapon Skill": 9999,
    "Technique": 9800,
    "Hax": 4000,
    "Defence": 9400
  },
  "Yoriichi Type Zero": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 4500,
    "Healer": 1000,
    "Speed": 5500,
    "Power": 5500,
    "IQ": 3000,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 8500,
    "Technique": 6500,
    "Hax": 3200,
    "Defence": 4500
  },
  "Yushiro": {
    "Captain": 4000,
    "Vice Captain": 3800,
    "Support 1": 5400,
    "Support 2": 5400,
    "Tank": 3400,
    "Healer": 5000,
    "Speed": 4600,
    "Power": 4200,
    "IQ": 6800,
    "Breathing": 1000,
    "Demon": 5800,
    "Hashira": 1000,
    "Weapon Skill": 2200,
    "Technique": 4600,
    "Hax": 4800,
    "Defence": 3600
  },
  "Zenitsu Agatsuma (Eyes Closed)": {
    "Captain": 5000,
    "Vice Captain": 5400,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 4400,
    "Healer": 1000,
    "Speed": 7600,
    "Power": 6000,
    "IQ": 3200,
    "Breathing": 6800,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6400,
    "Technique": 5400,
    "Hax": 2200,
    "Defence": 4400
  },
  "Zenitsu Agatsuma (Infinity Castle)": {
    "Captain": 7000,
    "Vice Captain": 7400,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 5800,
    "Healer": 1000,
    "Speed": 9400,
    "Power": 7600,
    "IQ": 4200,
    "Breathing": 8600,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 8200,
    "Technique": 7200,
    "Hax": 3000,
    "Defence": 5800
  },
  "Zenitsu Agatsuma (Scared)": {
    "Captain": 2200,
    "Vice Captain": 2600,
    "Support 1": 3400,
    "Support 2": 3400,
    "Tank": 2600,
    "Healer": 1000,
    "Speed": 5000,
    "Power": 3000,
    "IQ": 2400,
    "Breathing": 3200,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 3200,
    "Technique": 2600,
    "Hax": 1400,
    "Defence": 2400
  },
  "Zohakuten": {
    "Captain": 7200,
    "Vice Captain": 7700,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8600,
    "Healer": 1000,
    "Speed": 6800,
    "Power": 7600,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 8900,
    "Hashira": 1000,
    "Weapon Skill": 3600,
    "Technique": 7000,
    "Hax": 6600,
    "Defence": 8800
  },
  "Alvida": {
    "Captain": 3000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4500,
    "Weapon Skill": 4500,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 4500,
    "IQ": 4500
  },
  "Axe Hand Morgan": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 2500,
    "Weapon Skill": 6000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 5000,
    "IQ": 3000
  },
  "Baby Five": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 3000,
    "Combat Power": 4500,
    "Speed": 4500,
    "Weapon Skill": 6000,
    "Willpower": 4000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4500,
    "IQ": 3500
  },
  "Baccarat": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 5000,
    "Weapon Skill": 3500,
    "Willpower": 4000,
    "Power": 3500,
    "Hax": 7500,
    "Defence": 3500,
    "IQ": 4500
  },
  "Bepo (Sulong Form)": {
    "Captain": 4500,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 7500,
    "Speed": 7800,
    "Weapon Skill": 5000,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 3500,
    "Defence": 7000,
    "IQ": 4500
  },
  "Bian": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 7500,
    "Weapon Skill": 5500,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 2500,
    "Defence": 3500,
    "IQ": 4000
  },
  "Buffalo": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Weapon Skill": 3000,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 3000,
    "Defence": 4500,
    "IQ": 2500
  },
  "Captain John": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 8000,
    "Speed": 6500,
    "Weapon Skill": 8000,
    "Willpower": 8000,
    "Power": 8000,
    "Hax": 2500,
    "Defence": 7500,
    "IQ": 6500
  },
  "Caribou": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 4500,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 4500
  },
  "Mother Carmel": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 1800,
    "Healer": 2000,
    "Devil Fruit": 4500,
    "Haki": 1000,
    "Combat Power": 1800,
    "Speed": 2000,
    "Weapon Skill": 1800,
    "Willpower": 5500,
    "Power": 2000,
    "Hax": 6000,
    "Defence": 1800,
    "IQ": 8000
  },
  "Chew": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 5500,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 3000,
    "Defence": 5500,
    "IQ": 3500
  },
  "Professor Clover": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 2000,
    "Weapon Skill": 2000,
    "Willpower": 7500,
    "Power": 2000,
    "Hax": 1000,
    "Defence": 2000,
    "IQ": 9200
  },
  "Dalton": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 7000,
    "Power": 5000,
    "Hax": 1500,
    "Defence": 6500,
    "IQ": 5500
  },
  "Douglas Bullet": {
    "Captain": 8500,
    "Vice Captain": 8500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9700,
    "Healer": 1000,
    "Devil Fruit": 9200,
    "Haki": 9200,
    "Combat Power": 9500,
    "Speed": 7500,
    "Weapon Skill": 7500,
    "Willpower": 9500,
    "Power": 9700,
    "Hax": 8500,
    "Defence": 9700,
    "IQ": 6500
  },
  "Fake Straw Hat Crew": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 1000,
    "Support 2": 1000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 3000,
    "Weapon Skill": 3500,
    "Willpower": 3000,
    "Power": 3000,
    "Hax": 2000,
    "Defence": 3500,
    "IQ": 3000
  },
  "Figarland Shamrock": {
    "Captain": 9800,
    "Vice Captain": 9200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9550,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9800,
    "Combat Power": 9800,
    "Speed": 9400,
    "Weapon Skill": 9800,
    "Willpower": 9400,
    "Power": 9800,
    "Hax": 7000,
    "Defence": 8800,
    "IQ": 8000
  },
  "Fukurou": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 2500,
    "Defence": 6000,
    "IQ": 5000
  },
  "Gaimon": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 1800,
    "Support 2": 1800,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 1500,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 2000,
    "Hax": 1000,
    "Defence": 5000,
    "IQ": 3500
  },
  "Mr. 5 (Gem)": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 4500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000,
    "IQ": 4000
  },
  "Gild Tesoro": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 6500,
    "Combat Power": 8000,
    "Speed": 6000,
    "Weapon Skill": 5000,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8500,
    "IQ": 7500
  },
  "Giolla": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Weapon Skill": 2500,
    "Willpower": 4500,
    "Power": 2500,
    "Hax": 6500,
    "Defence": 3000,
    "IQ": 4000
  },
  "Hannyabal": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 5500,
    "Willpower": 6500,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 5000,
    "IQ": 4000
  },
  "Igaram": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 1000,
    "Weapon Skill": 4500,
    "Willpower": 6500,
    "Power": 3500,
    "Hax": 2000,
    "Defence": 4500,
    "IQ": 5000
  },
  "Jaguar D. Saul": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3000,
    "Combat Power": 7500,
    "Speed": 3500,
    "Weapon Skill": 3500,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 1200,
    "Defence": 8500,
    "IQ": 7500
  },
  "Jango": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 5000,
    "Weapon Skill": 4500,
    "Willpower": 3500,
    "Power": 3500,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 3500
  },
  "King Harald": {
    "Captain": 9800,
    "Vice Captain": 9200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9800,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9200,
    "Combat Power": 9800,
    "Speed": 6000,
    "Weapon Skill": 9200,
    "Willpower": 9600,
    "Power": 9800,
    "Hax": 3000,
    "Defence": 9800,
    "IQ": 8000
  },
  "Kuro": {
    "Captain": 1000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 6000,
    "Speed": 8000,
    "Weapon Skill": 7000,
    "Willpower": 4500,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 3000,
    "IQ": 8500
  },
  "Kurozumi Semimaru": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 4000,
    "Power": 4000,
    "Hax": 1500,
    "Defence": 4000,
    "IQ": 3500
  },
  "Machvise": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 2500,
    "Weapon Skill": 2500,
    "Willpower": 5500,
    "Power": 7500,
    "Hax": 5000,
    "Defence": 7500,
    "IQ": 3500
  },
  "Saint Manmayer Gunko": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 8500,
    "Combat Power": 8000,
    "Speed": 8500,
    "Weapon Skill": 8500,
    "Willpower": 8000,
    "Power": 8000,
    "Hax": 9000,
    "Defence": 7000,
    "IQ": 7500
  },
  "Manshelly": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 1200,
    "Healer": 9500,
    "Devil Fruit": 8500,
    "Haki": 1000,
    "Combat Power": 1200,
    "Speed": 2000,
    "Weapon Skill": 1500,
    "Willpower": 4000,
    "Power": 1200,
    "Hax": 3500,
    "Defence": 1200,
    "IQ": 3500
  },
  "Monet": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 4000,
    "Weapon Skill": 2500,
    "Willpower": 7500,
    "Power": 3500,
    "Hax": 6000,
    "Defence": 2500,
    "IQ": 6000
  },
  "Mont Blanc Noland": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 3000,
    "Weapon Skill": 5500,
    "Willpower": 8500,
    "Power": 4500,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 6500
  },
  "Nico Olivia": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Weapon Skill": 3000,
    "Willpower": 8000,
    "Power": 2500,
    "Hax": 1000,
    "Defence": 2500,
    "IQ": 8500
  },
  "Nojiko": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2000,
    "Healer": 2500,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 3000,
    "Weapon Skill": 3000,
    "Willpower": 6500,
    "Power": 2000,
    "Hax": 1000,
    "Defence": 2000,
    "IQ": 4500
  },
  "Pappag": {
    "Captain": 1200,
    "Vice Captain": 1200,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1200,
    "Speed": 1500,
    "Weapon Skill": 1000,
    "Willpower": 3000,
    "Power": 1200,
    "Hax": 1000,
    "Defence": 2000,
    "IQ": 3500
  },
  "Pell": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 9000,
    "Power": 5500,
    "Hax": 2000,
    "Defence": 7000,
    "IQ": 5000
  },
  "Pica": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 7000,
    "Speed": 3500,
    "Weapon Skill": 5500,
    "Willpower": 5500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 8500,
    "IQ": 4000
  },
  "Ripley": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 2500,
    "Combat Power": 6000,
    "Speed": 3500,
    "Weapon Skill": 6000,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 1200,
    "Defence": 8000,
    "IQ": 6000
  },
  "Saint Charlos": {
    "Captain": 1500,
    "Vice Captain": 1200,
    "Support 1": 1500,
    "Support 2": 1500,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1200,
    "Speed": 1500,
    "Weapon Skill": 2500,
    "Willpower": 1500,
    "Power": 1500,
    "Hax": 1000,
    "Defence": 1500,
    "IQ": 1500
  },
  "Senor Pink": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4500,
    "Combat Power": 6000,
    "Speed": 5500,
    "Weapon Skill": 3500,
    "Willpower": 8000,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 7500,
    "IQ": 4500
  },
  "Shu": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 6000,
    "Weapon Skill": 4500,
    "Willpower": 4500,
    "Power": 5000,
    "Hax": 7500,
    "Defence": 5500,
    "IQ": 4500
  },
  "Spandam": {
    "Captain": 2500,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 4500,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Weapon Skill": 4000,
    "Willpower": 2500,
    "Power": 3000,
    "Hax": 2000,
    "Defence": 3000,
    "IQ": 4500
  },
  "Sugar": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 1500,
    "Healer": 1000,
    "Devil Fruit": 9000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2500,
    "Weapon Skill": 1500,
    "Willpower": 4500,
    "Power": 1500,
    "Hax": 9200,
    "Defence": 1500,
    "IQ": 5000
  },
  "Thatch": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6500,
    "Combat Power": 7000,
    "Speed": 6500,
    "Weapon Skill": 7500,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 1500,
    "Defence": 7000,
    "IQ": 6500
  },
  "Funk Brothers (Combined)": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 3000,
    "Weapon Skill": 3500,
    "Willpower": 4500,
    "Power": 6500,
    "Hax": 1500,
    "Defence": 6500,
    "IQ": 2000
  },
  "Tom": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 3000,
    "Weapon Skill": 3500,
    "Willpower": 9000,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 7500,
    "IQ": 8000
  },
  "Uta": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 3000,
    "Healer": 3500,
    "Devil Fruit": 9000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 3500,
    "Weapon Skill": 2500,
    "Willpower": 7500,
    "Power": 5500,
    "Hax": 9200,
    "Defence": 3000,
    "IQ": 6000
  },
  "Vergo": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8000,
    "Combat Power": 7000,
    "Speed": 6500,
    "Weapon Skill": 6500,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 2000,
    "Defence": 8000,
    "IQ": 6000
  },
  "Very Good": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 4500,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Weapon Skill": 3000,
    "Willpower": 3000,
    "Power": 2500,
    "Hax": 1000,
    "Defence": 3000,
    "IQ": 2500
  },
  "Wadatsumi": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 2500,
    "Weapon Skill": 2500,
    "Willpower": 4500,
    "Power": 6500,
    "Hax": 1500,
    "Defence": 8000,
    "IQ": 2000
  },
  "Wyper": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 4500,
    "Weapon Skill": 5500,
    "Willpower": 8000,
    "Power": 5500,
    "Hax": 4000,
    "Defence": 4500,
    "IQ": 4000
  },
  "Zephyr": {
    "Captain": 8800,
    "Vice Captain": 8500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8800,
    "Combat Power": 8800,
    "Speed": 7500,
    "Weapon Skill": 8500,
    "Willpower": 9200,
    "Power": 9000,
    "Hax": 4000,
    "Defence": 8500,
    "IQ": 8000
  },
  "Gon Freecss (Base)": {
    "Captain": 5500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 5000,
    "Aura Control": 3000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Technique": 3000,
    "Willpower": 8500,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 4000,
    "IQ": 3500
  },
  "Gon Freecss (Adult)": {
    "Captain": 8500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7500,
    "Healer": 1000,
    "Nen Type": 9700,
    "Aura Control": 7500,
    "Combat Power": 9800,
    "Speed": 8000,
    "Technique": 9100,
    "Willpower": 9800,
    "Power": 9900,
    "Hax": 9200,
    "Defence": 7500,
    "IQ": 5000
  },
  "Killua Zoldyck (Base)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 6000,
    "Aura Control": 5500,
    "Combat Power": 6000,
    "Speed": 8500,
    "Technique": 6500,
    "Willpower": 7500,
    "Power": 6000,
    "Hax": 3500,
    "Defence": 4500,
    "IQ": 6500
  },
  "Killua Zoldyck (Godspeed)": {
    "Captain": 7500,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6500,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 8500,
    "Combat Power": 9200,
    "Speed": 9999,
    "Technique": 9200,
    "Willpower": 9200,
    "Power": 9000,
    "Hax": 5500,
    "Defence": 6500,
    "IQ": 7000
  },
  "Kurapika (Base)": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 5000,
    "Aura Control": 5500,
    "Combat Power": 5000,
    "Speed": 5500,
    "Technique": 4500,
    "Willpower": 8000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500,
    "IQ": 8500
  },
  "Kurapika (Emperor Time)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5000,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 7500,
    "Combat Power": 7800,
    "Speed": 6500,
    "Technique": 6500,
    "Willpower": 9000,
    "Power": 8000,
    "Hax": 8200,
    "Defence": 5000,
    "IQ": 8800
  },
  "Leorio Paradinight": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 6000,
    "Nen Type": 3000,
    "Aura Control": 2500,
    "Combat Power": 3000,
    "Speed": 3000,
    "Technique": 3000,
    "Willpower": 7500,
    "Power": 3000,
    "Hax": 1500,
    "Defence": 4500,
    "IQ": 6000
  },
  "Silva Zoldyck": {
    "Captain": 8000,
    "Vice Captain": 8500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9200,
    "Healer": 1000,
    "Nen Type": 8000,
    "Aura Control": 9000,
    "Combat Power": 9000,
    "Speed": 9000,
    "Technique": 9200,
    "Willpower": 9200,
    "Power": 9000,
    "Hax": 4000,
    "Defence": 8000,
    "IQ": 8000
  },
  "Zeno Zoldyck": {
    "Captain": 8000,
    "Vice Captain": 8800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 9200,
    "Combat Power": 9100,
    "Speed": 8000,
    "Technique": 9500,
    "Willpower": 9300,
    "Power": 9100,
    "Hax": 6500,
    "Defence": 7800,
    "IQ": 8500
  },
  "Illumi Zoldyck": {
    "Captain": 6500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 7500,
    "Aura Control": 7000,
    "Combat Power": 7500,
    "Speed": 6500,
    "Technique": 8000,
    "Willpower": 7500,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 5500,
    "IQ": 8500
  },
  "Milluki Zoldyck": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 2000,
    "Combat Power": 2000,
    "Speed": 1500,
    "Technique": 2500,
    "Willpower": 3000,
    "Power": 2000,
    "Hax": 3500,
    "Defence": 3500,
    "IQ": 6500
  },
  "Kalluto Zoldyck": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 4500,
    "Aura Control": 4000,
    "Combat Power": 4000,
    "Speed": 5000,
    "Technique": 5000,
    "Willpower": 5000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3500,
    "IQ": 5500
  },
  "Alluka Zoldyck": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 1500,
    "Healer": 1000,
    "Nen Type": 9999,
    "Aura Control": 1000,
    "Combat Power": 1000,
    "Speed": 1500,
    "Technique": 1000,
    "Willpower": 6000,
    "Power": 1200,
    "Hax": 9999,
    "Defence": 1500,
    "IQ": 3000
  },
  "Nanika": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 9500,
    "Support 2": 9500,
    "Tank": 9999,
    "Healer": 9999,
    "Nen Type": 9999,
    "Aura Control": 1000,
    "Combat Power": 5000,
    "Speed": 3000,
    "Technique": 1000,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 2000
  },
  "Kikyo Zoldyck": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Technique": 3000,
    "Willpower": 5000,
    "Power": 2500,
    "Hax": 1500,
    "Defence": 3000,
    "IQ": 5000
  },
  "Maha Zoldyck": {
    "Captain": 9999,
    "Vice Captain": 8000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Nen Type": 8000,
    "Aura Control": 9500,
    "Combat Power": 9200,
    "Speed": 7800,
    "Technique": 9500,
    "Willpower": 9500,
    "Power": 9200,
    "Hax": 3500,
    "Defence": 9000,
    "IQ": 8000
  },
  "Gotoh": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Nen Type": 4500,
    "Aura Control": 5000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Technique": 5500,
    "Willpower": 7000,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 6000,
    "IQ": 5500
  },
  "Canary": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 3000,
    "Speed": 3500,
    "Technique": 3500,
    "Willpower": 5500,
    "Power": 3000,
    "Hax": 1500,
    "Defence": 3500,
    "IQ": 4000
  },
  "Isaac Netero (Base)": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9000,
    "Healer": 1000,
    "Nen Type": 9300,
    "Aura Control": 9800,
    "Combat Power": 9500,
    "Speed": 8500,
    "Technique": 9800,
    "Willpower": 9700,
    "Power": 9500,
    "Hax": 5500,
    "Defence": 9000,
    "IQ": 9400
  },
  "Isaac Netero (Prime)": {
    "Captain": 9999,
    "Vice Captain": 9700,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9700,
    "Healer": 1000,
    "Nen Type": 9999,
    "Aura Control": 9999,
    "Combat Power": 9999,
    "Speed": 9900,
    "Technique": 9999,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 8000,
    "Defence": 9700,
    "IQ": 9500
  },
  "Ging Freecss": {
    "Captain": 8000,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 8500,
    "Combat Power": 7500,
    "Speed": 7000,
    "Technique": 8500,
    "Willpower": 7500,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 5500,
    "IQ": 9300
  },
  "Biscuit Krueger (Child Form)": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 3500,
    "Combat Power": 3000,
    "Speed": 4000,
    "Technique": 4500,
    "Willpower": 6000,
    "Power": 3000,
    "Hax": 2000,
    "Defence": 3000,
    "IQ": 8500
  },
  "Biscuit Krueger (True Form)": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Nen Type": 8000,
    "Aura Control": 8500,
    "Combat Power": 8200,
    "Speed": 6500,
    "Technique": 8800,
    "Willpower": 8000,
    "Power": 8500,
    "Hax": 3000,
    "Defence": 8500,
    "IQ": 8500
  },
  "Pariston Hill": {
    "Captain": 4500,
    "Vice Captain": 8000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 3000,
    "Speed": 4000,
    "Technique": 3500,
    "Willpower": 5500,
    "Power": 3000,
    "Hax": 5000,
    "Defence": 3500,
    "IQ": 9200
  },
  "Cheadle Yorkshire": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 6500,
    "Nen Type": 3500,
    "Aura Control": 3500,
    "Combat Power": 3500,
    "Speed": 3500,
    "Technique": 4000,
    "Willpower": 6500,
    "Power": 3500,
    "Hax": 2500,
    "Defence": 3500,
    "IQ": 8800
  },
  "Mizaistom Nana": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 4500,
    "Combat Power": 4000,
    "Speed": 4000,
    "Technique": 5000,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 2500,
    "Defence": 3500,
    "IQ": 8500
  },
  "Cluck": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 2500,
    "Combat Power": 2500,
    "Speed": 2500,
    "Technique": 3000,
    "Willpower": 4500,
    "Power": 2500,
    "Hax": 1500,
    "Defence": 3000,
    "IQ": 7000
  },
  "Piyon": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 2000,
    "Aura Control": 2000,
    "Combat Power": 2000,
    "Speed": 2500,
    "Technique": 2000,
    "Willpower": 4000,
    "Power": 2000,
    "Hax": 1200,
    "Defence": 2500,
    "IQ": 6500
  },
  "Ivlenkov Botobai Basdenmiller": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3500,
    "Combat Power": 3000,
    "Speed": 3000,
    "Technique": 3500,
    "Willpower": 5500,
    "Power": 3000,
    "Hax": 1800,
    "Defence": 3500,
    "IQ": 7500
  },
  "Beans": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1500,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 1500,
    "Willpower": 5000,
    "Power": 1500,
    "Hax": 1000,
    "Defence": 2000,
    "IQ": 5500
  },
  "Wing": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 5000,
    "Aura Control": 6500,
    "Combat Power": 4000,
    "Speed": 4000,
    "Technique": 6500,
    "Willpower": 6000,
    "Power": 4000,
    "Hax": 2000,
    "Defence": 4000,
    "IQ": 7000
  },
  "Zushi": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Technique": 3500,
    "Willpower": 5000,
    "Power": 2500,
    "Hax": 1200,
    "Defence": 3000,
    "IQ": 4500
  },
  "Satotz": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 5000,
    "Aura Control": 6000,
    "Combat Power": 5000,
    "Speed": 6000,
    "Technique": 6500,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 1500,
    "Defence": 5500,
    "IQ": 5500
  },
  "Menchi": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 4000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Technique": 5500,
    "Willpower": 5500,
    "Power": 4000,
    "Hax": 1500,
    "Defence": 4000,
    "IQ": 5000
  },
  "Buhara": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 2500,
    "Aura Control": 2500,
    "Combat Power": 3000,
    "Speed": 2000,
    "Technique": 3000,
    "Willpower": 4500,
    "Power": 3500,
    "Hax": 1200,
    "Defence": 5500,
    "IQ": 4000
  },
  "Hanzo": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 4500,
    "Aura Control": 4500,
    "Combat Power": 4500,
    "Speed": 6400,
    "Technique": 6000,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 4500,
    "IQ": 5000
  },
  "Pokkle": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 2500,
    "Aura Control": 2000,
    "Combat Power": 2000,
    "Speed": 2500,
    "Technique": 2500,
    "Willpower": 4000,
    "Power": 2000,
    "Hax": 1500,
    "Defence": 2500,
    "IQ": 5000
  },
  "Tonpa": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1000,
    "Combat Power": 1200,
    "Speed": 1500,
    "Technique": 1500,
    "Willpower": 3000,
    "Power": 1200,
    "Hax": 3500,
    "Defence": 2000,
    "IQ": 5500
  },
  "Kastro": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 4000,
    "Combat Power": 4000,
    "Speed": 5500,
    "Technique": 5500,
    "Willpower": 5000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 4000,
    "IQ": 4500
  },
  "Hisoka Morow (Base)": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 8000,
    "Combat Power": 7800,
    "Speed": 8200,
    "Technique": 8500,
    "Willpower": 6500,
    "Power": 7800,
    "Hax": 7000,
    "Defence": 5500,
    "IQ": 9000
  },
  "Hisoka Morow (Bungee Gum)": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Nen Type": 9000,
    "Aura Control": 8300,
    "Combat Power": 8500,
    "Speed": 8800,
    "Technique": 9000,
    "Willpower": 7000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 6000,
    "IQ": 9200
  },
  "Kite": {
    "Captain": 6000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 6500,
    "Combat Power": 6200,
    "Speed": 5500,
    "Technique": 7000,
    "Willpower": 7000,
    "Power": 6200,
    "Hax": 3000,
    "Defence": 6000,
    "IQ": 6500
  },
  "Knuckle Bine": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 6500,
    "Combat Power": 6500,
    "Speed": 6000,
    "Technique": 6500,
    "Willpower": 8000,
    "Power": 6500,
    "Hax": 3500,
    "Defence": 6500,
    "IQ": 5500
  },
  "Shoot McMahon": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Nen Type": 5000,
    "Aura Control": 5000,
    "Combat Power": 4800,
    "Speed": 4000,
    "Technique": 5000,
    "Willpower": 6500,
    "Power": 4800,
    "Hax": 2500,
    "Defence": 5000,
    "IQ": 5000
  },
  "Morel Mackernasey": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Nen Type": 7000,
    "Aura Control": 7500,
    "Combat Power": 6800,
    "Speed": 5500,
    "Technique": 7000,
    "Willpower": 7500,
    "Power": 6800,
    "Hax": 3500,
    "Defence": 6500,
    "IQ": 7000
  },
  "Knov": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 5500,
    "Aura Control": 5000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Technique": 5000,
    "Willpower": 6000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4000,
    "IQ": 6500
  },
  "Palm Siberia (Base)": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3000,
    "Combat Power": 2800,
    "Speed": 2500,
    "Technique": 3000,
    "Willpower": 4500,
    "Power": 2800,
    "Hax": 2500,
    "Defence": 2500,
    "IQ": 5000
  },
  "Palm Siberia (Beauty Form)": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 4000,
    "Combat Power": 3500,
    "Speed": 3000,
    "Technique": 3500,
    "Willpower": 5000,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 2500,
    "IQ": 5000
  },
  "Ikalgo": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 3500,
    "Combat Power": 3800,
    "Speed": 4500,
    "Technique": 4000,
    "Willpower": 5000,
    "Power": 3800,
    "Hax": 3500,
    "Defence": 3500,
    "IQ": 6000
  },
  "Ponzu": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1800,
    "Healer": 1000,
    "Nen Type": 2500,
    "Aura Control": 2000,
    "Combat Power": 1800,
    "Speed": 2000,
    "Technique": 2000,
    "Willpower": 3000,
    "Power": 1800,
    "Hax": 3000,
    "Defence": 1800,
    "IQ": 5500
  },
  "Meleoron": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 5500,
    "Aura Control": 4000,
    "Combat Power": 3200,
    "Speed": 4000,
    "Technique": 3500,
    "Willpower": 4500,
    "Power": 3200,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 5500
  },
  "Johness": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3500,
    "Combat Power": 3500,
    "Speed": 4000,
    "Technique": 4500,
    "Willpower": 4500,
    "Power": 3500,
    "Hax": 2000,
    "Defence": 3500,
    "IQ": 4000
  },
  "Kanzai": {
    "Captain": 6000,
    "Vice Captain": 5800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 5500,
    "Aura Control": 5500,
    "Combat Power": 6000,
    "Speed": 6000,
    "Technique": 6000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 1500,
    "Defence": 5500,
    "IQ": 4500
  },
  "Chrollo Lucilfer": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Nen Type": 9800,
    "Aura Control": 8500,
    "Combat Power": 8000,
    "Speed": 6500,
    "Technique": 8000,
    "Willpower": 8500,
    "Power": 8000,
    "Hax": 9500,
    "Defence": 6000,
    "IQ": 9000
  },
  "Feitan": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Nen Type": 7000,
    "Aura Control": 7500,
    "Combat Power": 7500,
    "Speed": 8400,
    "Technique": 7500,
    "Willpower": 8000,
    "Power": 7500,
    "Hax": 6000,
    "Defence": 5000,
    "IQ": 6500
  },
  "Phinks": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 6500,
    "Combat Power": 7200,
    "Speed": 6000,
    "Technique": 7200,
    "Willpower": 7500,
    "Power": 7200,
    "Hax": 3000,
    "Defence": 6500,
    "IQ": 5500
  },
  "Nobunaga Hazama": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Nen Type": 5500,
    "Aura Control": 6000,
    "Combat Power": 6200,
    "Speed": 6000,
    "Technique": 7000,
    "Willpower": 7000,
    "Power": 6200,
    "Hax": 2000,
    "Defence": 5000,
    "IQ": 5000
  },
  "Shalnark": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 6000,
    "Aura Control": 5000,
    "Combat Power": 5000,
    "Speed": 4500,
    "Technique": 5000,
    "Willpower": 5500,
    "Power": 5000,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 7000
  },
  "Franklin Bordeau": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Nen Type": 6000,
    "Aura Control": 6000,
    "Combat Power": 6000,
    "Speed": 3000,
    "Technique": 5500,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 6500,
    "IQ": 5500
  },
  "Machi Komacine": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 8000,
    "Nen Type": 5000,
    "Aura Control": 5500,
    "Combat Power": 5000,
    "Speed": 6000,
    "Technique": 6000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4500,
    "IQ": 6000
  },
  "Pakunoda": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 5500,
    "Combat Power": 5000,
    "Speed": 4500,
    "Technique": 5000,
    "Willpower": 7500,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000,
    "IQ": 7500
  },
  "Kortopi": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 2500,
    "Combat Power": 2200,
    "Speed": 2000,
    "Technique": 2500,
    "Willpower": 3500,
    "Power": 2200,
    "Hax": 4500,
    "Defence": 2000,
    "IQ": 4500
  },
  "Shizuku Murasaki": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3000,
    "Combat Power": 3000,
    "Speed": 3000,
    "Technique": 3500,
    "Willpower": 4500,
    "Power": 3000,
    "Hax": 3500,
    "Defence": 3000,
    "IQ": 3500
  },
  "Bonolenov Ndongo": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Nen Type": 4500,
    "Aura Control": 4500,
    "Combat Power": 5000,
    "Speed": 3500,
    "Technique": 5000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 1500,
    "Defence": 6000,
    "IQ": 4500
  },
  "Uvogin": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8300,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 6000,
    "Combat Power": 8200,
    "Speed": 4500,
    "Technique": 6500,
    "Willpower": 7500,
    "Power": 7800,
    "Hax": 2000,
    "Defence": 7500,
    "IQ": 3500
  },
  "Neon Nostrade": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 1500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 1000,
    "Combat Power": 1200,
    "Speed": 1500,
    "Technique": 1000,
    "Willpower": 3500,
    "Power": 1200,
    "Hax": 4500,
    "Defence": 1500,
    "IQ": 3000
  },
  "Light Nostrade": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1500,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 1500,
    "Willpower": 3500,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 2000,
    "IQ": 4500
  },
  "Melody": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 4000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Technique": 3000,
    "Willpower": 4500,
    "Power": 2500,
    "Hax": 3500,
    "Defence": 2500,
    "IQ": 5000
  },
  "Baise": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 3200,
    "Speed": 3500,
    "Technique": 4000,
    "Willpower": 4500,
    "Power": 3200,
    "Hax": 1500,
    "Defence": 3500,
    "IQ": 4000
  },
  "Basho": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 3500,
    "Speed": 3000,
    "Technique": 4000,
    "Willpower": 4500,
    "Power": 3500,
    "Hax": 1500,
    "Defence": 4000,
    "IQ": 3500
  },
  "Linssen": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 2500,
    "Aura Control": 2500,
    "Combat Power": 3000,
    "Speed": 3500,
    "Technique": 3500,
    "Willpower": 4000,
    "Power": 3000,
    "Hax": 1500,
    "Defence": 3000,
    "IQ": 4000
  },
  "Eliza": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Nen Type": 2000,
    "Aura Control": 2000,
    "Combat Power": 2200,
    "Speed": 2500,
    "Technique": 2500,
    "Willpower": 3500,
    "Power": 2200,
    "Hax": 1200,
    "Defence": 2500,
    "IQ": 3500
  },
  "Zepile": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1500,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 2000,
    "Willpower": 4000,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 2000,
    "IQ": 5000
  },
  "Battera": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1500,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 1500,
    "Willpower": 4500,
    "Power": 1500,
    "Hax": 2000,
    "Defence": 3000,
    "IQ": 6500
  },
  "Razor": {
    "Captain": 6000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Nen Type": 5500,
    "Aura Control": 5500,
    "Combat Power": 7500,
    "Speed": 5000,
    "Technique": 7000,
    "Willpower": 6500,
    "Power": 7500,
    "Hax": 2500,
    "Defence": 7000,
    "IQ": 4500
  },
  "Elena": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1000,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 1500,
    "Willpower": 3000,
    "Power": 1500,
    "Hax": 1200,
    "Defence": 2000,
    "IQ": 3500
  },
  "Genthru": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 6500,
    "Aura Control": 4500,
    "Combat Power": 4500,
    "Speed": 4000,
    "Technique": 4500,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 7000,
    "Defence": 4500,
    "IQ": 7000
  },
  "Goreinu": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2000,
    "Healer": 1000,
    "Nen Type": 1500,
    "Aura Control": 1000,
    "Combat Power": 1500,
    "Speed": 2000,
    "Technique": 1500,
    "Willpower": 3000,
    "Power": 1500,
    "Hax": 1500,
    "Defence": 2000,
    "IQ": 4500
  },
  "Neferpitou": {
    "Captain": 7500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9200,
    "Healer": 9000,
    "Nen Type": 8500,
    "Aura Control": 8500,
    "Combat Power": 9400,
    "Speed": 8900,
    "Technique": 8500,
    "Willpower": 7500,
    "Power": 8500,
    "Hax": 8200,
    "Defence": 7000,
    "IQ": 7000
  },
  "Shaiapouf": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 3000,
    "Nen Type": 8000,
    "Aura Control": 9500,
    "Combat Power": 7500,
    "Speed": 6500,
    "Technique": 7000,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 6000,
    "IQ": 8000
  },
  "Menthuthuyoupi": {
    "Captain": 7500,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9600,
    "Healer": 1000,
    "Nen Type": 8000,
    "Aura Control": 8000,
    "Combat Power": 9200,
    "Speed": 6000,
    "Technique": 7500,
    "Willpower": 6000,
    "Power": 8800,
    "Hax": 6000,
    "Defence": 8800,
    "IQ": 4000
  },
  "Meruem (Newborn)": {
    "Captain": 8000,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Nen Type": 8500,
    "Aura Control": 8500,
    "Combat Power": 9500,
    "Speed": 7500,
    "Technique": 7500,
    "Willpower": 8000,
    "Power": 9000,
    "Hax": 7500,
    "Defence": 9000,
    "IQ": 8800
  },
  "Meruem (King)": {
    "Captain": 9800,
    "Vice Captain": 9400,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9700,
    "Healer": 1000,
    "Nen Type": 9900,
    "Aura Control": 9900,
    "Combat Power": 9900,
    "Speed": 9400,
    "Technique": 9700,
    "Willpower": 9800,
    "Power": 9900,
    "Hax": 9700,
    "Defence": 9700,
    "IQ": 9800
  },
  "Komugi": {
    "Captain": 1200,
    "Vice Captain": 1200,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 1200,
    "Healer": 1000,
    "Nen Type": 1000,
    "Aura Control": 1000,
    "Combat Power": 1000,
    "Speed": 1200,
    "Technique": 1000,
    "Willpower": 6000,
    "Power": 1000,
    "Hax": 1000,
    "Defence": 1200,
    "IQ": 6500
  },
  "Colt": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 3500,
    "Combat Power": 3800,
    "Speed": 3500,
    "Technique": 4000,
    "Willpower": 5000,
    "Power": 3800,
    "Hax": 2000,
    "Defence": 4500,
    "IQ": 4500
  },
  "Cheetu": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3500,
    "Combat Power": 4200,
    "Speed": 8500,
    "Technique": 4500,
    "Willpower": 4500,
    "Power": 4200,
    "Hax": 1500,
    "Defence": 4000,
    "IQ": 3000
  },
  "Leol": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3500,
    "Combat Power": 4000,
    "Speed": 5500,
    "Technique": 4500,
    "Willpower": 4500,
    "Power": 4000,
    "Hax": 1500,
    "Defence": 4500,
    "IQ": 3000
  },
  "Bloster": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 3500,
    "Combat Power": 4500,
    "Speed": 3000,
    "Technique": 4000,
    "Willpower": 4500,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 5500,
    "IQ": 3500
  },
  "Welfin": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 3500,
    "Combat Power": 3800,
    "Speed": 4000,
    "Technique": 4500,
    "Willpower": 5000,
    "Power": 3800,
    "Hax": 2000,
    "Defence": 4000,
    "IQ": 5000
  },
  "Zazan": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Nen Type": 4000,
    "Aura Control": 4000,
    "Combat Power": 4500,
    "Speed": 3500,
    "Technique": 4000,
    "Willpower": 4500,
    "Power": 4500,
    "Hax": 2000,
    "Defence": 5000,
    "IQ": 3000
  },
  "Hina (Chimera Ant)": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 3000,
    "Combat Power": 3000,
    "Speed": 3500,
    "Technique": 3500,
    "Willpower": 4000,
    "Power": 3000,
    "Hax": 2500,
    "Defence": 3000,
    "IQ": 3500
  },
  "Rammot": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3500,
    "Aura Control": 3000,
    "Combat Power": 3800,
    "Speed": 4500,
    "Technique": 3500,
    "Willpower": 4000,
    "Power": 3800,
    "Hax": 1500,
    "Defence": 3500,
    "IQ": 2500
  },
  "Flutter": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 2500,
    "Combat Power": 3200,
    "Speed": 5500,
    "Technique": 3000,
    "Willpower": 3500,
    "Power": 3200,
    "Hax": 1200,
    "Defence": 3000,
    "IQ": 2500
  },
  "Owl": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Nen Type": 2000,
    "Aura Control": 1500,
    "Combat Power": 2500,
    "Speed": 2500,
    "Technique": 2000,
    "Willpower": 4000,
    "Power": 2500,
    "Hax": 4000,
    "Defence": 3000,
    "IQ": 6000
  },
  "Peggy": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Nen Type": 3000,
    "Aura Control": 2500,
    "Combat Power": 3200,
    "Speed": 3500,
    "Technique": 3000,
    "Willpower": 3500,
    "Power": 3200,
    "Hax": 1500,
    "Defence": 3500,
    "IQ": 2500
  },
  "Charlotte Pudding": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 4000,
    "Weapon Skill": 1000,
    "Willpower": 4500,
    "Power": 3000,
    "Hax": 8000,
    "Defence": 2500,
    "IQ": 7000
  },
  "Kaku": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 7000,
    "Weapon Skill": 7500,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 6500,
    "IQ": 6000
  },
  "Kalifa": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4500,
    "Combat Power": 5500,
    "Speed": 6000,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500,
    "IQ": 6500
  },
  "Shirahoshi": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 3000,
    "Healer": 3000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 3000,
    "Weapon Skill": 1000,
    "Willpower": 6000,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 4000,
    "IQ": 5500
  },
  "Fisher Tiger": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 8000,
    "Speed": 6500,
    "Weapon Skill": 3000,
    "Willpower": 9000,
    "Power": 7500,
    "Hax": 2000,
    "Defence": 7500,
    "IQ": 6500
  },
  "Tashigi": {
    "Captain": 3500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 5000,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 6500,
    "Power": 4500,
    "Hax": 1500,
    "Defence": 4500,
    "IQ": 5500
  },
  "Carrot": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4000,
    "Combat Power": 6500,
    "Speed": 8000,
    "Weapon Skill": 5500,
    "Willpower": 7000,
    "Power": 6000,
    "Hax": 3000,
    "Defence": 5000,
    "IQ": 4500
  },
  "Pedro": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Weapon Skill": 7000,
    "Willpower": 9000,
    "Power": 6500,
    "Hax": 2000,
    "Defence": 6000,
    "IQ": 6500
  },
  "Imu (Revealed)": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Devil Fruit": 9999,
    "Haki": 9999,
    "Combat Power": 9999,
    "Speed": 9999,
    "Weapon Skill": 9999,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9999
  },
  "Zetsu": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3000,
    "Power": 5000,
    "Hax": 7500,
    "Defence": 5000
  },
  "Izuna Uchiha": {
    "Captain": 6000,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 9000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 8000,
    "Taijutsu": 7500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Anko Mitarashi": {
    "Captain": 3500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 6000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 4000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000
  },
  "Shizune": {
    "Captain": 2500,
    "Vice Captain": 4500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 3000,
    "Healer": 8000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 2000,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4000
  },
  "Mangetsu Hozuki (Reanimation)": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 6500,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 7000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 7500
  },
  "Momo Nishimiya": {
    "Grade": 3200,
    "Captain": 3000,
    "Vice Captain": 3500,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 3800,
    "Combat Specialist": 3000,
    "Technique Specialist": 4000,
    "Power": 3200,
    "Hax": 3500,
    "Defence": 3000,
    "IQ": 5000,
    "Speed": 6000
  },
  "Kasumi Miwa": {
    "Grade": 3000,
    "Captain": 2800,
    "Vice Captain": 3200,
    "Healer": 1000,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 3000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 3200,
    "Combat Specialist": 4500,
    "Technique Specialist": 3000,
    "Power": 3200,
    "Hax": 2500,
    "Defence": 3200,
    "IQ": 4500,
    "Speed": 5500
  },
  "Junpei Yoshino": {
    "Grade": 2500,
    "Captain": 2200,
    "Vice Captain": 2500,
    "Healer": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 4500,
    "Cursed Energy": 3500,
    "Combat Specialist": 2500,
    "Technique Specialist": 3500,
    "Power": 3500,
    "Hax": 4500,
    "Defence": 3000,
    "IQ": 4500,
    "Speed": 4500
  },
  "Yoshinobu Gakuganji": {
    "Grade": 8500,
    "Captain": 7500,
    "Vice Captain": 7000,
    "Healer": 1000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Domain Expansion": 6000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 8000,
    "Combat Specialist": 5000,
    "Technique Specialist": 7500,
    "Power": 7800,
    "Hax": 6500,
    "Defence": 6500,
    "IQ": 8500,
    "Speed": 5000
  },
  "Yu Haibara": {
    "Grade": 3500,
    "Captain": 3000,
    "Vice Captain": 3200,
    "Healer": 1000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 3800,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 3800,
    "Combat Specialist": 4500,
    "Technique Specialist": 3200,
    "Power": 3800,
    "Hax": 2500,
    "Defence": 3800,
    "IQ": 4500,
    "Speed": 5500
  },
  "Kaien Shiba": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 8000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 6500,
    "Sensei": 7500,
    "Ally": 8500,
    "Power": 7500,
    "Hax": 5000,
    "Defence": 6500
  },
  "Hanataro Yamada": {
    "Captain": 1000,
    "Vice Captain": 2000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 1500,
    "Healer": 8500,
    "Zanpakuto": 5500,
    "Reiatsu": 3500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 8500,
    "Power": 2000,
    "Hax": 3500,
    "Defence": 2500
  },
  "Tessai Tsukabishi": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 7500,
    "Healer": 7500,
    "Zanpakuto": 1000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 8500,
    "Sensei": 6000,
    "Ally": 7500,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 8000
  },
  "Lilynette Gingerbuck": {
    "Captain": 1500,
    "Vice Captain": 2500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2000,
    "Healer": 1000,
    "Zanpakuto": 4000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3000
  },
  "Pernida Parnkgjas": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 8500,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 9000,
    "Hax": 9500,
    "Defence": 8500
  },
  "Quilge Opie": {
    "Captain": 7000,
    "Vice Captain": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 8000,
    "Hax": 8000,
    "Defence": 7500
  },
  "Lucius Zogratis": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 9200,
    "Healer": 9500,
    "Magic Power": 9999,
    "Grimoire Skill": 9999,
    "Combat Skill": 9500,
    "Mana Control": 9999,
    "Speed": 9800,
    "Squad Synergy": 8000,
    "Transformation": 9800,
    "Experience": 9900,
    "Willpower": 9800,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9500,
    "IQ": 9999
  },
  "Lucifero": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9999,
    "Healer": 1000,
    "Magic Power": 9999,
    "Grimoire Skill": 9500,
    "Combat Skill": 9800,
    "Mana Control": 9500,
    "Speed": 9500,
    "Squad Synergy": 7000,
    "Transformation": 9999,
    "Experience": 9500,
    "Willpower": 9500,
    "Power": 9999,
    "Hax": 9500,
    "Defence": 9999,
    "IQ": 8500
  },
  "Magne": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 5500,
    "Quirk Versatility": 5000,
    "Combat Skill": 5500,
    "Speed": 4500,
    "Resolve": 6500,
    "Teamwork": 6000,
    "Mentor": 3000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 4500,
    "IQ": 4500
  },
  "Crust": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 8000,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6500,
    "Combat Skill": 7500,
    "Speed": 6500,
    "Resolve": 9000,
    "Teamwork": 7500,
    "Mentor": 5000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 8500,
    "IQ": 6000
  },
  "Inko Midoriya": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 1000,
    "Healer": 3000,
    "Quirk Power": 2000,
    "Quirk Control": 3000,
    "Quirk Versatility": 2000,
    "Combat Skill": 1000,
    "Speed": 1500,
    "Resolve": 8000,
    "Teamwork": 5000,
    "Mentor": 6000,
    "Power": 1500,
    "Hax": 2000,
    "Defence": 1500,
    "IQ": 4500
  },
  "Melissa Shield": {
    "Captain": 2000,
    "Vice Captain": 3500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 2500,
    "Healer": 3000,
    "Quirk Power": 1000,
    "Quirk Control": 1000,
    "Quirk Versatility": 6000,
    "Combat Skill": 4500,
    "Speed": 4000,
    "Resolve": 7500,
    "Teamwork": 7000,
    "Mentor": 4000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 4000,
    "IQ": 8500
  },
  "Zarbon": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 5500,
    "Technique": 5000,
    "Form": 4000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 5000,
    "Power": 5500,
    "Hax": 3500,
    "Defence": 5000
  },
  "Dodoria": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 4500,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 4800,
    "Energy Manipulation": 4500,
    "Martial Arts": 4000,
    "Power": 5500,
    "Hax": 2000,
    "Defence": 5500
  },
  "Bojack": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6500,
    "Form": 6000,
    "Speed": 7000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 7500,
    "Energy Manipulation": 7500,
    "Martial Arts": 6500,
    "Power": 8000,
    "Hax": 4500,
    "Defence": 7000
  },
  "Cabba": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 6000,
    "Form": 6500,
    "Speed": 6000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6000,
    "Martial Arts": 6000,
    "Power": 6000,
    "Hax": 3500,
    "Defence": 5500
  },
  "King Piccolo": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 7500,
    "Martial Arts": 6500,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 6500
  },
  "Amai Mask": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Hero Rank": 8500,
    "Threat Level": 7500,
    "Combat Power": 8500,
    "Speed": 8000,
    "Technique": 7500,
    "Energy": 8000,
    "IQ": 7000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 8800
  },
  "Platinum Sperm": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8000,
    "Speed": 9000,
    "Technique": 6500,
    "Energy": 8500,
    "IQ": 5000,
    "Willpower": 6000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 7000
  },
  "Bakuzan": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 6500,
    "Combat Power": 6500,
    "Speed": 6000,
    "Technique": 5500,
    "Energy": 6500,
    "IQ": 3500,
    "Willpower": 6000,
    "Power": 7000,
    "Hax": 3500,
    "Defence": 6500
  },
  "Charanko": {
    "Captain": 1500,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 1500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 1000,
    "Combat Power": 2000,
    "Speed": 2500,
    "Technique": 3500,
    "Energy": 2000,
    "IQ": 2500,
    "Willpower": 6000,
    "Power": 2000,
    "Hax": 1000,
    "Defence": 1500
  },
  "Norma Selner": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 3000,
    "Healer": 3500,
    "Aura": 8500,
    "Combat Power": 3000,
    "Speed": 4000,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 8500,
    "Power": 6000,
    "Defence": 4000,
    "Hax": 9500,
    "IQ": 9000
  },
  "Nasiens": {
    "Captain": 2500,
    "Vice Captain": 4000,
    "Tank": 3500,
    "Healer": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4500,
    "Speed": 5500,
    "Magic Specialist": 7000,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 6500,
    "Defence": 4500,
    "IQ": 8000
  },
  "Jigoro Kuwajima": {
    "Captain": 6800,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1500,
    "Speed": 8500,
    "Power": 7000,
    "IQ": 7800,
    "Breathing": 8500,
    "Demon": 1000,
    "Hashira": 8000,
    "Weapon Skill": 8000,
    "Technique": 8500,
    "Hax": 1500,
    "Defence": 6000
  },
  "Murata": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Speed": 4000,
    "Power": 3500,
    "IQ": 4000,
    "Breathing": 4000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 4000,
    "Technique": 3500,
    "Hax": 1000,
    "Defence": 3500
  },
  "Hotaru Haganezuka": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 2500,
    "Healer": 1000,
    "Speed": 2500,
    "Power": 4000,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 5000,
    "Hax": 1000,
    "Defence": 3500
  },
  "Beyond Netero": {
    "Captain": 9500,
    "Vice Captain": 9000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 9000,
    "Healer": 1000,
    "Nen Type": 9000,
    "Aura Control": 9500,
    "Combat Power": 9500,
    "Speed": 9000,
    "Technique": 9500,
    "Willpower": 9500,
    "Power": 9500,
    "Hax": 8500,
    "Defence": 9000,
    "IQ": 9800
  },
  "Tsezguerra": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Nen Type": 6000,
    "Aura Control": 6500,
    "Combat Power": 6000,
    "Speed": 5500,
    "Technique": 6500,
    "Willpower": 6500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500,
    "IQ": 7000
  },
  "Mito Freecss": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 1000,
    "Healer": 4000,
    "Nen Type": 1000,
    "Aura Control": 1000,
    "Combat Power": 1500,
    "Speed": 2500,
    "Technique": 1500,
    "Willpower": 7000,
    "Power": 1500,
    "Hax": 1000,
    "Defence": 2000,
    "IQ": 5000
  },
  "Kenpachi Zaraki (Bankai)": {
    "Captain": 9500,
    "Vice Captain": 8000,
    "Support 1": 9800,
    "Support 2": 9800,
    "Tank": 9800,
    "Healer": 1000,
    "Zanpakuto": 9500,
    "Reiatsu": 9900,
    "Bankai": 9800,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 9999,
    "Hax": 4500,
    "Defence": 9800
  },
  "Yammy (Ira)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8500,
    "Bankai": 1000,
    "Resurreccion": 9500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 2000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9000,
    "Hax": 6500,
    "Defence": 9500
  },
  "Coyote Starrk (Los Lobos)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7500,
    "Healer": 1000,
    "Zanpakuto": 6000,
    "Reiatsu": 9500,
    "Bankai": 1000,
    "Resurreccion": 9400,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9000,
    "IQ": 6500,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 9500,
    "Hax": 8500,
    "Defence": 8000
  },
  "Baraggan (Arrogante)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9000,
    "Bankai": 1000,
    "Resurreccion": 9300,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9000,
    "Hax": 9900,
    "Defence": 8500
  },
  "Tier Harribel (Tiburon)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8800,
    "Bankai": 1000,
    "Resurreccion": 9150,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 6500,
    "Sensei": 1000,
    "Ally": 5000,
    "Power": 8800,
    "Hax": 8500,
    "Defence": 7000
  },
  "Nnoitra (Santa Teresa)": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 8000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 8500
  },
  "Zommari (Brujeria)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 6800,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 7500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6000,
    "Hax": 9000,
    "Defence": 4500
  },
  "Szayelaporro (Fornicaras)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 6600,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 9000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7000,
    "Hax": 9200,
    "Defence": 5500
  },
  "Aaroniero (Glotoneria)": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 6400,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 2000,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Chino": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3800,
    "Healer": 1000,
    "Eyes": 6500,
    "IQ": 6200,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 1000,
    "Chakra": 4800,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 3800,
    "Power": 4800,
    "Hax": 6800,
    "Defence": 3800
  },
  "Tokikake (Chaton)": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7500,
    "Combat Power": 7000,
    "Speed": 7500,
    "Weapon Skill": 8000,
    "Willpower": 7500,
    "Power": 7000,
    "Hax": 1000,
    "Defence": 7000,
    "IQ": 6500
  },
  "Shikamaru Nara (Eighth Hokage)": {
    "Captain": 9500,
    "Vice Captain": 9500,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 4200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9999,
    "Summon": 1000,
    "Jutsu": 6800,
    "Clan": 9000,
    "Chakra": 5800,
    "Sensei": 7200,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 5800,
    "Hax": 7200,
    "Defence": 4200
  },
  "Fukaboshi": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 6000
  },
  "Free Hugs": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 7000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8000,
    "Combat Power": 7000,
    "Speed": 4000,
    "Technique": 4000,
    "Energy": 1000,
    "IQ": 3000,
    "Willpower": 6000,
    "Power": 7500,
    "Hax": 6000,
    "Defence": 7500
  },
  "Izuku Midoriya (Dark Deku)": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Quirk Power": 8800,
    "Quirk Control": 8000,
    "Quirk Versatility": 8500,
    "Combat Skill": 7800,
    "Speed": 8800,
    "Resolve": 9800,
    "Teamwork": 4500,
    "Mentor": 5000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 7000,
    "IQ": 7800
  },
  "Dosu Kinuta": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 3000
  },
  "Kozo Kanamori": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Speed": 1500,
    "Power": 3000,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 4500,
    "Hax": 1000,
    "Defence": 2500
  },
  "Akatsuchi (Boruto)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 1000,
    "Chakra": 5200,
    "Sensei": 3000,
    "Speed": 3500,
    "Taijutsu": 5500,
    "Power": 6200,
    "Hax": 4500,
    "Defence": 6800
  },
  "Cho-Cho Akimichi": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 8000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 6000,
    "Power": 6200,
    "Hax": 3500,
    "Defence": 6500
  },
  "Kaku (Enies Lobby)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 6500,
    "Weapon Skill": 6500,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Hanabi Hyuga (Boruto)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 9000,
    "Chakra": 5500,
    "Sensei": 6500,
    "Speed": 6000,
    "Taijutsu": 7500,
    "Power": 6000,
    "Hax": 8200,
    "Defence": 5000
  },
  "Pakura (Reanimation)": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 4500,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 5000
  },
  "Ao": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 3000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 4500
  },
  "Twigo": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4000,
    "Speed": 3500,
    "Magic Specialist": 3500,
    "Willpower": 4500,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3500,
    "IQ": 3000
  },
  "Kibito Kai": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 7000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 4500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Metal Knight": {
    "Captain": 8000,
    "Vice Captain": 7500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 9200,
    "Threat Level": 1000,
    "Combat Power": 8500,
    "Speed": 7000,
    "Technique": 8000,
    "Energy": 8500,
    "IQ": 9900,
    "Willpower": 7500,
    "Power": 8800,
    "Hax": 9000,
    "Defence": 8500
  },
  "Magetta": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 4500,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 3000,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 4500,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 7500
  },
  "Juzo Kumiya": {
    "Grade": 4000,
    "Captain": 3800,
    "Vice Captain": 3500,
    "Healer": 1000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4500,
    "Combat Specialist": 4500,
    "Technique Specialist": 5000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 4000,
    "IQ": 4000,
    "Speed": 4000
  },
  "Doberman": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 6000,
    "Speed": 5500,
    "Weapon Skill": 6500,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 5500
  },
  "Choji Akimichi (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 9200,
    "Chakra": 8500,
    "Sensei": 6000,
    "Speed": 5000,
    "Taijutsu": 8800,
    "Power": 8800,
    "Hax": 5500,
    "Defence": 9200
  },
  "Gohan (Ultimate)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 7500,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 8000,
    "Form": 1000,
    "Speed": 8500,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 8000,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 7500
  },
  "Holdem": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5500,
    "IQ": 3500
  },
  "Whitebeard (Prime)": {
    "Captain": 9999,
    "Vice Captain": 9500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9999,
    "Healer": 1000,
    "Devil Fruit": 9999,
    "Haki": 9800,
    "Combat Power": 9999,
    "Speed": 8500,
    "Weapon Skill": 9700,
    "Willpower": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999,
    "IQ": 9000
  },
  "Absalom": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Weapon Skill": 3500,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 4000,
    "IQ": 4500
  },
  "Golgius": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 4500,
    "Speed": 5000,
    "Magic Specialist": 5000,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 5000
  },
  "Yahiko": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 3000,
    "Speed": 4500,
    "Taijutsu": 4500,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3500
  },
  "Onoki (Boruto)": {
    "Captain": 7200,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 5800,
    "Sensei": 5500,
    "Speed": 4200,
    "Taijutsu": 3000,
    "Power": 7800,
    "Hax": 8200,
    "Defence": 4800
  },
  "Kakashi Hatake (Anbu)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 7000,
    "IQ": 8000,
    "Summon": 5500,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 6500,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 4500
  },
  "Reggie Star": {
    "Grade": 7000,
    "Captain": 6800,
    "Vice Captain": 6500,
    "Healer": 1000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6200,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6500,
    "Combat Specialist": 6000,
    "Technique Specialist": 7200,
    "Power": 6200,
    "Hax": 7800,
    "Defence": 6200,
    "IQ": 7500,
    "Speed": 6000
  },
  "Fuguki Suikazan (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 6500
  },
  "Katsuyu": {
    "Captain": 2000,
    "Vice Captain": 3000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9000,
    "Healer": 9500,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 1000,
    "Speed": 2000,
    "Taijutsu": 2000,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 9000
  },
  "Boruto Uzumaki (Momoshiki Possession)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 9200,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 9200,
    "Clan": 9200,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 8200,
    "Taijutsu": 7800,
    "Power": 9400,
    "Hax": 9400,
    "Defence": 8000
  },
  "Guru": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 1000,
    "Healer": 7000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 1000,
    "IQ": 8000,
    "Sensei": 6000,
    "Power Level": 3000,
    "Energy Manipulation": 5000,
    "Martial Arts": 1000,
    "Power": 2000,
    "Hax": 7500,
    "Defence": 1000
  },
  "Shino Aburame (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 8000,
    "Summon": 5500,
    "Jutsu": 7200,
    "Clan": 8500,
    "Chakra": 5500,
    "Sensei": 8000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 6200,
    "Hax": 7800,
    "Defence": 5000
  },
  "Sumire Kakei (Two Blue Vortex)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 4200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8200,
    "Summon": 7800,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 3500,
    "Power": 6200,
    "Hax": 7000,
    "Defence": 4200
  },
  "Kushimaru Kuriarare (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Lord Slug": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 6000,
    "Ki Control": 6500,
    "Technique": 5500,
    "Form": 7000,
    "Speed": 5500,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 5500,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 6000
  },
  "Kozuki Toki": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2000,
    "Weapon Skill": 1500,
    "Willpower": 7000,
    "Power": 1500,
    "Hax": 9000,
    "Defence": 2000,
    "IQ": 7000
  },
  "Spinner (Final War)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9000,
    "Healer": 1000,
    "Quirk Power": 8500,
    "Quirk Control": 5500,
    "Quirk Versatility": 4500,
    "Combat Skill": 6500,
    "Speed": 5500,
    "Resolve": 9000,
    "Teamwork": 6000,
    "Mentor": 2500,
    "Power": 8500,
    "Hax": 6000,
    "Defence": 9000,
    "IQ": 4500
  },
  "Android 13": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Ki Control": 5500,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5500,
    "Energy Manipulation": 5500,
    "Martial Arts": 4500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Sung-Sun": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3500
  },
  "Galdino (Mr. 3)": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 3000,
    "Weapon Skill": 1500,
    "Willpower": 3000,
    "Power": 2500,
    "Hax": 6500,
    "Defence": 5000,
    "IQ": 6500
  },
  "Garaga": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4200,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 6800,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 5800,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 7200
  },
  "Deepa": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 6800,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 6800,
    "Power": 7200,
    "Hax": 5800,
    "Defence": 9000
  },
  "Koby (Early)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 1000,
    "Healer": 1500,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1000,
    "Speed": 1500,
    "Weapon Skill": 1000,
    "Willpower": 7000,
    "Power": 1000,
    "Hax": 1000,
    "Defence": 1000,
    "IQ": 3500
  },
  "Suigetsu Hozuki (Boruto)": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 6500,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 7000
  },
  "Kuzan (Blackbeard Pirates)": {
    "Captain": 9000,
    "Vice Captain": 7500,
    "Support 1": 9000,
    "Support 2": 9000,
    "Tank": 8800,
    "Healer": 1000,
    "Devil Fruit": 9400,
    "Haki": 8700,
    "Combat Power": 8800,
    "Speed": 6600,
    "Weapon Skill": 6000,
    "Willpower": 8500,
    "Power": 8800,
    "Hax": 9600,
    "Defence": 8800,
    "IQ": 8200
  },
  "Boruto Uzumaki (Two Blue Vortex)": {
    "Captain": 8500,
    "Vice Captain": 8200,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 8500,
    "Summon": 4000,
    "Jutsu": 9200,
    "Clan": 8800,
    "Chakra": 8800,
    "Sensei": 4000,
    "Speed": 9400,
    "Taijutsu": 8800,
    "Power": 9200,
    "Hax": 9200,
    "Defence": 7500
  },
  "Shuhei Hisagi (Bankai)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 6500,
    "Reiatsu": 6500,
    "Bankai": 7000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 6000
  },
  "Cell Jr.": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5500,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 5500,
    "Energy Manipulation": 5500,
    "Martial Arts": 5000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 4500
  },
  "Hanabi Hyuga (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 7000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 8000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 4500,
    "Power": 3000,
    "Hax": 6500,
    "Defence": 2000
  },
  "Tensei Iida (Ingenium)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 7000,
    "Quirk Versatility": 5000,
    "Combat Skill": 6000,
    "Speed": 8500,
    "Resolve": 7500,
    "Teamwork": 7000,
    "Mentor": 5500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5500,
    "IQ": 6500
  },
  "Hyogoro": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8000,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 2500,
    "Willpower": 7500,
    "Power": 6500,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 6500
  },
  "Madara Uchiha (Kid)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 8500,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 5000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3000
  },
  "Kitsuchi": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 4000,
    "Speed": 4000,
    "Taijutsu": 4500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 6000
  },
  "Sai (Happo Navy)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 6000,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 4500
  },
  "White Zetsu": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Katasuke Tono": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8800,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 1500,
    "Sensei": 4500,
    "Speed": 2000,
    "Taijutsu": 1500,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 2500
  },
  "Atsui": {
    "Captain": 2000,
    "Vice Captain": 1500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 3500,
    "Defence": 3500
  },
  "Omoi": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 4000
  },
  "Shoto Todoroki (Final War)": {
    "Captain": 7200,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7200,
    "Healer": 1000,
    "Quirk Power": 9500,
    "Quirk Control": 8800,
    "Quirk Versatility": 8000,
    "Combat Skill": 7500,
    "Speed": 7800,
    "Resolve": 8800,
    "Teamwork": 6500,
    "Mentor": 5000,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 7200,
    "IQ": 7800
  },
  "Nagato (Reanimation)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9999,
    "Healer": 9999,
    "Eyes": 9500,
    "IQ": 8000,
    "Summon": 9000,
    "Jutsu": 9600,
    "Clan": 8500,
    "Chakra": 9999,
    "Sensei": 1000,
    "Speed": 7500,
    "Taijutsu": 6500,
    "Power": 9500,
    "Hax": 9700,
    "Defence": 7500
  },
  "Ryuma": {
    "Captain": 6000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 7000,
    "Weapon Skill": 9200,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 6500
  },
  "Inojin Yamanaka (Two Blue Vortex)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 3200,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 6800,
    "Summon": 6800,
    "Jutsu": 6000,
    "Clan": 8200,
    "Chakra": 4800,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 3200,
    "Power": 5200,
    "Hax": 6500,
    "Defence": 3200
  },
  "Deidara (Reanimation)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3500,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 4500
  },
  "Jura": {
    "Captain": 9000,
    "Vice Captain": 8200,
    "Support 1": 7800,
    "Support 2": 7800,
    "Tank": 9500,
    "Healer": 1000,
    "Eyes": 9000,
    "IQ": 8800,
    "Summon": 1000,
    "Jutsu": 9500,
    "Clan": 1000,
    "Chakra": 9800,
    "Sensei": 1000,
    "Speed": 9300,
    "Taijutsu": 9000,
    "Power": 9700,
    "Hax": 9600,
    "Defence": 9500
  },
  "Yuta Okkotsu (Culling Game)": {
    "Grade": 9500,
    "Captain": 9300,
    "Vice Captain": 9000,
    "Healer": 8000,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 8900,
    "Domain Expansion": 9500,
    "Cursed Spirit": 9200,
    "Cursed Energy": 9500,
    "Combat Specialist": 9100,
    "Technique Specialist": 9400,
    "Power": 9400,
    "Hax": 9800,
    "Defence": 8900,
    "IQ": 9000,
    "Speed": 8500
  },
  "Nomu (USJ)": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 9500,
    "Healer": 8000,
    "Quirk Power": 8500,
    "Quirk Control": 3000,
    "Quirk Versatility": 5000,
    "Combat Skill": 7000,
    "Speed": 8500,
    "Resolve": 5000,
    "Teamwork": 1000,
    "Mentor": 1000,
    "Power": 9000,
    "Hax": 6000,
    "Defence": 9500,
    "IQ": 1000
  },
  "Torune Aburame": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7500,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000
  },
  "Akatsuchi": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 5000,
    "Power": 5000,
    "Hax": 3500,
    "Defence": 5500
  },
  "Kagami Uchiha": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 9000,
    "Chakra": 5000,
    "Sensei": 4000,
    "Speed": 5500,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 8000,
    "Defence": 4000
  },
  "Kaku (Giraffe Awakening)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6500,
    "Combat Power": 7000,
    "Speed": 7500,
    "Weapon Skill": 7500,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 7000,
    "IQ": 6000
  },
  "Tento Madoka": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 1500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 1500,
    "Clan": 1000,
    "Chakra": 1000,
    "Sensei": 1000,
    "Speed": 2000,
    "Taijutsu": 1500,
    "Power": 1500,
    "Hax": 2000,
    "Defence": 1500
  },
  "Charlotte Brulee": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2500,
    "Weapon Skill": 1000,
    "Willpower": 3500,
    "Power": 1500,
    "Hax": 7500,
    "Defence": 1500,
    "IQ": 4500
  },
  "Himawari Uzumaki (Bijuu)": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 8000,
    "Healer": 3000,
    "Eyes": 8200,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 8800,
    "Chakra": 9800,
    "Sensei": 1000,
    "Speed": 7000,
    "Taijutsu": 6800,
    "Power": 9200,
    "Hax": 8000,
    "Defence": 8200
  },
  "Zansuru": {
    "Captain": 5200,
    "Vice Captain": 4200,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 5200,
    "Power": 6800,
    "Hax": 5800,
    "Defence": 5800
  },
  "Tajima Uchiha": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 9000,
    "Chakra": 6000,
    "Sensei": 5000,
    "Speed": 6000,
    "Taijutsu": 6000,
    "Power": 6500,
    "Hax": 8000,
    "Defence": 5000
  },
  "Koharu Utatane": {
    "Captain": 3000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 4000,
    "Speed": 2000,
    "Taijutsu": 2000,
    "Power": 3500,
    "Hax": 4500,
    "Defence": 2500
  },
  "Soi-Fon (Bankai)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 8500,
    "Reiatsu": 7500,
    "Bankai": 8500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8500,
    "IQ": 6200,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 8800,
    "Hax": 8200,
    "Defence": 5000
  },
  "Awakened Cockroach": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 7500,
    "Speed": 9000,
    "Technique": 5500,
    "Energy": 1000,
    "IQ": 4000,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 6000,
    "Defence": 6000
  },
  "Bell-mere": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 4000,
    "Willpower": 7000,
    "Power": 4000,
    "Hax": 1000,
    "Defence": 3000,
    "IQ": 5000
  },
  "Mitsuki (Two Blue Vortex)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 6500,
    "Healer": 1000,
    "Eyes": 6500,
    "IQ": 7500,
    "Summon": 6500,
    "Jutsu": 8000,
    "Clan": 4000,
    "Chakra": 7800,
    "Sensei": 1000,
    "Speed": 8600,
    "Taijutsu": 7200,
    "Power": 8000,
    "Hax": 7800,
    "Defence": 6000
  },
  "Mamushi": {
    "Captain": 5500,
    "Vice Captain": 5200,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 6500,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 7800,
    "Clan": 1000,
    "Chakra": 8800,
    "Sensei": 1000,
    "Speed": 7800,
    "Taijutsu": 7800,
    "Power": 8500,
    "Hax": 8000,
    "Defence": 8500
  },
  "Ao (Kara)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5800,
    "Healer": 1000,
    "Eyes": 8200,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 5500,
    "Speed": 5500,
    "Taijutsu": 5500,
    "Power": 6800,
    "Hax": 7200,
    "Defence": 5800
  },
  "Glorio": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 6500,
    "Form": 1000,
    "Speed": 6500,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 6500,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 5500
  },
  "Ideo": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 3000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 5000,
    "IQ": 3500
  },
  "Samui": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4500,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 4000
  },
  "Pekoms": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4000,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 3000,
    "Willpower": 5500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 6000,
    "IQ": 4000
  },
  "Zoro (Pre-Timeskip)": {
    "Captain": 4000,
    "Vice Captain": 7500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1500,
    "Combat Power": 6000,
    "Speed": 5000,
    "Weapon Skill": 7500,
    "Willpower": 8500,
    "Power": 6000,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 4000
  },
  "Arden": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Magic Specialist": 5000,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000,
    "IQ": 4500
  },
  "Aoba Yamashiro": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 3000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 3500
  },
  "Ohm": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 6500,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 4500,
    "IQ": 5500
  },
  "Tecchin Tecchikawahara": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Healer": 1000,
    "Speed": 1500,
    "Power": 3000,
    "IQ": 5000,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 6000,
    "Technique": 4500,
    "Hax": 1000,
    "Defence": 2500
  },
  "Ay (Boruto)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 3500,
    "Speed": 7800,
    "Taijutsu": 7800,
    "Power": 7000,
    "Hax": 5500,
    "Defence": 7200
  },
  "Jarul": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8000,
    "Combat Power": 8000,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 1000,
    "Defence": 8500,
    "IQ": 6000
  },
  "Kuroobi": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4500,
    "Speed": 4000,
    "Weapon Skill": 2000,
    "Willpower": 4500,
    "Power": 4500,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 3500
  },
  "Paragus": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 3000,
    "IQ": 6000,
    "Sensei": 3000,
    "Power Level": 4000,
    "Energy Manipulation": 4000,
    "Martial Arts": 3500,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 3000
  },
  "Tapion": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 6500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 6500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Shinobu": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 3500,
    "Weapon Skill": 4000,
    "Willpower": 5500,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 5500
  },
  "Kotetsu Hagane": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3500,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3000
  },
  "Ruin": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 6000,
    "Speed": 5000,
    "Magic Specialist": 5000,
    "Willpower": 5500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500,
    "IQ": 4500
  },
  "Dellinger": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 3000,
    "Combat Power": 4500,
    "Speed": 6000,
    "Weapon Skill": 3500,
    "Willpower": 4000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 4000,
    "IQ": 3500
  },
  "Renga Kokubo": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 4200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 4800,
    "Clan": 1000,
    "Chakra": 4200,
    "Sensei": 1000,
    "Speed": 4200,
    "Taijutsu": 4800,
    "Power": 4800,
    "Hax": 4800,
    "Defence": 4200
  },
  "Nail": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 5000,
    "Ki Control": 5500,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 5500,
    "Energy Manipulation": 5500,
    "Martial Arts": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Kumadori": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 6000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5500,
    "IQ": 4500
  },
  "Karin (Boruto)": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 4000,
    "Healer": 8200,
    "Eyes": 8500,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8800,
    "Chakra": 7200,
    "Sensei": 3000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000
  },
  "Boruto Uzumaki (Karma, Two Blue Vortex)": {
    "Captain": 8800,
    "Vice Captain": 8400,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 9200,
    "IQ": 8500,
    "Summon": 4000,
    "Jutsu": 9500,
    "Clan": 9200,
    "Chakra": 9400,
    "Sensei": 4000,
    "Speed": 9600,
    "Taijutsu": 9000,
    "Power": 9600,
    "Hax": 9500,
    "Defence": 8200
  },
  "Haba": {
    "Grade": 6000,
    "Captain": 5800,
    "Vice Captain": 5500,
    "Healer": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6000,
    "Combat Specialist": 6000,
    "Technique Specialist": 6500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 6500,
    "IQ": 5500,
    "Speed": 6000
  },
  "Might Duy": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 1000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 7000,
    "Speed": 7500,
    "Taijutsu": 9000,
    "Power": 7000,
    "Hax": 2000,
    "Defence": 5500
  },
  "Kiseru Gankubi": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 5200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 1000,
    "Chakra": 5200,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 4800,
    "Power": 5800,
    "Hax": 5200,
    "Defence": 5200
  },
  "Mercenary Tao": {
    "Captain": 2500,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 4000,
    "Energy Manipulation": 4500,
    "Martial Arts": 5000,
    "Power": 4000,
    "Hax": 4500,
    "Defence": 3000
  },
  "Gale Wind": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 7200,
    "Speed": 9000,
    "Technique": 8500,
    "Energy": 1000,
    "IQ": 6000,
    "Willpower": 7000,
    "Power": 7200,
    "Hax": 8000,
    "Defence": 5500
  },
  "Dr. Kureha": {
    "Captain": 3000,
    "Vice Captain": 5000,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 3000,
    "Healer": 8500,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 3500,
    "Weapon Skill": 1000,
    "Willpower": 7000,
    "Power": 3000,
    "Hax": 1000,
    "Defence": 3500,
    "IQ": 8500
  },
  "Tengai Hojo": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Quirk Power": 6500,
    "Quirk Control": 7000,
    "Quirk Versatility": 4000,
    "Combat Skill": 3000,
    "Speed": 2500,
    "Resolve": 6000,
    "Teamwork": 5000,
    "Mentor": 2000,
    "Power": 3000,
    "Hax": 5000,
    "Defence": 8000,
    "IQ": 5000
  },
  "Giriko Kutsuzawa": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 7000,
    "Speed": 4500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 7000,
    "Defence": 4000
  },
  "Nue": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7200,
    "Healer": 1000,
    "Eyes": 4000,
    "IQ": 3000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 5800,
    "Taijutsu": 5800,
    "Power": 6800,
    "Hax": 6200,
    "Defence": 6800
  },
  "Buntan Kurosuki": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 4800,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 5200,
    "Chakra": 4800,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 5200,
    "Power": 5800,
    "Hax": 5200,
    "Defence": 4800
  },
  "Silvers Rayleigh (Prime)": {
    "Captain": 9800,
    "Vice Captain": 9800,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 9900,
    "Combat Power": 9700,
    "Speed": 9700,
    "Weapon Skill": 9800,
    "Willpower": 9600,
    "Power": 9900,
    "Hax": 9800,
    "Defence": 8800,
    "IQ": 9500
  },
  "Yodo": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 1000,
    "Chakra": 4200,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 3800,
    "Power": 4800,
    "Hax": 5200,
    "Defence": 3500
  },
  "Charlotte Oven": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 6000,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 3000,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6500,
    "IQ": 5000
  },
  "Nami (Pre-Timeskip)": {
    "Captain": 1500,
    "Vice Captain": 5000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 1200,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 2500,
    "Weapon Skill": 3000,
    "Willpower": 4000,
    "Power": 2000,
    "Hax": 2500,
    "Defence": 1200,
    "IQ": 8000
  },
  "Ikumi Unagiya": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 1500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 3000,
    "Hax": 1500,
    "Defence": 2500
  },
  "Saint Marcus Mars (Itsumade)": {
    "Captain": 8800,
    "Vice Captain": 7800,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 9300,
    "Haki": 8500,
    "Combat Power": 8600,
    "Speed": 8500,
    "Weapon Skill": 6500,
    "Willpower": 8200,
    "Power": 8800,
    "Hax": 9200,
    "Defence": 8800,
    "IQ": 8500
  },
  "Inazuma": {
    "Captain": 3500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 4000,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 5500
  },
  "Orochimaru (Boruto)": {
    "Captain": 7500,
    "Vice Captain": 6800,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 6000,
    "Eyes": 4000,
    "IQ": 9600,
    "Summon": 8500,
    "Jutsu": 9200,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 7000,
    "Speed": 6500,
    "Taijutsu": 5500,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 6500
  },
  "Kid Goku": {
    "Captain": 2000,
    "Vice Captain": 1000,
    "Support 1": 2000,
    "Support 2": 2000,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 3000,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3000,
    "Martial Arts": 4500,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 3000
  },
  "Cho-Cho Akimichi (Two Blue Vortex)": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 7200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4800,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8500,
    "Chakra": 6500,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 6800,
    "Power": 7200,
    "Hax": 4200,
    "Defence": 7200
  },
  "Sarada Uchiha (Mangekyo Sharingan)": {
    "Captain": 7500,
    "Vice Captain": 7200,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 5500,
    "Healer": 2000,
    "Eyes": 9500,
    "IQ": 8200,
    "Summon": 3000,
    "Jutsu": 8200,
    "Clan": 9200,
    "Chakra": 7200,
    "Sensei": 1000,
    "Speed": 7800,
    "Taijutsu": 7800,
    "Power": 8000,
    "Hax": 9000,
    "Defence": 5500
  },
  "Ryu": {
    "Captain": 6000,
    "Vice Captain": 5800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 7200,
    "IQ": 6800,
    "Summon": 1000,
    "Jutsu": 8200,
    "Clan": 1000,
    "Chakra": 9000,
    "Sensei": 1000,
    "Speed": 7800,
    "Taijutsu": 7500,
    "Power": 8500,
    "Hax": 8200,
    "Defence": 8500
  },
  "Smiley": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 2500,
    "Weapon Skill": 1000,
    "Willpower": 3000,
    "Power": 4000,
    "Hax": 5500,
    "Defence": 6000,
    "IQ": 1000
  },
  "Manda": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 4000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 4500,
    "Defence": 8500
  },
  "Takuma Ino": {
    "Grade": 6500,
    "Captain": 6200,
    "Vice Captain": 6000,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 6500,
    "Combat Specialist": 6200,
    "Technique Specialist": 7000,
    "Power": 6500,
    "Hax": 7200,
    "Defence": 6000,
    "IQ": 6500,
    "Speed": 6200
  },
  "Sadi": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 4500,
    "Willpower": 4500,
    "Power": 4000,
    "Hax": 1000,
    "Defence": 3500,
    "IQ": 4000
  },
  "Karui": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 4500,
    "Hax": 3000,
    "Defence": 4000
  },
  "Sakura Haruno (Genin)": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1500,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 2000,
    "Clan": 1000,
    "Chakra": 2500,
    "Sensei": 1000,
    "Speed": 2500,
    "Taijutsu": 2000,
    "Power": 2000,
    "Hax": 2500,
    "Defence": 2000
  },
  "Ameyuri Ringo (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5000
  },
  "Lucci (Enies Lobby)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 7000,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5500,
    "IQ": 6000
  },
  "Shura": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 4500,
    "Speed": 5000,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 4500,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 4000
  },
  "Gamabunta": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 8500,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 7000,
    "Power": 8000,
    "Hax": 4500,
    "Defence": 8500
  },
  "Future Gohan": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6500,
    "Form": 6000,
    "Speed": 6500,
    "IQ": 6500,
    "Sensei": 3000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 6500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5500
  },
  "General Rilldo": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 7000,
    "Speed": 6000,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 6000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 8000
  },
  "Rock Lee (Boruto)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 1000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 7500,
    "Speed": 8800,
    "Taijutsu": 9600,
    "Power": 7800,
    "Hax": 3500,
    "Defence": 6500
  },
  "Ui Ui": {
    "Grade": 4500,
    "Captain": 4000,
    "Vice Captain": 4000,
    "Healer": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5000,
    "Combat Specialist": 3000,
    "Technique Specialist": 6000,
    "Power": 3500,
    "Hax": 7000,
    "Defence": 3500,
    "IQ": 6000,
    "Speed": 4500
  },
  "Might Guy (Boruto)": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 3000,
    "Jutsu": 1500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 8500,
    "Speed": 4000,
    "Taijutsu": 8000,
    "Power": 5500,
    "Hax": 2500,
    "Defence": 4000
  },
  "Kurenai (Boruto)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6200,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 7000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 3000
  },
  "Miss Valentine": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 5000,
    "Haki": 1000,
    "Combat Power": 2000,
    "Speed": 4000,
    "Weapon Skill": 1500,
    "Willpower": 3000,
    "Power": 2000,
    "Hax": 4500,
    "Defence": 1500,
    "IQ": 3500
  },
  "Araya": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 1000,
    "Chakra": 4200,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 4500,
    "Power": 4800,
    "Hax": 5200,
    "Defence": 3500
  },
  "Hiruzen Sarutobi (Prime)": {
    "Captain": 9200,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9200,
    "Summon": 8500,
    "Jutsu": 9700,
    "Clan": 7000,
    "Chakra": 8800,
    "Sensei": 8500,
    "Speed": 8000,
    "Taijutsu": 8200,
    "Power": 9200,
    "Hax": 9200,
    "Defence": 7000
  },
  "Granny Ogami": {
    "Grade": 4500,
    "Captain": 4000,
    "Vice Captain": 4000,
    "Healer": 1000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 3000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5000,
    "Combat Specialist": 2000,
    "Technique Specialist": 6000,
    "Power": 3500,
    "Hax": 6500,
    "Defence": 3000,
    "IQ": 6000,
    "Speed": 3000
  },
  "Jinpachi Munashi (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 6500,
    "Hax": 5000,
    "Defence": 5500
  },
  "Commander Red": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 1000,
    "Healer": 1000,
    "Ki Control": 1000,
    "Technique": 1000,
    "Form": 1000,
    "Speed": 1000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 1000,
    "Energy Manipulation": 1000,
    "Martial Arts": 1000,
    "Power": 1000,
    "Hax": 2000,
    "Defence": 1000
  },
  "Gaara (Boruto)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 4000,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 8800,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 5500,
    "Speed": 5500,
    "Taijutsu": 4000,
    "Power": 8800,
    "Hax": 8200,
    "Defence": 9000
  },
  "Vegeta (SSG)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8000,
    "Healer": 1000,
    "Ki Control": 9000,
    "Technique": 8000,
    "Form": 7500,
    "Speed": 8800,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 9000,
    "Martial Arts": 8500,
    "Power": 8800,
    "Hax": 8000,
    "Defence": 8200
  },
  "Kibito": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3500,
    "Healer": 6000,
    "Ki Control": 5000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 4500,
    "Energy Manipulation": 5000,
    "Martial Arts": 3500,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 3500
  },
  "Vander Decken IX": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Weapon Skill": 4000,
    "Willpower": 3500,
    "Power": 3000,
    "Hax": 6000,
    "Defence": 3000,
    "IQ": 4000
  },
  "Edward Weevil": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7500,
    "Combat Power": 8000,
    "Speed": 7000,
    "Weapon Skill": 7000,
    "Willpower": 7000,
    "Power": 8500,
    "Hax": 1000,
    "Defence": 8000,
    "IQ": 2500
  },
  "Gums": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8000,
    "Combat Power": 6500,
    "Speed": 5500,
    "Technique": 5500,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7500,
    "Defence": 5000
  },
  "Jerome Guizbatt": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6000
  },
  "Amado Sanzu": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 1500,
    "Healer": 5500,
    "Eyes": 1000,
    "IQ": 9999,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 1000,
    "Sensei": 4500,
    "Speed": 1500,
    "Taijutsu": 1000,
    "Power": 3000,
    "Hax": 7800,
    "Defence": 1500
  },
  "Lucci (Enies Lobby Leopard)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 6500,
    "Speed": 7200,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 6000,
    "IQ": 6000
  },
  "Gengo": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 4200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 5800,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 4200,
    "Power": 5800,
    "Hax": 7800,
    "Defence": 4200
  },
  "Kami": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Ki Control": 5500,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 3500,
    "IQ": 8000,
    "Sensei": 7000,
    "Power Level": 4500,
    "Energy Manipulation": 5500,
    "Martial Arts": 4500,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 3500
  },
  "Shojoji Otsutsuki": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 8200,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 8800,
    "Clan": 9500,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 7800,
    "Taijutsu": 7200,
    "Power": 9000,
    "Hax": 8800,
    "Defence": 8200
  },
  "Mabui": {
    "Captain": 2000,
    "Vice Captain": 3000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 2000,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 2500
  },
  "Kiriya Ubuyashiki": {
    "Captain": 6000,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 1500,
    "Healer": 1000,
    "Speed": 1500,
    "Power": 1500,
    "IQ": 8500,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 4000,
    "Hax": 5500,
    "Defence": 1500
  },
  "Luffy (Pre-Timeskip)": {
    "Captain": 7000,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 5500,
    "Weapon Skill": 1000,
    "Willpower": 8500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5000,
    "IQ": 3500
  },
  "Matsuri": {
    "Captain": 6500,
    "Vice Captain": 6200,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 7500,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 8200,
    "Taijutsu": 7500,
    "Power": 8800,
    "Hax": 8800,
    "Defence": 8500
  },
  "Gin": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 5500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 4500,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 4500
  },
  "Kyros": {
    "Captain": 5500,
    "Vice Captain": 6500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 6000,
    "Combat Power": 7500,
    "Speed": 7500,
    "Weapon Skill": 8500,
    "Willpower": 8500,
    "Power": 7500,
    "Hax": 1500,
    "Defence": 6000,
    "IQ": 5500
  },
  "Hoki Taketori": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 3000,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3500
  },
  "Android 19": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 6000,
    "Martial Arts": 3500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Kakashi Hatake (Sixth Hokage)": {
    "Captain": 9200,
    "Vice Captain": 8800,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 6500,
    "Healer": 1000,
    "Eyes": 6000,
    "IQ": 9500,
    "Summon": 7000,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 8800,
    "Speed": 7800,
    "Taijutsu": 7500,
    "Power": 7500,
    "Hax": 7200,
    "Defence": 6000
  },
  "Kamanue": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Speed": 4000,
    "Power": 3500,
    "IQ": 3000,
    "Breathing": 1000,
    "Demon": 4000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 3000,
    "Hax": 3500,
    "Defence": 3500
  },
  "Kinkaku (Reanimation)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 9500,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 7000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8000
  },
  "Big Mom (Young)": {
    "Captain": 9000,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8000,
    "Healer": 1000,
    "Devil Fruit": 9500,
    "Haki": 9000,
    "Combat Power": 9000,
    "Speed": 8000,
    "Weapon Skill": 1000,
    "Willpower": 6000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 7000,
    "IQ": 7000
  },
  "Usopp (Pre-Timeskip)": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 1000,
    "Healer": 1500,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 1000,
    "Speed": 2000,
    "Weapon Skill": 6000,
    "Willpower": 3000,
    "Power": 2500,
    "Hax": 2500,
    "Defence": 1000,
    "IQ": 6500
  },
  "Shima": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4500,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 6000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 7500,
    "Sensei": 6000,
    "Speed": 4000,
    "Taijutsu": 4500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 4500
  },
  "Flect Turn": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7500,
    "Healer": 1000,
    "Quirk Power": 8500,
    "Quirk Control": 8000,
    "Quirk Versatility": 6000,
    "Combat Skill": 6500,
    "Speed": 6000,
    "Resolve": 8500,
    "Teamwork": 5000,
    "Mentor": 4000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 8000,
    "IQ": 6500
  },
  "Charlotte Chuhlhourne": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 4500
  },
  "Sanji (Pre-Timeskip)": {
    "Captain": 3500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 6000,
    "Weapon Skill": 2000,
    "Willpower": 7000,
    "Power": 5000,
    "Hax": 1000,
    "Defence": 4500,
    "IQ": 5500
  },
  "Fuhrer Ugly": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8000,
    "Speed": 5000,
    "Technique": 4000,
    "Energy": 1000,
    "IQ": 4000,
    "Willpower": 7000,
    "Power": 8500,
    "Hax": 5500,
    "Defence": 8000
  },
  "Jinin Akebino (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500
  },
  "Gladius": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 4500,
    "Speed": 4500,
    "Weapon Skill": 4000,
    "Willpower": 5000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4500,
    "IQ": 5000
  },
  "Karui (Boruto)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 3500,
    "Speed": 5800,
    "Taijutsu": 6500,
    "Power": 6000,
    "Hax": 4500,
    "Defence": 5000
  },
  "Metal Lee": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3500,
    "Summon": 1000,
    "Jutsu": 1000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 6200,
    "Taijutsu": 7000,
    "Power": 5000,
    "Hax": 1500,
    "Defence": 4500
  },
  "Arinsu": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 4000
  },
  "Rokuro": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Speed": 3500,
    "Power": 4000,
    "IQ": 3000,
    "Breathing": 1000,
    "Demon": 4000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 3000,
    "Hax": 3000,
    "Defence": 3500
  },
  "Oga": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4800,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 1000,
    "Chakra": 5200,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 5800,
    "Power": 5800,
    "Hax": 4800,
    "Defence": 5800
  },
  "Sasuke Uchiha (Curse Mark)": {
    "Captain": 3000,
    "Vice Captain": 2000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 7000,
    "IQ": 5500,
    "Summon": 4000,
    "Jutsu": 5000,
    "Clan": 9000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 3500
  },
  "Dende": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 1500,
    "Healer": 9000,
    "Ki Control": 3000,
    "Technique": 2500,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 2500,
    "Energy Manipulation": 3000,
    "Martial Arts": 1500,
    "Power": 2000,
    "Hax": 4000,
    "Defence": 1500
  },
  "Sakura Uchiha (Boruto)": {
    "Captain": 7500,
    "Vice Captain": 8200,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 8000,
    "Healer": 9800,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 8500,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 8500,
    "Sensei": 7500,
    "Speed": 7200,
    "Taijutsu": 9200,
    "Power": 8500,
    "Hax": 7200,
    "Defence": 8000
  },
  "Mimic": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Quirk Power": 6000,
    "Quirk Control": 5500,
    "Quirk Versatility": 5500,
    "Combat Skill": 4000,
    "Speed": 3500,
    "Resolve": 5000,
    "Teamwork": 4000,
    "Mentor": 2000,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 4500,
    "IQ": 5000
  },
  "Gerd": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 7000,
    "Combat Power": 7000,
    "Speed": 5500,
    "Weapon Skill": 6500,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 1000,
    "Defence": 7000,
    "IQ": 5500
  },
  "Yugao Uzuki": {
    "Captain": 2500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 4000,
    "Hax": 4000,
    "Defence": 3000
  },
  "Karura": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 5500
  },
  "Vegeta (Mini)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6500,
    "Form": 7000,
    "Speed": 6500,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 7000,
    "Martial Arts": 7000,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 5500
  },
  "Shaz Domino": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 6500
  },
  "Homura Mitokado": {
    "Captain": 3000,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 4000,
    "Speed": 2000,
    "Taijutsu": 2000,
    "Power": 3500,
    "Hax": 4500,
    "Defence": 2500
  },
  "Nuova Shenron": {
    "Captain": 7000,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 8000,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 7000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 8000,
    "Energy Manipulation": 8000,
    "Martial Arts": 7000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6500
  },
  "Kiyotaka Ijichi": {
    "Grade": 3000,
    "Captain": 2500,
    "Vice Captain": 3000,
    "Healer": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 2500,
    "Combat Specialist": 1500,
    "Technique Specialist": 3500,
    "Power": 1500,
    "Hax": 4000,
    "Defence": 2000,
    "IQ": 6000,
    "Speed": 2500
  },
  "Tsunade (Boruto)": {
    "Captain": 8000,
    "Vice Captain": 7000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 7500,
    "Healer": 9500,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 6500,
    "Jutsu": 7000,
    "Clan": 8500,
    "Chakra": 8200,
    "Sensei": 7000,
    "Speed": 6200,
    "Taijutsu": 8200,
    "Power": 8200,
    "Hax": 6500,
    "Defence": 7200
  },
  "Zaku Abumi": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 3500,
    "Hax": 3000,
    "Defence": 2500
  },
  "Killer Bee (Boruto)": {
    "Captain": 7000,
    "Vice Captain": 8000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 7800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 6800,
    "Clan": 1000,
    "Chakra": 8500,
    "Sensei": 6000,
    "Speed": 6800,
    "Taijutsu": 7800,
    "Power": 8500,
    "Hax": 6500,
    "Defence": 7800
  },
  "Oceanus Shenron": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5000,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 6000
  },
  "Mirai Sarutobi": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 7000,
    "Chakra": 5000,
    "Sensei": 3000,
    "Speed": 5500,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 5200,
    "Defence": 4500
  },
  "Baki": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 5000,
    "Speed": 4500,
    "Taijutsu": 4500,
    "Power": 5000,
    "Hax": 4500,
    "Defence": 4500
  },
  "Tamago": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 4500,
    "Combat Power": 5000,
    "Speed": 4500,
    "Weapon Skill": 5500,
    "Willpower": 5000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 5000,
    "IQ": 5500
  },
  "Hidari": {
    "Captain": 7500,
    "Vice Captain": 7200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9000,
    "Healer": 1000,
    "Eyes": 7500,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 8500,
    "Clan": 1000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 9200,
    "Taijutsu": 9200,
    "Power": 9200,
    "Hax": 8500,
    "Defence": 8800
  },
  "Black Zetsu": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8500,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 3000,
    "Power": 4500,
    "Hax": 8000,
    "Defence": 5000
  },
  "Apacci": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 2500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4000,
    "Hax": 3000,
    "Defence": 3500
  },
  "Shepherd Sommers": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7500,
    "Healer": 1000,
    "Devil Fruit": 8000,
    "Haki": 7500,
    "Combat Power": 7000,
    "Speed": 6500,
    "Weapon Skill": 6000,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 8000,
    "Defence": 7500,
    "IQ": 7000
  },
  "Shibai Otsutsuki": {
    "Captain": 9999,
    "Vice Captain": 9999,
    "Support 1": 9999,
    "Support 2": 9999,
    "Tank": 9999,
    "Healer": 9999,
    "Eyes": 9999,
    "IQ": 9999,
    "Summon": 9999,
    "Jutsu": 9999,
    "Clan": 9999,
    "Chakra": 9999,
    "Sensei": 9999,
    "Speed": 9999,
    "Taijutsu": 9999,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9999
  },
  "Omoi (Boruto)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 4800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5200,
    "Sensei": 4000,
    "Speed": 5800,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 4800
  },
  "Charlotte Snack": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 5000,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 5500,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5500,
    "IQ": 5000
  },
  "Shinki": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6800,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 6500,
    "Hax": 6500,
    "Defence": 6500
  },
  "Gedatsu": {
    "Captain": 3500,
    "Vice Captain": 3500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4000,
    "Combat Power": 4000,
    "Speed": 4000,
    "Weapon Skill": 2500,
    "Willpower": 4000,
    "Power": 4000,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 3000
  },
  "Tsume Inuzuka": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 6000,
    "Jutsu": 4500,
    "Clan": 5000,
    "Chakra": 4500,
    "Sensei": 3000,
    "Speed": 5500,
    "Taijutsu": 5500,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 5000
  },
  "Hana Inuzuka": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 5000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 6000,
    "Jutsu": 4000,
    "Clan": 5000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 4000,
    "Hax": 3500,
    "Defence": 3500
  },
  "Launch": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 1500,
    "Healer": 1000,
    "Ki Control": 1000,
    "Technique": 2000,
    "Form": 1000,
    "Speed": 2000,
    "IQ": 2500,
    "Sensei": 1000,
    "Power Level": 1500,
    "Energy Manipulation": 1500,
    "Martial Arts": 2000,
    "Power": 1500,
    "Hax": 3000,
    "Defence": 1500
  },
  "Jabra": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 4000,
    "Combat Power": 5500,
    "Speed": 6000,
    "Weapon Skill": 3000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5500,
    "IQ": 4500
  },
  "Driscoll Berci": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 6000
  },
  "Rin Amai": {
    "Grade": 4500,
    "Captain": 4000,
    "Vice Captain": 4000,
    "Healer": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5000,
    "Combat Specialist": 3500,
    "Technique Specialist": 6000,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 4000,
    "IQ": 5500,
    "Speed": 4500
  },
  "Saint Shepherd Ju Peter (Sandworm)": {
    "Captain": 8800,
    "Vice Captain": 7800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9000,
    "Healer": 1000,
    "Devil Fruit": 9300,
    "Haki": 8500,
    "Combat Power": 8500,
    "Speed": 6500,
    "Weapon Skill": 5500,
    "Willpower": 8200,
    "Power": 8800,
    "Hax": 9200,
    "Defence": 9000,
    "IQ": 8800
  },
  "Inojin Yamanaka": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 4000,
    "IQ": 6200,
    "Summon": 6000,
    "Jutsu": 4800,
    "Clan": 7800,
    "Chakra": 3800,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 2500,
    "Power": 4000,
    "Hax": 5800,
    "Defence": 2500
  },
  "Goku (GT)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 8500,
    "Technique": 8000,
    "Form": 1000,
    "Speed": 8000,
    "IQ": 5500,
    "Sensei": 1000,
    "Power Level": 8500,
    "Energy Manipulation": 8500,
    "Martial Arts": 8000,
    "Power": 8500,
    "Hax": 7500,
    "Defence": 7000
  },
  "Viola": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3800,
    "Support 2": 3800,
    "Tank": 2000,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 4000,
    "Weapon Skill": 3000,
    "Willpower": 4500,
    "Power": 2500,
    "Hax": 7500,
    "Defence": 2000,
    "IQ": 6500
  },
  "Yoroi Akado": {
    "Captain": 2000,
    "Vice Captain": 1500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3000,
    "Hax": 4000,
    "Defence": 3000
  },
  "Mizuki": {
    "Captain": 2000,
    "Vice Captain": 1500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 3000,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 3000
  },
  "Isari Funato": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 6200,
    "Chakra": 5800,
    "Sensei": 1000,
    "Speed": 5800,
    "Taijutsu": 5200,
    "Power": 5800,
    "Hax": 5200,
    "Defence": 5200
  },
  "Kabuto Yakushi (Boruto)": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5000,
    "Healer": 8500,
    "Eyes": 5000,
    "IQ": 9000,
    "Summon": 5500,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 6000,
    "Speed": 5200,
    "Taijutsu": 4500,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 4800
  },
  "Shizuma Hoshigaki": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 5500,
    "Jutsu": 6200,
    "Clan": 5500,
    "Chakra": 6800,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 5800,
    "Power": 6800,
    "Hax": 5800,
    "Defence": 6200
  },
  "Garo": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 5800,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5500,
    "Power": 6800,
    "Hax": 6200,
    "Defence": 5500
  },
  "Berenice Gabrielli": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 7000,
    "Defence": 4000
  },
  "Mikazuki": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 3200,
    "Clan": 1000,
    "Chakra": 3200,
    "Sensei": 1000,
    "Speed": 5200,
    "Taijutsu": 3200,
    "Power": 2800,
    "Hax": 4200,
    "Defence": 2200
  },
  "Mr. Popo": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5500,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 6500,
    "Sensei": 6000,
    "Power Level": 5000,
    "Energy Manipulation": 5500,
    "Martial Arts": 6000,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 4000
  },
  "Squard": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 5500,
    "Weapon Skill": 7000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 5000
  },
  "Weinheidt": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5500,
    "Speed": 5500,
    "Magic Specialist": 6000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 5000,
    "IQ": 5000
  },
  "Enma": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 6000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 3000,
    "Speed": 5000,
    "Taijutsu": 6500,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 8000
  },
  "Kiba Inuzuka (Boruto)": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 4500,
    "IQ": 5200,
    "Summon": 6500,
    "Jutsu": 5500,
    "Clan": 6500,
    "Chakra": 5000,
    "Sensei": 3500,
    "Speed": 6500,
    "Taijutsu": 6500,
    "Power": 6000,
    "Hax": 5000,
    "Defence": 5500
  },
  "Fu Yamanaka": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7500,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 4500,
    "Hax": 6000,
    "Defence": 3500
  },
  "Tomura Shigaraki (AFO Fused)": {
    "Captain": 9500,
    "Vice Captain": 8500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 9200,
    "Healer": 1000,
    "Quirk Power": 9900,
    "Quirk Control": 9000,
    "Quirk Versatility": 9000,
    "Combat Skill": 8500,
    "Speed": 9200,
    "Resolve": 9800,
    "Teamwork": 4500,
    "Mentor": 4000,
    "Power": 9900,
    "Hax": 9999,
    "Defence": 9200,
    "IQ": 8500
  },
  "Ku": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 5800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7200,
    "Summon": 1000,
    "Jutsu": 6800,
    "Clan": 1000,
    "Chakra": 5800,
    "Sensei": 1000,
    "Speed": 5800,
    "Taijutsu": 5800,
    "Power": 6800,
    "Hax": 7200,
    "Defence": 5800
  },
  "Elec": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Ki Control": 5000,
    "Technique": 5000,
    "Form": 1000,
    "Speed": 5000,
    "IQ": 7500,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 5000,
    "Martial Arts": 4000,
    "Power": 5000,
    "Hax": 5500,
    "Defence": 4000
  },
  "Buggy (Emperor)": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 3500,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2000,
    "Weapon Skill": 2500,
    "Willpower": 6500,
    "Power": 2500,
    "Hax": 3500,
    "Defence": 3000,
    "IQ": 5500
  },
  "Choze": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 7500,
    "Speed": 7500,
    "Technique": 7500,
    "Energy": 1000,
    "IQ": 5500,
    "Willpower": 7000,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Kae Yukiwari": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 3800,
    "Clan": 1000,
    "Chakra": 3200,
    "Sensei": 1000,
    "Speed": 3800,
    "Taijutsu": 2800,
    "Power": 3200,
    "Hax": 4200,
    "Defence": 2800
  },
  "Shunsui (Bankai)": {
    "Captain": 9700,
    "Vice Captain": 8800,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 9800,
    "Reiatsu": 9700,
    "Bankai": 9800,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8200,
    "IQ": 9200,
    "Sensei": 7000,
    "Ally": 8000,
    "Power": 9700,
    "Hax": 9900,
    "Defence": 7000
  },
  "Kagura Karatachi": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 6500,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 6000,
    "Power": 6000,
    "Hax": 5800,
    "Defence": 4500
  },
  "Hundred-Eyes Octopus": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8800,
    "Combat Power": 8200,
    "Speed": 6000,
    "Technique": 7000,
    "Energy": 1000,
    "IQ": 5000,
    "Willpower": 7500,
    "Power": 8200,
    "Hax": 6500,
    "Defence": 7500
  },
  "Ibiki Morino": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 5000,
    "Speed": 3500,
    "Taijutsu": 4000,
    "Power": 4000,
    "Hax": 6000,
    "Defence": 4000
  },
  "Remi": {
    "Grade": 3500,
    "Captain": 3200,
    "Vice Captain": 3000,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4000,
    "Combat Specialist": 3000,
    "Technique Specialist": 4500,
    "Power": 3500,
    "Hax": 5000,
    "Defence": 3000,
    "IQ": 5000,
    "Speed": 4000
  },
  "C": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 3000
  },
  "Bug God": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8000,
    "Speed": 6000,
    "Technique": 4000,
    "Energy": 1000,
    "IQ": 3500,
    "Willpower": 7500,
    "Power": 8200,
    "Hax": 5000,
    "Defence": 8500
  },
  "Madara Uchiha (Reanimation)": {
    "Captain": 9500,
    "Vice Captain": 8000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 9999,
    "Healer": 5000,
    "Eyes": 9500,
    "IQ": 8500,
    "Summon": 8500,
    "Jutsu": 9500,
    "Clan": 9000,
    "Chakra": 9999,
    "Sensei": 7000,
    "Speed": 8500,
    "Taijutsu": 8000,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 9000
  },
  "Do-S": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 7000,
    "Speed": 6000,
    "Technique": 6000,
    "Energy": 6000,
    "IQ": 6000,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 5500
  },
  "Code (Limiter Released)": {
    "Captain": 7800,
    "Vice Captain": 7200,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 7800,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6800,
    "Summon": 8200,
    "Jutsu": 9000,
    "Clan": 1000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 9500,
    "Taijutsu": 8200,
    "Power": 9500,
    "Hax": 9200,
    "Defence": 8000
  },
  "Moegi Kazamatsuri": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 5000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4000
  },
  "Frost": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 6000,
    "Form": 7000,
    "Speed": 7000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 6000
  },
  "Tsubaki Kurogane": {
    "Captain": 4000,
    "Vice Captain": 4000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 4800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 3200,
    "Clan": 1000,
    "Chakra": 3200,
    "Sensei": 1000,
    "Speed": 6200,
    "Taijutsu": 5800,
    "Power": 5800,
    "Hax": 4800,
    "Defence": 4800
  },
  "Kurotsuchi (Fourth Tsuchikage)": {
    "Captain": 8000,
    "Vice Captain": 6500,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 6200,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 5000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 7200,
    "Hax": 7000,
    "Defence": 6500
  },
  "Hellfire Flame": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8200,
    "Combat Power": 7500,
    "Speed": 8000,
    "Technique": 8000,
    "Energy": 1000,
    "IQ": 6000,
    "Willpower": 7000,
    "Power": 7800,
    "Hax": 8000,
    "Defence": 5500
  },
  "Izuku Midoriya (U.A. Entrance)": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Quirk Power": 7000,
    "Quirk Control": 1500,
    "Quirk Versatility": 1500,
    "Combat Skill": 2500,
    "Speed": 2500,
    "Resolve": 9000,
    "Teamwork": 5000,
    "Mentor": 3000,
    "Power": 6000,
    "Hax": 3500,
    "Defence": 2500,
    "IQ": 6500
  },
  "Toneri Otsutsuki (Boruto)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7200,
    "Support 2": 7200,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 9500,
    "IQ": 8200,
    "Summon": 1000,
    "Jutsu": 9300,
    "Clan": 9999,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 8600,
    "Taijutsu": 7200,
    "Power": 9400,
    "Hax": 9700,
    "Defence": 8000
  },
  "Kawaki (Karma, Two Blue Vortex)": {
    "Captain": 7400,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9000,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 9200,
    "Clan": 1000,
    "Chakra": 9200,
    "Sensei": 1000,
    "Speed": 9200,
    "Taijutsu": 9200,
    "Power": 9500,
    "Hax": 9500,
    "Defence": 9000
  },
  "Kaori Itadori": {
    "Grade": 5000,
    "Captain": 4500,
    "Vice Captain": 4500,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5500,
    "Combat Specialist": 3500,
    "Technique Specialist": 6000,
    "Power": 4500,
    "Hax": 6500,
    "Defence": 4000,
    "IQ": 7000,
    "Speed": 4000
  },
  "Wasabi Izuno": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 3000,
    "IQ": 4200,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 4500,
    "Hax": 4200,
    "Defence": 3500
  },
  "Konohamaru Sarutobi (Two Blue Vortex)": {
    "Captain": 7000,
    "Vice Captain": 6800,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 5500,
    "Jutsu": 7500,
    "Clan": 7200,
    "Chakra": 6500,
    "Sensei": 8000,
    "Speed": 6500,
    "Taijutsu": 6000,
    "Power": 7000,
    "Hax": 6500,
    "Defence": 5500
  },
  "Temari (Boruto)": {
    "Captain": 6000,
    "Vice Captain": 7000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 7000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 5000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 7000,
    "Hax": 6200,
    "Defence": 4500
  },
  "Royd Lloyd": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 4500
  },
  "Killingham": {
    "Captain": 6500,
    "Vice Captain": 6500,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 8500,
    "Haki": 7000,
    "Combat Power": 8200,
    "Speed": 6000,
    "Weapon Skill": 5500,
    "Willpower": 7000,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 7000,
    "IQ": 7500
  },
  "Shikadai Nara": {
    "Captain": 5500,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8800,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 8000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 4000,
    "Hax": 5800,
    "Defence": 3000
  },
  "Minato Namikaze (Reanimation, KCM)": {
    "Captain": 9200,
    "Vice Captain": 8500,
    "Support 1": 8500,
    "Support 2": 8500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8800,
    "Summon": 7000,
    "Jutsu": 9000,
    "Clan": 1000,
    "Chakra": 9500,
    "Sensei": 9000,
    "Speed": 9999,
    "Taijutsu": 8000,
    "Power": 9200,
    "Hax": 9000,
    "Defence": 8000
  },
  "Charlotte Daifuku": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 5500,
    "Combat Power": 6000,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 6000,
    "IQ": 4500
  },
  "Mikoto Uchiha": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 7500,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 9000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 4500,
    "Hax": 7000,
    "Defence": 3000
  },
  "Anko Mitarashi (Boruto)": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 6000,
    "Jutsu": 6200,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 6000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 4500
  },
  "Torifu Akimichi": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 7500,
    "Chakra": 6000,
    "Sensei": 4000,
    "Speed": 3500,
    "Taijutsu": 6000,
    "Power": 6500,
    "Hax": 4000,
    "Defence": 7500
  },
  "Hiashi Hyuga": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 9000,
    "Chakra": 5000,
    "Sensei": 6500,
    "Speed": 5500,
    "Taijutsu": 7200,
    "Power": 5500,
    "Hax": 8000,
    "Defence": 4500
  },
  "Denki Kaminarimon (Two Blue Vortex)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8800,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 2800,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3800
  },
  "Mito Uzumaki": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 5500,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 8500,
    "Chakra": 9200,
    "Sensei": 5000,
    "Speed": 4000,
    "Taijutsu": 4000,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 5500
  },
  "Neptune": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 5000,
    "Combat Power": 6000,
    "Speed": 4500,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 1000,
    "Defence": 6500,
    "IQ": 6000
  },
  "Daz Bonez (Mr. 1)": {
    "Captain": 4000,
    "Vice Captain": 4500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 6000,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 1000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 6000,
    "Willpower": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 7000,
    "IQ": 4500
  },
  "Iwabee Yuino": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3800,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 4500,
    "Power": 4500,
    "Hax": 3800,
    "Defence": 4800
  },
  "Foxy": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 5500,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 3000,
    "Weapon Skill": 2000,
    "Willpower": 3500,
    "Power": 2500,
    "Hax": 7000,
    "Defence": 2500,
    "IQ": 5000
  },
  "Nine": {
    "Captain": 7500,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Quirk Power": 9000,
    "Quirk Control": 7500,
    "Quirk Versatility": 8500,
    "Combat Skill": 7000,
    "Speed": 7000,
    "Resolve": 8500,
    "Teamwork": 5000,
    "Mentor": 4000,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 6500,
    "IQ": 7000
  },
  "Kurozumi Higurashi": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 1000,
    "Combat Power": 1500,
    "Speed": 2000,
    "Weapon Skill": 1000,
    "Willpower": 4500,
    "Power": 1500,
    "Hax": 7000,
    "Defence": 2000,
    "IQ": 7000
  },
  "Sasuke Uchiha (Two Blue Vortex)": {
    "Captain": 8500,
    "Vice Captain": 8800,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 8000,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 9200,
    "Summon": 7000,
    "Jutsu": 8800,
    "Clan": 8800,
    "Chakra": 8000,
    "Sensei": 8500,
    "Speed": 8800,
    "Taijutsu": 8800,
    "Power": 8800,
    "Hax": 8800,
    "Defence": 8000
  },
  "Gamakichi": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 7500,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 5000,
    "Power": 6000,
    "Hax": 4000,
    "Defence": 6000
  },
  "Crocodile (Cross Guild)": {
    "Captain": 7000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Devil Fruit": 8200,
    "Haki": 7000,
    "Combat Power": 6200,
    "Speed": 5500,
    "Weapon Skill": 5500,
    "Willpower": 7500,
    "Power": 7500,
    "Hax": 8000,
    "Defence": 6200,
    "IQ": 8200
  },
  "Iori Hazenoki": {
    "Grade": 5500,
    "Captain": 5200,
    "Vice Captain": 5000,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 5500,
    "Combat Specialist": 5000,
    "Technique Specialist": 6000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5000,
    "IQ": 5000,
    "Speed": 5000
  },
  "Eis Shenron": {
    "Captain": 6000,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 6500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 7500,
    "Energy Manipulation": 7500,
    "Martial Arts": 5500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Victor": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 2000,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2500,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 3000
  },
  "Butsuma Senju": {
    "Captain": 6500,
    "Vice Captain": 5500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 8400,
    "Chakra": 6000,
    "Sensei": 5000,
    "Speed": 5500,
    "Taijutsu": 6000,
    "Power": 6500,
    "Hax": 5500,
    "Defence": 5500
  },
  "Neva": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Ki Control": 6000,
    "Technique": 5500,
    "Form": 1000,
    "Speed": 4000,
    "IQ": 7000,
    "Sensei": 1000,
    "Power Level": 5000,
    "Energy Manipulation": 6000,
    "Martial Arts": 3500,
    "Power": 5000,
    "Hax": 6000,
    "Defence": 3500
  },
  "Hinata Hyuga (The Last)": {
    "Captain": 2500,
    "Vice Captain": 2000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8500,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 7000,
    "Power": 6000,
    "Hax": 8500,
    "Defence": 4500
  },
  "Kawaki (Two Blue Vortex)": {
    "Captain": 7200,
    "Vice Captain": 6800,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 8500,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 8800,
    "Clan": 1000,
    "Chakra": 8800,
    "Sensei": 1000,
    "Speed": 8800,
    "Taijutsu": 8800,
    "Power": 9200,
    "Hax": 9200,
    "Defence": 8500
  },
  "Selkie": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Quirk Power": 5500,
    "Quirk Control": 6000,
    "Quirk Versatility": 4500,
    "Combat Skill": 6000,
    "Speed": 6000,
    "Resolve": 7000,
    "Teamwork": 7000,
    "Mentor": 5000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5500,
    "IQ": 5500
  },
  "Wolfram": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Quirk Power": 8000,
    "Quirk Control": 7500,
    "Quirk Versatility": 6000,
    "Combat Skill": 6000,
    "Speed": 5000,
    "Resolve": 7500,
    "Teamwork": 4000,
    "Mentor": 3000,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 7000,
    "IQ": 6000
  },
  "Ino Yamanaka (Boruto)": {
    "Captain": 5000,
    "Vice Captain": 6000,
    "Support 1": 8200,
    "Support 2": 8200,
    "Tank": 3500,
    "Healer": 6500,
    "Eyes": 7000,
    "IQ": 7800,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 8800,
    "Chakra": 5500,
    "Sensei": 5500,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 8000,
    "Defence": 3500
  },
  "Sajin Komomora (Bankai)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 7000,
    "Reiatsu": 7000,
    "Bankai": 8000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 8000,
    "Hax": 6500,
    "Defence": 8000
  },
  "Domino": {
    "Captain": 2500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 3000,
    "Speed": 3500,
    "Weapon Skill": 3500,
    "Willpower": 4500,
    "Power": 3000,
    "Hax": 1000,
    "Defence": 3000,
    "IQ": 5500
  },
  "Izumi Uchiha": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 6000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 8500,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 2500
  },
  "Paulie": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 4000,
    "Speed": 4500,
    "Weapon Skill": 5000,
    "Willpower": 5000,
    "Power": 4000,
    "Hax": 1000,
    "Defence": 4000,
    "IQ": 5000
  },
  "Super Android 13": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 5500,
    "Form": 7000,
    "Speed": 5500,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 7000,
    "Energy Manipulation": 7000,
    "Martial Arts": 5500,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 7000
  },
  "Hebiichigo": {
    "Captain": 2500,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 4800,
    "Clan": 1000,
    "Chakra": 3800,
    "Sensei": 1000,
    "Speed": 3800,
    "Taijutsu": 2800,
    "Power": 3800,
    "Hax": 5200,
    "Defence": 2800
  },
  "Kankuro (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 7800,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 4000,
    "Speed": 4500,
    "Taijutsu": 3500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 5000
  },
  "Shikadai Nara (Two Blue Vortex)": {
    "Captain": 6800,
    "Vice Captain": 7800,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9200,
    "Summon": 1000,
    "Jutsu": 6200,
    "Clan": 8500,
    "Chakra": 5000,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 3800,
    "Power": 5500,
    "Hax": 6500,
    "Defence": 4000
  },
  "Gion (Momousagi)": {
    "Captain": 7000,
    "Vice Captain": 7000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 8000,
    "Combat Power": 7500,
    "Speed": 7500,
    "Weapon Skill": 8500,
    "Willpower": 8000,
    "Power": 7500,
    "Hax": 1000,
    "Defence": 7000,
    "IQ": 7000
  },
  "General Blue": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2500,
    "Healer": 1000,
    "Ki Control": 2500,
    "Technique": 3500,
    "Form": 1000,
    "Speed": 3000,
    "IQ": 4500,
    "Sensei": 1000,
    "Power Level": 2500,
    "Energy Manipulation": 2500,
    "Martial Arts": 4000,
    "Power": 2500,
    "Hax": 4500,
    "Defence": 2500
  },
  "Iruka Umino (Boruto)": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 2500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6200,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 8000,
    "Speed": 2500,
    "Taijutsu": 2500,
    "Power": 3000,
    "Hax": 3000,
    "Defence": 2500
  },
  "Hody Jones": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 5000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 3500,
    "Willpower": 5000,
    "Power": 5500,
    "Hax": 2000,
    "Defence": 5000,
    "IQ": 3000
  },
  "Royal Ripper": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 8500,
    "Combat Power": 8000,
    "Speed": 7500,
    "Technique": 7500,
    "Energy": 1000,
    "IQ": 6000,
    "Willpower": 7500,
    "Power": 8000,
    "Hax": 7500,
    "Defence": 6000
  },
  "Dordoni": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 4000,
    "Sensei": 3000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 4500
  },
  "Shion": {
    "Captain": 2000,
    "Vice Captain": 2000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 2000,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 6000,
    "Sensei": 1000,
    "Speed": 2500,
    "Taijutsu": 1500,
    "Power": 4000,
    "Hax": 6500,
    "Defence": 2000
  },
  "Yashamaru": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 4000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 3000
  },
  "Pakkun": {
    "Captain": 1000,
    "Vice Captain": 1500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 1500,
    "Clan": 1000,
    "Chakra": 1500,
    "Sensei": 1000,
    "Speed": 4500,
    "Taijutsu": 2000,
    "Power": 1500,
    "Hax": 4000,
    "Defence": 2000
  },
  "Wakuraba": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Speed": 5000,
    "Power": 3500,
    "IQ": 3000,
    "Breathing": 1000,
    "Demon": 4000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 3000,
    "Hax": 3500,
    "Defence": 3000
  },
  "Degesu": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 6500,
    "Technique": 6000,
    "Form": 1000,
    "Speed": 6000,
    "IQ": 6000,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 6500,
    "Martial Arts": 6000,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5500
  },
  "All For One (Prime)": {
    "Captain": 9800,
    "Vice Captain": 8800,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9200,
    "Healer": 1000,
    "Quirk Power": 9999,
    "Quirk Control": 9700,
    "Quirk Versatility": 9900,
    "Combat Skill": 9200,
    "Speed": 9500,
    "Resolve": 9800,
    "Teamwork": 6000,
    "Mentor": 8500,
    "Power": 9999,
    "Hax": 9999,
    "Defence": 9200,
    "IQ": 9700
  },
  "Prince Grus": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Weapon Skill": 4500,
    "Willpower": 6000,
    "Power": 6000,
    "Hax": 7000,
    "Defence": 6000,
    "IQ": 5500
  },
  "Siddharth Bachchan": {
    "Captain": 8500,
    "Vice Captain": 8000,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 8500,
    "Healer": 1000,
    "Aura": 8800,
    "Combat Power": 8800,
    "Speed": 9200,
    "Mana Output": 8500,
    "Summon": 1000,
    "Rank": 9400,
    "Power": 8800,
    "Defence": 8500,
    "Hax": 9000,
    "IQ": 8000
  },
  "Orlumbus": {
    "Captain": 5000,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 3500,
    "Combat Power": 5000,
    "Speed": 3500,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 1000,
    "Defence": 5500,
    "IQ": 4000
  },
  "Yamato (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 5500,
    "Support 1": 6200,
    "Support 2": 6200,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 6500,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 6000
  },
  "Naruto Uzumaki (Four-Tails)": {
    "Captain": 4000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 8000,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 2500,
    "Summon": 5000,
    "Jutsu": 4500,
    "Clan": 8500,
    "Chakra": 8500,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 6500,
    "Power": 8000,
    "Hax": 5000,
    "Defence": 7000
  },
  "Ryogi": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 4800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5200,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 1000,
    "Speed": 4800,
    "Taijutsu": 4200,
    "Power": 6200,
    "Hax": 5200,
    "Defence": 4800
  },
  "Ginkaku (Reanimation)": {
    "Captain": 6500,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 8000,
    "Clan": 1000,
    "Chakra": 9500,
    "Sensei": 1000,
    "Speed": 6500,
    "Taijutsu": 7000,
    "Power": 8500,
    "Hax": 9000,
    "Defence": 8000
  },
  "Hako Kuroi": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4200,
    "Support 2": 4200,
    "Tank": 3800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5800,
    "Summon": 1000,
    "Jutsu": 5200,
    "Clan": 1000,
    "Chakra": 4200,
    "Sensei": 1000,
    "Speed": 4200,
    "Taijutsu": 3800,
    "Power": 4800,
    "Hax": 5800,
    "Defence": 3800
  },
  "Hiashi Hyuga (Boruto)": {
    "Captain": 6500,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 8800,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 9200,
    "Chakra": 5500,
    "Sensei": 7800,
    "Speed": 5500,
    "Taijutsu": 7500,
    "Power": 6000,
    "Hax": 8200,
    "Defence": 5000
  },
  "Hiruzen Sarutobi (Reanimation)": {
    "Captain": 8500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9000,
    "Summon": 8000,
    "Jutsu": 9200,
    "Clan": 7000,
    "Chakra": 8500,
    "Sensei": 8000,
    "Speed": 7000,
    "Taijutsu": 7500,
    "Power": 9000,
    "Hax": 9000,
    "Defence": 6000
  },
  "Satori": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 3500,
    "Speed": 4000,
    "Weapon Skill": 2500,
    "Willpower": 3500,
    "Power": 3000,
    "Hax": 3500,
    "Defence": 3000,
    "IQ": 4000
  },
  "Grand Fisher": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 4500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 3500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 4000
  },
  "Elder Kai": {
    "Captain": 4000,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 3000,
    "Healer": 5000,
    "Ki Control": 6000,
    "Technique": 7000,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 9000,
    "Sensei": 8000,
    "Power Level": 5000,
    "Energy Manipulation": 6000,
    "Martial Arts": 3000,
    "Power": 4000,
    "Hax": 8500,
    "Defence": 3000
  },
  "Sai Yamanaka (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7200,
    "Summon": 8000,
    "Jutsu": 7000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 4500,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 4500
  },
  "Mugino": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 5500,
    "Speed": 4500,
    "Taijutsu": 4500,
    "Power": 5000,
    "Hax": 5000,
    "Defence": 4000
  },
  "Deathpierce": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5500,
    "Speed": 5500,
    "Magic Specialist": 5500,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000,
    "IQ": 5000
  },
  "Shizune (Boruto)": {
    "Captain": 3500,
    "Vice Captain": 5500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 3500,
    "Healer": 8500,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 5800,
    "Clan": 1000,
    "Chakra": 5000,
    "Sensei": 4500,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 4800,
    "Hax": 5500,
    "Defence": 4000
  },
  "Iceburg": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3000,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1000,
    "Combat Power": 2500,
    "Speed": 2500,
    "Weapon Skill": 2000,
    "Willpower": 6000,
    "Power": 2500,
    "Hax": 1000,
    "Defence": 3000,
    "IQ": 8500
  },
  "Mei Terumi (Boruto)": {
    "Captain": 7200,
    "Vice Captain": 6200,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6800,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 4000,
    "Speed": 5000,
    "Taijutsu": 4500,
    "Power": 7000,
    "Hax": 7000,
    "Defence": 5000
  },
  "Chojuro (Sixth Mizukage)": {
    "Captain": 7800,
    "Vice Captain": 6500,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 5800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 1000,
    "Chakra": 6200,
    "Sensei": 4500,
    "Speed": 6200,
    "Taijutsu": 6500,
    "Power": 7200,
    "Hax": 6500,
    "Defence": 5800
  },
  "Dr. Myuu": {
    "Captain": 3000,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Healer": 1000,
    "Ki Control": 3000,
    "Technique": 4000,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 8500,
    "Sensei": 1000,
    "Power Level": 3000,
    "Energy Manipulation": 3500,
    "Martial Arts": 2000,
    "Power": 3000,
    "Hax": 6000,
    "Defence": 3000
  },
  "Majin Kuu": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7000,
    "Healer": 7000,
    "Ki Control": 5500,
    "Technique": 4500,
    "Form": 1000,
    "Speed": 4500,
    "IQ": 3500,
    "Sensei": 1000,
    "Power Level": 6000,
    "Energy Manipulation": 6000,
    "Martial Arts": 4000,
    "Power": 6000,
    "Hax": 6000,
    "Defence": 7500
  },
  "Boro": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 8800,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 6800,
    "Clan": 1000,
    "Chakra": 7200,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 7200,
    "Power": 7800,
    "Hax": 7000,
    "Defence": 8500
  },
  "Kawaki (Base)": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 5000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 7000,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 5500
  },
  "Gan Fall": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 4500,
    "Combat Power": 5000,
    "Speed": 5000,
    "Weapon Skill": 5500,
    "Willpower": 6000,
    "Power": 5000,
    "Hax": 1000,
    "Defence": 4500,
    "IQ": 6000
  },
  "Hinata Uzumaki (Boruto)": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 5500,
    "Healer": 1000,
    "Eyes": 9200,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7000,
    "Clan": 9000,
    "Chakra": 6500,
    "Sensei": 6000,
    "Speed": 6500,
    "Taijutsu": 8200,
    "Power": 7000,
    "Hax": 8500,
    "Defence": 6000
  },
  "Sumire Kakei": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 7200,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 3000,
    "Power": 5500,
    "Hax": 6200,
    "Defence": 3800
  },
  "Asuma Sarutobi (Reanimation)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6000,
    "Summon": 4000,
    "Jutsu": 5500,
    "Clan": 7000,
    "Chakra": 6000,
    "Sensei": 5000,
    "Speed": 5500,
    "Taijutsu": 6000,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 5000
  },
  "Ggio Vega": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 3500,
    "Defence": 3500
  },
  "Sajin Komomora (Human Form)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 6500,
    "Reiatsu": 7000,
    "Bankai": 7500,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 5000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 7500,
    "Hax": 6500,
    "Defence": 8500
  },
  "Gomah": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6500,
    "Healer": 1000,
    "Ki Control": 7500,
    "Technique": 6000,
    "Form": 7500,
    "Speed": 6500,
    "IQ": 6500,
    "Sensei": 1000,
    "Power Level": 7500,
    "Energy Manipulation": 7500,
    "Martial Arts": 5500,
    "Power": 7500,
    "Hax": 7000,
    "Defence": 6500
  },
  "Nianzol Weizol": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5000,
    "IQ": 5500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 5000
  },
  "Kin Tsuchi": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 2000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3000,
    "Clan": 1000,
    "Chakra": 2500,
    "Sensei": 1000,
    "Speed": 3000,
    "Taijutsu": 2000,
    "Power": 2500,
    "Hax": 3500,
    "Defence": 2000
  },
  "Akamaru": {
    "Captain": 1000,
    "Vice Captain": 1000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 3000,
    "Summon": 3500,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 4500,
    "Sensei": 1000,
    "Speed": 6000,
    "Taijutsu": 5500,
    "Power": 5000,
    "Hax": 3000,
    "Defence": 4500
  },
  "Hayate Gekko": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4500,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 1000,
    "Speed": 5500,
    "Taijutsu": 5000,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 3500
  },
  "Tobirama Senju (Reanimation)": {
    "Captain": 8000,
    "Vice Captain": 8500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 9999,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9000,
    "Summon": 1000,
    "Jutsu": 8500,
    "Clan": 8400,
    "Chakra": 8500,
    "Sensei": 7000,
    "Speed": 9000,
    "Taijutsu": 7000,
    "Power": 8500,
    "Hax": 8500,
    "Defence": 6000
  },
  "Udon Ise": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6200,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3500,
    "Sensei": 2500,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 3000
  },
  "Griamore": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Tank": 6500,
    "Healer": 1000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5500,
    "Speed": 4500,
    "Magic Specialist": 5000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 7000,
    "IQ": 4500
  },
  "Hizashi Hyuga": {
    "Captain": 4500,
    "Vice Captain": 4500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 8500,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 8500,
    "Chakra": 5000,
    "Sensei": 3000,
    "Speed": 5500,
    "Taijutsu": 7000,
    "Power": 5500,
    "Hax": 8000,
    "Defence": 4500
  },
  "Zala (Miss Doublefinger)": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3500,
    "Healer": 1000,
    "Devil Fruit": 6000,
    "Haki": 1000,
    "Combat Power": 3500,
    "Speed": 4500,
    "Weapon Skill": 3500,
    "Willpower": 4000,
    "Power": 3500,
    "Hax": 5500,
    "Defence": 5000,
    "IQ": 4500
  },
  "Himawari Uzumaki": {
    "Captain": 1500,
    "Vice Captain": 1500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 8000,
    "IQ": 4000,
    "Summon": 1000,
    "Jutsu": 3500,
    "Clan": 8500,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 4000,
    "Taijutsu": 5500,
    "Power": 5500,
    "Hax": 7200,
    "Defence": 2500
  },
  "Arata Nitta": {
    "Grade": 3500,
    "Captain": 3000,
    "Vice Captain": 3000,
    "Healer": 7500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 3000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 4000,
    "Combat Specialist": 2500,
    "Technique Specialist": 5000,
    "Power": 2500,
    "Hax": 5500,
    "Defence": 3000,
    "IQ": 5000,
    "Speed": 3500
  },
  "Denki Kaminarimon": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 8000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 2000,
    "Power": 4000,
    "Hax": 5000,
    "Defence": 3000
  },
  "Goku (Mini)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Ki Control": 7000,
    "Technique": 7000,
    "Form": 7000,
    "Speed": 6500,
    "IQ": 5000,
    "Sensei": 1000,
    "Power Level": 6500,
    "Energy Manipulation": 7000,
    "Martial Arts": 7500,
    "Power": 6500,
    "Hax": 6000,
    "Defence": 5500
  },
  "Charlotte Cracker": {
    "Captain": 5500,
    "Vice Captain": 6000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 7500,
    "Haki": 6500,
    "Combat Power": 6500,
    "Speed": 5000,
    "Weapon Skill": 7000,
    "Willpower": 6500,
    "Power": 6500,
    "Hax": 7000,
    "Defence": 7500,
    "IQ": 5500
  },
  "Trebol": {
    "Captain": 3000,
    "Vice Captain": 7000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7000,
    "Healer": 1000,
    "Devil Fruit": 7000,
    "Haki": 5000,
    "Combat Power": 5000,
    "Speed": 4000,
    "Weapon Skill": 5000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 7000,
    "IQ": 6000
  },
  "Darui (Fifth Raikage)": {
    "Captain": 8200,
    "Vice Captain": 7000,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6800,
    "Summon": 1000,
    "Jutsu": 7800,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 4500,
    "Speed": 6200,
    "Taijutsu": 6000,
    "Power": 7800,
    "Hax": 7200,
    "Defence": 6000
  },
  "Izumo Kamizuki": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5000,
    "Summon": 1000,
    "Jutsu": 4000,
    "Clan": 1000,
    "Chakra": 3000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 3000,
    "Power": 3500,
    "Hax": 4000,
    "Defence": 3000
  },
  "Blueno": {
    "Captain": 4500,
    "Vice Captain": 5000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5500,
    "Healer": 1000,
    "Devil Fruit": 6500,
    "Haki": 4500,
    "Combat Power": 5500,
    "Speed": 5500,
    "Weapon Skill": 3000,
    "Willpower": 5500,
    "Power": 5500,
    "Hax": 6000,
    "Defence": 6000,
    "IQ": 5500
  },
  "Genma Shiranui": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 1000,
    "Jutsu": 5000,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 3000,
    "Speed": 5500,
    "Taijutsu": 4500,
    "Power": 4500,
    "Hax": 4500,
    "Defence": 4000
  },
  "Gustaf": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Tank": 5000,
    "Healer": 1000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Demon Form": 1000,
    "Goddess Blessing": 1000,
    "Chaos User": 1000,
    "Combat Power": 5500,
    "Speed": 5000,
    "Magic Specialist": 6000,
    "Willpower": 5000,
    "Power": 6000,
    "Hax": 5500,
    "Defence": 5000,
    "IQ": 5500
  },
  "Empty Void": {
    "Captain": 7500,
    "Vice Captain": 7500,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 6500,
    "Healer": 1000,
    "Hero Rank": 1000,
    "Threat Level": 1000,
    "Combat Power": 9000,
    "Speed": 9500,
    "Technique": 9900,
    "Energy": 1000,
    "IQ": 8000,
    "Willpower": 8500,
    "Power": 8500,
    "Hax": 9500,
    "Defence": 7000
  },
  "Shikamaru Nara (Boruto)": {
    "Captain": 8800,
    "Vice Captain": 9500,
    "Support 1": 8000,
    "Support 2": 8000,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 9999,
    "Summon": 1000,
    "Jutsu": 6500,
    "Clan": 8800,
    "Chakra": 5500,
    "Sensei": 7000,
    "Speed": 5000,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 4000
  },
  "Namida Suzumeno": {
    "Captain": 2000,
    "Vice Captain": 2500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 3000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4200,
    "Summon": 1000,
    "Jutsu": 4800,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 1000,
    "Speed": 3500,
    "Taijutsu": 2500,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 3000
  },
  "Shin Uchiha": {
    "Captain": 5500,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 7200,
    "Healer": 2500,
    "Eyes": 8500,
    "IQ": 6000,
    "Summon": 1000,
    "Jutsu": 7200,
    "Clan": 9000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 6800,
    "Taijutsu": 6500,
    "Power": 7200,
    "Hax": 7800,
    "Defence": 6500
  },
  "Fukasaku": {
    "Captain": 5000,
    "Vice Captain": 5500,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7500,
    "Summon": 7000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 8000,
    "Sensei": 8000,
    "Speed": 5000,
    "Taijutsu": 6000,
    "Power": 7000,
    "Hax": 7500,
    "Defence": 5000
  },
  "Kanata Ubuyashiki": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 1500,
    "Healer": 1000,
    "Speed": 1500,
    "Power": 1500,
    "IQ": 7500,
    "Breathing": 1000,
    "Demon": 1000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 3000,
    "Hax": 4000,
    "Defence": 1500
  },
  "Mukago": {
    "Captain": 3500,
    "Vice Captain": 4000,
    "Support 1": 2500,
    "Support 2": 2500,
    "Tank": 3500,
    "Healer": 1000,
    "Speed": 4000,
    "Power": 3500,
    "IQ": 3500,
    "Breathing": 1000,
    "Demon": 4000,
    "Hashira": 1000,
    "Weapon Skill": 1000,
    "Technique": 3000,
    "Hax": 4000,
    "Defence": 3500
  },
  "Botamo": {
    "Captain": 3000,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 7000,
    "Healer": 1000,
    "Ki Control": 4000,
    "Technique": 3000,
    "Form": 1000,
    "Speed": 2500,
    "IQ": 2500,
    "Sensei": 1000,
    "Power Level": 4500,
    "Energy Manipulation": 3500,
    "Martial Arts": 3000,
    "Power": 4500,
    "Hax": 5500,
    "Defence": 8000
  },
  "Akari Nitta": {
    "Grade": 2500,
    "Captain": 2000,
    "Vice Captain": 2500,
    "Healer": 1000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 2000,
    "Domain Expansion": 1000,
    "Cursed Spirit": 1000,
    "Cursed Energy": 2500,
    "Combat Specialist": 1500,
    "Technique Specialist": 3500,
    "Power": 1500,
    "Hax": 3000,
    "Defence": 2000,
    "IQ": 4500,
    "Speed": 2500
  },
  "Gari (Reanimation)": {
    "Captain": 4500,
    "Vice Captain": 4000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 4500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 7000,
    "Sensei": 1000,
    "Speed": 5000,
    "Taijutsu": 5000,
    "Power": 7000,
    "Hax": 6000,
    "Defence": 5000
  },
  "Third Kazekage": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 7000,
    "Summon": 1000,
    "Jutsu": 7500,
    "Clan": 1000,
    "Chakra": 6500,
    "Sensei": 4000,
    "Speed": 5500,
    "Taijutsu": 4500,
    "Power": 7500,
    "Hax": 8500,
    "Defence": 6000
  },
  "Shibi Aburame": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 4000,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 5500,
    "Clan": 8000,
    "Chakra": 4500,
    "Sensei": 4000,
    "Speed": 4000,
    "Taijutsu": 3500,
    "Power": 5000,
    "Hax": 7500,
    "Defence": 4000
  },
  "Dan Kato": {
    "Captain": 5000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 4500,
    "Healer": 3000,
    "Eyes": 1000,
    "IQ": 6500,
    "Summon": 1000,
    "Jutsu": 6000,
    "Clan": 1000,
    "Chakra": 5500,
    "Sensei": 4000,
    "Speed": 4500,
    "Taijutsu": 4000,
    "Power": 5500,
    "Hax": 7000,
    "Defence": 4500
  },
  "Tenten (Boruto)": {
    "Captain": 3000,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 3500,
    "Healer": 1000,
    "Eyes": 1000,
    "IQ": 5500,
    "Summon": 5000,
    "Jutsu": 5500,
    "Clan": 1000,
    "Chakra": 4000,
    "Sensei": 3500,
    "Speed": 4500,
    "Taijutsu": 4500,
    "Power": 5500,
    "Hax": 5500,
    "Defence": 3500
  },
  "Neliel (Gamuza)": {
    "Captain": 7000,
    "Vice Captain": 6000,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 6500,
    "Healer": 5000,
    "Zanpakuto": 1000,
    "Reiatsu": 8200,
    "Bankai": 1000,
    "Resurreccion": 9000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 8000,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 7000,
    "Power": 8200,
    "Hax": 7500,
    "Defence": 6500
  },
  "Ulquiorra (Segunda Etapa)": {
    "Captain": 7500,
    "Vice Captain": 6500,
    "Support 1": 5500,
    "Support 2": 5500,
    "Tank": 8800,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9700,
    "Bankai": 1000,
    "Resurreccion": 9700,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 9500,
    "IQ": 7800,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9600,
    "Hax": 9500,
    "Defence": 8800
  },
  "Luppi (Trepadora)": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5200,
    "Bankai": 1000,
    "Resurreccion": 5500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5200,
    "Hax": 5500,
    "Defence": 4500
  },
  "Cirucci (Golondrina)": {
    "Captain": 3500,
    "Vice Captain": 2500,
    "Support 1": 3000,
    "Support 2": 3000,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 4500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 4000,
    "Defence": 4000
  },
  "Dordoni (Giralda)": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5200,
    "Bankai": 1000,
    "Resurreccion": 5500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4000,
    "Sensei": 3000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 4500,
    "Defence": 5000
  },
  "Ggio Vega (Tigre Estoque)": {
    "Captain": 3500,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4700,
    "Bankai": 1000,
    "Resurreccion": 5200,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5000,
    "Hax": 4000,
    "Defence": 4000
  },
  "Charlotte Chuhlhourne (Reina de Rosas)": {
    "Captain": 4000,
    "Vice Captain": 3500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5200,
    "Bankai": 1000,
    "Resurreccion": 5500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 3000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5500,
    "Hax": 5000,
    "Defence": 5000
  },
  "Apacci (Cierva)": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 4000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 4800,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 2500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 3500,
    "Defence": 4000
  },
  "Mila Rose (Leona)": {
    "Captain": 4500,
    "Vice Captain": 3500,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 5200,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 5000,
    "Bankai": 1000,
    "Resurreccion": 5200,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 3500,
    "Sensei": 1000,
    "Ally": 6000,
    "Power": 5500,
    "Hax": 3000,
    "Defence": 5200
  },
  "Sung-Sun (Anaconda)": {
    "Captain": 3000,
    "Vice Captain": 3000,
    "Support 1": 4000,
    "Support 2": 4000,
    "Tank": 4200,
    "Healer": 3000,
    "Zanpakuto": 1000,
    "Reiatsu": 4500,
    "Bankai": 1000,
    "Resurreccion": 5000,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 4000,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 4500,
    "Hax": 5000,
    "Defence": 4200
  },
  "Wonderweiss (Extinguir)": {
    "Captain": 4000,
    "Vice Captain": 2500,
    "Support 1": 3500,
    "Support 2": 3500,
    "Tank": 7500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 7500,
    "Vollstandig": 1000,
    "Fullbring": 1000,
    "Speed": 6500,
    "IQ": 1000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8000,
    "Hax": 8500,
    "Defence": 7500
  },
  "As Nodt (Vollstandig)": {
    "Captain": 6200,
    "Vice Captain": 5000,
    "Support 1": 7000,
    "Support 2": 7000,
    "Tank": 5500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 8500,
    "Fullbring": 1000,
    "Speed": 6200,
    "IQ": 6200,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8000,
    "Hax": 9500,
    "Defence": 5500
  },
  "Askin (Vollstandig)": {
    "Captain": 4800,
    "Vice Captain": 4500,
    "Support 1": 6800,
    "Support 2": 6800,
    "Tank": 7000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8800,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 9200,
    "Fullbring": 1000,
    "Speed": 7000,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 8800,
    "Hax": 9700,
    "Defence": 6800
  },
  "Bambietta (Vollstandig)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 7200,
    "Fullbring": 1000,
    "Speed": 6000,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7200,
    "Hax": 8500,
    "Defence": 5000
  },
  "Candice (Vollstandig)": {
    "Captain": 5500,
    "Vice Captain": 4500,
    "Support 1": 5200,
    "Support 2": 5200,
    "Tank": 5000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 7200,
    "Fullbring": 1000,
    "Speed": 6800,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7500,
    "Hax": 7500,
    "Defence": 5000
  },
  "Giselle (Vollstandig)": {
    "Captain": 4800,
    "Vice Captain": 3800,
    "Support 1": 5800,
    "Support 2": 5800,
    "Tank": 4500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 7000,
    "Fullbring": 1000,
    "Speed": 4500,
    "IQ": 5800,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 5800,
    "Hax": 9200,
    "Defence": 4500
  },
  "Lille Barro (Vollstandig)": {
    "Captain": 9200,
    "Vice Captain": 8500,
    "Support 1": 7500,
    "Support 2": 7500,
    "Tank": 8000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 9900,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 9700,
    "Fullbring": 1000,
    "Speed": 8800,
    "IQ": 7500,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 9900,
    "Hax": 9900,
    "Defence": 9200
  },
  "Meninas (Vollstandig)": {
    "Captain": 5000,
    "Vice Captain": 4000,
    "Support 1": 6500,
    "Support 2": 6500,
    "Tank": 5800,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 6000,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 6500,
    "Fullbring": 1000,
    "Speed": 5500,
    "IQ": 4000,
    "Sensei": 1000,
    "Ally": 1000,
    "Power": 7000,
    "Hax": 3000,
    "Defence": 5800
  },
  "Quilge Opie (Vollstandig)": {
    "Captain": 7500,
    "Vice Captain": 7800,
    "Support 1": 6000,
    "Support 2": 6000,
    "Tank": 7200,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 8800,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 8500,
    "Fullbring": 1000,
    "Speed": 8800,
    "IQ": 7800,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 8600,
    "Hax": 8800,
    "Defence": 7800
  },
  "Ichigo Kurosaki (Fullbring)": {
    "Captain": 3000,
    "Vice Captain": 5000,
    "Support 1": 4500,
    "Support 2": 4500,
    "Tank": 6500,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7500,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 8800,
    "Speed": 8500,
    "IQ": 4500,
    "Sensei": 1000,
    "Ally": 8000,
    "Power": 8000,
    "Hax": 7000,
    "Defence": 6500
  },
  "Kugo Ginjo (Fullbring Bankai)": {
    "Captain": 6000,
    "Vice Captain": 5000,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 6000,
    "Healer": 1000,
    "Zanpakuto": 1000,
    "Reiatsu": 7800,
    "Bankai": 1000,
    "Resurreccion": 1000,
    "Vollstandig": 1000,
    "Fullbring": 9000,
    "Speed": 7500,
    "IQ": 6000,
    "Sensei": 1000,
    "Ally": 3000,
    "Power": 8200,
    "Hax": 7500,
    "Defence": 6200
  },
  "Lumiere Silvamillion Clover": {
    "Captain": 9600,
    "Vice Captain": 9000,
    "Support 1": 8800,
    "Support 2": 8800,
    "Tank": 8000,
    "Healer": 3000,
    "Magic Power": 9500,
    "Grimoire Skill": 9500,
    "Combat Skill": 8800,
    "Mana Control": 9500,
    "Speed": 9800,
    "Squad Synergy": 9000,
    "Transformation": 5000,
    "Experience": 9500,
    "Willpower": 9500,
    "Power": 9500,
    "Hax": 9000,
    "Defence": 8000,
    "IQ": 9500
  },
  "Yorki": {
    "Captain": 5500,
    "Vice Captain": 3500,
    "Support 1": 5000,
    "Support 2": 5000,
    "Tank": 2500,
    "Healer": 1000,
    "Devil Fruit": 1000,
    "Haki": 1500,
    "Combat Power": 3500,
    "Speed": 3500,
    "Weapon Skill": 4500,
    "Willpower": 6500,
    "Power": 3500,
    "Hax": 1000,
    "Defence": 2500,
    "IQ": 5000
  }
};
